var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrgStruct(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "841.8pt",
    height: "595.2pt",
    viewBox: "0 0 841.8 595.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask_0"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,367.8,46.800039)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_1",
    width: 118,
    height: 58,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAHYAAAA6CAAAAABAVvLaAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAVUlEQVR4nO3ZMRGAMBQFwSchJQVFpDCDkBQIiIRYD5j4NHsGVsAl OXtxLW/PKu9KWr26BhaLxWKxWCwWi8VisVgsFovFYrFY7C9sZj17fyOo+j71I9kN 3q+yBJqa9AAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_3"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    d: "M367.59 516.39H435.621V548.646H367.59Z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask_4"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,367.8,87.000019)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_5",
    width: 118,
    height: 58,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAHYAAAA6CAAAAABAVvLaAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAVElEQVR4nO3PIRmAMBhF0ScmEURA0oMIC0CEiUkE1VmKH3NugfPd 5Keu5y1unMlWja7uZMdisVgsFovFYrFYLBaLxWKxWCwWi61n26xne9buUV7LBwyV oWqCLN14AAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_7"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    d: "M367.59 476.07H435.621V508.32603H367.59Z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask_8"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,367.8,133.20001)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_9",
    width: 118,
    height: 51,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAHYAAAAzCAAAAABnWaMSAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAATElEQVR4nO3NIQGAMBQFwCcnEARYkAkEHQiwIIhVXwfEx9wVuOQn c5UbyVm/rqnVarVarVar1Wq1Wq1Wq9VqtdrvbXvr2ydJv6tdRzbMNB2XHKOMwgAA AABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_11"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    d: "M367.59 433.99H435.621V462.214H367.59Z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask_12"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,367.8,177.60002)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_13",
    width: 118,
    height: 47,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAHYAAAAvCAAAAAATTWHyAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAATUlEQVR4nO3NoQGAIAAF0YtGgpFAdAz2IBgYw8DquAQ/3VvgAbWF FX5zxXUo+XW9tra2tra2tra2tra2tra2tra2tufb68u3A3h63M0GCCNF8F2YLIEA AAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_15"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    d: "M367.59 391.91H435.621V417.86003H367.59Z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask_16"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,207,64.20003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_17",
    width: 203,
    height: 27,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAMsAAAAbCAAAAAD3riTAAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAd0lEQVR4nGNgGE5AJjx+WAAboF+i64cJ4GFgiK8vH+ggpQLIrq8X APklfqCTORWAwahfBiUY9cvgBKN+GZxg1C+DE4z6ZXCCUb8MTjDql8EJRv0yOMGo XwYngPkl32Hog3CwX4bNOAzQLzrFA+0I6oDggU7mVAUACdAidFNMWJAAAAAASUVO RK5CYII="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_19"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,221.4,57.00002)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_20",
    width: 155,
    height: 53,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAJsAAAA1CAAAAABzHMbOAAAACXBIWXMAAA7EAAAO xAGVKw4bAAACU0lEQVR4nO2UIZOkMBCFW0QgEBERCARixAgEYsQIRKoQiBEIBAIR MSICEREREdF//ZJOZo/ZW7F3YquuKp8YmPTrfq8SAKBQKBQKhUKhUCgU/mfa+/Xr Ap+VaX82yydWPHD+qlA7PQ3sp+OcueINqg6ElPdqFFCNrL/CpYfudj9EVwOwIVSC kEt5q6G9AYwNCWsZuF462YSqkAOjmoB8iStxbA98vPNoRZNYMgkFmaRDW8VBPNuc eVi6LE4jNwuMns2eLQqOdbOItga5T24JCmmk1uEXAAcSNso5tVlz+AYuftLPVMsS WgHp1dx6HSWQJyWTUEAZpVeUggZlmzPK0GVbO+TSs+caznLedbQ2Ffdj3JNdxcm6 2zeQtutwSEJQCqSrKj/B9uxGXKiWJbTCY85NA3MTucRJqXd9AmXjzksa9LI5s3h6 pOw9ZOM4Yngvdmed1WwLUiOhd8pSNqfMGjdC4ZCFMVswNw94WqX2mWpZQitVLD8V SSBPSr1mStn0YlK2l82ZHhfe9XcUIRso7xgM2Cyq9vfJ8xYvoFbYKJsK+8/zuZGQ svlrG57Y5aiAv50prdD9aisRJPCaFHtvGPZiYRIPlrO9bN6YEHHGB8RsA4Yj1zuE 522x9YHx74TmiE0jav/IxkmYztSirkAE7fGWjVboXhjEjcHHpNBbIzFIJyBne9l8 oq2gSXdd2KcTgo67+fz6nIXSVCJp//gS/l4ReUKaFHo5xhfXDGf5VzZnVvvN79mH UJrvNbz31hg+TnD0f91bKBQKhUKhUCgUCoV/4RdCWc3/Zvm9yAAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_22"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,207,84.000019)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_23",
    width: 203,
    height: 27,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAMsAAAAbCAAAAAD3riTAAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAc0lEQVR4nO3YoQ2AQBBE0RUIBIISKAGBQNIDAnkFICjgBK1zJNDB JDPZzKtgfzJqIzIZ1i2FqbXsdw61jyjsI1DGt6WwZw4wu0WSWzS5RZNbNLlFk1s0 uUWTWzS5RdPfcrFfKADH15JEa1nYN4CcHXvnSA9nJiLPEQE6jQAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_25"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,221.4,76.8)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_26",
    width: 156,
    height: 53,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAJwAAAA1CAAAAACRwN23AAAACXBIWXMAAA7EAAAO xAGVKw4bAAACeklEQVR4nO1UoZLjMAwVCAgwMDAICDAoCCgIKAgI8ExBQEFAQUCA QUBAgEFAgIF+fSW5vZ3r3XZmyYIdP7Dy6j0rz7JVgIyMjIyMjIyMjIyMjN8H+0W+ bN39J338i+KGeNj/MebY/fWH3bygw061J1DW6sICqArqEioFRo9zUlRWf0ajQVck JohYsqbU9B9zVMKwuqwLW6blg0zbtVX8FaoPpVX8VVvTqiae1urV3LpKWBBDjScY F9jvEFxxuLDuOADcw4ZcPUU/wnpvkSFiyXqPSCchzqKmvwAtmn1SsaHlgxRhEzFa qoIOznGJZynUHIgTwBw8di/m4ihh71yA7V4cPXRRB9dFhasd0IAh0nEHJPrxRK64 ehJL1m/lBeunudVZMqdbnOXcD1KEYQZTJ3PhCsMmhcIEZ97tYHl9RbtcnkJL5vrY IF3Nxue5QnSgqVDjI7K5FL2ckmsmsWTJlcaWOSRz+3RQbzUcqREPUoRcqIzzgK5g 7cqFCnRpdziifTE3xwqU6WJB5hTuC8A1muBcrLYJ+POxp1vmFkvkzjViLokl65ei +ezcCGMgc5e4pc4lUoTHDTScHJs8Upd4daNt0jlu5V8wO244UaPIHMzYQ7EP/Ob2 W4sL7YOwTZHNpUifXuTASZyy/ghx+/Pmdh+v/OaGBi9sLpEivKKPD0sOvb89Vwe/ 2DAcw+tElCdXGXpGmkamp06VNGa1hqqGqpMpuliZuhQrAzx8PHksTlk/Nm0JzJW2 MH1Pd2GVLcAauVYh0/a655Rsr7qzeq74Oo2Vof0a6/KW/krsxzeyt+R38PhF+664 Mm9kb8mMjIyMjIyMjIyMjIzfjg/ur8y20l1IGgAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_28"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,207,104.4)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_29",
    width: 203,
    height: 26,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAMsAAAAaCAAAAAA88vdlAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAbUlEQVR4nO3YsQ2AQAxDURdXXJmSkhHYgYIxrmQASgpWRycxQqQY y2+CfClNAmBZJXQAx6PhasCoHiJLzJazej0S7F/LwP9tbqHkFk5u4eQWTm7h5BZO buHkFk6KLUo3sojQ+SndHWjV65Ek8AL6OiLNDWTqnQAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_31"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,219.6,96.60002)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_32",
    width: 161,
    height: 53,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAKEAAAA1CAAAAAAMzdQ/AAAACXBIWXMAAA7EAAAO xAGVKw4bAAACcUlEQVR4nO2TIbPkIAzHIxAVFRUVFRWICgSioqKigpkKRAWiArGi YkVFBQKBQOSrXyh74t7tPHGz887wE4UJSfgnoQCFQqFQKBQKhUKhUPg8jMv2f2sg Gusv+fZkiej5z4p5B/NuXMy7kxbHnxbzlhG7tEjE2DkNHXbKMeVAudltx8qg9xin 5BFBYM3WiI+qjReDI7YCCfGKzo5si7iQL1wLsB1DT6Ed9nUUMHu8WtqDfZwUp/uo ou+zGdqImKIRQ/2nQh3vRTmJXHumPOUTJNJrg3rFGboBdneXAucTJhQirgM62QeU I3KeOn1HZ8cpVBJXBHCKnKVI9fM7dYcLvw7aw3F0K8qG44O7I5upeu4VfXuOzReF yNJibUN34HBtAFtw8XKVIV1PA2wyLis8Q3OLfT7GoPfVuIVUQ1J4R2fHPRxPNHgc UYE5AWrqOccTB5jJeY20P8JB2ZokHIzLZlh8qqnxu/mqkOqkNCzMdAc1iT61t8ZP OKnA4NKwusFkhTKsYDzAuSvHw1M89Uthjs6Om+Ocp95SR1Ic47zjuFyp/RVsnuPM z98KBViXzfCwSSHs518KmYu7PZ6xTgpnJAEq1vQOrevQmthR9HS9pkwnAo3BwRwQ Itv3l8IcnR0FamXGPGWJxo55yjTEOto1rnnKL4VhQ53NG6l176cM1WK3buuhUg00 SEOeJHB6fqoajKZ3XulNzum5K6hVC4PZBhAS5AhiJBsoKuKOfjkOm52Tfeb0B+06 PfuGUqsBWr1P934cU3pSuNiFZfMi7wixkEP1zY9NlX5z+mn4P9xGJfwgqZ2FQqFQ KBQKhUKhUPggvwBkJdK7+AF+nAAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_34"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,207,124.20002)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_35",
    width: 203,
    height: 26,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAMsAAAAaCAAAAAA88vdlAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAa0lEQVR4nO3YsQ3AIAxE0RuAgkEoGCE7UKSgYISUlFkdIiUbWPLF ujfBfcmVgUjqvEPou2V4j7CSn5br+L/zbRneZ26gqoWSWjiphZNaOKmFk1o4qYWT WjiphdPXEsRuad4brCQge79QjBQsxF0iz/4UglsAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_37"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,239.4,117.000019)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_38",
    width: 95,
    height: 53,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAF8AAAA1CAAAAAACSGgVAAAACXBIWXMAAA7EAAAO xAGVKw4bAAABcklEQVR4nO2RK7ODMBCFj6hAIBAIBAKBQCAiEFcgMoNAIBAIBGJF BaIiIiIiYv/63ZRi2qo7rbmTT+xkHzmzDyASiUQikci/pdO6S76ozzT56zf1NQZO twr1BuQrKch76UJqWHM01KLYqEdCJX4mHA5WohkVZQWlKRVnRb2t2Rv9xYNV5hgX c9WDvBuuQsr5CTc3J3ZsvcpYYTY4nJRnMrhYXXE22stZYbWjF31m14K7q2WU3ITI aiZpcE54srlfqeZR2ynjVe8Gh1Nxro3czs88OYWzopNVvOjPoVfeTceo7n2L/ga5 es6lnzZ9a+S3Lh/6hzNYBP3eLaLf46xQGPyb/QTrS8VI/NKMsp9jDpl9Y6Vc5seq yR/7uTudvWpyTep7qel9elbsyrzsRw4abIdaUu1ue1CNZZCYBBpKi2CZilTC/YK7 sxsiMtSGrNy3PSoy3qzc+gPMYWb93GqY8DP8tGLa4SkaJoxEIpFIJBL5M7/Fznky 1ev7ugAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_40"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,469.8,52.200025)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_41",
    width: 260,
    height: 27,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAQQAAAAbCAAAAAC/lK4sAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAA60lEQVR4nO2YrQ7DMAyEDQoCCgYCCgoMBgoKAwoKIg0MDhQODBYM DBQMBPjVlzibtL3AXMn+QKMrOlvKzxnAqGCMoQFwU4ydQsl4ypwAlrwkp04yzj2y GAGm/HPNWpks3Kj/x5bbK+Hq85coShuRJHH5yptQy080SxuRpDYhLK20EUku6Sht wdgRw9lJW5DE8QPhSUHaiCQrl29XJFgTuPyVBmkjkmz8THJe2oco/az6XvjBOmFR 2qK0RWnGojR8RWmPWKauDSKWU1KV/ERpLNPXUI5Iok2frHQpq7GOoO/65JsW8VDW HlGjhBf7m4gvK26RBAAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_43"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,507.6,40.8)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_44",
    width: 133,
    height: 67,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAIUAAABDCAAAAACXAJlJAAAACXBIWXMAAA7EAAAO xAGVKw4bAAADT0lEQVR4nO1Vre+sOhAdUVFRUYFAIBAIBAKBQCCaIBCIFQgEAoGo QCAQFRXzr99pC2R/yb6XzRPvJvf2JP2aOTOdtrscgIiIiIiIiIiIiIiI34bGoCl/ exE45E0OLOe0YLmgnrteMpnSmr1RAwcgARC3ybEIUgK/w11sSCLIRm7JgSV+kWSf i+B2dkNn0VbQGW1TqM1uMjgXxMGg9x6IeFwcgBoFM32wnYvFFkAh6v0KZy/EPSQ5 B2gtAA3DTj1fycM/VVGie40UG9BrihnHMsVSYMtRS2Oy+SCvwArmJXBomWFeYuFt xOLbSpaGmzmEQ38W2+STKOJMmsJL2CaO1XiKDD8+foeS+oE225aBjrdCj2gGVmDK UJHRV5rA2QeOuz5s1jnYiAXrQhsDs10Ih1Mx2/okJRlwpHBJloLmCpLPVTRYA5Ov DaRtpwUqlNPmqzPuzGD6MKfzBI7znRrTYOuQORu5OixCeIYpXYpP0hm6tIZekk6W dZb5+ccX4Qeupu5wPTVTtteadfiaephXaGkLXzrN6TyB42IWOmCwzbifO6NNtgO5 D89P7QJ9EuLkdFkdbjuyeYP9XLH7h59no3KASjW0Qa1q3zcCyhTSCnjrSqe5rG+O q+Jgl20fm8b9N7patiE8bYUL9Ekch0J424jKBfBOpZ+L+A+o8f6/8c+v/L+gLe4Z Vx9fOSLiD0IiSAtJAoUACTIhJfSKyKUTRX4THlyuZ/yZB3gW2hcZ3jGSFi5gO2F7 MCSiyuLASCTnBRSJorwIK33me3zB5XpGABu0I9BIPGbXvsjwDhJUaYcU82lnKS4S j0SvJASkwoWTgzwQBB6DMHqE4IJnJC3OQI9XHhJa+nIXLPkiwzteB0isasRT0BdR JlSwHltL8lFNdMjXTTBqmoZdQXDBM1IQcxoVaCTiTshv979meMe60oUlw57Zxom7 k2BsxsMZt4lESQTC/Kp3K84aggueEQbtTxdoJPHcNfgiw4+7sHo3oCfQs+uVU/N0 9MbRqGMNBGarHAcgzQgueEbQL3e6K48i0XUNvsjwDq6qpIZaQlFAnUBeOg0UJJAk Uo2qLgJrGSflJM24XM/ogtLyzgNll/j2RYaIiIiIiIiIiIiIiL8VvwDeiEzQ2e8C FQAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_46"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,469.8,72.60001)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_47",
    width: 260,
    height: 26,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAQQAAAAaCAAAAAB0yH2JAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAA5klEQVR4nO2YIRODMAyFIyoQiIqKiYoIBGJiAjGB6B1ikh+AnEAi KhAV+etLy9CT4ZZ+gvTdIV5y3KUPAKZBdLneEI1CWWh3IhoAJi6bUScPLAsKADOX ZNTJzLRai+jzERHbPBRN0o8NnxKNoJhY2i9fhl6O9usQ+DnHm7QRSda8J7TTeGkH l8H20g4uwEZ3aQuSzKmDuh3qijzbj7p3RCpD8IP59eI/MyxO2kLlQnCUlrYgSY3S UKN0od4ToEbpwhmlXSTa+Qb9IqJFmzyjdJf/vj4B3lx2ffJLH8KDr43tGIJTKOED bGeIL1mP+xoAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_49"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,502.2,64.8)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_50",
    width: 151,
    height: 53,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAJcAAAA1CAAAAABpICZAAAAACXBIWXMAAA7EAAAO xAGVKw4bAAACKklEQVR4nO2TobOkMAzGIyoqEIgVCETFCsQKBKIC0RkEAoGoqEBU ICoQCERFRf71SxeG5e3Mvbl95m5u+hMNId+XlAIAiUQikUgkEolEIvFXyET2TZVJ xuWnLX9kinT2cV636MXvlTkO0/xp+x+ZiALD8Mq4td9ohZL84wE/MgEYO0209nD3 XMybXWmrFl2uO+fpIPcgVt9PYBVIB0YtvpqwO9LDqnGrQFhcCyijPVYhFg4V7W9G fVU8p7y6vT8NFsMGECT0WxZ0gytkXmWhDb5yFtgzUKHyhmMDk4Hgax9aux7pboUH W0wWRrFMZOcoGbY3+kZOFXUdRXNRdHGKPLu978s5MSIvcLGbaQOD1dJHNjtX4YOO kt5yDBI5eCWwpDXe2QbQ857CbmXNHO6K/NpGu2UlIi5sMoeKPl0qwkWh4pT87Pa2 rQojRY1KoRrprOgRRicKaJAz3x+BChVWEhmtNfIMK1j6PYXdataaw7gA2zrtRIs3 GeCOpW8PFcQiXBVznAJnt6/bYisdcYmP3sENqw67xTHoQ900A44m3GAPfehWzBXG laQVZhzrPYXdus1q5Coo67PeV6PPWqzNekNxqOKv3pn8otBxCpzdvu7rpsjCVVE/ IFecj1bRr0PBCDdpXdJrfoZcj0JBZuJK0pKuVb6nsFvvk22BD7bP4zoWwLXtcioc qjjFyqviOeXV7Q//UhbkJfw7ZDa/hEQikUgkEolEIpH4f/gFeZHSGVCAhMgAAAAA SUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_52"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,469.8,88.800029)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_53",
    width: 260,
    height: 51,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAQQAAAAzCAAAAABUayl3AAAACXBIWXMAAA7EAAAO xAGVKw4bAAABM0lEQVR4nO2aIXPDMAyFHwgoMBgICCgoKAgYCAgIKDAbKAwYHCgo GBgoCAjQX58l13f9BdPu9D6gREz3znb83QUgyjnnJQFpyfkcsDV6KazAqs8+XDt9 9iWE7iayTcC0idy6cO1D8t9tuv+KWAiH3nsOV2oIdxm9B/FklXe0KOKStEQPwdhk 9h7Bk27QOn4cvAfx5Cv2GqjwNEALYV6T9yCePORS6m41LKfrG7gpDIYA/UYcvUfw pKo0Ql8TqNIKVRpUaYMqrVClG1RpUKVjr4EKTwNQpQ2qNKjSLzAEUKWp0lRpgyoN qrRBlVao0g2qNKjSsddAhacBqNIGVRpU6RcYAqjST5VOd5GfksSyi1zLPTJU21R6 1J/eL6pSInu09vv5XejmnJdybRxyzqdo7VDefgHzfK2cO1VSvgAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_55"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.59999999,472.2,80.4)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_56",
    width: 254,
    height: 81,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAP4AAABRCAAAAADXt0S2AAAACXBIWXMAAA7EAAAO xAGVKw4bAAAHZUlEQVR4nO1aLZOsShJNUQKBQCAQCAQCgUAgWiAqAoFAIBAIBAKB KIFAIErkX9/MSpqZnXs3Ymbvx3S8V0fQRVaek8lXT51mADw8PDw8PDw8PDw8PDw8 PDw8PDw8PP6ByM8Q5um7u/g2tCcUWHx3F9+GeQl2uvj5gUcGGmso7QR7B90OW39g tWAPkB24x2+7AAsimieL5k+av/Zkap12LJ8JtJ2gsnba7woAEr1FhSBJHwujLaWl AiNla4le/A628WqD854dfRYn4hpAbNvQzHDsozr2JcAKlknZPT9sNe8Q2jrA5t4F UKizdXmy6LNWWMqeTDHXPBNC22UFbQo67KsCabjoXUMIkvShsM7AzNJSw7dq5qKP i181Npc2Asrbr44+iwj72cb0CChYlhT18ljnIcdEnTrFHGwH00KXbDmW/N4FSDHh yyEs4Pl9VU8NnkoomWYkxFvQtGFNqQDg5uCuIYRn0n8VDrU5UmmptfpE5aLBxd8w u9pQlLdcHX0WBcYR3Y/jBsHZ6jU7jmJrG4QKiweqmBqhwxwM3U9vuzS2ENCtKiyA YQkaDGVPpmqksb4Shg04B0osnhU4wNFbVAiS9KHwvOUA0lI8TdMm0Se/OJurDc57 dvRZtJbu/55Oc7fs4aZjnGFvGhwOdzglBnyYndX68bYLMK6QY3yx+EJqun1lT6Z6 nM0RXgk19lvY2uHEuwJpuOgtKgRJ+lDYGD0F0hLR1l6iwqdzsGxXG5zXXR19FmVN jZSg6rEJlY4CHUMTB32XNVAXkD0g0iGox9LGb7vAU6kGYdGuambOcnsytY1DFz8T glqXEPRt2twViOSit6gQXNLHwukwMp1bIjSpRG9+8bja4LxnR98LZR9/mPDSCHX0 hwkeHh4vhrCO/7o2/9EK/ljVLyHfUf9t7WOcdvWnin4Vvf3b2rF+fOWP/Uim7KQl z2INFCeONF5GWqyFG63/Thrv2EC241mwuSIHJUmSA5JU7YjX6rLf2B+mB44YpCvO GA3zRn4tIQtWQ2Lw5JUir+FpMUcDF5FJ9ocd9CvEmIlAz7LCl8BxhgWGhZ1BtIlI fQlFJG/he9DSAWJ4lfgBZ5ctGy3365U8FtlF8ghnw6aEFh8kcR7FYkI7hMsWUvxs riSXA5IUIpm8a6myDWRS1LFkZlf7QpYz2mw5WnXM4XiqvecTRmCP5OwiRwY3CSqB ydAeLehDJwC0bifHK3wXiLDiznQg2vE+gOmFEojkU/htsE3Zs/6PR59gxh3RxWSr ETIrRrMcc4IpHF1M3nI0DzqNo6lxNZuSJMkBSQoOWl8nTo78qdV0X6TkSAuKTSeZ XjITZNLcdtsOviIBOSv3s5KLlG6SrtN6piSw7LsIQL3Y6sl3AYXmsBt1I9rENiYR ikjewveAL8y05leJj6DTRgkhVmw16HzzzwyYZ6euUZVY0v2jjoEm1NENJqgxlSTJ AUkKzTRbFbl7GSszkgKdQzJLilhsereFTBqsk7YqdzaJukmQl+0usrlJIhfYJFhn ZhIBfZYKhC8ByLA8+2Fn08fajc0CrskUkbyF74FcoeYq8RGdoQKVOaiL+IH9Tt6N nt0Qixonurs6XNYzrp13aqyezkCSJAckiXwnPfIH39W1VXREBQ4G8xyndQ8fuM2Y 5TiMNimxHWzimpt3srH0lcORxk1Cpzt2xwpsIwLTocdU+BKoN7q8RUVfCKJdYKdb EIpI3sL3gGZDLKX+T65+CYlOdcrWTLUdeSwORTogW5VoWJauj8msTY2zXOTQJEly wCWFxK6K3KZclb7eKN70qVZQMWsweqCZamxpJV9PbeqekbZP5K+zi8hkNXUZ5A9w PpAFwm56qIvvAr1WVFV1DxBtYvf5RRHJW/ge5OIXpcRXcTafTFTmZ9+rBPmq+//x q/xfAV+Iz0H95M5y0OmvtfCrfA8PDw8Pj9+GaMUziBb2ZWQvUrcY5EVqZHCiNVZK S8KwNZzZHBDYyo3pMyPLFhobigTZJtGo2Zulel1whivEFRJRe0d6EaxbVqlti1oM yI88rGKbYhWsJlvIBJx9T6E1i539zDChccSfvbHQHci/SqwzTDOIxrRmHYYT1h1b aRfiCptTg3ek10DCL8Njt/QPz5ZfKtGWVv8x2Zph4ytO29NsZL72YzFW8Tins7Rr TM+G/Sc5R/IUl8bR0fHBMfBYQjltLzV4I70IKvJHZFoiOnDqNrI9bUPb0/WNwtPZ 8K0P+QXdwK9ml43H5GI2ekrs1DW7kwizsxENfpO1Tuykpv2S5QqX2jvSiyDCZWhi nHrMY1x2u5e8JdODo7H1jInCOsJ5wIJfApo+wmnA1PTaAD3DLb98TbDvmM0anMRm bx+xAglxhdGpwTvSq6AYydcVQ0fr/WYgaxrQtmHvNqQ60qV7X5MPbeZeAtLivRzb hD6rnB1j4X71KseObKnToCTyGPp8jGxURZYrsBpZtnekl0Rx/A6V6Qv/kPBSiP6X 6fsSHvnvUPHw8PDw8PDw8PDw8PDw8PDw8PDw+BfgPzBwLt+zabINAAAAAElFTkSu QmCC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_58"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,469.8,124.8)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_59",
    width: 260,
    height: 27,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAQQAAAAbCAAAAAC/lK4sAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAA60lEQVR4nO2YrQ7DMAyEDQoCCgoKBgoMCgoKAwYKIg0MDhQWDBYU FhQE+NWXOJu0PcDkTfYHkhw7W8rPBcAojCGcHUAzhYAKJdNS4gIwpyk6dZJx1UZ0 9AA+Ei0A2mTmTt0Xdtjf4Jc2jURB2ogkkctX3oRSfqRJ2ogkpQl+rqWNSHKLvbQF 44cYrk7agiSOHwgHeWkjkqxcvl2RYE3g8lcapI1IsvMzybXSPkTpJtX3wgfWCYvS FqUtSjMWpeEtSreIp7SqEDGfkqrkK0pj/n31+Ygk2vXJwikmNZYv6E2ffFIjNnnu EDVKeABoYYgvgQPWlwAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_61"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,489,117.60002)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_62",
    width: 195,
    height: 53,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAMMAAAA1CAAAAADZ3wByAAAACXBIWXMAAA7EAAAO xAGVKw4bAAACmElEQVR4nO2Ur4+sMBDHR1QgEBWICkTFiooTiBWIEyQrKhAIBAKB QCAQKxCIivnX3/THshzi8nLJJS958xHdTvv9zsz1SgEYhmEYhmEYhmEYhmH+UW6N +itd40Bs7S8380PuK97+RjcsYF0OUGgaREkrRQYqB1mAyqSCTHtVrrNzCFJrLSG5 0r535WWuwuQQ06T8IkhjWkoVk8vPZaZeUSan4dLLW3hia42rAVpEd4MZK+iwE3iH cQQ3IFqHFsDu6y7fIYBDxOnlot99cQW4OzzWTwc52Q+xm5DCkCAK0piWUsXkAugR 1zFFlH2bLr0cwhM5NdMDGCxh63JcrXJLW6KC/aFwEPiU80S7hcbmCOkkSL7a5CK3 k2RR5Bp7g/Lu8sOrsBdbFxKYKIhjzGleFaMr9CHdI0YGbyWOl15ewjMGq57WBurs 2VZb0w/22dROSDQVyoJOabFAZ7A175AuKoqMTiO6wuFhCxWNWBd4I8khpgn9q0OC JIgjpKVUMbroZs9AlWNE2QXaSy8v4ZnGCYUGphFKNENXrS53VbtSW7J90l8oM7JO vb8vR0jzBTSdT3QBzD3UCOQqUMM+05kcYvv0kpAgCZIsLr0qRhcA3X+qHKNpgg9U 116S8PJJC3zAA6e9E85ousFoLK7PHZYOHnvotXXTVL9D8Ft0PtEVPge7DX6xwoxu +Ce8vTMu+xgTJEGShaWjYnRRJrdQ5RhZ9D/XXpLwTFkA6MI/xZo+e5HRW6Gz7POD XgF6eApFr4e/O40RpzBs+QfFuyDuh0X/BM1zEgSxa+pKxARJkGRh6agYXfQS1YYq p+ijocauvSThr9Ls8hQp1D9wfY2+Ef4SdXGOsrv4getr9I2QYRiGYRiGYRiGYZj/ kT+Muwhcbvnu3wAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_64"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,498.6,176.40001)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_65",
    width: 118,
    height: 48,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAHYAAAAwCAAAAADhzdG8AAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAYklEQVR4nO3YoRXAIAAD0YhKRAfoEJUIBDtUIBmhggFYnQeGDYK5 W+CLuEiHerK7FKSrdXufdPvVXhf7eletsLCwsLCwsLCwsLCwsLCwsLCwky3e7++f bDjzwqn42ehddTcAAW2Dh3DuDakAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_67"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,508.2,167.4)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_68",
    width: 88,
    height: 81,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFgAAABRCAAAAABz8T4gAAAACXBIWXMAAA7EAAAO xAGVKw4bAAACzUlEQVR4nO2WIY+sMBSFr0AgEAjECERFBQJRgUCMaFJRgahAIBBX jBiBqBiBQNy//m4pb7Ob7M4OyW7y8tIjOs1p88HctocCJCUlJSUlJf2CpJ3b3+Aq uplH+fPcfJu5gWrCsYAJ0WRQzdwa5D6gBDUCCmgw9Cf1OrimMDl7oPJ3oF5Smz1s u/atI6eAB7XntlyJ24Yur4MFtTu+hp5ycsO9qGnQ3vGAAKBJI4O724PB08OeKEVB YbakCjoG93pVkqzW4gPYL10A++kEGEbmYL2NcgmlEN7m2yDaywGOpdgqFUpRkzwB zizikMnbgxePF8zlIJFuNVTIBT0Wr2VvX7zrmVdOSgoqdNCJ4/mqBN0R6USgvA4W 4VBJ16HLODiR937Fh6MD6HCuonE4pcNZwMx9Ge2au1V2RfzkfB9gRWipB7m1diu6 LSRPQ87KaEB0pBGcFhpXfY32dbUkuq1x9AScwX2CYdU81S6Ajvs8HA2IDgiNjODE OOxxLkmob8AQwOPKK5kvJmBGz8PRgOh061/wYXvNYEDvn4GnjkvRkRKdIaf9/cJ9 pXYjOxznxRTB0bZ0YXBDpf4EfInBpcg8ePEys6xT2Cdcx2xArHcjO5zLzVuEkHHR xisUeLEDtPjl5lDvnhn+A6CGZ87Lku+eqcN3Wgl45iT9S4opJ34eHFNO/wZY8H7V YmxDyuUhx0KkqXCE+KDwhY3jTGAOrt9/jIUecX4ZzClnNgPCinFTJDTlISHC/URp 4qtKCZxy/MPzFDXmk6P8JbiCGx+WWk+kSM8jgL1xluhVG2oV35TWABbrgi21p8Bl AKttBzfDVsHdMtiEOCvewN7OCLNfzoCx3yznrRgZLPZqNAxuqRNd/laKJUPki6x6 ARxTjuNzWMccSvQGw4dHw6j3a5u+r1MusAB35WCpwFozfkiYbxTe6Vck+Z2SkpKS kpKS/k/9AcdNDJVCLVCdAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_70"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,197.4,153.00002)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_71",
    width: 118,
    height: 32,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAHYAAAAgCAAAAADiG9MnAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAA3ElEQVR4nO2XIQ+DMBCFT1RUIBAVFYiKiQkEAoGYuAQxgZioQFZO IBCICcT99V2bjX/Qq4CXwOXVfAR4eTmAUqr40gOi5ekQeyVh4UYewBPRrsHwoFHA ArxoBRjYvflZVj5sBewPK6+RFmFi2/PNzJ0slT9zI0tMckSuGFZPwuxqJ1Pil6qZ WipAhbAdBVmgWrZYA1bJYosGKBWfpJqETcUnqsmrswXoKr6suopPQictvjsi1vzW H4gxTXmt+RefjpvCDPCM00Jmux0B4s3kw5uC45OgslsfhBv+0Bd92cYXW1k69QAA AABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_73"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,208.8,143.40001)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_74",
    width: 83,
    height: 67,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFMAAABDCAAAAADFD2ZHAAAACXBIWXMAAA7EAAAO xAGVKw4bAAACI0lEQVR4nO2Uoc/kIBDFRyAqECsqECsQFRUrKlZUVDSpQFQgEAjE iIqKigoEAjH/+k2/7n2b3CabXG5zuVz4CZIXMg+mQx9AoVAoFAr/OQov0NvPevZU 1bn/rKfbIEQB0mJQ0OEN6mBhHuAWeHWoJ+QDpUMnnxLAIAOPqhe2tG0KxB70jrBk D2tcIQ3gFkhpSsmuO+9ancZvyaQwrtvPql+pyK9J8heQ4FZJ89JGH2pqYDc19RD9 0UhHJqT2WwLU1MLiHlUvnpr0UWv59N12sdnXHu2NKkUdrxV1sDqwq9biKQFubJaH R9WL50ACkoUxtyYrb1WOYpsGmnaqTYSGFPAATW51+5T8OSMo7uWsevXkY2ZzDMFf RdAVD8m1dQhdgGk6BnVBBdIjtk8Jx5bG6qz6vSdR+Oe5yM97Olo+71rHP8rAwDFj INxDqOHq0VX81yK/dF7DYBSHEWfsHZtTw8Avv8X3CVmTHaOvaR/TrLJtswGVvSVk YWi+mAyL1XSvTi1yHEXc3ndxZEIaWrpyJNjtKxhsFIJmG0FwcHQ0Jlw41U7dZDf3 fh3fek6Rr9rwWuUeHUhOqsUfMcGi4+CYoiWTZoBTzziEqNL73oPnq1aBDZMMm8Zd Qtjv6wJhG1IWXervJDDoU8Ped+QF3d56+g7uDpLHcIWaR3QBuAY0FTTo+1nhLHhE N+xOfUGpUEms33p+ITm8P82VE7FQKBQKhcJf4gesL7XZCc4lvwAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_76"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,287.4,153.00002)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_77",
    width: 118,
    height: 32,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAHYAAAAgCAAAAADiG9MnAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAA3ElEQVR4nO2XoRKDMBBET0QgIhARFYiIioqKiooIxM0gEIhKJAJR UYFAIBD7673QTvsFuQh4ImExbxjmskCUCWNkuTFfZCuZa6sRqVgWQ3cIZ6JZtpEU InnAk1+A2RH1crMlhfjR6lMBla7xxIWsXatrpRGNsnFjwiOftq6VtT2CvGDA6WoL T9kGKJPWrqvVNTbb6VgqW/MO0FZ8mrzQfYtPlevg9jZAR/Gl5Sg+BXZafI6Zo/vO HGSmEsdf8Q3yyb6a+OAAU+o4xSqIBPlFkEs7AlOVPIan8rH45w2YCsXrU0gOQgAA AABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_79"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,299.4,151.80002)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_80",
    width: 80,
    height: 39,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFAAAAAnCAAAAAC9XZAIAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAB+klEQVR4nO1VoRKlMAxcUYGoQCAQCMQTCASiAoHoDAJRUVFRURHx BAKBQCAq8usX7sQ7wby5O3WCFZ2ELClJmwV48OAPUGu0xV1AOVpG9fcJN2e4ut2J vWP79wkb5163AcNaSUITxFb06klQQ1siXTiaUtUvM5mBgkIfL4aSUH/xK7r9woVp I4WYrl25CZuNXBU7JS7CbldZs39nCtwgrFJPE/YuZCV8w7c9fK/2nWsczHs1ZrUt mE+IsWwlGywbtgh3qI41toO2XHOPgctjgd9uS84TXtxr7orT+lUJPREo4B1artQR FA9iYz6gONh17eQo3KF5kNhdvlpY264qtgN3m2uEfs6WO+Sx4TmxrLXYSBGXtQpj MtnIa8TjbUI5A6ullVenqesSCnrRjJJq5cmkWp6IjThALKTuFxMSi/VtyQ8e/C8w HiapQq5sKzd9go6E0aMhbWZHgyEHSDTV+PhfkaKWkX7vLzrhzx3Lztf8jhkpL2um yKWISLvG3/yvOGnzqhWBsoxjyTov+zW/4Y3TIx5KhEqG1+f+43/NV7IXNRqEFXdR B/Z+Xmt+6dOVohL7conYwG2r8fG/omc9Z9XzNHJvV5xZ+9SyX7ORSCGCJuX3bFqD j/8VQ0BL+pKRDm5AmGBHFWig6qfQl0j99S8ji4//4MGDf8APMqeoRO1Uy4AAAAAA SUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_82"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,159,213.6)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_83",
    width: 107,
    height: 45,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGsAAAAtCAAAAACM1cqhAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAUUlEQVR4nO3YIREAIBAF0RNIAiAQhEAgmSEEkghEoDpHCL7aLfD8 mikLtStq0a15NG23tsg6WFhYWFhYWFhYWFhYWFhYWJ+sIaLWm0SpKMpmFyenr7vq WwajAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_85"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    d: "M158.96 357.38H220.37702V381.424H158.96Z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask_86"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,45.6,213.6)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_87",
    width: 146,
    height: 45,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAJIAAAAtCAAAAABgjG3yAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAZ0lEQVR4nO3OIQGAQBQFwSdOIBAXAYGk0QkEAQiAoDoa1Dq+2Ekw SUHr2AsZWzJddy1z+t+Fr24JsERYIiwRlghLhCXCEmGJsERYIiwRlghLhCXCEmGJ sERYIkqWcvx9eDtbkqWUlgcp8wS7GQAXmgAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_89"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    d: "M45.435 357.38H130.474V381.572H45.435Z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask_90"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,25.8,252.00002)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_91",
    width: 92,
    height: 37,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFwAAAAlCAAAAADqqdGNAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAVklEQVR4nGNgoCkwiKcNiNZgYBCppxWo5mBQqK9Pp4XDs+vrBUCG K9AktEcNHzV81PBRw0cNHzV81PBRw0cNHzV8IA2nFRBgEKCZ2eUsDAwyDjQCIgwA +F8qNCnEt6cAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_93"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,33.6,243.60002)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_94",
    width: 66,
    height: 67,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAEIAAABDCAAAAAANY4yRAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAB6UlEQVR4nO2UobOjMBDGV0REREQgIhARCAQiAhERkRkEoiLiCURF BKKiAoGIiNh//Tav03t319KKdyduJp9YArv8soT5FqCqqqqq6r+Q0WDVUVIhYn6L mLaQm6OkRqvb+03LKchn27VaHPI1aooD9WLahBjoQUwr0yghhhIBtnJl1/gaMSZA wyVYpAfQIb8jBs1viIBvEPNaEKeYC4J6YSUivbpuSRSET/E1gu2eEFOS5rMLiX3Z /1J2V2gKIvfhNSImQQibp2tB+CU39w+Z1yQLYoZjBPd01JZ+mGvY6JQH5rxrQHgG Q8e8dwJGLRyDbjhCVP1V8d677xFUynH+HuK8lHhz4ZcX5YOxb+4VT+zKcdmv/YgC 1kWhVagyWfaCuFMxLeOJrHIBk/e9AVwQTw8IiWcdd5GdQANhp57IW1xBuRWoQ5QD TornEa4BMPKQ+Z+IBgcwKJeLoZxE8gt6GnNxI0SHDflC0koW255LynwOkN/EsgWX WY/XD3LJvodSR19EpoN5g5+IvhTTPHL4eBohxTyR2alIZGtREULmZcnG4HhHQNz9 Qtgc8/LklxjfUTwlBsox5lpLg1R7bZQmZ5I7mafWmfWWxsHkLHuCuGn7OEx9qRzT obg/nPC/yLbva6qqqqqq/ql+AENhjo4KNbIWAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_96"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,26.4,279.6)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_97",
    width: 89,
    height: 51,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFkAAAAzCAAAAADZD/tPAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAYUlEQVR4nGNgoB2wiKcFMGBgUKmnDRBhMKivT6a6i9Pr6xVAJgtQ PYQVRk0eNXnU5FGTR00eNXnU5FGTR00eNXnU5FGTR00eNXmImUyjfjetxgpkGFj8 qe5iEHCneggjAACFP0QQme+sjAAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_99"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,24.6,271.2)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_100",
    width: 95,
    height: 81,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAF8AAABRCAAAAACRLSVZAAAACXBIWXMAAA7EAAAO xAGVKw4bAAADm0lEQVR4nO2XobPrKhDGEYgIBAIRUYGIiIhAREREMBMRUYGoqIhA ICIiEBEIxP7rb4G0t309c+415868N/nNmel22f1KOOmXLSEnJycnJycn/3skwn5O XgCif06/hZokfaEVJVxrPVa00z0ll0bqusKEZjlBhwYvtiel9ILBKMryt/oDVEm/ ibN3REfrQI7LFAzR3m+xsXuwdU40MVYc4FJKtScEFMvL3+qbnST9+yZH4NjFQeIO F0t0qGiciLGpChPKb6pfoCulZpcSFDmWv8Hfsr4N1i5V0e+C21Efd+ivWSAntJtu rt+HUjpHa/9Ev4cBN2Ko2fD0SdG3d3JH/dhcYMwCOWHuMkS24hWl0nI+v9XnUFBi A9gO/Qn8ls7Hw8ayQE4sVxIssYbk0j/W5+klVYrLM1unW0L7qn5L/OKl9Dcc+lF9 LqUdnvyXqbTdup+Tp36bh+rn9NsgJCfDhdCxajtSj+iGPWl1+kyWfDSZoyB87Csi ulpLTA8DFSOuMjaMIp0AdpTwkzlGCLW1aNF8gHo1Cuytcxq9hwwRfdTu0TZ1vK6e qt2v0Ii4bUoBmYMIG74nqYOX8BMTeLVfFXDj8Kx8ZNiJcINfrNklH81RkArwj6MT zhFPVUG7T3OgZLuR1HGEX+wfu62hcQwDIVd0n1Qt99Vj3s0PfYNGaXlasovZsE3B Fupb6l1yxxF+0oPgscfLAEZENNCmarOmz22geejjYwCNVYHi8aoj4xesWlYdOQtT 1j/CT6gFWCiRgOd9X8nqU3WPVukJLOShzxxARKEVdsHQOdMuWuhWAMeyPivhV/B0 dzLoX3MiGd7bI4/LdCj08lzNsF+S7NsnMF70d8uF8q8/OflbpEmylThGohlShT7Z olt2RIw6m+GYjDMFJYFvsfRY7LW+HAXYiaPqo+mVATgNGocECdI5A820wjrTfV5i qgVFXbrnjwQOMNofMYcVx9NS0N6mOD2bXmFRNyCGSCUMOMNtJn1QEuzyC6g5lu9U TsAkk1nkuAZhzaNANF4/m964b+hlDaweNDhr+6xPrXdF/x6nvP+SgM16f8RDSFPc UTC52D6b3mgh4gELOQCaI6Es60sQddEHlT3hSOTzKTFfb1k/FzBK3PpseoPuZXZD 2Rkn0C7rs7D7kPWvxXOORNYvsQki6+eCdl+jeja9s7hnWD1/gVX//rXwmsgxfxsJ WOr8aEpwGL7InpycnJycnJz8df4BMXtFVbdOG6cAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_102"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.59999999,88.8,252.00002)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_103",
    width: 98,
    height: 38,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGIAAAAmCAAAAAAaBxGoAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAX0lEQVR4nGNgoAPQKa6nIcjXAFqRTUsb6uvjgVbk16c70AzkQ63w p10sxI9aMWrFqBWjVoxaMWrFqBWjVoxaMWrFqBXEWhGtQDOQDrWC5l2YcNpaEQy0 goN2wQQCLAwAeoU6Gg3O58QAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_105"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,90.6,244.20003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_106",
    width: 95,
    height: 67,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAF8AAABDCAAAAADfM4bJAAAACXBIWXMAAA7EAAAO xAGVKw4bAAACbUlEQVR4nO2VoZOjMBTGn0AgEBUViIoIBAIRUVGByAwCgUBERCA+ UYFARCAQEfnX9yX0Zve2vW5vdudmbiaf4JHk8Wv6PvIgSkpKSkpKSvrflQvKT48W jj3G6vv8o5d6fjBfulnB19//gUb3xwfTes0os6AOwET5CFNQf9aQVAM6p76lChTC EWU+AFW4L1HcAl+JBPI94Z6/jnwZN8KsjCcNMRuC7ydfqKbaWsJI0hOHbPHC2Eq7 gqeEP9AeEJ6XIYaEe777xY8cBwVL0FT6Oj+rTb3ze+uFU1znBivmwI8B3q915IeE e/4STFlw4/hBiFO4Z/6C8/rOX1x149f8V8fAj4H3bWzgx4R7/tkbLoy4cbBUoia4 Dq7wQ828WLcLl0weuD6L0Nun+kxingM/JjwwWLKvJ7r5WGigIcCwvw3MIKPvi6W+ pwIlL3Pub/7yuj4Gf2PCH96tT4qefdyCfe25VxXfuQ8qLz/LT0r6Swk+RpJIASI0 TqAsDaaSZNdhKMKEjOMjBm5XfLpiqtR8WKo85j/nt1toZuetGtaM73ovmlZcQcqb wbdqtqqN48a502nlRhBTOz54XuZh+fCcrw1ZRdpyyzopS6GV1PwYqTW28JE/AXF8 sabrRif31MmB+w7F5afKtnPgT1chRLbzO9tOzOcdrn0A7OPuKq9Lbds9tduUeoWf ad+pDWXrGnGhnW+ugvsa12fkrycD9vFocu8yNiGmqlifr/kHf2WLnMy4Gw7ErnEr LCcozfUZ0LM9Pe3j/kJDR21LMXX3Ny5/wQ/2WHm/on6kdeYq5+vlwTsWdpiUlJSU lJSU9E/0BnwK22pTMq9BAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_108"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,89.4,318.00004)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_109",
    width: 101,
    height: 64,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGUAAABACAAAAAAmduaWAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAbUlEQVR4nO3YoRGAMBBE0ZUpAIFEUAIyIh0gEEhKoICIaz2BCSWs Yf4XZ9/cxUXSvJhLko5wV1fJjkSUR9m9BxtKH85QUFBQUFBQUFBQUFBQUFBQUFBQ UFB+otyXtVep/h/4LG3eTXrn5H2SrwbSBYOJEYkXkQAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_111"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,94.8,313.2)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_112",
    width: 85,
    height: 69,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFUAAABFCAAAAAAeSPUdAAAACXBIWXMAAA7EAAAO xAGVKw4bAAADEUlEQVR4nO1XIXPrMAz+gIFBQECBQYFBQEGBQUBAgO8CDAwEAgwC DAICAgIGBt6ff7Ld7t1tl7dut9293ct3qS3JsqqqliIDBw4cOHDgwB90AmjlV1t1 Har5q42i2kTXKbK+Ub2fapzI91A0eFwdKTE4L5RBeXSfeSDrA4MP9Z6zl0VqC2N0 wGVEJbCC+SiHs9VtD2uYy0+1UuaBrI9rDz3uOktFi4c6ovZ2g44URJBW2yXGq97i kqxOhjJ/t2o1EPdiMCvcfW08hguWxLtm4m0dm8DN181oyvzdatvt+qrWASlmTaOn yHFtZh+g5uAXDaMETeF0i6uH6jN/04egQHtxfQE78A2o9XdYPfBvQ/N5O4eRTzZZ O8J76pF5b0llSnj0qhqSQmB9HxT43I/3oWx+hVUKuUgxS2zgZ1NiLXxE0yNTpEhz umFOuTkLLm9FFfaJh1mK5XUV5azPH9J3VSYzv9j5XFbU9rRsAsqx1fo5RsIW4y9s 2sVEscrr7BKLEJK3vPhaM5l5thBQqJp018Gp5OuSdmXVNQq2Cjbwxle0MdZmCleU OG1j7JD5MVKTqcpxXAWZydpAMGGyt5Ce4Hi6hPA2rq+w7a7Y9DN3i97f0e2u6PQz 3/XqwE+HCJbA7+6gMcU+zxgt1YUiCqYsJtnjVtXIJ1LOXBleZibatlBPtdzui+0H zti14w2a3Y31fcY2zKZQnAKxCFn2AV/HirdWC1eHlzl9zViojavTfVG7h43awKnO WT9x6HhXnsE1ShVqnbhnyWSSPWyV0rCf6p8sApc07P8N5nNWD/wYXMfxGmNsXOcd WheUGEVjTiP3BxgGuiQRXIW+4mHgLtq79w+FXIWUOSkvCE2NM6Fzi+BEHRvO0Tpk EbNU8+vzWfO79YFm95T78JgT3pqLd5wSzx3fOtLVIrq5zaI4x6c6NiO3D9c5vG+1 WiGKr1zozitffND3i4wVKPmKOYuKr0vFVl3zSGNup1Cl7I8UHfzkeknCmHMI3GEN M7VJdIurzg1Cuhk8jPiBGvc4zJdfaA/8V/gNGzLSEBcfCAgAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_114"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,89.4,277.2)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_115",
    width: 101,
    height: 65,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGUAAABBCAAAAADtKjUzAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAW0lEQVR4nO3ZoRWAMBBEwRVICkBGUAAiBaQvRFrnUcTlRcxvYMS5 22RN16juSc53ltfT6pE5fqXVnoRCoVAoFAqFQqFQKBQKhUKhUCiU7ZQFH/g1a0Lu 8mWkHx8VEob4WCITjwAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_117"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,90,269.40003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_118",
    width: 102,
    height: 94,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGYAAABeCAAAAAD0nT5+AAAACXBIWXMAAA7EAAAO xAGVKw4bAAAEGklEQVR4nO1YIZOsOBBuEREREYFAICJGIBARiAhEqhARCEREBKIF AhGBWLHixP316zTMVb2avX27s/te1dXjq1nydXfIt8mQng4AFy5cuHDhwoVvQiMA KvnLZYIDWNUvl1G7qJNcEFvZj5MG4RcLMi0OtPcGbtEJ6UAOIC2oge2ndIKbjJ7B eL1XTQJVAyqyJ2Ot9dUCoSdLI9A1IdvPTWfjIUhmBtgB+vCi9RY3GRrr7eLDoF9w LX1cj2w/JQOzO2USyAztALMm2/WrsL4dqcM5my0Csv3UZBDFKZPT2kGzhY1m4xE9 WC9wnJpTZpeAbD+pdKIs2m+AenLRL1x4hJ4iPfYtZTA1SbA9mBqaFkwDjWEqXLpJ RExt9OKIGqZ9SWY1xpaH4BuOsBziwyNaK7UCjJRGblsPC4K1cqd9aOnD1AVxo8Sg 7SJHd0SZuhHYho2H4BuOcGhLivoR0s8ZAKX1fY9m2KhnDCSTMVumc126kYwFMx9R prMu29emZeYh+IYjbGb/IEOZAim/UBoZTUyaZFZn77MpdDKnjIPWH1GmdGM7lX4p lSHO2ZRwHcWDjEvTCnnHvOeqQ0jKJvhXptAqh8Aya9wqYBfTaptQkT0uQxnilCnh VD8uGqPkLmvef1ZokDfop9DSX63f73O7vUUvXPgSqEzzVH/OoxILdqUFkZZBMJPO UwrgYPF9QaYJJTdssl712ZYaI/QHe23q9R4M7RdkXE8yHU1o12dLdcy8uoMhQD6C 5PtKGbwokjETiE2fbRm8XQ62gcj3YPuFsmR8RXwdIM3YlX+9tFRa+8Uw0y8JLTvZ 97wMDf1OkVaUvwUlNcr//G5V+CaZC38uqjm03nvtumToh90L7aFtVChHmBFHzT46 OA38GWXjl1L4MP+EzFpXuuyavZdZ3sDTLuxWsdaSTkw7tAGKb+eNtUP/l94E1wXM P64it3LlMWBujM8e1N8dlVdkwR4yFZfk2ylFUJcqofYhsUzhH5cR+S5Dx716K5XU MCVKY7DokjMXWXznbFChjuaYTeGfWLSwxIbHWOIMeURfIcR2wEjfR/bRse+UMYB0 nD9kiH9G5o63y7lvR/w9Mhf+PChf3pV1cw/aBjqEFgYdbXHnvWOXHFMHfQPlDdog 1ZIcsEv3IHtN7QD99LO3L+W85+uZSjGzV21kViOltbL/2KUrkZXa7FijaCP1TzW7 iOmZLohUU/2sSmAZl3ywxCAzc65EjjMnZHDhVcPwKgba99lsEQW7zAuuJOMHVPHx zPmWTFdqLpOodGHWD3eZ4iILtVhSawc6q1J/17HrmE2eNeU1+aHZiHWkvLzH9cZM bWE5F41cZgu79r3Kcp3Wptn8UrHrlBEah/ani/aD4AdcX0b9WK2+4bpw4cKFCxcu /N/xD7xbJVG3PmFLAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_120"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,88.8,357.00004)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_121",
    width: 102,
    height: 49,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGYAAAAxCAAAAAANP4PxAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAYUlEQVR4nO3YoRGAQAxE0S0CgYxEUALi+kCcRCIRiLR+iGthY/i/ gTezcZGK2t9094R02pXMJvW8m7fJdPNZYGBgYGBgYGBgYGBgYGBgfs9c4W0yJT+b o4DZvulW82YRiwZUWmEPAYV2mQAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_123"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,88.8,354.60005)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_124",
    width: 105,
    height: 58,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGkAAAA6CAAAAACW8yi/AAAACXBIWXMAAA7EAAAO xAGVKw4bAAACBklEQVR4nO2VLZPbMBCGFwgYCAgYGAgIGAgYCAQIGOyMgIGAgIGA gECAQUBAQUH/fFeym8zc5XrXXHugo2ccfXhf7Rvb8hqg0Wg0Go3G/wgL9ItfYrVo 0Msx5rVh1Ej2zrK7lD+MP0jAzxCHOeKmMPtLD5MPDubgIvhlE330iaEBY4DagHUO cJf2m0fIIHKJiPztbPvkLrwmeHVRp1SzKLQwIZ3oL4BWJThDEN6oJNEpV5zMhnVO TjepV9RdmMh7JAgIkmI1wauL+qEPJwOjh2nFK2DAyDKtSwsix4iRnFwyWOcAd2kS lMLmlPcIOdEZ5WuCl0bjGQ6n1K0aohrISbHNIq2zM4hfd+/KDdY56W9SN3flqkTe I+SEMwRdErx8gDIMAGoALXCJJ4AhWAMScXIMdMdsmhlFhwGUhEHVOTndpGxei1Nn 9ojugNk4lQTj29uJ/vpH+QPpI8Tj/fpJaeO39HU3fgWrTn/3qXXdGwGm+k+kVQg2 lD6X6nAK2Si/ZEjXbeHJbXxyVOv8WMbTIX3aSeawO1J1WIby/vCN3iMFdlHesvO4 6VzH8ZA+6+SyvjtlqkcyUTksTlQEUcLqrt7V8XxIn3X6LtXNSUaqCWj47qRX4B19 0TJ9bMpYH9InEboc1CuqeI6K89D5cgcVVe4pLt3YAxVHWcbDIW00Go1Go9H4B/wE N318PEk5roIAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_126"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,25.8,310.80003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_127",
    width: 90,
    height: 40,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFoAAAAoCAAAAABbKbIUAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAV0lEQVR4nGNgoCHg8I+nBbAAGm1STxvAw8DgUF9PfTdn19cLgI2m figbjBo9avSo0aNGjxo9avSo0aNGjxo9avSo0dQ3miZAgGZ9mWoOBgYWCwdaAA0G ABc5KzKvGLBKAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_129"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.59999999,24.6,306.00004)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_130",
    width: 97,
    height: 58,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGEAAAA6CAAAAACFJGhLAAAACXBIWXMAAA7EAAAO xAGVKw4bAAACKElEQVR4nO2VobOcMBDGPxERERERgUCsQCAiIhAnEJk5gUBEIBCI CATiBOJExYn+690Enujc67TMm4pO8xsmtzt8uY8Ne3tAoVAoFAqFL3Lb/rZDnGpe iWoYxZ9ABZi8VmdIGoaIKkUCUKRT8qEicyhZlb+mejeoRjsA8uE3LDPsy2AH7UC+ crgMQbZh889xmCBGv/acyEO10nKKl/sQsHRz9+ZwJ/FgnwGRq5FhIOxyXoEn8dYU VnOSUcATYKWg4Dg5VRuFKivNlOwitfHN4RHj3qC3iCLa29w5PCYTT4cU1uPpkB4Z am0Ph0O10WizMqnWZqH3Y2r4TjuZvaHNBvG0jcer43qOU0qh2JpOJYfvNzfDRBOz w6HaqPdZySqXpPlt/AS/KYhb8AyX4oQm3AAHdOnKofGcqha79RKwvqk4+VD5TmQl q3oB5b3+vJ9Cbqpf91tm/839r/NJIxb+XYyA1DylSAvDnQtNPKxqnkyQxKHg7hZp HqXF5PQqvYO3evMh6H0Idz36TeqliQZNnL2ILjY6QEde+BeW0qsOKmIVvJ2C5jG3 8ZMvWi80K3TW+XaiPnBq2cFMMaeXi1hoxOHAe9cqNtlhIoTKeRuIzOEwLTLm9LKD 2+vT4VvbD3Yyj+QwOlrhvNqSQz6lV42Y08sOkie0bKFbHTqeNF3fSNHzZHKK/4bS 9FF8Vzhpj5HVq+s1+DPQ10/4z9DyDMT1+guFQqFQ+D/4AV5IfSKzjNZJAAAAAElF TkSuQmCC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_132"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.59999999,156,271.80003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_133",
    width: 116,
    height: 49,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAHQAAAAxCAAAAAAuZNIkAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAXUlEQVR4nO3YoQ3AMBBDUYOCDJBRCg4E3D4BGaGrV4qUAUJ85P8F HjCzVNIT6S2a9H7uQko7mhu1zgkKCgoKCgoKCgoKCgoKCgoKCnqDWq/BjY6Km65P s7m6dc7TD9kPgYx7GjzDAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_135"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,162,262.80003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_136",
    width: 99,
    height: 81,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGMAAABRCAAAAADj4kfvAAAACXBIWXMAAA7EAAAO xAGVKw4bAAADf0lEQVR4nO1WIZPzKhS9AhGBQEQgIhAVFRWIioqKzFRURERUVFQg KiIiEBEIBH/9OxfS3f1mO6/d92af4syWTQ+XHKCXwyWqqKioqKioqPg30MaY5ncl ZAL639XokiHWkLutIGnyorp+Q6S0OrTikxBG86JFCZWGyKi1+xX2SbGGDnfv6Jjc Pdmjd3GgfglL3PIqTSa6FBsR06aE9okwTOXulxrnyME0zOaYNEaqZCXRaaY+aREG Gh0mzsQu3O0OMyih12QML5+7X2JyWcMF51xbNDbz7D3xTP2YX5KJg+9vFzQl9LL+ jO9o6LRd18HfisbV0Zk1tIqn/JJMnFwXg3JDCS179ZZGzirA6gV7vmr08R5YI6Qg 80syMV7Iz3S5UQ79gYZKB06NxVJjjCTVIX0aZE+joSHBUKt5tSBaRfzXUg6VHfLq 0f1Kw/A/b7938Ux/GzzTioqfQSC5jYLt7jUfiT2Mlg8Ksv8rpfYwL75gcEAoW22P cTyWzwUH8ihRnr4Bx5lt5Bbu6aCS9+kk0+zCSH9R0fmlcfABl6y4J9jCeI8aY/l8 50A2Cp2fnmmcbhMujw0NQaUzXSKPdONfFAzXpA4fhc5zZKMxG9Y4mZt7BNp1yDON FHdkcXn0ieNKC42vVHNdJhhB1hjiyBrTNLX51nCfgeXp6V4do+x4uzxP+jZ/rOOT 2iW5eWjAKvM6KBzLXj0C7TrkqYaMB7qmOe4UHDbtVo2vVBvv/qEx8lQl1hHM+nus gXYd8iyvcEu3nBaK9Ywuhst59UkhlWQn4LNCIHlgypxjIke2ugSKfJ3z0z8jz+Ul 9d8gvpcWT6iKih9BbrbFc7U88PnQ/VZ0Oh+HZmsVmj1XuUxn7+0UtyhQUB2/eefL sPgjO9DNLz52tF9cuPZRTheSyzzHzoYBZWOmYU0oYnq0bRxNuk1v1i59FAKlmsd4 FLgj4WD0XkBOUh+EWC7W03kuNGJQjEFDzGnsF/FufTROufV5jg5l4MTV7phcJsHY 6JarKLTNZa7FNeLGZsLzexpDbGRbNDZNONPg6OQlnLzjrmY5YR06dZn+2CsUvqNO +3fXoRY4bNFAgdvSEdP214mmCV0hzHKH23ASmf7Q2MKir/79WlLyLY4ssqnhCpaL 266D9Zpc2bLNmrXm7R55xQ7cIubHtaT9Pwpc8/saFRUVFRUVFRUf+AOd5kQ+MOFT ogAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_138"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,156,301.2)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_139",
    width: 117,
    height: 51,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAHUAAAAzCAAAAACMbhgRAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAaklEQVR4nO3YoQ3AIBRFUYao7AgVHaG+AomoeCMgEQhWhxCSDtDk 1dy7wMnPcz+EfzqbuXoMVW61xanmy1lZqqyLZlRUVFRUVFRUVFRUVFRUVFRUVNRP apGzOtXH/jO9h7on66lS2qyLvnULlodZ1qgc4QAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_141"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,160.2,295.80003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_142",
    width: 102,
    height: 70,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGYAAABGCAAAAAAbGL6IAAAACXBIWXMAAA7EAAAO xAGVKw4bAAADHklEQVR4nO1WobPcLBBfgUAgEBGIiBUREREIBOIEMxEnIhAnEBEI BOJExJP957tA7l1fp9PXXvt9M53hJxh22eUHy7IA0NHR0dHR0fGvISmAzP9zmjnA GDgiSi5mJMU0S2BmHkAgCpA4AJfAa8sGGPT0Gk+WHtHj6vBubhbQTBlITsI6r0WY okJHCqDWexp4e3E7WypTaEeNjADDcgBGF9g2On0JLlxI8oVG/wkNZPNOM0RYPNbd BJUY0ayInCRLNH6Xnu32NRrpMjtp3vTNgN2Wt0ITbx6cVglneQbtTUhvLRwv0XCU UI5X0GwaSbFMAzDEYWYgKQXM/G0KKA7jSzRP0KI7Ov42hACqmaViCbGMpX6dBazJ MM+CshoHsuOSW6pz1BOyedCVbbafQmuRQO0YJ31f9kWv6HUVocqTniNz2S9aQ3A0 msmDrnDzCE40289pgke4TjAEcleeGqerCFUGpTMAmWhtvaN5SU+Ne3g011+gWa8G NoTh9qSpYqOhWpYazbZh2U0U1Kzu4dFcfyVoLLNpx33SeaE4FJoqQpWvzpy7ubNK k2UNWvMgmmb7KehABwaDGUAbMxaRClgRm8z0SN2BQ0sBevTOFCgm1INm+xsoa/uZ 3NFBib3D+Taz9fFGr/F+5soWM360Z/QJo0rFlVwog/VYHl/K0lKjAC0ZFx1VNCp3 teWTLsnrsyIaFzZQGM+pePmfnNDuI0101l4PJ+5e32HF28TuIsmbNnTlEzpXdbTe WFY/foE0rWXJnv6Mh9jhpurQCfqGVAjc1QcWTje7/sVopqA4BvqyHIYTB02QHV36 ojuco/GDxwThpJFBHSLDLr+hYUm0zuj2j1etTPhOM+ZpLTSXkyah8azoDqR6DIcf I1h/bTQqHGCjhScNC88D4ffvgqatqjReJ3ZMwbHEkkx6iSVodqu6M2gWositJngJ REOHygRm+h4Wult0ji1U1sSG6/ZdCugZGAXyUIaO0EgpBpCSLQujA0eEqnumAH/U LwZCnTSULhdTQkU92FQNGsKP8drP8YH1fdWXP5qno6Ojo6Oj4//CV1W7t6UvwqnF AAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_144"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,696.6,301.2)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_145",
    width: 127,
    height: 47,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAH8AAAAvCAAAAADvWEo4AAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAYUlEQVR4nO3YqxWAMBQE0RSDQCAogXMQkRSASAmRT9J6PoYSRmSm gSvWbUp450V1DD5/XHf3C+g/0y/Q8FVfX19fX19fX19fX19fX19fX38Bv0L3Z0z/ hf/HPTA+Nmj5vwa6SZXG66ZyFwAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_147"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.59999999,707.4,283.2)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_148",
    width: 93,
    height: 109,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAF0AAABtCAAAAADmYDKyAAAACXBIWXMAAA7EAAAO xAGVKw4bAAADDklEQVR4nO2WoZejMBDGRyAQERGIiIiIigoEAoGowCEQiApEBQKB qIhARETkX7+ZSdh779rr7XbfnbiX7+2+DpOZj1kafhuArKysrKysrKysrKysrM9L BNTlb7mfgobQY2A0QGEMfUij8LayNCUlTBETSuBKBbFUYEIfy79XGwS5V/vmR+jp DzGdWzHTby5Y/TNhwl6UHmfh0t4ChEby8gv3wQG5Tyucg8AeGYws4LpA75XERzYt ODElGmtPzRrOsXRkd+DlF7rf2H3FIXxyV/Me0B377cTtnOi3abxdXBtLR5r6j+4K hyH3eaWr6H5bqKl3Uvg4OyfG22l38p5K+8/MLnxgnU9+W9bkPrmroyez705wOyfm qfArLBNw6afcZajpa8c62bQVSI3bpizqWiq8U9VJgAo3ByeUBFXRD5diJRgRl1+4 S/qgKX4VTfdNFXG3avHkxvrb7ln/nVRZ0b4QRhIWTUkQNJyIRCxxVdOmplXBjPzI cw13pfBBFokxQ+02b8AiNSyCEfd/i+/vAHjRBNju1mPvHhA8mKEmzsca7krho/tS 9EH4FuYbt1qkbJCFHwjL0UVBgZwswhnfeLv0JrmnGro4wkf3HpABhJk5ug/7FGSF L64JxlIe2iUg4nSQ5H6f/RU4n2qo6wgf3WfoggxtuhNYP5sgSxy2TrMLbEX3YSda YeZq4+yphi6O8NHd3cMVJr8sQ3S3JbrD4Bc3Jhe3rr6/4ADkbhef8qmGu1L45MnU NWJGX84laNw3+FsSd3Sn+UIYEB2yURtmoeo7deRjDXel8Nlz/4viO2dlva+ETKYi c48JyGg0Ag8OChJEq9dnx+ciZI5MxUq6BeF0t3SwY3JOCBcbQ4kvJx9rv+jOyCQq NkUBN+ambRM5+VASQ9/BO+6ETENUbOgwXCNY3K7Ajm463Dns97dmJ2QqoiKdna6e bkfkZ3JGdw6H/fSOOyGTqdiYbXARit1BTnanUOPR9a0nQ8gkKgow9G9IGVN9kJN2 EoeSLr5OqIzMrKysrKysrKysrKysf6EfiZAZJy1xYmoAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_150"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,697.8,333)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_151",
    width: 125,
    height: 25,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAH0AAAAZCAAAAAA5jn61AAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAWUlEQVR4nGNgGFDAEl4/QCBbhoFBZ6Asr6/3Z2AwqK93dxgIUA61 XWBAojx/1PZR20dtH7V91PZR20dtH7a26ygMBCiG2j6A7TqJgbPdGRj+IgMS7iDA wAAApAxd9RDTZZYAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_153"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,716.4,325.2)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_154",
    width: 64,
    height: 53,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAEAAAAA1CAAAAADU7bJwAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAA80lEQVR4nO2RIbPCMBCETyAiIiIiIiJOPIFARCAQFZ1BVlQgKp5A VFQgEIiKiP3rXEPAUBTzzJv72sl0d2430zkiRVEU5S+wrf0q71sc/Rf5AyZ5OmJL hkUHZvcUG5aPl0Pk4nve5obBDQISDZAMgDNVMY/X2b4cov76XhDBXF6kPSQTEM7L eBGePHbVGdrtaoHNvaRP2eCYe8kkmGW8iE03A6k6Q4dmrYD2MoTbjoA2ScHvSMt4 ERHRI1Un0dSvFkhF+T+Mcjt1+CnjRbg8XXKuzmXK2w8Fho2cclgmLwsNoQpy7CI/ nLgsZG0LiqIoyr/gDrlxSDfDofIHAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_156"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,237.6,248.40003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_157",
    width: 110,
    height: 44,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAG4AAAAsCAAAAAChoNJAAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAZ0lEQVR4nO3RoRGAQAxE0UgkEoFICZTADBIRQQGUcOLkibTOHYNE r/q/gTfZmImb4hZ1zZ07UtbZucimOa5lvFzRfK3AwcHBwcHBwcHBwcHBwcH9c9Ul 1Y+TNbhNx+1j00Wzpftq9gAWS2TKPoCFdgAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_159"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,244.8,242.40001)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_160",
    width: 88,
    height: 67,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFgAAABDCAAAAAA9752wAAAACXBIWXMAAA7EAAAO xAGVKw4bAAACVUlEQVR4nO2Vr/OcMBDFVyAQCAQCcSICgUAgEIiIzEQgEBERCMSK EwgE4gQiYv/1bhL6m2un31Z18hEMm328y22OdwCJRCKRSCT+jKqAOv95OVc1QD9P 3YeNzdqcN0+X1MPqLJL+qHFpUWe3xoIG/lyXV2uDNq+whMFAviJKuIpRg1jhsWAP IHAVvFysj9i8JDfG+04lT4MegnbtjCDxcAc8aNoQrsIg9wsnRxKlW7Xk5dEVsXlJ bowXpOwybsCysD1eB9eZ8cahMHsmaSClnByID0qQOeXVvCR3o2jpAaDJ7wDsLuhA w15PCMahaBwRjWysKul3Icie6mpekjvj7LW3yi0sxO60gl6FOVq3qu0QsfA6/kYk RVc2pNvRj4Kq2Pwq+Z4CG6iX15MPVtByLmWNAqTFAxFfJhZe1yAMT7eWoPe9q7HO sIvNr5K3+FF8BhVfzM1hfwTex5d73fJlHP+NcSLxDTW/DJxb3cq/dX+PdTHjUoPQ AyeiX+hCXdiZf4i2iFLOO1i60BZvjAenTgOtayeX96Qm6jstnhu/xjiRVNupdKgF nZxu1EbpSACkMt+u3xhPGxwG5kPNJHoK2V8NGBIOdgM+CWJ92kkurzFKDYcSKYC7 oLjYtTe2B6dXHo3HUwdjgGcwjrU8uh37TUfp+FtjTbM6t0q6VvQQjc1eBWM70uif jPWEmXPFYiBI+zCKXxnTxvM/Vab3c/EpxoFXb7u2bDyfJvPZFWslYZpBThCkrAR/ 5u+jLYRaiLMf8Hv6G9bKz+PmH9zvKZFIJBKJxH/DJ/hL2Zk//H8vAAAAAElFTkSu QmCC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_162"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,238.2,276.00004)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_163",
    width: 110,
    height: 44,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAG4AAAAsCAAAAAChoNJAAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAYUlEQVR4nO3RoRGAMBQE0RORCEqIQCJSAIIOECkAEYmIoIDfOpkU cYPYbeDNzUneUr1tFWkPX49UIppn2xt9cqvntgsODg4ODg4ODg4ODg4ODu4XnK3B ZSPXxsbtdHUs+gBvbWgkDMRF+wAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_165"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,250.8,261.6)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_166",
    width: 68,
    height: 94,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAEQAAABeCAAAAAC/Ne2TAAAACXBIWXMAAA7EAAAO xAGVKw4bAAACPklEQVR4nO1VLZPbMBR8QEDAQEBAwOABAwMDAQEDA80YBAQIGBgY GAgYBAQcKDhwf73vScmd7/Jx7bQzLdCOR7ObOBtpbWkBCgoKCgoKCgr+Pg49wNT8 oUl1FvIEiKhB11YC1F4DdNaAQFQgLQKYjyvpO1OxfQ8bdgFehmGGymPUpEODofdi bYKDFfJlz1nfmUpcK7pBBb7xBUA1K8LZz8o6JEN/XEh5NtHhlPW9qUzwbnICvWBA msnojoZMJl7ThkjfxVWes76Fj+Zi8jr6A5i1iWxynCKgF7Ft8bKcN5pg1regRDkx oWHFTpDutKSgjalAcrCd/Ai2zvoZ1qffFvwjKNo6Qsmet4YVoAakx2ic2jPETB7C 97govzSbsa2bSDYRXMBo9gxFIo9NEIKiwXlAt4IP4wirgMbvGE0kke9N+uBol9C/ bvwL63csm9jvTKKL1WyHhUzaCP2EUe0YmSTyOFgJWvjWaQpWaw6RD6cc55Xxjqmf BXudTsEOqr13+v4ehnl4/Cb+AqSl4po1JlrT4OpcQqxURY8+McHHYxpo1q347CG2 tp/Mj8NxglQpInYHwyWUlLf0Eiam+KxW3Dwq0j77bNKM1DU4cVdwpYQmUEB89Cdl B1hUYoqrR3HzVOuNSUsmJz0DbJAqhXU2YSXHeVOJKa4exc1DjfnVRJw6T/u0pSFV itiag2GTa8HQcpjl5bzWcDaBPvsSbMUFnVs6VUrltEgldCmYFGwn34Otc9gFBQUF BQUFBf8nfgLLAIgfhD4XEwAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_168"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,238.2,302.4)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_169",
    width: 110,
    height: 52,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAG4AAAA0CAAAAABOJVK2AAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAY0lEQVR4nO3YoRGAMBAF0RMISohAUEo6SAGIyEgEBaR1DoYadhC7 DbyZ++4i4LaKVZK7JtZIjtPm+XKVWa3JycnJycnJycnJycnJycnJycn9hWs70vFx 6MdvcFxPbmVO+bTEDXG0el5bx0PxAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_171"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,238.2,290.40003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_172",
    width: 112,
    height: 94,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAHAAAABeCAAAAADeLc/RAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAC5UlEQVR4nO2XoZPjIBTGn0AgEAgEIuIJREQEIgJRwUxFRAUiAhGB iEBUVFSeuH/9HrDd2d27nZvtTTt3c/ymw773IPkCffNtCtDpdDqdTqfT6XQ6nX+I qAGSeqKgjiA3hoiSywFLAQVQLoEjRQIVcAXsNpYcoK4HSvQdilEfR8w+ery61YM+ jBkw4K7mGK1IZtcYQAaqgQ81B6jrQexTnO/Y4lYEwHoaeAZQmCWGKbBlsHaO5Umy X4ogrqHm0NaDm4HlO7a4HV4F6XqMVRDXYWPWuiOdK244keC2qVDzN4LwdUExn8WL 4NUuR5hP5loE42kFa/WO4+1IvykZan4T1BmXrx8pP9ANqCEEqcwT9cM8KcZmpy0H IUA6y982Tclf1tPpH+5pmlfosTsdFHJ4qqBZI34oSXJBpnhxRI2cV0+kABQHSR8y xxKJ6qit2GZqTujy4Vj/CEGeSrWB0hbV8ntC8FmGaM9qXGyS/uKxBBAQPILDpAOy s7VxSqIV69ByIsF4geSOnKKok/MruQ2uY4vq7AdBhCBpmN3u/UXSEqgBPUhCECaI gKdoM6MVUIt1qDl6B0nGNMRyp8txwaLGIJs4t6jMfiqYy+EWwRoEV7ZCtmlCOPgi aEmwFOtQc4kD7Bv9w6gOkW0sVrGTIPq1RWX2l4KbyXrxOJdDgBq0I7W4TiGBt34x 74605cT3EZK4mIOgK5cpj3Vr6H2LyuwHQWoBxcLkqWmQFOp3XILWGujHl6Yx8/um qXlpkHKJdPVKLsVsqDb6AVo0/Nw0t212/hc42qfquc2bJ8goRYagitvuUkNzSU3m QNEfvVF8ymU5rnwxZ6UvSwiQLLmkDcmzbVzveA39PTvAlUwu4FBdJNR3QfSAuz9t jxAkczorMm2UZNI7HusjFMGI+JAfId8OLg4b7ghpdCvLprgkCfI8GnyEYDKWwWTJ Q3kxyOaSvPx2mZ14iOAjbtrpdDqdTqfT6XQ6nb+EHzrQrIE8LJ90AAAAAElFTkSu QmCC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_174"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.59999999,316.2,472.2)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_175",
    width: 107,
    height: 49,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGsAAAAxCAAAAAD4wQhBAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAZ0lEQVR4nO3RoRGAQBBD0QgkAoFAUsAJSliHpAQEgiIQ2zoHQwsX wfzfwJtJJGP9kZaukIqHqpi0ZK7Rvj3ztQbDVYGFhYWFhYWFhYWFhYWFhYX1E6vM 7ds+y5Q0uaizLjkaFnzqdAOLrG3eh4qaPQAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_177"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.59999999,324,454.80003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_178",
    width: 83,
    height: 109,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFMAAABtCAAAAAD4qQIBAAAACXBIWXMAAA7EAAAO xAGVKw4bAAACzUlEQVR4nO2WIbOcMBDHV0REREQgEBERTyAQCMQJBDMnTpxAVJxA RCAiEBERERH71btJ7ipeb0rvzU2n0+YvAuwuPzZs2ABQVVVVVVVVVVVVVfVnpUlv RvZIejN0Qq4TU44KoElJM+imls5lOwpeZpEMXEuaFDlyaNMC05w/n+TiITE/ggln WFPSct0NjmCsj25MBpENU7QUiayEGpNuy5MUPzG3NTP3m/4WgCIHlBS0LWAcV9iD WwCy4bpFdd1QllBj9SlNL7k/i8U5M50zBCzMyW9hSecSh3xTNtyWdfb9I9Tcy/CM eYpNyfOargozzGCJ6WWPH/mmbNgugw+MMs+hZe5PmfmFpCd20dpHnqu3npgBcSs3 ZYM7CVzATZBDf8EcMFUuzUhqzVM1OdVdt7IhvqRTUFTtbFACFAcac2ip+939mZlG +WyBUiZvV9O+n1n1t4npgStaqq3mJ2pQIKeetyqvVvYxNslPyzFdArTN3XOA3ON+ cfRBGXSOmpIKxu8DdhdLLmex03jdA3XFtMTdUjwHGlBR96EvQGMHmwHG6UJYR1d0 pL5HtDEwjZdZp+8xew40YyFDymRxII3bUc4YWHYtTuPmjCDmN9TEzJ4DjdgyVZgj 21eYAhux8SueyNiANfQsjj2NAge3sOw5kKB3eS5Mj5HaPhqH1yhunrEtuqAVbrun PLewC7dM2XMEZZqqLTQxG91A6j1ctw1ZqO5ai7y9sjzmuhfPb6pU9r06XnZV/6A4 tR+W1imkLTH/DglIB9pT545BMbymARfn7rspzkPa+gcY44ZD701YoRheZcI5Mee5 zUwiD3Cx9JPDqZtEajbuRWJiGn9jxFxj84N5uxGztbvDLzKhRUWjwu7BlHEk5nWH 89eYPfWjXVC2wbIHEy0j5hiN/xqT5cZTRiVT/bVQLP8aNZo6LEj1MrOqqqqqqqqq qqqq6j/Vd8Le7ZydTguKAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_180"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,315.6,502.19999)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_181",
    width: 108,
    height: 31,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGwAAAAfCAAAAAAnu3d+AAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAV0lEQVR4nGNgoCvgsHCgD9AAWmZTTy/AwcDgTzfLBECW5dMjtgxG LRu1bNSyUctGLRu1bNSyUctGLaOBZdXxdADZYMuc6dZI5QG29f3p4TEgMKFHbCEA AMFKPx6OVR63AAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_183"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,322.8,494.40003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_184",
    width: 84,
    height: 58,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFQAAAA6CAAAAAAL/iE3AAAACXBIWXMAAA7EAAAO xAGVKw4bAAAB40lEQVR4nO2Urc/bMBDGH2BgYGBQEBBwoCBgwKDAIOCkgIICg4CA gAMvCHhBwMDA/vmdr+20rZPaSdWQH1lp7sO/nu2cgaampqampvcrzIAr76YuAxJf +TjUnxj1b+hnXH3BwetQt8c155m6DRK48BZ5mfaAfC4TuEwrFt4jLecFTOBUn0sy +5VSs00rkQecxlqbgPNxgUCiYqTjTKVCsySzXyn1O92gVDfiNHOF8uwqVAYir+sQ heY5JbOfM+PwgRu0HHSD5dArlPx2GRU6ndDdl//pUzL7uYh16yli8Fpe0sL5NKiT j6ND8i5zrlHq6ug6s/9FWtD7FV/YrKb/rFC72Y4m2Kgur03/62l5a/Ouej3uWXfR IzMKSgft46xvkFSE4+e8TuYCeinsV70OFLXz2tUkSL/zuVgMQYOjTvodug0L+gvw NW5Eoh+7utQyFzBkbYlVm6xm0qWPO/cQzYvFYqjXJRH/UemuTVidm+bzFarVfJoL mOqE87wZNM1HJc9fblCLBWF5hArWLmyBxJZv0G9HWsylIEccbpWKXl1RXElXqMVA xS0PUJ/QE3oevb4hIRLiR+ZoLiS1qO/1OtBlMmenjxNSTPCDxeBGTjH+5bAez+79 cq9caU1NTU1NTVU/AAx5asWNHz4gAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_186"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,315.6,520.2)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_187",
    width: 108,
    height: 51,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGwAAAAzCAAAAABX1bIzAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAaElEQVR4nO3YIQ6AMBBE0RGIygoOgEQgKisQJByAoyAqK3p1loQz jCD/X+Als24lb+thac9h1WGqJ+lyYSO/2O04VgEDAwMDAwMDAwMDAwMDAwMD+wnW FkPnhxkfZZvLalOsOTtWjJIekZxyNRLxTEEAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_189"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.59999999,327,508.2)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_190",
    width: 71,
    height: 93,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAEcAAABdCAAAAADSliQ+AAAACXBIWXMAAA7EAAAO xAGVKw4bAAACK0lEQVR4nO2VIZOkMBCFn4hAICIQCEQEAoGIQCAQqUIgEBEIREQL RMQI5Pz96ySzdXtXzO1O1dyqfEPC657MoxmSAGQymUwmk8n8FEXP3fAGo6NEs73B p1tgG01Epda0CihHDSetxkRUFHbT0DW0Cv3QxvhJQfKAUbDSzFg1KpQuxAd/SM4s So6M5lx16hg/KegcHz58TYN6NQRjtyX6HIvZKmMNsU/rRh3jax9xiocP38oAJwXF etTKPrbhEY96fKN1jC8ZbxoPH/6TBEa/7dy5zVegsvIU79L0MBO0jvEX8PC3wA8k 8wJNV43v8BGzlS8Mn2grMJutjmqZeerChuN3h8ZRC0tLEtdUGEcQuimqU4lbgRPT /aMLhy/EUfA5iWsfve4Gnmd9VDyY7+ZsVnp0xtzDyoVV/FUSlzYlYTBcT7VFdUq+ JrzjRRa7WI/wXEnJMonrehy5CUSuj+rc/QzcGnZOHcIxeD+EcxLf4fzWqK+xb/LJ /AeWUhpUO43o+TltCnMJU8vdxQZNrppH4vkU8yFseQ9vg/jDh+TSYa/h1ExVc/B0 lN1dUS1kaJDglcFvEJXyIeTfAEl89tl5nh+8w+utN0vPLxq1W8WJkATUuliS4Z0T 8yGMPkn8XQ8vp7UlHCQc6CjZR6AIDV5UlhTWJuVDGH2S+IST5YHOExeCJWweruPl 3HvqQuMNx1pytCPlQxh9kngNemVL/Afzk10ik8lkMplM5mf4BdYtl4Vg5so/AAAA AElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_192"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,479.4,243.60002)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_193",
    width: 89,
    height: 38,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFkAAAAmCAAAAACKFGhnAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAVElEQVR4nGNgoB2Ir6cFyOZgkKGJwfX1CgwK9fX+DtQG/lCTFage wgqjJo+aPGryqMmjJo+aPGryqMmjJo+aTJTJNGrl0q5lzpBOE4PzeagexHAAAP14 JaBcNI2vAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_195"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,481.8,226.80002)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_196",
    width: 81,
    height: 95,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFEAAABfCAAAAAC17nSaAAAACXBIWXMAAA7EAAAO xAGVKw4bAAABj0lEQVR4nO2UoZKDMBBAVyAiKhAVCEQEIiIiogJRsTOICgQCcQKB QCAqIhARiP3124SpuLbqGnFzs08QZnfzSDJkAQRBEARBEARB+HM04QSn0Gii+aay GB2VUJJzZFvq8hpL2IZMxggblzVUmYxW22i8+akATyGD8bFrQxZqXWc0wrp8bItU qEBhFYcGsxiF/4fa+LJdchrPhJowp7GhGthYjMRPE7uD0RvtF3DrTL6KAZsC590X cN/PR6kjgB1PKf1kbElF42VTlkpHsTvUNQyer2Fn9k5Pmz6lQEOrrT3PT6XIRp6W 0k/GcU2pMcwLaf4y32XVzT4aAZYhuiEF3NaPt8Ffj9Ihro4PK6Z/okKXjH3qBoex 9zqtUYE/jCmAdx1Ws9yOUt6NfmtUd1pnPi+rqcevh3HDtEY/kTmMMTBMEPZiHCGV umPXr8aSBmQCcoPBlhsOFFgpxKZlo0E+dH6DFLAGrAPjIJVyJVz1kX4y6jh4fP0J 4ip+QYFlHNo3Hbp68xVBEARBEARBED7hG9e8hAS/E4HCAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_198"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,479.4,267.00004)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_199",
    width: 89,
    height: 19,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFkAAAATCAAAAADeo/55AAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAQUlEQVR4nGNgoB3QiacFMGFgEKmnDZBhUKivT6e6i9Pr6xVAJitQ PYQVRk0eNXnU5GFuMk2AAg1LUQYdB1oAEwYAgSD2kL+tJzoAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_201"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,484.8,259.80003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_202",
    width: 71,
    height: 46,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAEcAAAAuCAAAAABfIFtRAAAACXBIWXMAAA7EAAAO xAGVKw4bAAABEElEQVR4nO2RIY+EMBBGP1FRgahYsaKiAlGBQCAQiCaICkQFogIx AlGBQKzg7++UTS4huZBL9mSfmKT90peZKVAoFAqFC0+j/0MzxDZM32vkyoUeI9Ei iRxgFi+hiCxnHq0WY77NmRzG+ATqGB4i0igunjpwCQbGwXgQqoh2hHV8ZptIQihE fWbqpZ4rqlUoUgRvLx59enT29C17GnLjgL45PcfWAX1M5sz4MTY0HOxqd6m6zrVL yCSyJ1bs0eeuFvXphxPrc7s5UwkiwUxcWWmH64KajVbDa3H+IDoGxDnUfsLHg6FT W0jmzKYXbQ0wz6uVu8uPfoW7hgo3GdHdh/3Q5intTdb5P3kKhUKh8BVvmFQ4TMBd HgAAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_204"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,479.4,279.6)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_205",
    width: 89,
    height: 37,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFkAAAAlCAAAAAAMgBrJAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAV0lEQVR4nGNgoB3gcaAFMACaHFxPEyDDwBBPG5MVQCbHUz2EFUZN HjV51ORRk0dNHjV51ORRk0dNHlYml8dTG6SDTY6mTSsX2H6WCae6k4HAm4XqQQwH AGx3H7ViG+lRAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_207"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.59999999,482.4,266.4)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_208",
    width: 81,
    height: 82,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFEAAABSCAAAAAAJcGdEAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAB0ElEQVR4nO2VIa+kMBSFj6ioqKhAIEYgEAgEYgQCcZMKBKICUYGo QFQgEIgR78/vbeeZmTezi5jsJpt+ojltL6c3oQeATCaTyWQymcz/jzB+uXzU0XXQ u/ptieZzU0XxoiHxvCI3Hkw3rIdXO92AcVpbqDBaXl/meQJmCu1kHBBoaTz0Dak6 KW98+3y+56EboC3UjJ29qiagHHV0DAIhNjd2Rc11a2UaL5YDsRpRyRXUvepxamNN 27Oj3oiuuHbJkV28Es64rhktu5NtvWn3b8eoKPhnRzjSDffCNU6xo1gVCh6S49bq DcWCaVBik3xANW0W345RifCzR4h+Jsm9NjQSkUNp57pteB577G0JDLatxpnnPQ2y F+iRdqMqalTl2zdK/EphH5b82+JT6HgPHu/H++Mz/xQpH6b6hfoDB5GHGX2NbXYT RrcoGOco3mnPUQjlPfBJnSI+qHzVLTgEVh1iNwvHWR5VtfLEdqjugbc/gvLe8RKI cxVVEx+9xACrG1EQjjjCPQf+rk47ikXyNf9q9Cp3WWm5yWJNG6XjT2kKfFLnHDmw HXdla+yDLViRwGUa1X3D2Gt5TYGP6pzjQ7cf5rM/nkwmk8lkMpnMX+cXKQxkT3KN ydcAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_210"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,315.6,550.80007)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_211",
    width: 107,
    height: 31,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGsAAAAfCAAAAADFZ2wHAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAR0lEQVR4nGNgoCfgsHCgCzBhYWCwqacTMGFg8KeXXQ4gu/LpEVWj do3aNWrXqF2jdo3aNWrXqF2jdg0Zu+jXFqVnG5t+fQcA5K0/5t5vBikAAAAASUVO RK5CYII="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_213"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,328.8,543.60006)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_214",
    width: 66,
    height: 58,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAEIAAAA6CAAAAAAhTtCYAAAACXBIWXMAAA7EAAAO xAGVKw4bAAABmElEQVR4nO2UrZOlMBDEW0REREQgEIgIBOIJBAKxYqoiEIgIRETE CEQEAnFy//kdHrwVy35VvTNXx69iZkh1OtADcHFxcfEPYg2gi6ckyggMzXM2Yqmy GplHUMei1XJQ8BwsIhOKabIY8b7u9dnGzWOFrLXWq0aBlx6Mhky0jFmX8/5UVv+6 12cbiz0kADm7TpGQKVdusGwWooCV+VU2FONRn2jicYhYYK0zWhIXRaTasuJtx+4i J3XUH5mW8iGRZrnvHJJIUIwJcpGex+6QWCoc9desv3v/3zE9L3HxF3BTqoCOufKm 7DHoe0P7KC1ulU8N2loCqzxLImpO55ksYJKk3FJ7IxdM3Bu+g5Mkwd8Ua8n0eBs6 jA3IqXySMGGQrRnUgvMfieq9wds8Sp89TQU5CT0rOAKFMJ4kkpHgl5NINOKiintD 7qI2ibj9jUT9pU8l2k5cIOuPEjIN0awLr8tiXEAqtgZc5m3kUc0+gpizKZeQlLgY P5lUwdKmdf6XPE5xX36Md/S2x50MPmjLnyUuLi4u/gveANbFYFhZiqCrAAAAAElF TkSuQmCC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_216"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,617.4,247.20001)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_217",
    width: 105,
    height: 36,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGkAAAAkCAAAAACvL0tUAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAVUlEQVR4nGNgoB+QKK+nA4gG2uRAD4vq6wXANjnQGoTDbKJ5DBmM 2jRq06hNozaN2jRq06hNozaN2jRq06hNg8cmOvVqDOhiUTkL0Gs6NO8+AYEIAwCJ k0dfdLFA+QAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_219"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,621.6,230.40003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_220",
    width: 91,
    height: 94,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFsAAABeCAAAAABpkDf2AAAACXBIWXMAAA7EAAAO xAGVKw4bAAACSUlEQVR4nO2UIY/kMAyFDQYMKAgoKFhgUFBQEDCgYECkgAEFAQsC CgwWFAwIKCgo8F8/J2lvtbualU6r0d1J+YDlxs9Pk2RigEKhUCgUCoVCoVD4Z7BE ZJ7kvZAJ9BzrMw9A4t29BQNK9kBD9breL1BTv5By7wueKrhSn6U1NWBvkMoPvRvu onfDuucWecDF1QYtn5BnvfjBs2nTwplXA8s6ZqlljG2p/NBbs0oiJmKD0hEcoHGs Yu6C1EUUF5BvAYP3WUo800qQy4+YZsjeiFhl746HIXu/Zu+0oLne/GjfsrRnl67p O++BJ2NC6Bq2OKjsPWxt+t2z3W6pOS1cGYhxWCBJdT6Tb71DiNe3OOiInKqpBjec HF1J9jDS6xlQDNKCdtB7aCdI0laU1kIqP/Q2MTr3tRL38DOGZNB1XyvxX1b4S1QN qGcdf7d18/gkb7iY6/lP9LewjCeYNPTyAOJEO0PtF3kvk57v/R6ziLS8mGoQjcvp 3uaJMCs+MbY998AGjDzcdbQyteYRFwu86rf1lOMhUiur9sb+ktO9jcnUWfGJ+mpY AwcKDIpRJmKVp5v0yUeOu8jQLIbqPc1totltPlJtDqOWDDFctpMYKZnf2ABbuIh3 jC+7aLnrwzunuU28d5uPNGly5s3hcjeeb6cwoUbgzYY5x0O0vfz2zul+Juaw+cSV RtfC1EM/mVWuaWa5S/Li7f3U7HEXaZl4FZwJjzS1xbgrHmPiqMRjFsdTPOLPwbgp dZhN+j0WCoVCoVAoFAqFwv/DL/Sn5HDM4owWAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_222"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,617.4,271.80003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_223",
    width: 105,
    height: 30,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGkAAAAeCAAAAAAKzm+fAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAVUlEQVR4nGNgYOBQoD2QYQACiep6OoBkoE0O9LCovl4AbBPNA88Z ZhMDrYHBqE2jNo3aNGrTqE2jNo3aNGrTqE2YNtGpZWlAF4vKWYBe03GgAxBhAAAp pTjTCtQRHAAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_225"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,617.4,260.40003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_226",
    width: 105,
    height: 70,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGkAAABGCAAAAADqE+UFAAAACXBIWXMAAA7EAAAO xAGVKw4bAAABZElEQVR4nO2SoY7DMAyGDQICCgIKCgoMBgoGCgIODFgqKDgwUFBQ UDBQUJBHuFc/5882qdJJN93p0PmT6rr57DlNR2QYhmEYhmEYhvGXtNVvukPruxfn bMO8uJ9P8tN8eq3y1hCNkUUkRBFH/nLxRBfp1bFER5Eo51nCnU/SlAD/psqjHRmq o3aj98CuVy+BN/Y7b4Fm7haijVddP4cxUiLKeZZw+8CbQ4BP1H0EtCNDdeKm9B5I mJR9mGkNLonsVF/x60FmIV3QmixrOH24tgjwqVpuAZtBhur06D2enpbNXS6NUSfR LS/GHpO2SvdQ3gkSLjmaagT4NIf1Piln5Z0evQd4lWnS+9qmQZLQ+C7Srr6cmKz3 SUVmR2kalhLgU0+PSTl7TkLvEcch3xp5Y2bddcuu0v+9fnCq2IecNHSX6vSQWioB vlbtUI4M1c/er+mzH7+X+zMYhmEYhmEYhmH8Cz4BY65ZII4djbEAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_228"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,617.4,292.80003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_229",
    width: 105,
    height: 30,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGkAAAAeCAAAAAAKzm+fAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAV0lEQVR4nGNgoB/gSa6nPah2BtpkQweLgICHgcGhvt6B1iC8vl4A bBPNY8hg1KZRm0ZtGrVp1KZRm0ZtGrVp6NgUT2uQDbaJfi1LnmiaewkInGkeQwgA AK6UNiU6g95EAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_231"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,628.2,277.8)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_232",
    width: 70,
    height: 82,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAEYAAABSCAAAAADMAv3VAAAACXBIWXMAAA7EAAAO xAGVKw4bAAABf0lEQVR4nO2TIZODMBBGP4FAIBAVERURCERERAUCsTMVEYgIBCIi IqICgai4v38LnV7TznRueu25fWJnWZZHIBtAEARBEAThoxSNrT9gSXRIzduaQwfU qYwxdibGFqBouBpDCRgzuQJGozUFxcY0GJ5pRs1hAXwNryyhM4g7TDVfg0bQAWTr M/WEPdnWPdMMzY8mFazxjrxCwqax0APHqaeg+HI+VU8/itdp3KqpJrBm2HOxihdN B9ODltbSuEdB1jxdTeHT9h+8muc4L2oXXahnfdGkyO8nx3o9xyMv7lT+9q9rz4F0 XuLnXqbkXYK+GyH7/iAIn8Ao3gsOfGiOleI5K2+VLYOxwRVZW8unbgz7ew3p3RcP 1joeLWlfjVlly0Aeg83aOO7WEb/XNKG3dIoLT1k8nReVVbZsfUxT1rZqvHvUJG2v q3Haq5BVtmy903VZG8dJFY8awvV+qrTnjltly0CBD1XWtsYwTa9uwv0R+zNWfUQj CIIgCILw33wDnx9g7vBrs0QAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_234"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,692.4,213.6)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_235",
    width: 134,
    height: 49,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAIYAAAAxCAAAAAA63Y6AAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAYklEQVR4nO3YqxEAIAwE0RSApCA8AkEBCApAIBFpnU8Th9it4E3m VMw+KdYmLofD6C4vH8bwqT3G8vIYRbuKAQMGDBgwYMCAAQMGDBgwYMCAAQMGDBgw lAx5l/HJ6z4mecE2et6t8sCizQkAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_237"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.59999999,703.8,204.6)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_238",
    width: 98,
    height: 81,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGIAAABRCAAAAAAMICzRAAAACXBIWXMAAA7EAAAO xAGVKw4bAAACvklEQVR4nO2WIZOkMBCFIyIQiAgEAoGIQEQgEAhEqhAjEIgVCAQi AjEiAoGI6L++3WnuTszdzdbUbt1dXV7VUl0v3byEmfkWIZKSkpKSkpKS/rgmAHBf G7G7evVfG3HexIwRJsCeZXgiWDOHF5nDDYJZ0VjY2EELCyO3FtCKyYu4/Cwhh44i VDDZOSgY632TrayhVrDWmy966As2jvsqvN+4dcIIHIvLzyIaKKm3Breds8LBbRNm dRTR4qZxoRbR0DAEHcY7t250Xjx8XH6i5RAcQZvhiBrakiJ6/CrEe0Sjhcqvb93J rXTe9WMRI/htO8JNHs5OmiMqmBaKCG/hLd4jGhbyEVoNMrZ2/KA+ErHtFoUPJx+s zaUthWmFsaZXCgY7SKGsEtHQVhRWKitjq8JO3QtefhIx09Vujyt0ok+R0XStzOMK nSgp6a9SF2AiUDoiqhaRpgxOJKmL0G3AiBtYwotiN07l0GZhoPLU1FbF6jGhCFPe lAhKjUR1XkSadgROJGnO0EUwNQD2oAh24xT+KPuQqzDk6xHbYvUYQYSNiLmIyngl 5DRE0olsZMi5Iv/aGyh245SCOyKywZO1QG1cPUZoqL5FXEQlvFKE/g5dJOFsQU6b A8VunMKdL15SOQRq4+oxQh5+XjniIirhlSJ+QFeBl3RAelDsxilFu+nlsY/nSG1c /eTjVtZWBMqLqBdeCZxI0iFCl/4qG3szduMU2Z0RubUtkyxWv9GnEfXXSkRN+qeF pHVSELT8VYuT2MsYKw44zWW/rC6robkiuC6g2zd0agCRKbFPbL8uszi8P7+uct1A ju9x0HuHrBr2s2L7ZZXQVRQx1rO/anzBp4hzIVoXtTvYflkFzAtF0IPiGv9FxYgj wwh9s/7OLa9LW9OVAqFV91zrToi2Jae0BNQ+45akpKSkpKSkpP9P74JhGEefnMkX AAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_240"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,316.2,357)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_241",
    width: 104,
    height: 37,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGgAAAAlCAAAAACLsfPPAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAS0lEQVR4nO3XMREAIAxD0QwIQARDx0qoM6xz4KEZuB8Db8j0Jd+i +hfX2Y4tqSxQPqj7nAkEBAQEBAQEBAQE9CnkyRZbiI00pGXqAOEpRrBQix8sAAAA AElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_243"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,317.4,340.2)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_244",
    width: 104,
    height: 95,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGgAAABfCAAAAAAhCN1oAAAACXBIWXMAAA7EAAAO xAGVKw4bAAACa0lEQVR4nO2WIY/zMAyGDQoKCgIKCgYCCgYKCgYKCiwFDBQEDAwU BBQUFBQEFAT4r59b73TgNukm7ZM+4AdEc17bbxZVbgEURVEURVEURVEU5f8k77Py 8nu7DjvVJ43SEMLv7cI6amz+QSMosXvaryUDYBaKpzxes3gZBzhRYWZKHat3oggS 3IgcizbZik6w9EcNlAvNGW/fJhBR1ldG4wj3CbrkYhY8WDJhLpBKgDh4AgnCaE3w +UrWkoUVpWZa6ksevOGTiCjrK6NtDWuCbKMeQgwzmYRgqAWgBgkk4BNwr9tMtqBr s6HUbI57hBjHb1HWl0Y3ayuoaA3AB+/IcH1JZziTYSMJDqMYT9ylCyGh1IjRiFQ9 xEfKCyO/ITqY7+ejH1+d39wcMxsnYCMJDiOyRrqsKDU+uZlvlGsf4k/Kr4eEn5Gs uw+2wBL6pj2DwTzrblgcmkWQgAVoG8jR7GWdPWpYGy+7VOND/ElRFOVfMhOlHOqN JgORiKZ9YocM0rClduCNUWKfWqiJB8WRmnroNzjkvxol58jksc+XAcjbcYW2MDzx aKnvqWqoqySeVn4nxAUklXAfU+Uu/9GHXzM8+CqaA89iLvcr1PfAM5x/s7BPMInX nqrkEkgqT+KV+JX2dMA9BePer6TeWiNGhjq7GznoDqPvmD8ApppySeX/7t8yOm8x LOSzeUHXilFJbtgbJ7/NeyeJDZ2Q+hOVkipX94YRrojI11X0oysBLZw7aG4Xvnka /NUcM/mIC8wNFnt4pHImT/g3Rjbu3y52faLwmT9JVfOSt8+OYD9qpCiKoiiKoiiK oihv8QUVouNH9+ruhAAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_246"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,316.2,247.80002)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_247",
    width: 104,
    height: 45,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGgAAAAtCAAAAABn4nGiAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAYUlEQVR4nGNgoBtgcY+nOYjWAFpkUk8HUAy0yKG+ntYeyq+vh1hE 69hxGLVo1KJRi0YtGrVo1KJRi0YtGrVo1KJRi0YtGrVo1KKhZpEDjUE8zCI6AKBF EuV0sCeY1rGDAACFVlireVveeAAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_249"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.59999999,323.4,237.6)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_250",
    width: 83,
    height: 81,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFMAAABRCAAAAACLEcXXAAAACXBIWXMAAA7EAAAO xAGVKw4bAAADH0lEQVR4nO1WoZLjMAwVMDAwMDAICDAoKCgIKCgIyExBQYFBQUGB QUBBgIFBgIF+/SS5e9vb3cvN3iy42cubbkYrOS9KZD0LYMWKFStWrPju8N43X0y5 R0L7tZzHAh49gONsHSXtOXUH0FjnjXl1GG8AWn4lXto40F49wm9xvQtnVyIOEDlp uE4j7iCmjGn/6jjiCBssUJfGQLfZTsLvcL8I53SEUwJa2SFQPukMcVJb+ihpgOoI ES396bo03vwBLUj4LTQehLNMMd4enH3OJbBtsZObxBHP437u0NWl8ka/4TwUI5z5 zP9VztJDJs5Jd488xTEN/Zw1burS+u4fcsoH4Sd2ON5f8hzTfSbOjBjrTeKYO4dn mDuQpUucmSu3oyiVXHM1jQflqebE77yiStON4qAwVb41sjt0rXsNv+VMfLX4PsI5 /x10bSH/QYgyWfHdYUhqbCvbjUzFm1aRRR4tGtVK1Bu+0nalrerALcuuL3luQyLd Gdg8iKY2c6R22mFWlhqNotT+gfezpV6+Zp2Pi5y3pLQOyeQyiAmRuvJ2ozZUhzRv +hF9yNRuXZiHg2HOptyzWuRMF7qEFEMexBTOmGOM5hTPYexKFzh35kyZOUlq/9Bn tzsYEzBpHMR8yZNwuW5S0an/+e57bDlPDKRoS9gU+n6BlA0HMYVzU+4jyfRJzSRY p8p5Jo2/cJ7jVeXrcqKO6khaxHV3UmhudjptRIgaSz+pu7Z8yKoqUe6LT8YV/xb8 EPsvpuwxhu2n71Je8dRj+OSERjbgq0OVTha1tG0bL5MUm4q37gcn4wsspoRHU2hC 0rt7xP2zo8ERyxbCPGLHw0eoJvVUgwvpWzzBtdBU5HhoNPPx2eFpNLtNDc0flyRj QjUtHi9pQZh4LBpQXXCiRj5hbp4dPPgMhaeKAYWzmiSpZbfwPSWttEXjWMRguj07 HO7hOnp6z0ee1aTHHpeEyeKMeHBlpLT6KeLh2QFnnGZPcjlRXjIiiUmcBheEnuI8 JFtvWy1F/cUBrE58tVBHJDFVna4Wv+ey4/PgZy47VqxYsWLFiv8bPwAMNhGwGbhB mwAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_252"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,316.2,330.6)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_253",
    width: 104,
    height: 35,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGgAAAAjCAAAAABd6BDSAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAXElEQVR4nGNgoBvg8I+nPfBnYWAwqacH0GFgcKivp7V/kuvrDcAW 0Tp2BEYtGrVo1KJRi0YtGrVo1KJRi0YtGrVocFvkQGPgDrbIhi69CaBFPOl0sCed h9bRAwcAxNRAsvw+ehEAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_255"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,318.6,321.6)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_256",
    width: 99,
    height: 67,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGMAAABDCAAAAACt/OR/AAAACXBIWXMAAA7EAAAO xAGVKw4bAAACj0lEQVR4nO2WLW/kMBCGBxgEGAQEBEQ6g4CCgIBItyDA0oKAAIOA ggADg4AAgwADg/nrN7ara9qurrlKlU4nv2B39vXEj78yXoCsrKysrKysrK9IkPj3 Iiokye9lCBQQGOXYF1BKKceCdXJg0HS1FIwMyaPBbi1ARw0xtbkBjFVq/pQxIA+M 2k/bBhK1QTGau1tAOrtjpw+n62i06HnpsUmpEgGw57H5U8ZsITDmXYxY0ZMlzQuq 1RKPMzeD0iGLjN6aYVixS6kLCoE9vDR/on2JDO201jwxOqePwACwiRENuctVD8ct pc6o9VXGgJIGpNi8025AYqzP8BwYTzWOsZNoqLXyvjR3iKlprS4xSkzq+Y54vDAG tHtgWNx57CQa6wzWwKIgpv4VowxflrIr8dutw1GRyOo3xqtOqRd0YrxXGGnW/yzd XkqrJn2UX2Xgg5P1AOE22bOrfVLdZLKEtgPWy4oYt3GID7fiifyilwRtZEg5GZMp RUEoOXAeSi6LYeilGT8yeiwFlaltBmNm3wJ67ZfQoNxuHZ+XyVMRk5t7Y2wO0bIn NNa12h2ax5DTy76tHxkF9tKbAtsab2JXoSze8YeUhdpZiQO92puCQlBVPhvWsAY7 6o+ToxVACtU2ePFgsYwyMw6etWi0HsJ+9PhT6zoUIBxvTjsFQruFnQ2jws4dKpVq +kqhcsdWPGBIh9y5lapJD4yuqZWtR1qrusPOTkDDLqHD5mzMR9FhpTeaTRsZKVSa HdOjTccNVFiDicpuR4zwGRjWoWELVVoFTnvDzkZlw93fHIgzREYKaaqT/+NxK9Lf kjrNVmlehSHEX6J+Z0AqxdVrh9Xlo/yqDxfCpds0KysrKysrK+uf1C+KAuV/a57d CAAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_258"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,315.6,440.40003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_259",
    width: 113,
    height: 48,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAHEAAAAwCAAAAAADEcrFAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAaUlEQVR4nO3YoRHAIBBEUUqhiIjIdIBEnohAIBAI5LXODSYNZFb9 38Cbm3WXkr57ua51hdiFoHsPcXh7VDUfRyyyBQsiIiIiIiIiIiIiIiIiIiIi4g/i NFXziE36JXtDzFV2olnNsgW/NrKwdpu9dVUIAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_261"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,313.8,422.40003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_262",
    width: 119,
    height: 109,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAHcAAABtCAAAAAC+H6GrAAAACXBIWXMAAA7EAAAO xAGVKw4bAAADnUlEQVR4nO2XLZOsOhCGW0QgEBEIBCICMQIxAhGBoAoxYkQEYsSK CMSICAQiIqL/+u1OmN1h94hbxa2zVbfy1NZs0/l4J2RI8wJkMplMJpPJZDKZTCaT yfyf2R4APdZ/XVeTpn2CIuhKghIAheLv0ai3b1NVAHQpqbWkDmXKnEBsD4l9h8QV rtuCvlIU3+GCdlvgSnEH4sOFxxUlrCNlZLGamDklrNEEwXOyLurCz6WEKVAM1yCm p6R870WN90/dB5qYac4tGG/wqSvB2sJYxLjSG8wP1r3z7fjgD9adNmtipju1YEM7 /KmrhJtvrhhZF2psvWbdaaN+V+zUxrpBWRMzZ6DNnOFLNzhsh3DzCB2OH977knWr sExueN3nEayJmfKErhh6/o3SR1/SnO1Im9brSkMxjJdSSxCapi/12JZaQFdRV4BW xczJJX/By/4NqkH8im4m899RUA3iI6CKYUGViQuRKlIKZMF/EHP8mJWKm9TpJ64L 6GE1VCAUh5oOXg+td0HRuWyoLjlupUe79Xxig6NTeg9PsT2EopmrgIrDUqFpgA5i Y+Hhgpgd7rrbTJ8VrB+q3MMzlEgHH6yzM9jFEOgABi43DpZx7cKA5cqXDR3UkmoQ fYlyD88gcKDdXcPSYhvDpKu5bdW35yqxoSVOKCl/oZpLurCHp5iDDbB6qVDFMOoa f58noMpH24iXdJ+nYL2FqLuH5+jGGroair6IIfS8cWrspdCFoCrVV10DXI3asaPz u+N1pjCTyfwtku0h38P1pOLHr365naP1qSXUVJXEbpdSNsXUr4GXd4oTHofKWMYO sO0xr38lBkmV5RLdjn23PlYsZJWiX0p2ae8SY3JKiFuVvFOc6TC0Wh1VkW8k2wN9 oNduGuOGxq86up03XbogV1o2jdlUkezSqwvHZFllsZnkneKEh6F6Y5vx/TZH2wP3 hXU7HJbJPKfoduz1zfrYu+Pe4wq7XXp14RgMNab+tzThYWjllp/rTbZHbJp1h1WG 9fIw0e3Yd+tjJ8+vH0lXgZtfXTgGbnQmeqcmTngYWm5m+qGbbM8TF+u3683CM4i7 jW7n6z7zRR2cG3bd8MT21YVjoMZnqKN3knHCw9CbFz/vc7I9qOmX+hxVCw3N0kW3 c7A+LcjhWkDVwW6XUna3TiD1IJN3ShMehl5UDP4E3S7aofHPjd94t0tnrVMTXxP/ 3Rzvdilbp0wmk8lkMplMJpPJZDK/xz8+OlUcP5no+gAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_264"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.59999999,542.4,247.20001)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_265",
    width: 97,
    height: 50,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGEAAAAyCAAAAABpd+omAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAZElEQVR4nO3YoRGAMBBE0RWRCCQFpICUkBlKiECeSBFIWk+CoIOd QfzfwJubdSf526qzMoX2WMtSeIWyhLAtsCMgICAgICAgICAgICAgIPxYuMNVf4XL +9fI0tFsJ8zOZJvgawAZkFPkFstCegAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_267"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,543,229.80002)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_268",
    width: 95,
    height: 109,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAF8AAABtCAAAAADileKPAAAACXBIWXMAAA7EAAAO xAGVKw4bAAADRElEQVR4nO2XrbOsOBDFWyBGICIQCEQEAoFAIBAjUoWIQESMQCAi RiAQEQhExPnXXyfM7NZ779adeV+7W7X5mWnSzRnCwLnnEiUSiUQikUgkEolE4l9h stbqP6jvFrnaPyefQZFl/WHHnOUegM4tMFLuld/LlRemc8EdJY3ozlGBiuaFYvtT /RJN0C9QCfQCg9xN3mU9hMAi3b0c0RZxoYCbsmOfztERMpwW25/qd8jDYA9rvRJ8 ljPUTGvQlzQ67guKCxLK1c4s56jBag9LZ/szlpWCfotaysup36Adgn5D06kfF7jw Vo/rOVryTtc39A2ctcehcj8rXZ76LQYb9I8JOgrEBeVphux3iqPNeX9e6jurGL6S YrTqclGChoaGW614L9f5mlGpLhQX6oEqxYcURwVPdvxbx/Zn+iru4oMHNOzl1+mj SNN+3wl7SST+Eyj4bmMvnP0IV5K4s2GOPu99FtzyLgoPbx51yfVZvS1fQdVNxZ7Y wdT7jUSXjSiOab+SZKNxNwlRI3/WrTyrt/WvyCh4CasJMhuX0wZxxZGx4/Pr7STu 2+2vWjyqn9EvablT75sRYnZ8FFq3VaJoUD9r8Vh9W7+EnaZTfzcYWL+3GFCuKxV+ 1nwzoDXqZy0eq2/rU2WmMnijRDfzadn11qq+Z8PMqdKmpZxNtqazFsEyY/XjyFd/ jn4R8cLOE4l/BsluiZbGA/ecSOO4OYONn/7RcyLlN5qDZcPZbtPU+pyWZZnouj3b PN+ErDqBUxIVK/y3L3PHLgjVoKt3wwGqrw2mmmcbLxrOri04noXwxHGRPxRnwhsp 92iHeSnNLq/gyUsRrvM7fUFQmj3wZkkf5wInMu2t5X3pjQ863Dlpcqfzm2XjXNyj raOaCunRuomy3mz4UD987WLjt3coaA2llDILtyXotxynuXMM1haLde7RHv/Wv3SQ 6mjGj/VLGM1XW2E2Di5YZwWjTB7j8WGf92eOWTMInu0wr059NaEYfb9+qx+Co5JU TYZ9kWqjFfpgnST1PGRuDql05RmOo2E0ZE2Sw6Md5kU4FDwmOeqZVr16oL5Kwi7I GfPqnB/hqyTch39Kavk79ROJRCKRSCQSiUTif8YXyhsz/+BKXXwAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_270"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,542.4,307.2)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_271",
    width: 98,
    height: 36,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGIAAAAkCAAAAABXz7CjAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAXklEQVR4nGNgYJBQoCGQYQAC93qagnCgFfG0tSIfbEU67cIpGmpF PAPNgP+oFaNWjFoxasWoFaNWjFoxasWoFaNW0MOK8niagWKwFdG0bfxnA62QoZ0f QECFdrGAAABkjzRAth/4AwAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_273"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,552.6,301.2)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_274",
    width: 66,
    height: 57,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAEIAAAA5CAAAAACn2qI2AAAACXBIWXMAAA7EAAAO xAGVKw4bAAABgklEQVR4nO2TIY+EMBSERyBWVCBWIBAVFQgEYgWiogmiouIJRAWi oqJiBWLl/fl7j6BuN5dLUJd00jTpQKYDeR9QVVVV9Q/VjsBtuhTR7AoPe63G7JGV z2kHLZEAG4vBktOEmF7oYn6AFEIre+xHKsuHGoZALRJoQDDs3OWsVnZ2JIVnw0+P Ne86Q9OHGl/dGdHCTZhC5oiQbRs54umcu1FOL44wG+kh04eIvuCM4O4Gxz18LvOD I3KLBmeLokh7/aGFTXfeFDzIr/yd1jsLuwRHDVZ05Lw8laVhe0L327/nm65quF2O qLquPqclfSUTfKTGbtmgKGM72gLgcpohHhMSeuEk6nEt/kdE6qF4CgUQbw4+hpia 1MKPQsoG8WQ2tUDy0tvtbTz3c+O3pmkUPvBaxJiskOIgnkCiBRKnTXmDJHe4HxEC yFP4mF1peeiDXIsnxDtbFOW0H95adHHtmQUGhDzm4G2zNsbeV2IU5iWMhyeEdALJ 9BskFZCqqqqqP+gbBNpgaHt9DkoAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_276"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,499.2,156)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_277",
    width: 118,
    height: 31,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAHYAAAAfCAAAAAAXN2ZfAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAA3klEQVR4nO2XrRKDMBCET0RERCArEBGIigpEREXFzSAQFQgEAoGo qKioQEbsq/cypTN9gVwErLhk1Tf5m70QFVLbGXIvYG2IbhGYSMGSBRpqIOqIHjJE q2CpAlpZMvPVimFmTwp2w6rLrDjpEgOCVFfpUmnBokz8x1pl7IxZ6jsq77JffLGb XAjrgIsuseJ0qjwYXeyIURf4VdF3m4JPVT36LfhUZbzZ27s9gk8FewRfdu0v+Fpp 1Z+GjPwUYurV89rpF3xD+iK4tN/APbud0yzJBuZaxpo52OzWni19AJO4x0uWh2eN AAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_279"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,511.2,150.00002)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_280",
    width: 77,
    height: 53,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAE0AAAA1CAAAAAAhEznAAAAACXBIWXMAAA7EAAAO xAGVKw4bAAABQElEQVR4nO2SIZODMBCFn4iIiIhARCBWIBAVFRWICmYqKhAIRETF CQQCEYGoWLF//RZ6MwVxrqcun8rbN7O7yQuQyWQymczfQ7YgxX+kWSkVi9J/pFsj Fk4u29mQhS5piBwQSsCRW2ulNwQKW0kvo5W93tMnoJawnUnChYNPKXHhWIJZ+FyL N9wQz8JRdKqfpzmZtz4yRaBlo2uQa7haboiz9XI+P+e6iVy3TwShRk4kA+SKYTJ3 Nm99wEoDxAnoRMpBZAT4ikJOsX80SyMUH+tjxBkXcU5qPOevSHjrAyQELN1LpPsq pUXHjk/9EkvxqfdLUgfdrC/isE7HTv8agpWz0d0jj1xVbFsJJGYUnqI6GAfcFmDk r1Tu9AGvsVgN6RWp0fj002ikPqyWK9X0hf9xirBFGrDXmUwmk8n8X74BPidZZQDg VDUAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_282"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.59999999,543,366.60005)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_283",
    width: 97,
    height: 43,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGEAAAArCAAAAABNrrl1AAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAU0lEQVR4nGNgoD0wKK+nHai2AdoQT0ML6uvzwTbkO9AKpENtiKdZ DPiP2jBqw6gNozaM2jBqw6gNozaM2jBqw6gNozaMQBto34+jdV+U9v1pWgMA7vdD ao8vS9wAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_285"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,552.6,358.80003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_286",
    width: 67,
    height: 70,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAEMAAABGCAAAAACybHYcAAAACXBIWXMAAA7EAAAO xAGVKw4bAAACWUlEQVR4nO2VIXPkMAyFBQwMDAQMDAIEAgICBBYEBHgmICDAIMAg wGBBQMCCAwX985Wye73bdq/tTY9d3ux4ZNn5Im/0xgCHDh06dOinhgAw4vcYTQa3 AhFZ49BLwpEFqGQwRAZAAwTjdQQES+EBZA19R2tMkdYpd4BTXE21xuLanNnkWAIl wAQycsElXh4VMm1G1inSDHYDedOCtNDsuoa5nShGmbXK8EupZyiPTrNOcGUkiaHK J2XUOWRk5oEIpcpRNsxLKLCMD+owdA43xqXqR+ABN6RkpukMzKGgd7ezPFVY6vSo Dhtr+a8aQKK56w2YvmdrY+QOIQSoYnSyahvdY7n2wB99IT3Ld2X99xmHdlUmEFUG ndceteCN/ionS0GtIzm1ygeGMWXMXc4drkmGKW6mnl2xJWYGFNeg5rw0WdE+uxrm rcubUQaW/RnMJk27IMylaiOYM+BCyWlODaMMn4uYqrxlcHdjSINdvHoF4sVJAnZG Js2pYYQxZ1dgHt/VEQrxzniibm4Ht6GXJ0NxPCp3PGmOrmd5JigSvqsD6tiqL1DM Yk3XN7ZGOLk6dgbUNaC53SpgW6lYDWP/8HXwH5jFHGa5lysB6noPbepuublMZo98 zsPnDFyz9Imds4chxmvOOkjNlWbgh/uckXJgjuQX6YL4mk50C8JmvsAImXkkd8cI +Rb0JX2FAXlkX5bwGwPLr54c268wqmd2ciVBGFLYO9ptLFMF1nK3PLpo7yU3CJy8 3IwNnNQnZ2H4KFOz6hvkxvwU8Vb1a+Wnv3/40KFDh/4nvQCe9nwTGuRwTgAAAABJ RU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_288"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,156,331.80003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_289",
    width: 117,
    height: 41,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAHUAAAApCAAAAAAuIznsAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAZklEQVR4nO3YoQ3AMAxEUY9R2AEyQGFZYWFAQGBgQGGBV48rZYaL Kv2/wJPOzGZrSo9re49Qixh176FW76eyNtUqveiNioqKioqKioqKioqKivojte3K ylRX/CUuuZq/oTfpwJHZABJLcLj736b/AAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_291"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,154.8,334.2)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_292",
    width: 124,
    height: 34,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAHwAAAAiCAAAAAC48eLlAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAB8klEQVR4nO2Voa/rIBjFj0AgEAhERQViomICcUXFBElFBeITFRUI REXFxMTEE++ffx/Q3YndLLlJkz3RI0jP9jucwlYKHDp06H/RoICL+VB5N0JcxYfK sSjn9T2tpBe6nmHmYRFq9as63a4eE61GE3QCjzYVv2N5N0aVJyYuEEv+hLQmOZv+ y3k7WT8+ylVMxe9YjmVGLScgQc1+1Xr10YTGeZe879iNuTyaVPx+1UJGu5XfTDvD ebHwytH7la9NBNS28rtDKn6/chl7Hi4wvZ5p0pA0DUrENIwt7BldnBr+Vg5QvN1D 8fuVP5W3/WMSO/6Yhw59RqSbCe1CURBNi6Al/dHFongfomvT33QijWTDOHlOgGxN 8PFX2Qoj05NPEhksiWe2Jwov5WZukBS8IwvfZU4Xi+LrA37LN+lXPudOVMtrQqNG 8YAzLaNBBkvimY3SvhwVFBaJO+B6nsq5Ul4siu/DuJU78pbGMIBGnuqRqFFUGJlu hsR3x2BJPLP2vr6Wa35nxxaxoSEPubxYFH8V3VaeBJdrca0rrwkur2yFkWmNkXeN wZJ4ZkPzuvJeIUCFeAb16SvbQRZbfZf6C5jApYFrXJptRnpTEL6q0Q0u9JgGgQyW xHe2DfyCePfXe+/f6lfwDzrJ9/5X4UOHDm36B0Bekokw/FqyAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_294"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,157.8,242.40001)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_295",
    width: 111,
    height: 37,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAG8AAAAlCAAAAABpbei2AAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAWElEQVR4nO3RoQ2AMABE0RMMgKhAVlQgEB0AQcIgCETHuNUJS1wq /l/g5XJSuvPJdS/anGxXtUdo3Wv336uh51Y8PDw8PDw8PDw8PLzJvWBdJeo1qV25 Dn2aaFow49ejgAAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_297"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,165,234.00002)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_298",
    width: 87,
    height: 67,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFcAAABDCAAAAADM5MY9AAAACXBIWXMAAA7EAAAO xAGVKw4bAAACQUlEQVR4nO2VIZOkMBCFWyAQEREIBCICcQKBQCAQqUKsGBERgVgR MWIEIiIiAtF/fbuzMDs7U7fF1Ymrq8pXDD3JC296AvUAyGQymUwm8y8Ya9DyaS4s AANWf+Vr/DWK59/CGm7XfVBIaLiqkk/pfEAD/vEkV8dBC0oyLBsln32LsNTYd0j0 0K8rxkptiBo6dNtCfwVRgfSrxx5BRcQR6Mv9EMEc5bnhzcSCJGBfHMp4EQJmn66L MN8k+epQaPb1C0woH30dmqO8NIwXuPsCOFcah+yLJCyWfSt/5X65WYXqwXfyN3OU l12nHb77SgjWrKVO/TbYxp59ZbwY7jfy9jz2uylnjvId5dHCl2+4YTtvc2Bf/R5j KNj3bd8Hs7loSXErH5aWQPJN5TulHgq6txPAVNGKRjdQjmM1kKBHQY9loQUMLdQT r+l1R5eoxOyrEaBrYS8/wG2fpvenl3JLpymbP1ic+Y/hbKpAgvgMVQouWYC4J1ZN n7t4DkcZIMEbik/l3zcKCPgVfVQ0s1pNoqcxp90uniVMKvk2G/muQlPgBw2L86bD WiicG8oPzrRdPEmJbfK1fkHukcJLcDJT+qbuKEIkdjz9KZ71HUORfDfHlzoKrwpw IMHbiVKPfQucaLrexXN0W3A3vIIPgn3xGukFZeLFvlF73iZfsJRpC+ziOfSNYmpE GGoQuvR2HPgNN+hJDgraIUUe3UjOtEM85+vopI5M86+vgC9+FJ8R/GQWah8N6vcr fxYzmUwmk8mc4wNH7b97vrSLkQAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_300"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,156.6,396.6)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_301",
    width: 116,
    height: 36,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAHQAAAAkCAAAAAB9f0EMAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAY0lEQVR4nGNgGBDA4hBPV+DNAbTUpJ7OwBloqUN9PT09Wl3vD7GU nrGZP2rpqKWjlo5aOmrpqKWjlo5aOmrpqKWjlo5aSiVLFegIimGW0heALJWht6UW oFAWoGfoKiiIMDAAAMvQX3UavaSEAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_303"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,160.8,388.2)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_304",
    width: 102,
    height: 67,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGYAAABDCAAAAABL1S87AAAACXBIWXMAAA7EAAAO xAGVKw4bAAACYUlEQVR4nO2VIZOkMBCFWyAQCAQCgYiIQCAiEIgRqUIgRkRERCBa jEAgIhAIRP/16xDW3M5ecXW3deLyiVTX64YXwvAGIJFIJBKJROKfIDTz/TbmQE/f bzO/QLNN8cRHBhMiTtDNqNlfWlf3LJgoKGygQnWNmg7EDLF9h82cNott/QQe9eLB dD114I9x2dqJ3BAF3JEffblGPfsSyLN9g5z6YFOQ1QsCX2w8ZFKTAj9CR3XJVRS8 pWJ/btcob8jx7s72DRRVwaYio3UbbXI/nzYaZLSJwqFWs7WUxdHfs6nXTWvkJ9qs ECLalNS3wWbvXlsW7nMKA4nxeNZUxtF4aHdtzM4vEVcC8aKlA6vgYcEezkrws18k FCjhFHosahQF1nGUJyVCbN+wwXhyb1q837/GMIVV4puWvfdyE4l/j+Fv8hGidshg bp2rr7pyqAbujZeqQjQLrIq5KSacinChzqLMI9CZsDZzDo1D/nJ/gjAE5WK7fQDa R+9jnS2rNhzKRl2q6zSJbJ2nNV8X7RegsT36KANp0J7X3FOZHU/xOXd4wmDIQD/z ldCTPOuKWgg5JSCqZc5Jr6AlamuSLBTkRl9BlHmvGGzcFmzGr2zqELUy1D2Js26C wWUT1HJ3HzahpYKN3vs8ypfNsj04TxXhFzb59hSyAfLdssU6P2YxXTZBbUgqUpmf nC8OK5AP7VF4E+WPQyOh+Gm2CT7b8H/tYwpR+2p5U9sirppvPUJI4Ut1h3VShmzm dXcV8Iu2ZZTDTZQFHDgSC/6ZwK/Dmjd1W/0D8G0Sv1cTiUQikUgk/jd+AGtf7Ona uUVAAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_306"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,238.2,341.40003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_307",
    width: 112,
    height: 43,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAHAAAAArCAAAAACFwlOjAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAXUlEQVR4nO3YoREAIQxEUSSCQpAnkenkJBKBRKR1AuY6WHP/N/Am sy4pycvNZLUSYHdhM0Cl535BU61ngICAgICAgICAgICAgIC/AscralxwKn8KK8Cq uu/0qNb72lsvZ2j9C7amAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_309"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,249.6,326.40003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_310",
    width: 77,
    height: 95,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAE0AAABfCAAAAACIfBX8AAAACXBIWXMAAA7EAAAO xAGVKw4bAAACRElEQVR4nO2VIY/jMBBGBxgYGBgEGAQYLDAoCCgoCLC0IKAgoKCg wCAgwMAgICBg/vp+drp7d8rqjlS608lPlVONJi9ObX8lqlQqlUqlUqlU/mG0xWDM i2xv7Egs44tsNM/kuDXW2paoVW+dJHm6NJjw2aFiSp3MxVDbkLIiX4SVpXLEsbtH iktITJRS4onmaeKWYhi2nmJcEpFfb1uXRupYEy4D21L5dnLbJbf4bJvEiVtFtPSU vI5n4tMI2zbYMKeHfS82t7EtlW8nt6kv20iW7bCFzWOeYX0zbGDTHEMYEwPYHuuV u1I5yrTmG/00t54td2KBzdM4Xxcqc+uJxOeb8g1PLJWj7c6r/mFbGe6U5tVTTIFn Phdbz1O8ftqShK1UjjaF9cGaaVImS43FM23TKOxEqxTWNtepwco2mmReZVXWtClr /VvSyzZexjSvtFX+FhqbR1rkQ5eTo5XuJKnVJfNaVHRJFxSkFRiVzbGint1HbtuI vR5xqmY2lOaIFEle4KT65cbO43DGcsxYY+wYR4u7Z/eREFYxPVbCkchdd7rgtvF9 VQI5MQUceSRP8h3nMlIkm+nZfSRd1vPmWCI5ss3nFMHjhz05hqfttiGNSorstr37 yObG5dGyYyuyLQjPKnmEqNhzYrfx1X69KWzN3n1AsT1xp9ktiFnYFuZrvmG+I1VC 6p+2KH6xyb37gLBE+SOk1YiH5HOK4EvT5uTIP3Qr8x9GXlOUkSIYoSvdf6L8KC8D W6pSqVQqlUqlUvl/+ADNbLTU0/9vFAAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_312"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,25.8,336)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_313",
    width: 90,
    height: 27,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFoAAAAbCAAAAADZx8cXAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAASUlEQVR4nGNgoCFgMXCgBZABGq1RTxNQzcHA4EAbo+sFwEZTP5QN Ro0eNXrU6FGjR40eNXpIG02rapdGjYVyFqDjNWjSxBFhAAAesApghA/gvAAAAABJ RU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_315"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,34.2,331.2)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_316",
    width: 63,
    height: 45,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAD8AAAAtCAAAAAA8KuyTAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAA3ElEQVR4nO2PIW/DMBCFHzAoMDAIMCgwMBgIOFBQEHAsIKDAICDg gQCDgoH+f2mOlUlryFRV04g/HXm+++5koNFoNP4V7+DCG74Kxv4t32QTFp4hfq/B nm4UYCBPPs0K6alb4xJrfPbv9w90sAs07HVzUzDZYgXd7ByhI6ZeQ/eQGg/3I+FH LVOZn7tP1dRVP3Ll9iaqkaPUePz/FGkNf95ffOmcp+JfdbsvGC6ag0qNTwyCkK5L mr/9zMfaZSabXfGz2XySRrXsqfFXjiNl7UvIMfvX/Eaj0fhTvgDhLzHDQFjODwAA AABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_318"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,618.6,439.80003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_319",
    width: 110,
    height: 44,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAG4AAAAsCAAAAAChoNJAAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAWklEQVR4nO3YoQ3AMBBDUYPCgoKCwAOBBQEBhbdXQVaPInUGK+D/ BZ5kaOkKW0U6v+HrURi1kYt7TVv+XMgTHBwcHBwcHBwcHBwcHBzcFpzz6LidXJdq 2mrHBA6Fazy3j2uuAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_321"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.59999999,619.8,420.6)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_322",
    width: 109,
    height: 109,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAG0AAABtCAAAAACOk7CKAAAACXBIWXMAAA7EAAAO xAGVKw4bAAADZUlEQVR4nO2XL9PjKhTGj0BERERURFQgIiIiEBEREcwgEBGIiIgI RAUiAoGIQJyvfg9N290725ntO5t979wZfoJmzh+eQAocADKZTCaTyWQymUwmk8l8 Du/qk3ssZ7eJtx4RcW/OFWNhl2p++xpxLM7VogFgm344YuROwyXW0rNxg2EfdmU1 g4vDvT9LTeN9ANJ3KPTOxshq7KSHTRs0Kg5QtzDvJ6sta4WixvZGk6p2HzdfTh7g tgDrjcez1AR2AAULktTAWWzoSy4m9LEfdwbbBCq05jQ15qNZrI1lUhswMGpKmknj L7gYrEEH4U5Tg2JcpuvCoZA1/Q0nGm0PnD6XLPk00QIoZtPJ09R+hiP/K/2+p5Hs G9Uy/xF0QojL78OsOUVtciryb1NjvXwndsWSdsLUrmn5boiOjrQh4FJdo4qugi2U oOk0Ky1GmQK38ZF1hMGR/Ojih4n8v8CxGtBSm0ZVo3KrRs5xbMLM0VBboh9ZDAoq AQpbCvTylZXC4Eh+tk8T+d+ptdFR3s3uhrZ4Zk2BUtHuZ7aUP2/pDTq30gSLaUPx VEtZRxgcyUf7MiX/O7UgDal13BkYk1qFw4gMZsdp411vNBq0crLQx079UEtZRxgc yUf7MiX/OzUL5jmTl7h6d9vLGhc6LSlFo+4DWLzIDcYoLKndbPTXI+sI+9dMvkzJ /6taJUtoRSULEFQX1GoPZICrNh2lCDsw3kMzQj0Am+ZOXiSxiyPrCIMj+dHF03T3 /5afVkB627f4D/r5DNG+HtPbvqU/u5TM/CEFF+W3iWlE/8E5cQ5N7L5LitDW2IHq NvQdTIiaFnTcNYxIN4Ea2g09T85Kb1TwdQ9vsrQUgTey+vFzNRupwm+VK3RkLRuw 0KGhq4cJfKD6rrmym1V7Ky7GQypoD2+y1Nw5vnja4uQX1BYAlDZYh9XFBgM32liC ps5TNVkMS7ApBEy0N1I7vHcLWNoXvQzhC2rGAcPBWs6v9O9UWFNPbFcPtdXx1dp0 RNJg6doDh/duuavFyP0X1DrUSyzHqKQG00x4pccF64ea3YS3dCgs/DGTh/duuavR NH5FDbpZ0QLol7UHYVeq9PtZX6EdaMusoF50I8ipCjKkq8HhvVtAiBQGA/+CWiaT yWQymUwmk8lkMpn/If8AyTMvxbgkLdcAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_324"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,698.4,352.2)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_325",
    width: 125,
    height: 43,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAH0AAAArCAAAAABwPNgTAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAWklEQVR4nO3YoRGAQAwF0S8QCCSlICOuEwSFpHXOXA07N7MrYp/4 Lgnb9TbUdydF4d0jGfMiLZ2ZXF1dXV1dXV1dXV1dXV1dXX0HHfwaPZxeyVHMy2p2 MpOvfv2AiPCOXrsgAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_327"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,697.2,333.00004)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_328",
    width: 133,
    height: 109,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAIUAAABtCAAAAACqpv0PAAAACXBIWXMAAA7EAAAO xAGVKw4bAAADl0lEQVR4nO2Yoa+sOBTGj0AgKhAIBKICgUAgRiAqmiAqEAgEAlEx AoFAIBAV519/py1zd5PLJu/tsnmb7Pll0mm+c9r5bjvTQy8AwzAMwzAMwzAMwzAM w/w9Oq119btNAO7Wjb/bhMAX7OSiHIYSMloXLdNuMdQfqlkn6g9BqQQancfUbErB tBDCcOXGtGK0CrLFDhXJKbxUyIldqLUdkhsXEqV3IVxvsJBoNOpy1PYA6fYBzbKj bYKQ4dkkp+tiaoeZHxbCcOXGcV3bYUOzGhQSM4k25MRuja+eBn6nw9RP1zndY0u5 gBqEnJDsFbBY0OgXjASJ01Rt7z6mjuT3pCUM4U9uGAdqOHOJeppJLo8zThG7tavu XSxv8C70SeuWRxc1DrN3kcEUpwhCg9JNZr5SX/gOX6ePC58bx4GaT0kuxoP++nUe Py5C157bnYsaeymPJa+cTOokuuiPxHgXY3WaMEUQuh1OJ42FkFrFHfly4XPjuDIV aCRCgbXEPf1y4bsl1u2dC9wsQWtrELe0RAGnKg43OBo3oxWgHEAQtIVhB7VBSK0o cx0ghOHKjeOUQ5sVDt2QlK6EYQk5sTu+oXHixkXrW3vzU5W3G3jPr+TeYcOBZdT3 iF+Xn+VXchmGeZLE19caXvNYQTqVk0lbL6RTBq0C0X/JkJu5JDmZqtRkUA3lKMT8 0E83w1Hvo5j0hFmGh3Fzv+JbZVSDR5sco8I6yuJYjSG5xoLa7NyFM/P6jAnwH0dn akolWmZYgznDEenNrVS4jHY6yg0VVC/vA7XV2+1gHJaPusjPafQuJPTucrHawzbk Ql9y6w/ODJdTU/te+52eFryxB128MHt5F4vc35cLvyM5PaHJPMo5lVC/UZ3fEZfr PTmGY37IhaBVXQax4uTKjGrmVoRy4WWqk53D4yPrEzuSk0MLbKjqqkO8MH/Ixp/w C/Dz8r+FuP+2/YXMMP9Ruk3a4XebAHren/7Zo/D3KdWs0ppKaQtTAZWJgu/Hl+gn uh/GEBg61qarfZR11eeq3rj2/sqg9yj4fnyty4surjFEb+LAq32SAit4YRqOSJy1 3S/h46Kg+nqMMeRd2BOv9knoiksfKqKLze77JXxc0MXQ/wcmhChjPTq82idJ3SDt FstFWPZLoLutf7Wp66EsvnYEZYtX+yjNhjaP5cL5ankJiw1U0Jx4yCsETtEl9GoZ hmEYhmEYhmEYhmEYhvlf8AMD+mKrok1gMQAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_330"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,88.8,387.6)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_331",
    width: 102,
    height: 45,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGYAAAAtCAAAAAB5K0ERAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAWUlEQVR4nO3YoQHAIAxE0QhkBYIxEB0BxxBIBmCEW72mjHBR/y/w xKkkIqeyZG+36H5FGvFKc3j7mWreBQYGBgYGBgYGBgYGBgYmicm4pJP+As/2K6eZ Z7l9+VtX9nl5gssAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_333"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,88.8,384.00004)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_334",
    width: 105,
    height: 58,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGkAAAA6CAAAAACW8yi/AAAACXBIWXMAAA7EAAAO xAGVKw4bAAACNUlEQVR4nO2VIZOkMBCFn4hAREQgIka0GBGBQKyIQHQVAoGIQIxA RCAQIxAnTtyfv04zJ27O7M5ebV3V5SsmVd3M4yUBHkClUqlUKpX/BT+cvy9gs5jJ EXk08KXRNoAlGVpqAWOl0sOco33ZKUzNjpX5O/Jt3AxmzlepE+POB/oljchAdjI2 h9P65UVxLNc6kBskApqYkCkOJktvJ/omFe3Fad6d1i8v6od9OAEjIY1JnK4j+0l6 dyJCZj7EqY/Jaf0ifpjwcGK3Wxy6JrT3xUtvveDya/dWJKf1i/SD3PwekC28ssw3 cBfQMQftWeaunO0b9Bah0frT5M9f4p34L3Oq/DOUd8GR3nonh5FsI7L2fBjKyRJx GnXGQMtWe/BlcFY1rkglGulyikrr2WjirZVMOwBa5kWyp934YErruFlaWd5biSOp HwNI3mHfx4dwmCQMRbPuEmGYE+9ORdK6PTtZijP28uKsV9pcijdfihQQ31aLGJGi WJxDGqw4tXuW1TW0lFzvMopmIhrLnCQyikgv8wTxnJqs6SK7ZlLKrTqRJMW9xAVS 4kznEMMuTua+iLDl1WOcJnESjU+pPZ1UpJd5IphpGDW5p17uTaLLTZ1kcn4a7Op/ 2z1/F6cx3Mo2QmS7C/mhOaeXnIq09UTPby5qypko34rgMJQiDRJm0rmitMjpcGVu XTADXFeE0ciOdP2p4UH/GRoVaet9lJv/IbY/nrV3Ur7nH+LlD0elUqlUKpW/xU9L OX7/R/codwAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_336"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,238.2,373.80003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_337",
    width: 112,
    height: 49,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAHAAAAAxCAAAAAAnj3JeAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAY0lEQVR4nO3YoRHAIBBE0RMUEZkSKAEXgUgJJ5HIyGs9wFDDDuL/ Bt7MnjszefkLXXWALvQiFtiLKN+gq65XAAEBAQEBAQEBAQEBAQEBAQGPAtst6t2g +Nf2KL02l71Ui46S/aMReKieJvmfAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_339"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,247.2,364.80003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_340",
    width: 84,
    height: 81,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFQAAABRCAAAAABpzd6uAAAACXBIWXMAAA7EAAAO xAGVKw4bAAADSElEQVR4nO1WIdPjIBBdgUAgEBEREYiKiIiIiIoIZiIiIioqIiIQ EREIBCICsX/9Fkg/0353vZl+MzdzeTNtd95uHtDAYwFOnDhx4sSJ/xJCET4tOiBB flj05qCNopWuAGqtdQPyqhVAI5qOl0S0mSg6AaylRCptKhAd5PQz1iWJajftHThv nANrVlTgnN3XnpZhM3HHGfpgIZe6Gz0GOf2MMCTRMCqzApVqR6REDc5QogJMMyHC zIGvJkAudYsakBL4aqIV1lFUojXmdoiOu4miN1A04fhUIlzvrqFBnktdfBXfiPIl XGjICwRNGyGLCqx5FLViQBGfygQ2w24KLHJpXv5rUY0Z0AXrp2Omm3c7ie6IU34q EhMqhR2nuafS34qa+K0ozVVBfx0DJoEpLjkNIImB+ElEkeKS5VIqgEf6e9En0Fw+ j1L8gOiJ79CsMA2fFhUOvXpr9F4q8py65V1Le7HodSk1h44MTOma8jra2BFL4B37 s+YdzTbR0VrQbeEOsJsNVRjrIOC2G2LCPGJzxHSIzRseLOIRJy8iA6GTinGLVtjq YHVK9chxuOzqEWsd3hBVGNeWRHV0LXb3K7YVEh1TxJA3ueoRz2F4a6Y9NFnU8Cmw CssS23nZ5pSafHSO9faI8dq+cwWNiGsWJXPqgTvnwh3LmlyRUqGB3W77I6Y74C1R kHH95Dmoi1jOFSuEzK4kFFmSVMmQUhyj8g3NL9B/+nlU/AdE/y/Ifln/6kW+AeHt 2H/61XROKvqRV3Imee1pY8ruKqAgv6KxWBM7pYLaq7IBRnzORoZRhY7tYvN8n84u oBNlmNwMZjQ7U2G1u9AhmhSMmwnjBa1T1A1IOqg5G5lr7BYWB/WLfW0stTH9zShy JqZGz5YVWOhJI7Y8dOMbM2/AmPaqIdGcTQwYQ42H3MOz6GziGTLeGMNLExZGDRW4 6RBt/epji3V0Mi3kbGKy6Hpzz6KD5xU2NAHg5Kc11rMlh+oO0e1Ooy4bpzsgLz9n E5NE0bIXotIj3qHw3lpwq7eiIMKwQ3QI1pqCbKs8RHM2MUk0FPBClOw5WVhVRWOq EkGvk8tsQ2XBU2v1RaRsYkAI4CK1XydOnDhx4sSJfxq/AKwIIKkTzz0xAAAAAElF TkSuQmCC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_342"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,699,381.6)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_343",
    width: 124,
    height: 46,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAHwAAAAuCAAAAADPMyKeAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAZ0lEQVR4nO3YoQ2AQAyF4ScQiJNIRIdAnGQT5I2AQHT1SxMSRniC /1/gS1tXaQ1TTVruNPU0hcvOjMK7Y+n9xUOGAhwcHBwcHBwcHBwcHBwcHBz8n/i4 DI3CN98TcJcOx9zV6bj21wS9+I/QPeNS7gAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_345"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,699.6,385.80003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_346",
    width: 124,
    height: 33,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAHwAAAAhCAAAAAA+ZZBLAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAB+UlEQVR4nO2VIa+kMBSFj0BUVFQgEAgEAoFAIBAIEkQFoqKiAnEF AoFAjNi/v7e3E7J5b3eSl8xmDEeQOfAdTksmt8CtW7f+kG4BNXyqfdMYPlbeWO63 Gz20sxQyjGFrYMM6INADeaARi8FSxutaiX+jttrBGZBxXFrzjTx6vWLDiVVj1/zU VXxvOCvxbyxvfhXPcoOuQ78uXG7drIjLz2malOPvwuW1nyrx7+vOzI5neY9Q4cgq +RIH/xNOeAOF5843NVXi36eBCmDUsNrNZIHe2RHD7CafwcOE2canY4GxRFeI/x/i DX5OzTs/6K1bn5BxWHLMtFaawt7qk3YrFuKN54nujjNoh5L06YPmXzxdJXFSm9gE I9L1uvWIYBETuLKKD4Ovo5fHJoGnlt7NlumN11I5sRDPBI+tbmJOEcWVlnwxlBIO KYoLjnThZUttTODKljOPya/lD14xAzjiq0jKxUK8Cn5/li8lmX2i3DxooyuR2ARD 6GkfEcE6JnBls9We38pddmR54NPRHKpI5WIhvpX1xhc8BllaP8jOU4IbE5tgRLpE dsa19DYmcGV1+L5zPaKrMTivzRqoYFuMYpF8cFaj7qAXwCo/OcWItoLoeHgLm2BE ul18gwjmMYEryy3238dt3Mcr/1I/gv8i1bz2PwrfunXrqd+f85Kn5LHIPAAAAABJ RU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_348"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,394.8,263.40003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_349",
    width: 107,
    height: 35,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGsAAAAjCAAAAAC236vRAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAXUlEQVR4nO3RoRGAMBBE0ROUgUBQSDqIjEwBiAgkYlvnwtACa/i/ gTe3F+Fsbd1R29M65elKSxqGs4b0WMXwqYKFhYWFhYWFhYX1I6tu31dfy1Ra3UQd c0rDgrMlbrWsSQOVloHCAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_351"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.59999999,405,250.20001)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_352",
    width: 73,
    height: 81,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAEkAAABRCAAAAAC7ndT2AAAACXBIWXMAAA7EAAAO xAGVKw4bAAABrUlEQVR4nO2Ura/kIBTFj0BUVCAqECMQiBEjECMqKkgqEAgEAlFx RUXFExUr9t/fC+1LdrLpbt5mzG74hbScfhxObwGg0Wg0Go1G499gEoDt3uHkR3Qf 7zBCv4txVNEFo9xCEkOiGWr1XhgfjfA5CWVxND1VfRnqvvbawVqdhUnogRWsqZtv zj5HOMuqtn6LVV+G+gg4nBwkQcbwHXqnRSyds24jurPaitNiY9WX37eq0ymDM7k7 tqL9k3j4p+MHzky71bHqCxTxTa6BMXqhRbIOEVw3nzWsESEnedaJyzdV/cfa69+M 9zWkfpfT/4aw7npyfAkaeeL+rC/6n1h3YaSXcpxzUujnSIPdnUoU+NISuV82CJnz QwaaYKccu0wWp9p+HcIEDCvkKh6Bc3QCSfJMl2emZCB5IJJuRLqVFw7lXzM95mLH C3Lj1QYdi1Pw36R9Hl9HZEiUE/G7GlEXp0/1Qr/3GB6e95DTaYMdkaXxnOmIn26c 6cad6nSf65WqXjG0RhFSqdPEiwqeNMXYI6TI/fIvhsR1ilw7qzCpfuXt4lSNRqPR aDQajb/hB5g/YmX80vCLAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_354"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,479.4,306)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_355",
    width: 88,
    height: 47,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFgAAAAvCAAAAABC2VKRAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAWUlEQVR4nO3QoRGAQBQD0UjEiRMU8CWSAhA4ykAiKAGR1hl6uAxm t4A3mUixjjPQJs2O1FT2NXrvbfcPrtHvrsDAwMDAwMDAwMDAwMB/wom6WsR9JmnZ A5Ve7C45c6MNnBUAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_357"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,481.2,296.4)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_358",
    width: 84,
    height: 81,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFQAAABRCAAAAABpzd6uAAAACXBIWXMAAA7EAAAO xAGVKw4bAAACy0lEQVR4nO1WLY/jMBAdYBAQYGAQYDCgoCAgoCAgwFJBwIKABQUB AQEBBQYBAQbz12/Gzu6dlJ7U7u1Jp5OftK73zfh5/JHxAGRkZGRkZGR8F96IKHy3 6DzjQPyrkRuDiCWARcV9MJpZRJ2IQouD2l0NgPo0H7C+gWPRdvOrgcBhT+DD6hXQ TNQNP4mRWvZ8312pAechmQ8ooitoOsP9Ddh1mKACQwg0qiGYmlqTCD/NcL8vu2sS TeYDzjycRZGnpA9RN60i2kBDWnMvEaGTv3V3lcbzToj5gBtbWLSik/wXRS2dxJcc 9KSkF4macF7ezx+udMXhd6I9RSwwr/2tSaKGbnNg0TDzDsqoSLSkHdWWdHJNy38s Oox8fjKnql1dAB+9qQBdZQugtm0UKCwgEnzkJSrF1yC6sqe2kMwH0UFamfMAjuWL MPHsZM4DugfHmvG/QvGNM4UyMQNZvr3ccgZSpUKxJj5SyfgUJK1sg2QsarR8ZvV9 CT3f4ZU2A4kvhYrGJ1UdqZl2UcBxwf7O6Ya/zbMO1130GikxqidFQ7/cWZTB3xIn q1G6VtT8AIlPlBifXX4IxrMo4i46zGkBWm0SqfCJekWUtfzH8mUc0sg74Gi7h2pf fqJeEJUEYI28P/JMcbIC3TlRs86kd0kyk1DR+EeQEL8dtv0Lohn/IiT/KM5GVt7I EiNXxfJKoYWygsKCwtc0Y/HhcJ2J3/0b0cbjbSyXTFjD+4V0Q9CFJ5PJp6gG75Cc WscTWbWMADUV0yQl34XU2jdUrP2rkSZRDYN3XLRKYdN7ENFhCsQTMLYH5cMzogjL 2FIB0whqvYpotxYc5Da0VH010m2hutz8HE68s/O0bd2Fek8tlXFPy5dECz56LpoI HRd25aXl98hf+UKMAzSdxsrKjSgelU9PxfsJLxVVqrj+CKX75c5YWavJZVVGRkZG RsYBPwCIu+ttBpBeaQAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_360"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,396,415.2)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_361",
    width: 106,
    height: 47,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGoAAAAvCAAAAAAu3wCUAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAa0lEQVR4nO3YoQ2AUAxF0ScQSAZAIhF/BBySAb6oYIAvEYiuDiQk TNAKcu8CJ81zlfLqm2d0FmlOkdxNKu7rEl57qSF+JoOCgoKCgoKCgoKCgoKCgvoR tVt4x0NNSd+YKnVb/E13dYxf6esCY9ZkERL8gYMAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_363"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,399.6,405.6)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_364",
    width: 96,
    height: 81,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGAAAABRCAAAAAAI1fzsAAAACXBIWXMAAA7EAAAO xAGVKw4bAAADFklEQVR4nO2WIY/zOBCGBxgsCAgoCCgwMAgICAgICLAUYBAQYGAQ YBAQEGBgYGAwf/3G7u5eT1t199T9pJPOr6oqHY/9ZNz4zQAUFRUVFRUV/S81SinF nwSgs3H9g+tXOIAjwHVZrlBTNZK/TdbQ9SI2yabPAJsmBp283FJr8waqhzz8HMCR J0AVRxUrjkqi5Ku0Hnh0CtXm0HY5UGPoWIjjLbXDOk3Lw88BI7KUOQY5Y8dpGkqo uEYiN7BZkJjKpADHRYtzn2+pC91KoMLz8FNtOySADFTs5QZocTEJUIO+AXKgw2vU s3lPHXDPf923gBZnzv12EbFlLbsBZs9UAug2qrxCDowOfOTKQk4Vty36HoCnJVGx CvF8a0IFfmh8XEICoK1g8AA5IC2oA6YTciqnTNquPPwc0Kdv++A5TdX8gmw+Y2r6 OnLF6jcARUWvSGi4kCWKZe1AyG4b4Zq8lNzyLlTNVl9Yio+Kjm0PjbXqmuaCFkKl dXRDD3mrvgLokC8HCFxWbGXcV+zJSBUdvPtQt8hzf7M+2g2hRzIiz43PBoHyZhPY D3j14yPAHAVoOvqHlmSpfqUJNQHuQ1Bz6wBWR+mX6LPTbTP9kPnj7JC84AiePQKY wMGQme4m3Yv7ANyHxqg+AYc6MsA4JtHaBOAzNjRjw+MhAAyZV2zbOEpUPY7vgPvQ doD5AOws2bqDAZuPLSISAVqkzK8A8kGBDVtiSCUbNIwiVRBwH2pDWA/y6x1GX8Ox kL1jkNlD/dDR9QheWA36eP5EPXD1719V/0Zj/EmoqOg/IZF8s+qH0VCz0a1L6giS x6ZO1a6VHGCaoH/gnD/VGuSKfI2bQT5EZah7BOXI12BU0uspVtYy/wrApWZ49cBQ 7hsAWQZsJrWrcBGHrZxxTrsX2pl3gEtWdtBLhW6WhSEBVJgPy/bTufN8HYDThO3i RY8tk5F67rU6DNvtGNmLW0Su2YRm9TsuUGn0kvx7p9419n302pBdGwPqu3b0J3V8 qs4dqutfXfMfUuff15VNO675rwKKioqKioqKin6ivwDZWiF2qvysYgAAAABJRU5E rkJggg=="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_366"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,696.6,414.6)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_367",
    width: 130,
    height: 45,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAIIAAAAtCAAAAABHIuwaAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAV0lEQVR4nO3YMRGAMAAEwQhBQEpcIIEiRURQpoh1YoEZmKfYU7D1 lfKDak92botwzWhtEbKC2REQEBAQEBAQEBAQEBAQEBAQEBBeJow84YgKxv7VVX7S DU/TlNbE9PYUAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_369"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,316.8,213.6)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_370",
    width: 102,
    height: 45,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGYAAAAtCAAAAAB5K0ERAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAUUlEQVR4nGNgoBOQCI6nNXBmYWBIrqc9MGFgyKeDNQ6j1oxaM2rN qDWj1oxaM2rNqDWj1oxaM2rNqDWj1oxaM2rNoLTGnw7WyIBGUxRoDXgYAHZuXIrN dZQKAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_372"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    d: "M316.72 357.38H375.458V381.572H316.72Z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask_373"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,396,293.40003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_374",
    width: 107,
    height: 44,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGsAAAAsCAAAAABHiRkEAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAXElEQVR4nO3YoQ2AMABE0S8rKxgAgUAgKpEkjMMIFV2dkGCRnPp/ gZecPChzJmDqI9MFLUSNUR9rCyx4vlbl/5qWlpaWlpaWlpaWlpaWltanFfsclhTV C+xHppUbcrxjD5PiSQAAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_376"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,401.4,283.2)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_377",
    width: 91,
    height: 81,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFsAAABRCAAAAACYxoUjAAAACXBIWXMAAA7EAAAO xAGVKw4bAAADKklEQVR4nO2WoZO7OhDHVyAqEBUIREUEAlGBQCAQmUFEICIQEREr KhCIiAgEYv/13ybh3s27vmvfzL2beSKfmcJms/mWZptlATKZTCaTyfxvKC2irX5H uyWlqPsd7Z4uV9YuFNoaemRKYdFUMMoZp+rTIVBCYWyRQkcNJdZp+lvteYegPXlh POhdaroOvXAaNOmFeulWeYmO8aDy7umaQrXjZeIap7/VXk3UfqzSUMkrBK/upENg uyAJqDkoOBSu/TKTSKH2wAfbafobSuqj9mqEEJC0l3VYT+0hLo6OZZF2r+meQvkX qjfaV0sTB5mr8q3oT+3VNB7TntRxcXSgqsmBGyGGpj15qS0oZANJXGbkXHGGak4d 4qRA+wVHAMWf6FjuYAZQHcTQlMs0/a12vIUn+Ao/2c+obLz90+EZlx9qZzLvUfzv FzhAbVEVAIYrOZ+0Bu4YrqP6GIRbt8DNYh9M20NlQqnkU1cn6xnH5c56W3jV7gNX jwX5KFFXHcRX0PgxCCPpCo93yWZLdeFtu61ARlbJeobm/UrzdqNZ8rfUVMug0z/c p3YcAG3o3C2eXjJ+gmD2VHLQaT1Jc7HZNfa7oE4Ifhl4iNpu6z+14yA8ILqGK1cw V3sqFn9pF0/aN6r0MbR03Y24141/SOSKS0fVUVBbXXsO0p6UB3aKzZray7E0mwnu 03qixovAssKSk2RrzWUUNwd4hwZDmtDrc3DmssGUSy2B33JLGezTeoOOLxj31fOf 0LbhpwxfPZnMr1NMaEQ4KrNUOMXDYKpFwcj2iFwlOy6PIrlhWOCCzaC5M+wuCkP8 K4ZjkI10jg+81tw2cfO32YE64ip7tBO1ehXLmtwQW56Or5qk3vj7XmuneYxNGnAD yM3fisVGXCSQ2wivtJO+T27QoQ1k7fu+y8m377Qfy9+1tRssFn5fT+2Jn9u65IbY BnZ63zsnS7etb7TV0c911A570sKKYsPR37jIqbAnNWvPdInujz0hDU4qX+g32tze mRLUxA3gHBrAG2dotiysY+fXhYbfttGtPnJpClg6M8bX3r/ixw3gC4bcAGYymUwm k3nFHygzNJesI44EAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_379"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,395.4,470.40003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_380",
    width: 106,
    height: 45,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGoAAAAtCAAAAABjF6GfAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAYUlEQVR4nO3RsQ2AMAxEUQ/AABQUGcUbpKSkoEhJkQG8OkGKsoGv 4f8Fnk5nJmw/L0U+qDs0HWZP9PxNLaJ8VM1/qUBBQUFBQUFBQUFBQUFB/ZRqnl6d lKZBuUbqW/5Nqxce3V8ghjEAEgAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_382"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,403.2,471)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_383",
    width: 83,
    height: 45,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFMAAAAtCAAAAAD38QhtAAAACXBIWXMAAA7EAAAO xAGVKw4bAAACIklEQVR4nO2WIY/jMBCFHzAIMAgICCgwCAgwMAgoCBgpwMDAIMDA wCCgICBgQf/+je3cSben292eCk6rPqnVvHbe56nUTAK89BIgHL/ZJ0PDCLU+mdlv 8Jd5T4ciH5KETtsVUwoOdnuTck0OZGAMSGOZi//CoGrLKVJEMHP+5GAvd0Tp2+XC J55Mow4q/guD3qeTaaAchuiYGZzHDt9GS9TSnnZuuKaJiv8UKZpdnEwLmhA6medE 0J6Zi0YjzjnvnaHiP2WOaQDMANPTmqzAEKzD6N0SJGbZrHZt+NuBGzQGU/znv/2X eJynS/XPZ770f8kpmdCFFIS3MQp3S29tsSj+mjbdpXvSfCGuegmR4BVfFqWFm2v0 HdMrNyB2mI3P24EDfB1mi+KBNgEp95nDeNVtlVkTCjX6nnnbGt4VMMQdZi7MYlG8 if5kmkjGe79wglfXz0SN/jHnaLEquMFf4YfCLBbF38TlZB6S8mC3OmdNMLP2/q65 xwoZ0gzvE2U7y2KrN+tiy/qfeephcl7nFtOXFq5q9K/Kp37k/0Vj+7F/6RtL+Xjr LzF5mLiN/R6CUPwv9fHYbSnQxnA8yFxxyQ8jG7/0okjERlG7+XyPqoWe8CiTeGl0 wXPM7VqlJUpFUZ3MXDTbcn+QmcRoaRI7JLrEJ9hBvY1tZZaCnyYenTPEteE5HbRd eUsuVvQEOecbfy3KgniMSY/1f0Wtej7zpe+uHyhulr3JMuFaAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_385"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.59999999,395.4,443.40003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_386",
    width: 107,
    height: 43,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGsAAAArCAAAAABajCm8AAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAXElEQVR4nGNgoCdgMXGgCxAB2hVeTx9QzcPAkE8nu+oVQHb50yGm FEbtGrVr1K5Ru0btGrVr1K5Ru0btGrVr1K5Ru0btGrVriNlFv755NL3sEmFgEKDP UIqDBgMAlbtdbDJ6DwEAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_388"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,400.2,443.4)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_389",
    width: 92,
    height: 46,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFwAAAAuCAAAAACAbiFOAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAC10lEQVR4nO1WIW/rMBD+gEGAgUFBQIBBgEGAQUFAgKWAgACDgoCA AwYBAQUFBQPvr7+znXXrpHartulJT/0UWfkud1+vZ/ts4IknvgclgWL3S+LlBPTN L4ljKsUi9s61sM2ogcZ3At3kCjhnIZ2TsECLOO5R9b58KPVmAAFHrFYdBQxYk2Cc nBRhlnrKX3m0L1iEtQ+lvu5yOA8HBe1Wh5WWqhoUyTPRwoxeWHx3IIz99JC4mZDF QwGSBefmmJeHrlYkQvTImYdZErzdPyLu13ILX2Y/AoubHYI7HEhwWXrvuk38qEEl 1+YR8aJ4fSORluS2LjfzTy3T4WdknvjfUFjUChU3jqJxvRLOOZMoMm+9hWUj+wkr vG9jBD/RhZ119r0B3h4kZBBmUueqJqbaJ4rEZQVSZe8r/jCS8hg0v3E3SBGLltn3 lvg5NGgcsHIQQhJPFInDDifNqTOzjtSJQqHOFOgSkX1vZq5m1CPEopY4RPFEkbgZ 4bP4MiNm3rYp8xzB4tn3dlkGI6ifGnWayCbxRJH4LvRLFj9JbmbcbqokniNYPPve x07EQsp3dOPFrdmKLtcv9yCH+/yJfwfJh8bruV+9TmalvzKtn8OdZTzuFK+k6ayy rRvG+dqr6EbDXaM0led24rlXdNjVonM1n9UHt0s2U2B7lHKDieJDvID0Ax/hktRF 7XQtPrXKaG4PLBHKWvBe6y1vwrqgEl7Fjcs2r5Ce6qwXqX0U14EP/zWdz2/i5YcG k3Yt/0EOdla52UOcumjlO4MPyx7R5gOdWLwkr7vBZ3EzcLerD+U78WL+sNkWsYmX GOoguXHoQ0DgK1zDPyhWRNuW+Vx5vXcmiyOs2MXiXcTjn72Gncd9EqcxiKn33FOk a+3Uk4AfuLLRtom38PUitrLA/EHrHE/Ccai4RCxxJPpw89j6hlfRfqmeeJskhc9h 2rufu5snyVdgvhP8xBO/h78cGrFsvsbOJAAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_391"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,696.6,442.2)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_392",
    width: 132,
    height: 29,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAIQAAAAdCAAAAABORpvwAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAASUlEQVR4nO3OoRHAIAAEwZeICEQkhUTiKSRFIL516OIZ5raClY7w TWeNnUgf7EdKF+xKggQJEiRIkCBBggSJyxN/+jCL9PawpgWk1O7KIUTz3gAAAABJ RU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_394"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,696.6,460.80003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_395",
    width: 132,
    height: 45,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAIQAAAAtCAAAAABKPJxdAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAVUlEQVR4nO3OIQGAMBQFwCeRSARiEWhCAASCCEjEqrME2I+4S3BJ llZqzbD3YtdIVB96nyUkJCQkJCQkJCQkJCQkJCQkJCQkPhN39eGZknactbb8wgub W9cvhMl6nwAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_397"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,396,321)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_398",
    width: 108,
    height: 36,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGwAAAAkCAAAAABJBoAQAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAYUlEQVR4nO3RoRGAMBBE0RUnIiMoIBKBQOIpA4FEICMQiGudyQw1 rPq/gTe3J1lbTk/HLE3p6i1qmZfjsDuzDqw5vrWCgYGBgYGBgYGBgbmxrRnaf8xV VTwuq4dUHCOOQh/FEU7Tqr5mXQAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_400"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,400.8,322.2)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_401",
    width: 94,
    height: 34,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAF4AAAAiCAAAAADzWTEIAAAACXBIWXMAAA7EAAAO xAGVKw4bAAACEElEQVR4nO2VLZPbMBCGXyBgICAgIGCwQMBAYIGAgYFmDAIOCAQI GBgYGAQEHDxwf70rO0nTXDvTgM6007yz45E38hN5vwy89NI/I70Arvw5/qETM0Sk rO4t0HBQMIkaOCL5a25gr2YaULRP4fWizsg9rSbPYbWI3TAih65goXfExDMy7dac KXPITx6/pPr0bOTSM0BJgIdxwIIz1pROJue0Vvyx0Pg0Xn/oe/wUguCDl/uKl6jV d5vkmvtEdHwS370dcMEv3aoxcz196E5CPCMdKF6DU5Bo0eY5vCGFmjancuiNvEw0 TpxkW6Da4O5Sqx3Uc6n9LjnhS/+h2k8ndbkt/TvvPrfMi3rcaEOdMFY3UeouRI1W SQXaOkt07/Xm0xq7NQau7gOVWvb2OFn04wXfAMf2ge7nkNJ66HgNs+9qi8aBBz/T 5MEjnVB9zNhtTsNI54pPxSUq1r4BiW806cMftVV3NvVZymh5BeZJiddmcEnSk+KT Ran4dEzxinclUW79eI+P/WNssrvhfU7S5lDTorLd8KN0ffXJQiLAb5mTLn7HoxQy 07G5w/PXD0VX/LDhTxKcwxBXDMxjN12Cs+jquwTnpDjJ9+CCd59kiQz6uXSok8d/ jOkx9pIqDavAMcoAYWe3ySLemloivfluqdVmHz01x2ibDV8LQ83Ytsvtz8X8ix9+ S/7LqV966a/UN5UHdE0DZ3jBAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_403"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.59999999,395.4,343.2)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_404",
    width: 110,
    height: 43,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAG4AAAArCAAAAAC8peL4AAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAXElEQVR4nO3RsQ3AIAxEURcMwCgMkAKJIqVHyAgMQOHVMdSpr/p/ gafTmYmr/onymtwbskZyHkszboVfbmpem3BwcHBwcHBwcHBwcHBwcP+crMN1Hfck V1oX1YptkVJiyKxePfkAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_406"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,398.4,336.00004)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_407",
    width: 102,
    height: 69,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGYAAABFCAAAAACdjMwmAAAACXBIWXMAAA7EAAAO xAGVKw4bAAACaUlEQVR4nO2WoZPjIBTGP4GIQCAiIioQEREVESsqKpiJQCAQCATi CURERcSKE/fP34N092a6Ozt33fbM8RuaeY8HvL4SvgI0Go1Go9F4EIcD0I9PTyMz YPXT08BOYoUnCnDOn4FlCRLO+AGJLA4uDgh4b9W/B5lfTtjAbRvEpYME+4TxrKIi ZMHl1ig387r795XzKq9pAK9wstFgNVmPRpH6QeSxEf3kAdpe/bs4huuX3RRyJ1e8 GK5GRau5mrWM2Ku5kLj69xBXdf3dt0C8NzG6GYF88JAWc0zmbWN6XP3vsX1z/h9y +jdpGv8DMiwOUN5Y+AljgjxD2fKUdjfP3sERkXNp3KOymifPYtYF4/uyRJ2wh4Uz Ud6kER2CwnTmY54T/NopLyIfeQ8WlmIOxKKG2ahLp1bUrmr2CSqXcYsuS9QJe1gv IHWbxho+9GbiSAh9dL3yVvP4V8pUTRYa1DSsXGUd7qrmbMrxVaslWZaoE/awSGm7 TXNcSjVJgA7LmOfzqDaLt2qKqd21GpZi7i9d1dQsPXXcnJff1ZSwzOJDNSoHL10w JvlJJDGOMgi87U01XWL5GmeVE2nUrt20KfDe5OR1WeK6NyV8PMLe7k2lKLkyX78r yn9m/hUTfzr99Zhu+sxsNB6ALXe188J3tSH48k/qWazMEhWfgHkQd77WH6DS6IC1 pw7UV08pHA3fGI0+vTw0DRfBIgejy7Ek9WK9gfqxrRfx0DQDslwFUo8TC2y/YjKI g9FH+6A0tjRyZDDFcMKYjYk+RDsLvp7Vi/TjoHdr1tjl7xnM79ZQ1L3JWaPRaDQa z+YXb6uegNSkRoYAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_409"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,157.2,418.80003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_410",
    width: 115,
    height: 59,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAHMAAAA7CAAAAABtI+o7AAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAa0lEQVR4nO3ZoQ2AQBBE0RFIBJICEEgEEkFCCVvACoo4Set3YOhg QPzfwMtm5EpftO7Wtl6aLnMhLW4zH3MwLpmYmJiYmJiYmJiYmJiYmJiYmJiYmJiY PzDP9FVuc3b/AELqDuOVrRiNS75VC7GW3ZJ631kAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_412"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.59999999,165.6,412.2)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_413",
    width: 86,
    height: 82,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFYAAABSCAAAAADrrHw9AAAACXBIWXMAAA7EAAAO xAGVKw4bAAADeklEQVR4nO1XoXLkMAwVMDAwMAgICBAICDAIWBCwQDMGBgsMAgIC DAIMCgIKCu7nT3I2c52218t2buZ6M3mTWcvS5lXJVs8SwIkTJ06cOPHPUAcA6/8+ b66BeoNYg4FKHJUB0GjuYWX5zwKIjy9V9kfQTZBVDLRCnCgrID9dIIYQINELuDFG iBYi8qd6wrI/lu4Q5MYEsQbvOCXHRM4Re1bILa46OpyFNiQs+2Pp/rB3WsuvA4IP TNv7WxWZ9gkR5Vky0w6BsOyPsFb9CHdaXy01ZCPZWvMcO6YdW6j3l5AUYdkfSpb4 oToNPadILQCS69hJ7QVgAH3lB+BoZ+VCW/aPIR78kR9EdeilnfgOqJGLXpVLKqhB 0QZdiRKYIgdWyZfEPlZhG1aamyapZKYwDWAz64NOlBsuEUKbYPQL8pdaKPHDyBhq CKlvbmxD57m6qlkKa6NtZrxMbMMWP07bc026lwpJbiPODOA25p0Wo8hmkgJ8iDbB 5apTnUy2XapWxOfKlGwzxsHlZtFaNANK/Dgt0aCaBlzVENMTI/KWNUBMCtQQ1SBS IPHjtG9SZ7yWaktfZDrx/0CpcvzvawNbU1COK4UiAtaA0lA+oLQRckL+6TTjsqG4 ryb7eCWuWpMoIfRTjM1MWYIJegIz+cVgoqaEP6fFJe7rlVVELamCq4N6htBivFyZ cae9Et4G3mzhT2lvqY37SpLCKH0NsoDBojBCDr+ypQHRynOV8Ke0LzXGfe1G45D7 DmDDU7fgMF+EkZUmo4+6i2A105bwp7S2k2tfuU1wBq4Aji4sr6wMk2EpsEUZJmQ3 aYtb+KuQx8RXnUaPX6Y68Y1h5dADVSaCIgAyKhjDMwOi3lyVvg8NMi0Y1HdXaRxU WVlD3mAOPBf0Y+QBgStdFatPt66mleriCn7uVTahc7NPag7Rg7ggSeuerF7xFiK9 oeXgCgviCok7hLZYT+X04//X4gI9RMA887zCu+S4eosr8RzBtLeMs8EPaWUOEMu7 Yj3BTiuu0fNIY569uMklniWguBLPEZZP54ht+jhbrkfuh7xdTLGWzrYbrbhWSW2s l2pyvEu2ylBc20vgQQPT+2x7zXOBIZ4D0oV7q2LxB/8OXK/F1fEIYXqoWy1NAsuB LS65s9O9ga5yIALxG6T3A8MHrodRvx8YPnCdOHHixIkTD+MnT5TSB4ydmmMAAAAA SUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_415"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,156.6,454.80003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_416",
    width: 116,
    height: 36,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAHQAAAAkCAAAAAB9f0EMAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAX0lEQVR4nGNgGBDAYuBAV2DBA7RUo57OIBhoqQO9LY2HWErP2Iwf tXTU0lFLRy0dtXTU0lFLRy0dtXTU0lFLRy2lkqXxdATlYEtN6N1riwZayhNMT4/G x0fL0DM2EQAAZ55eJE20Bx4AAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_418"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.59999999,156,448.80003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_419",
    width: 121,
    height: 58,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAHkAAAA6CAAAAACxXalXAAAACXBIWXMAAA7EAAAO xAGVKw4bAAACJ0lEQVR4nO1VoZKlMBAcEYGIQEREICIQiIgIBAIxVYiIFREIBCIC gUA8cWJ/f2cGntlXJ253qbuqS9d7YZKeThOKagAKCgoKCgoKCv4ZNPS36nt7VGEK f67aLajje84qB/cFWbeAnwwiWuvGAUCP2ECN2EKDWEOHHqyD2vFoOpkDGKYuvodu HPwl5DXLt3FqmJVmKV4PnXVILoWwNXEAa/UOIahdTX1yXdSLDQgOIaDakswBqL8C 4ec6DuPWPoW8Ru3UwRphuTlI8XLofeE+DDSYFVSP7xCWNMNaoYt7fviQMbFznJLM ZV8Q/o2OtmIHdT6FvBa29KZEIyw3n8ULDnc5T9DMdIUHnRnmJgO6qX3eP4QtuiTz 01kxH1swyY9gTqGsiZNohOXms/gEFzNczr/i5mCYp3fwC+atp11sxmiezsolmZ/O i/A7ZnrKNIhQ1nzGXYtGWG4+i09Q/D5UGnQV0Gp+NzRt7ZyizloRrZnlXwWqlrn0 w5NXcA4slDVF4ksjBDefHb8DPbSC/xsq4F96Cb4WzD8AO/VeUQzrjhNdU1V30FJ0 0NBCNWB7l3PYuzFSmOQEjfZcUabM1dzZzXgwTbXf5jxwxtL3jBIQN+cok9N45GOc 5AsU8HGXs4+gs1tSzdnbrXLmgU1l6Olh3OWsNlxbdyhy7jFN4qwzTlZvOINf43GX M+U4hTbFMCe6kfiuqaqv1De1uc+5oKCgoKCgoKDgx/ABjgeAPVEl7zoAAAAASUVO RK5CYII="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_421"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.59999999,616.8,347.40003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_422",
    width: 110,
    height: 43,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAG4AAAArCAAAAAC8peL4AAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAQUlEQVR4nO3YMQEAIAzEwMpgRAJOkIAUrFMT/HQxcHuqasxU1a0b aze3c9zB4XA4HA6Hw+FwOBwOh/vKhb9K9Bo9DymibxaVaLMAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_424"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,617.4,375)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_425",
    width: 110,
    height: 45,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAG4AAAAtCAAAAABq/AHlAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAUElEQVR4nO3YIRUAIBAE0QtBBELQAIEgCBKBQFx1rgCSFbyZAt+P mbiyXNRIwW2V5t6C02ne4eDg4ODg4ODg4ODg4ODg4H7iqkyb+dX5unUA24T3MCz9 T5kAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_427"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.59999999,617.4,404.40003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_428",
    width: 110,
    height: 43,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAG4AAAArCAAAAAC8peL4AAAACXBIWXMAAA7EAAAO xAGVKw4bAAAARUlEQVR4nO3YIQHAMBAEwRfwUgriqaCgIBLeelTk0KyB4VuVrd+J 9XU9OW1m1cLhcDgcDofD4XA4HA6Hu8b1n9N2h6fRARjWo6HNeO4qAAAAAElFTkSu QmCC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_430"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,394.8,213.6)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_431",
    width: 107,
    height: 45,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGsAAAAtCAAAAACM1cqhAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAXUlEQVR4nO3RoQ3AMBBDUYOADpABPEJgtinMCIG3ehWptLBG/y/w dD4p2bgzDalXqi5XrcBVq8rHcuBTxsLCwsLCwsLCwsLCwsLC+rSm/2++Vijr2iFq N6kFFjw1PfjDYvn4KV3IAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_433"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,400.8,207.60002)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_434",
    width: 90,
    height: 67,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFoAAABDCAAAAAA5Gk2NAAAACXBIWXMAAA7EAAAO xAGVKw4bAAACRUlEQVR4nO2VobOjMBDGV0REIBCIiIgIxIkTyIqKzCAQFYiKigoE AoGIQCAi9l+/b0OZ15v2eu28mafyG8rSLHwsyfJBlMlkMplM5oex+Gn7PY2z00Px MKqWC1Eb9bekT8s8qsfhAxtaztoBRYUpXElUOTwGhra9oxSQkowhKmzanOypqhCK CuFJ2eea6yODhnxYea2adYgdHeOwjCQJRy6OIXimhmfuKB3IhoMq9nt4Una8BsmW Is1Gx65Q1M64DbUTna4O0i3OEOkVd+TiTlrN3O/hWdl8/JImCr0ZmaEVpfapE+lq nqRqeTDH9k76NM79Hh7Q6hqLv6o+XYatTMJMcS3SJh5aqToe8ZD6TnotQ7+HB2pG 0V/S6xpNi1kOMtdh4pFE+jJtE9LFAWenhQGzxyVJOoXHqmXNZbmVk+JThziXOgC9 4TTGNdmKSisdYlKHuEQbpENMRbfwGpnrt2nCBydL8ZnMK6pkd7ZANyurrROrNGh1 W6JzSzSzubnfnnyfGS9ZScFTx2WAlZxhX+sY6+DV0p5YvOXAAe53S35AbJok/Qt3 CIPC26liQ9dr8B5OI15QRC/utyU/UDZcJel+7SHt4R9lydMwdIG5pSRdci22siU/ kO4mStLc47pwEU/R/BuJ4Bt8jVLVfMCcFFvyfWWfDC1SmJVIr4tMJ9xugu3hK5ek qYf7ebol35ee0AMHlg7RTgWfPotkndPSIWgdV6T/Rh5jS74tPWDndvdDpf/mZfK/ 2Fer9DKZyWQymUzmp/gDPQPA8OT8rZ0AAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_436"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,394.8,242.40001)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_437",
    width: 107,
    height: 33,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGsAAAAhCAAAAAD7FwraAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAU0lEQVR4nGNgoCNgya6nD7BgYFCgk1X18WC7/B1oD/KhdinQIari R+0atWvUrlG7Ru0atWvUrlG7Ru0atWuA7aJbe16EXnZFA31nQIeeAwiIMAAAeR1G AYbwJ8oAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_439"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,397.8,237.00002)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_440",
    width: 96,
    height: 53,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGAAAAA1CAAAAACbsLGgAAAACXBIWXMAAA7EAAAO xAGVKw4bAAABk0lEQVR4nO2SIXOEMBCFV0QgIiIQEYgIxIkTEQgEIjMViAoE4sQJ REUEIgKBiNi/3t2Emc5Ba9rKfHOTC7uPfVk2AIVCoVAoFAq/QcmfMjsiTn8tbzYq MqCGx3ZOSbQQyEAYkxZjKlCmAai0MAqar4BWpCZRkla00fJIg9x8rZ3YHhr7s0GD LRsIv26LuFM3OBhc4gx2XzEaDtgUkIg1rHjP0g4Vv5bSAB02XKtH7y/N9ShZ2e9C YWvpNXRSQhfBohVhBhfogBzQ6F29B5elczZIaVoxTaDCawMw0Ucj5Tuf5TBQT9oD 75clVUiBFjvvpuWQzphHlw16ao7/4nrpoIpjMnC7oKdsMK7UM+2NCM9UIQW6oDC0 0zNL7UsHmr1asY037E4GEROD3NclqGzQx3ljgxhoPlwhBZyHjyhGD0nqXgxgpBp+ iBL8Jl4N8I0vjndQ3XpNl0QAXR1jlSGDhiKgeHwcqDXQjx9ZysqmPtLcQ3evNMvN 2cDyurjLbNJH+Af4Fucrfkaez1IoFAqFQqHwDZ9U6n4WmfPBKAAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_442"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,238.8,213.6)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_443",
    width: 105,
    height: 45,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGkAAAAtCAAAAACIIBqcAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAATElEQVR4nO3NoQEAEABFwR9FwQCCAQwg2EAwgEEEq1Os8NO7BU7y iWMZtDfNY1Gk5ZkqExMTExMTExMTExMTExMT05+6JdpRUsoGQRerXpcrZ7FrmwAA AABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_445"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    d: "M238.8 357.38H299.178V381.572H238.8Z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask_446"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,697.8,246)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_447",
    width: 125,
    height: 45,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAH0AAAAtCAAAAACmZTsOAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAY0lEQVR4nO3YoRGAMABD0YgOwACIDoBgBBwSiewACAQCmdUxvesI Qfy/wBNxkaKV06GuWVpSuH1Iq71vid6uT5HJb3R0dHR0dHR0dHR0dHR0dHT0X+vB zyr715WWwp8aWXz0AY1HjrVaDTz/AAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_449"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,706.8,238.80002)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_450",
    width: 97,
    height: 70,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGEAAABGCAAAAAD5xKXxAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAC4ElEQVR4nO1WoY7kMAx9IKCgIKCgoMBgQEFBQEHAAEsBAQUBBQED AgoKBixYcPB+/ex0j+ye7jSjG5106lNVxXYmz/bUrwVOnDhx4sSJE38TXQRseCnF 3iO4lqhHh14dvdwbMWH11nSShYE1EkZrqv0gxozdpMhvSJl3gyuvHinGiMLfMOVl RbJIJHdzp2o/XAQHPaMgSTWTZD0lpGlaxPOG/UL3Jk10U4ZUqNoPF/G9/WCwYIcY nDC4sPZJGO5EpBXuwuCZqdoPEnROyj4YUnfvsbdeGGz7nkZhWC8YfnbpBqZqP1oC S9VjAyet4Qsw8DiKk2kGPIyXsiQ6WowtyFb7aUiqL0b3aIP/bwwvbnjYIr2UYBCp Q9PieK4boqZqTttUjwxUJ0Fjm6arszsYdUJVSn91XEaaQN1xjvnSEJ+XnRy3hUXz MOfE3tuCbO2Nt5b35BwjstviRpBd2zBl3kBLyBI4rsjjyrscVtefGXhGv7oUHYYF iD2xKdMugx2ulJwOr+PLxi5gSJARHFYXqGg17y5R4CM8zyiVQdZfGBxsdqUQRHiw GWHI8S1escxEbWVY8oUluy5hId0c/K0ZV/fuCmc+wmYLtQZdf2ag3EYv3GsrwuNu 5KVN2qV2TJDWK8O7JXZ7Hz3mpJudKV10/bePLmnY+6MGXX/5q0epoidMPKlyM+fc NtKyQTxsVIAkaMkt7GXzpCWzNKth7yRwXBI2UH2q698+WEnz+KWUua+p/WW0L5fB E/8AA4wIktVPI8D0hyVK9SFWMMeGoamC9jhIJIr4LY4FMnpDDqVTi0nmX2P2cg9s xSU6kJ96S68dpoBicVeG1enHkVjsRadqbCXdViyT355iuFlQ1DPnZS24jSLolSFx cTV2sx8M1/XX4/knhNCuo54JrcHP+k5QBu1SjYVgx8pwb55jwMxygNMXjgiUWNdq kaTf15h8JHXqErPvn2I4ceLEiRMnTvxr/ABOj6TP1FATVwAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_452"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,697.8,275.4)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_453",
    width: 125,
    height: 36,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAH0AAAAkCAAAAACBamrGAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAY0lEQVR4nO3RoRGAQAxE0S0gAolEIBHI6+EEJSAoAIFEpHUyDBVg 1vzfwJtsJG9tN9VDmtNWl9bMw3L6ndurD5aPn+jo6Ojo6Ojo6Ojo6Og/9WVydH26 q9LDp7faPyy7V6P0AOgfeAMENSnBAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_455"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.59999999,702.6,269.40003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_456",
    width: 110,
    height: 58,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAG4AAAA6CAAAAAB0LzPGAAAACXBIWXMAAA7EAAAO xAGVKw4bAAACK0lEQVR4nO1Voa7jMBAcEBAQsMDAIGBBQIBBgEFAgaWAggKDgICC gICAgnzA/fyt16nuXZ+e1Kcn3RGPKsuzM87UzsoBCgoKCgoKCgq+j/4K+Onf5W2N /CxzC0tjA9DIAKehZSt/p5cJYPNYKT9NuUxPa9Z5NLn0XPBpe3bBwXzgEd1e4cJz h41DqDZeEd0l4gBWyNj+IuXIplxOU7WqXnt+ZPVc8Hl7M6eVRxoWi5qXgD1Etjes 1RHCAzIkQ71uRjmyKZfTNFlVJ3ThllWchVe4HR/iqq2bguzOx2GQuAfLMcnekye2 q1GObNKyTpNVdYLpNlIVZ+EF/t4/4+KwoTq6JcWN217LMxbP7nmYI1ZSfpq0nKaz WlWngXej6rngNc62+a22OKyvATMYgrQOUeqEqvf0sVWUn6Zclimr9WylkbL6Rav8 wfG1VFDwH0HMXJlGLj3Y1O7CTQVTZ2ouFkKpzg6tUeAa9eAqqFFlsDdvxUXHO8V7 v1t/7XaTeCREhlLPi41UH6yOXIuuX+C7ywQ1Znlw8b04kltAhnGQm9qP+ohr2BlK TZibSPPM6si1eJ0u8vkIazaqfPtJnOP7GdfwwnHy4a841624O7dmo8o8fytu7fdm kpNqNE4PU+koX5W4QOKSI9fkMDesfdqdHmaSt4bei5M3bavYyqUnr7tRfrZKoja1 Si29kB1ak2aq0XiyZ6uI3Mg9+16rPLf4Y0dBQUFBQUFBwY/xGzdol4fIn0ZRAAAA AElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_458"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,542.4,213.6)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_459",
    width: 98,
    height: 45,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGIAAAAtCAAAAABwwOFrAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAYUlEQVR4nO3RMRXAIAxF0UhgQECEdKgDBgRkRAJjrBc4tfA79Lxn 4J78mH1QaSGslUX0lNYXETl1R8yMQ4TuCwEBAQEBAQEBAQEBAQHxW2K4rPES0jZx a4lr71V1O7lXswe+30ncU8wrpAAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_461"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,545.4,207.60002)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_462",
    width: 90,
    height: 67,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFoAAABDCAAAAAA5Gk2NAAAACXBIWXMAAA7EAAAO xAGVKw4bAAACR0lEQVR4nO2VIY/jMBCFBwQYDAgwMAgwKCgoMDhQUBCpIKAgoKBg gUFAQECAgYHB/PWdsdu7XbW3195Ki/wpihuP9TpxXl4AKpVKpVKp/DDY8sngtzQ2 I+wP99N7MqDS8VvSOk5xdz/dhAv8Im2stRqgU53lOWv5NsztnO/LWtWhVBSvwny0 kGcaHjrFw4O29eQhEdEKQDPRCdZ5SQhpmWgjBQ/wFjw56tUcQ9BAPaz54B8jtbfh Udu0zVWRvsCRVAsN7YAcxi1S5z1fOhDpfUIVTh+lHWXpPDxqOzS/pXtw1B4jiday rGZLiqWhj9J1vjH/9kF6TLnrMtyBHR3hU9cbsqVNmM7jBCJ9nrV0fYhNE44fpGlw Il2GOyZa8Y90jHRWaZmT4732vPUbkTayZSzdxmXl1fJghB0tTZYuwx1Gnrk8bt3J P4hDWqvZ6R17ozVsLQPIz98ir1HFITYTHDtEZYfAQ4d8gpt/ntW9sFiar1S+gJON 4w7Z4VqjQQlD8TIbW5wrZlYl/W7F59nxOzZyjEAbR7cGSvy6LHPwPLNPWt5Ah0uM QV+LL3BYYRXpZqLR0UbFE/QrdHQiDAPkLBii4vS7Fl/gci7SwzKxNMfcCGP03g9E EYs0BxbHyrX4PJi2RTppz9JGGhsWLjhS86VInwKn3+lafJ4SaAfHeSrSMfB2ctr5 yE3yVy5LG06/gNfiC9J79sDci0OM5pzMn0W01mSHILRduVZwKz4vbfnk+3Ih2/lX viz+E7T/W6xUKpVKpfJTvAPTecDITDVMkgAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_464"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,543,339.00004)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_465",
    width: 97,
    height: 44,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGEAAAAsCAAAAABQq4nNAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAXElEQVR4nGNgYFCgJWAAAvd6WoJwoA3xNLUhH2xDOs3CKBpqQzwD rYD/qA2jNozaMGrDqA2jNozaMGrDqA2jNozaMGrDqA1D0gZa93aDaWpDMtAGHgsH 2gEbAQYAK5VHzJDMLWMAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_467"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,547.8,328.2)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_468",
    width: 84,
    height: 81,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFQAAABRCAAAAABpzd6uAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAC80lEQVR4nO1Wr4+0MBAdgUCsQKxAICoQiIoKBALRBIFAVFQgEBWI CkQFAlEx//o3LdzlS/bYSy4r+5Ltljevrz92OwxAQkJCQkJCwoeQGYL4sGmJSqL8 sGmDJZBpNvm9BYGInjGLO4d+ndE8icAqEs/DAsx7cUr7A8B3jxh+NZWYBdNuzzuf S2QcBathsRSQAiVbLMsjwXFnlcP6lI4INCyL4VfT2YYozIdZsZIIBYqs086RKYBT oAydeyA6p6ZxOtpTuqAx4dRC+AWZl9FUb4wxOE2nrVYubuEY46hIjCt3jtnhlNKe 2J1pbtHSlK7iOEp9meqt3YLpqrCJoyKhl8wf2aIhSmXc/s+mBf32hEMA16YDJiGX ZaEn3pGpmOmv1tAnEqKBlsfHICUlSHaGX01Z+HI/hMJa/oZcFuGrK19DYS0JCX8C 30a0Bcgd9QOER5M3+IBt4v4By7JM0G9wMpeGefRX9xYCp8ZPDYp6H4E9KmwEFpRM qJWUN+j2OjiZSyOQs6v7xrQAY0ZHl5xu8rJtmcDVeDIVfjOzY0swDcylCQO+5Pem T7BmoLS7kIq12Ial7GR6dMZUxjgHJ3NpgumX/N6UDrWrUI0ooOddMD23P9MOSPC9 /UsTHq7uG9N26QDqSdW00JmyVSlz6JrQijCOfTGXJjxc3bdn+nHEiRMSPgUqjY46 1ESz0ZSgoLR40Ks/G1agu+h1zhCpqIg0cA+w9dRm65TrHd2NaYucV2zZWY+DwAHK GrQrcfBNuPCNl8JB50+aGHqfU40FIxUMR377Glc2tueAdYGsVZRAFG6UhSi0zsIb N160oFRI0yD3m6qPwdyaum/THDYNgwuVlD0oQysytlrslLieJy2ohNrJdBdG5aFg ujHlqJQ4Ta1CDtMurOt86ccQmrAWRz36Z6S/t6/AqNE/7qsYrtUDmo4GxOIpFk5U NfGeKiU11fAczFidNKUJKmdY2WcgGtL8XsWIPxdPb1D+Om1CQkJCQkLCf/gHln8c SEuRtAsAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_470"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,542.4,278.40003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_471",
    width: 98,
    height: 45,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGIAAAAtCAAAAABwwOFrAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAaElEQVR4nGNgYBBQoCEQYQACk3qaAmegFfG0tSIfbEU67cIpGmpF PAPNgP+oFaNWjFoxasWoFaNWjFoxasWoFaNWjFoxasWoFcPWivJ4moFisBXhtO13 JwOtkAimnSfi48MVaBcLCAAAxiBKK8eS3xEAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_473"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,547.2,271.2)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_474",
    width: 84,
    height: 70,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFQAAABGCAAAAAB3HuyNAAAACXBIWXMAAA7EAAAO xAGVKw4bAAACU0lEQVR4nO1WIdOjMBRcEYFARCAQiCcqIhARERUVbwaBqEAgEAgE AoGo+MSJ+/P38kJP9ObmKzffiZvLTid9W16WZMouATIyMjIyMr4clwlou69W3WrM lWP2cDZYwN6C3IqDgZffTOulkPsatIAzyj+Hm+yEhWjFPFw2g0B9EB56rPTA6K9y FVisjPV3q/ydpc5Op8VhIBTtwFh4JDvigQ/mb8L4IaJmmazyd5b6wE/RkWR9VxEt 3OyvIrrFDtnHJqIDDXZ7RxHwk3+KTmE32N3Mcfv7VoroeCX/3D5jsMo/R93EIX6W kgqgJGtRU1PKnyaXiKxeNXGsjPIzWE51Z/zDcCideDyUyfJi/pBo4jEBamYufXQ8 cSiOBNAZEgqp9wULbk4ebbeZ+S6WV/MrhfIrdcHSBxXqePHCPVlAWxZqjt5XUR5M NGFHanm1lNIUAYWTBEA0cHS8REGbEuA54+h9FaU12hBdo5ZXUaUpAjQBVDQ6PkZB SoDnjKP3l+27HiMHaZ78blRUaeKaACoaHS/bH4/t6wyZn3pfUMPU0dkmWV7NrzRx TYDofXV8RamqjbbUUUB7f4tXy+cI+O/Q2NCgCLdCXO9h+WbRVKhI7H+JRRPPAu6k KG9uvpBrVzi6t9xddrA3e0dzW8WCwTc6+7BJ7lx6ED9klXPFU3eXn/oh2ukoAv+J qOvvQc4khZxQ2DdrwVPvk6gW1XRedA9rfb+x7Jrkq3MiuppDNBX1aa9xoAqGqhqW anG+2N+WkHe/vOpTkdLhnOg7546MjIyMjIy/iR8zppL0TzLXhAAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_476"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,316.2,379.80003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_477",
    width: 105,
    height: 48,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGkAAAAwCAAAAAA3aAvZAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAYUlEQVR4nO3YIRHAMBBE0UiJgAOVEAcVUHASAgIKCs56D2SmUwG3 6H8DDyzb1nTZivpWT+kSQBFnSh5zVHdvycsXmkhISEhISEhISEhISEhISEg/Sfd8 qN6cQwE9Vr7Q1wt5JWMUbmTqbgAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_479"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.59999999,315.6,377.40003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_480",
    width: 107,
    height: 58,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGsAAAA6CAAAAACSBviCAAAACXBIWXMAAA7EAAAO xAGVKw4bAAACMElEQVR4nO2UIa/kIBSFj0BUIBAViApERUUFYgRiBEkFogIxoqIC gUBUjBgxYv/8XmhfMjN5m315k7xks3wJ5J5yc0+h5QKVSqVSqVT+Cbo82M94LRI8 /YwV5AJjpLVWyt5PDNxdFNrFDVDWCujLCCkhVZ5bVfT3WWTiWsNqHfh0hhRNBOkN s/RqODeLJKUtPWPJFv3GxrYLdi+N1qMxfoPewoK18WpO4TqQ2rLXfLZFv7GxJA8v AzXDjQhZL3KFV1NPCce+glG26G/ThwsOrzhvLcwyR4yLjdtIXiJa1xxeC33Bot+x O9C6zf++OC7AUVK+3IdX/T36t86nUvki/WzQ+YmDUfsbmtF6UTTz3qBEbQ+Tu15j rc5PDGs0Gk0T0xjnfLXE7CWYWWk9Z5VIUd98vnVt4gOPrIsQAcqLe9eHooWHUyVi CVdcJDpHzYMvzBpKFYGmOXQe9G7gvKGlDkGUrBLZPstHxomGBXXV3SsAsWhxC7HZ V07pV5iBU25U4zXEWdxDJC9tA/M25YI+0pa0u6k9K0cnr67PXr3Lxwh6990rUVg0 7cuYErHIr2xtceFUJedj31daERjtvxTkEcNM/atk7dFo0rMXC1OgsYyH120Jumie 7NqVaLB0hoOz9xDuJ7a6adi9blT1ZMsZDs55tNuUVMlyOaLiL2dIvSx/tY9+JgLn j/oh8nmZJsE/+cNErtrwj6zms5xXuPvjksnVzN8KfC2rUqlUKpXKf8Fv2RaFXQrL Zo8AAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_482"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,316.2,409.2)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_483",
    width: 105,
    height: 46,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGkAAAAuCAAAAAAOtGgyAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAWklEQVR4nO3YoRGAMABD0UhkBWNUMEIdAsEQHaASmdW5ztBr1P8L PBEXKdc5HKgf0pOA7Cq9/trubvua0ti+UEFCQkJCQkJCQkJCQkJCQlqQUi9B7vnI vTmpfgb5X3w+QDcwAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_485"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,316.8,413.40003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_486",
    width: 104,
    height: 34,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGgAAAAiCAAAAACWtMN3AAAACXBIWXMAAA7EAAAO xAGVKw4bAAABzUlEQVR4nO1UoY6tMBA9ogKBQCAQiIoVFYiKK65ATIJAICoQiIoR FQjEihX7+zttIXn3ZcVdXnLz8h4nTWDOzOnpNOkAFy78TShroGhfYRSAwb7ACKPB poh5Qn9jA1ieCwxubrAwoXJzjQH7GosUn0PJZgRDFndqK1HD9hK0o+LIlRXnrCz7 WaX4bEtrsxsBTsN4R2BadTMJ8060gJk/paCeuUrxSeiwH5gr+BIr3sQIhe+tfNZY sXfkC67Wsy7S0NYeRkuY5Os4drSEoIS78UiHkZajpPhPcfryf4rxVUYX/iPYzhPU 4A307OXx3OQJWpk4Wv5ckTgJ72XicgIwHKuykm/IetsoL+PCZsrMQv0Kcpi6oVOh qFF5IMgDJF1/WJlvg0kcabjM5QR2JirHDpNB0pM29/jsMkVahUcjDUvysue6cSPv Rm9+tKjm9yJxedvI5cRhlJQKWqZE1NO6qjQsEkXODY9GFv3dxynvKxnNrYtGQVPc 794nLm8buSORmV1pb0h60n3qKFNSEooHI+a1bMMgN+TnpdzqaETR31GoIwda+SMk LicOo6Tc3KKQ9Vpt0ShT5Cb3+9U9g29G3pPKA7Z5ruy08sKFfxlfg3GBwOzPrz8A AAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_488"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,87.6,415.2)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_489",
    width: 104,
    height: 49,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGgAAAAxCAAAAAAT9rNCAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAVklEQVR4nO3YsQ3AMAwDQQ6Q0qOkTKEdXLj0KFw9gGewWP0vcBDU UYr1zN3fGtLrRJ9UdvtBdh2o/T1AQEBAQEBAQEBAQEBAQEBAt6HMchLbgmLrVqgf HLJjBv4pzocAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_491"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,93.6,409.2)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_492",
    width: 85,
    height: 70,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFUAAABGCAAAAACY3IezAAAACXBIWXMAAA7EAAAO xAGVKw4bAAACuUlEQVR4nO1Wr4/lIBAegahAjEAgECMqKhAVFRUVk1RUVCAQFRWI Jyoqnjhx4sT96zfQt5fbzTbZ3NsVd+kXQmB+fB1gBgpw4cKFCxcufDHMBIDjp9Nu FsZWE1kw4LLAWoBKpoC5q4x8WcYq91qVuQyyvSjtGWuzwKbCxHcIC28KBl56CNM0 QeLv4Jc5QsCjqZ3KHKDYg4+jOJwEy2N2ShAkai+R+QDBexbJHbaa9ip4WjNruFGZ w2EPOQZ/FuxP/WBF4BamsRXWdow2COtORDmyTVh7DlTmL6zSuvZ9UtvHh1UIZrdw 072wor6HRliXWjb7sQMrBCrzF9bF46pPQmVZUVNBK8vmGsBx3YiQSaLoQfXsszY3 DQ2W+cMeqoHd2XH9hgTwBTBn53kB8u7ok9N+Bt0Q6aO2liSr0OW6r0q5m1zweQAm h0aU08JmkbMitZUlcoeb+d3eLEJvnKwbp1AF3itM0EiRTtD9ULCMywBG9JLrnOqi U7d5bZfExe2wlj6M6+v6wpWiBddOoGglTHpNkJJaoqEZ1A7NIBXkIvWh6OogPi0f boc1bm0EdXvD2sYa+mnGtc+sCyaM3M1TLXcLbDCRsPpAZIouCw9WcSsSwHsYy33w J2uAsbeIWxP1jfBnA8mN5hv1ndnRL06ukg31VmksOrNhV1izW5HIDlQb+un1xjJ3 gMwGpLqxku1pjZPityS3waASM09BhmyKDmq50kRX3A6J9Nnyo9mRkY7lXPgHMLO8 DFVIUV61lOTQpB+eISyVXVJ7rQHxkeX7cwmRZokPbkQKj1q8kWSkTk+xmiO0jRkp PIZzUvX8FKs7fDO33l+G0Q3tU6zVHf2xAwaiPOBOhvVO95r82ev/oWClzOX2Z27k j4A7lYcmXwoc+O9Z30XZbPps1vJPWX3Jf8iFCxcuXPh/8AvNiJotJK17uwAAAABJ RU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_494"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,616.2,213.6)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_495",
    width: 107,
    height: 45,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGsAAAAtCAAAAACM1cqhAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAWElEQVR4nO3YoRGAMBAF0RMIZEqJoABcykgBlID4rZOJx67abeDN zblfRXaMidSXdYXpPavuBLjqSdq2gE91LS0tLS0tLS0tLS0tLS2tfwvbAch9g9xt uD5H5V8uUPgA7wAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_497"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,622.2,207.60002)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_498",
    width: 90,
    height: 67,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFoAAABDCAAAAAA5Gk2NAAAACXBIWXMAAA7EAAAO xAGVKw4bAAACFklEQVR4nO2VLc/jMAyADQICCgIKCgYCCgoGBgYKCiwNFAwEDBQM BBQUFBQEFAT4r5+dfdx72jRt2umkk/Koq7U4eep0igeQyWQymUzmH9M0AGpffeVA D2P3ONzHAmpqvlKXZxqKx+Ei9nAKqkPEGjQa7BRYRN4GD1lQ6Q6Gg0EDG8RSZik0 GkstIy1cw7Oyq3gwNPnVgaHg6WSWg4/akOtpU9EYHRTr0NOOrKVhioUhm64d34uw wDU8K3shmQ1e1Ds4RuAaZGm7DeWW1OKgSiZqhxk0tT/V55jUEp6VTQPc1RYwFvM0 yVLnwgYXYDXPIVZPqwcg/KEewlHUKTzS9Pwj3tXOjOOOdJNWq9WFXtQq9FK17YOu qZb9yHUoiSyKOoVHIh3ht3qkyC+Og9Vc6DTNhahbMkldzEQ9SCaxI4SkTuE18oT3 +WjyZ2r/3UHLZP6AOxs3vXoP0Nqm2UrTgxpbxSMbLDiJWvpiCbfk+xxWz0fLLXz+ 0K3zHCto4mEeecT7yq/BF7V0v+qa/IBhgKTerBFdUJo6Vlrk/rOnGqQXgD+Duiff R61dUocFuepF2hzME7+GU5xnc1HP/Am35PvsaWvJgSPP61xstrSH06ShcosKw0V9 CtrS7pp8G3NpaPa4GlGvC40KSu528q470kkt3/npl+QHat70vaG5V33yZfIJhZf/ 5VtD+6vqTCaTyWQy/xu/APhRwMztxeVlAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_500"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,617.4,314.40003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_501",
    width: 105,
    height: 45,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGkAAAAtCAAAAACIIBqcAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAZklEQVR4nO3RsQ2AMAxE0SsoKFIwQkpKCgZAyhgUDJARKLw6JhIj 2AX6f4Enn6W8pnbFd64u7ZbRPUuHWfhJ3WwZUviHNiQkJCQkJCQkJCQkJCSkP0o1 uvZJGblUU6D+jljCx/OkB0OFW9Z39quHAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_503"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,617.4,295.80003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_504",
    width: 105,
    height: 109,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGkAAABtCAAAAACHeBDwAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAD2ElEQVR4nO1XoZLjOBBtIGBgYGBgYCAQEGBgEBAQ4KqAgACBgAED BAwMDAQMDAT61+91y8nuzdymsjW3c3VVelWjUUuyniW3nl6IMjIyMjIyMjIyMjIy MjL+G5TW2vJbmGZm9t/CFAfywmStIWp1gaXUjTW2oQYNVWqoW9kAk4YaW1Bdb92v oeRemXwIc9lifezq6JeJLI/MXUDDJTVE3pHnUxrasZXHtPtFph238sieSxMPFs8H Z0q0lpaPNE7UM5E21DzdinVyaeiNj3bCC0r3ixiiEaYTe++7xFTc8KaV1F3QqbRh x308jm4beuX0eV9nMrMjYepY8i8xHdnshAlrmnUqbThwscynYU5Dbdq932CSzJNv Y+bFB5uY8IVmYVoXPuhU2jCsdOWqX0mHDr/NhHmBd4dUsy1JRrWSUcgxy3vkHrIN o6QBqVe2GspQzb1792tMg5TOfe6R9f2baFUecDI+Qd46I+PPoBBhlrupTnKNA4Uq DglKqf8I6q1ei9K3leh8KtH9qDyB4xsdeKbDOsbdAKUIUJqZcbYmEb57sPzogHT3 cgQvXKWSiB6VJ/BjNN6vFI/09k6ESUy8gLsiUfVqCwreu7DV9ZyHYcdSlfIRPmcK w9LxUa4D7y/KVOEP2tBwC6YtsNy4sNUT03VxYNLyET5nir1bxgZMJw11TSdoZnWe SdekwXUhWZPWExNDg6tUPsKnRAXbHQ8oL+zHqzLROfp4OSV9vwcHuaa0nlQyBCNM Wj7Cp0xG3IAhkW8rGqcOqUHSDRPy8MgpKCXl2lSXPFOpRNam8hE+371fYVAD8/q1 nfH/Rzvcjt9CNPDo7HcQFbEjPU5idnCYKro7HbvZbh1W4VTBmJeNNNYq7k2tZqhW L16na6DcOut/cOh7OO5VvJ2ZA53miXebT3wTbw7vvVxlmFpBCnDn79TFwG/i2bAf 1EH7O4jTElOROufgISd/R8/HcvaY/YrrQH4DQLnFZSdv3sHoV3jBbdowmgM36xX3 Rrs1rSdyI8UbValInWEo5uETUwkps3xZ34K8eoBfFZfdi+HuT4zN8szlxuQgF53q /J2cZ+9dKQvYCu0MYVrtB6ZWfp68Y3ZcPPLBFpd2L3nzjhvSDf9pTS3Udf9YU1Tt R1P1KPayJrqNHz8Ufg2tjcUdCqaL99g6ZUre3IQ4X39igjsfUREpT59uRjA6OvMU U5E68Z3i+SOTETsguVe10GG4hC331JtLi0ozEq2SDWslbFLuIR3PQf4VKWlToZ2N 2o0vIHy07H340ny/RvO1F83IyMjIyMjIyMjIyMjI+FP4C6+BW4FrU695AAAAAElF TkSuQmCC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_506"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,396,369.6)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_507",
    width: 110,
    height: 45,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAG4AAAAtCAAAAABq/AHlAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAXklEQVR4nO3YoRGAMAAEwRSCoIgIZDqgBApARCAiEN86EczQwQ3i roEV774UuDoCdS6Tuykt2SeXHA1pvFxjVutycnJycnJycnJycnJycnK/4NDnAf5V Nsy7Vma1rwfpl2iDalPngQAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_509"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,397.2,366.00004)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_510",
    width: 105,
    height: 58,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGkAAAA6CAAAAACW8yi/AAAACXBIWXMAAA7EAAAO xAGVKw4bAAACiUlEQVR4nO1VLXelMBC9IiIiIiIiAjECgUBEPIFAzDkIxBMRiAgE AoF4AlFR0T+/k/B69rS73faJ1iz3hCGTCXPzeQFOnDhx4sSJE/8Dojqe70fXgaIi IqW1t9JgSQyJ0dkoUtDmXpQtfm6l8ib9AJPa1FSFhZcQtmGrUY3DjDbxiiFuZGde TWAcZeTiA6U/zMorPTIpSSpZOIQBVQQMPSEMtGCykYaeYgjyzkz1wsXH0R9cw02P TOqpuzMxXEQzhczUzHpDpGtHZGQGSZjGVHPxX5muBJe+TmTrTd2ZNhovGC/VM0LQ C4/C1Ey60vfVe7LExX9laiYrH3wZjivAE8iHK3dyDrgLsMzUazQWLXdKokeRw5L9 e3+IEx5YvN+Qgf4QjP0pphM/i8Rjh7mXWi832KZleqdO+UYUiavyNbRGzmvxfZEx qRkDD+Wy/JVuclddLmJsNv44O2oTycS+Kqh5B1YPZ96OZEyYh8iwO4/R3q5pKL7Z efGlZhcs6C7wGy/AxHMtLVjENLuYNKQ8jywQmYlbhMsO/4cw1SIgdAVukI9stKtU i283mvwRmdqNZKhNL4w00SVKjITJpN1uYYK65UzNUJgkzaz2kvMtWj6eVyYZ7a34 ki3WR6Qfd54VRhKmJhI5mT4LU7K73aPI8JYzXevChLkdxbr5PZO70cVtrk13pucm JJN9cbkvNTPn1eu8TGRz0mLtsXovTZ6BvjlJLdt3q6mbzY72xSPvU08X/3b5RK08 9/KHC9CNXTvWh88cVKlVFSQkEs6ykaiYnc6/imw6MS53zidPkEIHJTIriqm6f8tg Hu0HyBEbPwyXSPi6xir/eZ+/w2WjzWfdTpw4ceLEiRPfhl/AwJTRNJVj6wAAAABJ RU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_512"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,156.6,363.6)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_513",
    width: 116,
    height: 46,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAHQAAAAuCAAAAADc5GJqAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAW0lEQVR4nO3YMQ0AIRQE0S0okIEUHCCAgpISCViHkNOwP7nMGnjJ liPlYl6SNLd546Juc6+HNue5/UOrjGugoKCgoKCgoKCgoKCgoKCgf0NDkk5AvArJ dAFB8gBx6nw+52rO8gAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_515"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,155.4,366.00004)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_516",
    width: 120,
    height: 39,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAHgAAAAnCAAAAADh19MsAAAACXBIWXMAAA7EAAAO xAGVKw4bAAACnUlEQVR4nO1WIdOjQAyNWIFAIBCIihUIBAKBQCAyg6hArEAgECsQ KyoQCMSK/PXLbujN9OY7wzc3ne+mT9Dpy0sem0JSgA8++OC/BhLR+g5ju2qzvcN4 HwHZuPa0pnDw8Wew3AMFdCeqFyYWISxV0NNwSqkJaRK+hIS6UCHxTbINQINeLDRK kwZy2u55R10hxO4WeOz2lIqxhC+hZAuuoGm1hwEuZyzU8xqMG2gpDbcgBPX+5oen lI9K3KgYvoR5h2B8o1v4Fo0LautgzK2gWDkSDenNTq0/pdwb8x3jgXZrN2/U44Fj KcY3Gudg7Cc/x8qRQMq4vyWlIpVWXze2Dhl2g5Q/MsACqgYarLsMqMc+YT6DSGhU OaoUE5GyUncg4UvGJlzxq/eJz/QPUVfhqtsvQnjxcf3gpyPTmL7Dd+apffEF+hYa f7uSlq50NGHILtbRoqA+6CgfK7gphMiogejohIaRhwrV4wOyA4vtXEKTm+wAQobT z6csVK5j/VyyX2H2oiq0W/Tkm5bnQ5mDnSsyPoNxL2pqeUGMq9DAkzijxmxqJZxc 2B0M67s7lULCLSwRkY1ODT7WzyT7FS4SPKzCeOfMdLS85lYaOcQTbENzWKpPOu4f Nh6cx2YfnBhzBeqFhMIe4ylzO/cwjfUl+xXr8jTeVcLG1vL2Tf22qxBSB/Kx7l5F mjWaV5LxPifM93Gx0mpQ3JhIgtJIhcjW6Xd9yX5FR2bV0ZicowLsAw87u4J6Dt2X IzNb2BeRfraaWu7N/DhbXdFst0RImHD2ucg6f0cj9SX7D7TYKWgqLlojPwA5Ytki /1S8ZuqwnDRin0aaH4AOFBZ8hV6zuJKVUSGvJyF5Z6E+ZSG9lvqS/Re8598dI9zy Bx988KPwC8+cBJc9H4OvAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_518"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,480,360.00004)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_519",
    width: 87,
    height: 43,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFcAAAArCAAAAAAoQ0sKAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAYElEQVR4nGNgoBWwiac68BdhYFCppwGIZmAwqK9PprJzy+vjweYK UDlk40fNHTV31NxRc0fNHTV31NxRc0fNHTV31NxBb667A3VBPshcHVr0h4Dm8iRT 39hyHSqHLAIAAOK8KsnU2GoZAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_521"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,487.2,359.4)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_522",
    width: 65,
    height: 46,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAEEAAAAuCAAAAABSPisWAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAB5UlEQVR4nO2VoY+0MBDFn6hAICoQCEQFAoFAICoQTSoqKioQiIoR CMSKFStW7D9/U9jLXbjcl+MQX3LZJ5q8dvgxTaYzwEt/TYUFcnsKsZTQ+hShmbBk fqa7DIFmAeOnFt5NBkR3VHHyCBJBpTWq1X9JognplCRHmZY3ZPJVwIwrSIDyd4K+ qNV/SeJRPgkSXQcdHBOct9nEhKsxJgvOLExovVGr3wHyasGTYBBLXIRKOYjL0DNh rJC/32LOjFr9Tn2UgM5hszBQD7SkB/QUB76vRz6SS6e6gFZoy9V/K/7VSdX7C/41 FT+O9NHUwLiZ8eND+jGBUFH3Ya+/ISBfuJRHf9eg/kFlFg2X8SECHqk8MXKVPnMw 6ngO2S1EsRHE6OgYoeS3TWpSVTJzDn4k4xFCIKsAWwY1Glg0VAg/mRKHm1jnlT3X t9Ca6hzgpV9puELcOjgXa1CgyEWtnJriUNOdapKC+zRxr5VxHreovUJQDbdppPLj AvaKylhwUV/WIifpLk8CrX2Uo/aiygfetj6EFGla8lHceC5shM5xpyeeGCthjdpr RgwivaKOCT2WgqTWVEBuhFmETzmsUXs5dCotxAOYHDVwufDFRAPSc7BFmhU2w5Dx skX9S3R6ZLTiLOGl/6M3srJ5eXZoQJ0AAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_524"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,479.4,213.6)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_525",
    width: 89,
    height: 39,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFkAAAAnCAAAAABBSLvCAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAVElEQVR4nGNgoB3QiacFsGFgEKmnDVBhUKivT6e6i5Pr6w1AJitQ PYQFRk0eNXnU5FGTR00eNXnU5FGTR00eNXnYmkwTYMDAQyOTVRgYNBxoAQwYANN4 KHODVq5DAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_527"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,480,205.8)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_528",
    width: 87,
    height: 67,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFcAAABDCAAAAADM5MY9AAAACXBIWXMAAA7EAAAO xAGVKw4bAAACI0lEQVR4nO2VIbOjMBCAVyAQCAQCgYioQCAQFYiKnalAICIQCAQC gUBERERE7F9/u2l71+PNdXhz4ky+oWSa3XyzyUwWgEgkEolEIv+DrgTMD3NuBGjo OPsz9KZ9dpjrqYR1+yctgFJHLWReF3RtiGmgtSu5orJEyJswNELL8wrylci3BKUl f+W5x5PzOzUansOxYD/4pCWlqOWMrvR9UULvJLvxcDcNe9EmSDyxLknv03evpuCV 4VvBjxAEL/DatF+MrFu8hmnO2VvZYSEpHUGRevO2bpfFYTii+YR/eXMwY28UhqUX qhyKN921Zq9yPR9P+eb1ahFvGA5HvvkJfnvtRnXvMNSLk7cuE2/vH+fAZ2Yn2cku z9RSD8Ebhj9J8ZYClAiAUrbCGpIOK4QcEXMsOCGHroEKJeeKXQIFBiZT3hJoa3gO H5CyT9Oa06lS0mmy6gfJkcgbM/cAvsqD3BAzexoAake24na1jchBw72CPMIzeBaD Sry68Ow1haYCLF/S2WhFl1zRvQK+yD1lz+BJUqqDd9xn9mppXinti9kNcQ8ILSTj n3oFz3o7mwSvXy+8dJLmldBV9jHffRm8Kd2gpvIRPKm9OLtstIJxuZREq90BJovD jcvj/YsXJjdYTnkEz9EablOaoOMvD2Zm7FA+W1fEortA04WWB0noaa/gOe/CL/Xq ad8/WW98DB7J5MBS9fzHNf6dj8FIJBKJRCLn+ALLHsCS91xzqwAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_530"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,480,334.8)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_531",
    width: 87,
    height: 42,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFcAAAAqCAAAAADjH5ivAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAXElEQVR4nGNgoBUwcaA+EGBgUKmnAQhnYDCghbnxYHMFqByy8aPm jpo7au6ouaPmjpo7au6ouaPmjpo7ai7VzE2Opy4oB5mrQ4v+RTQDA4s3lV0LBNEy VA5ZBAAAp9onam/lz2YAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_533"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,481.8,334.2)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_534",
    width: 80,
    height: 46,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFAAAAAuCAAAAACaUsHAAAAACXBIWXMAAA7EAAAO xAGVKw4bAAACiUlEQVR4nO2Wr7OjMBDHvyIiIiICEYGIQCAqIhAIxM4gEBURFQjE ighEBeKJ/vu3CdzNu871dd5N1V13IMmXkA/Lj90FeNt/Z7qSpn4hUK0KzfmFQPQ9 ZtcSkW4bCuItkZFLUIVABNWTQ6vR2tw2tuhnLtqEaME2RrN4eO3Pog0jYcPU2FXJ bPRyrLr5op+5uHYH0KILsLRExCQHM/DKfDMx8YcAK5580U+A+kMdQIfhhNVYAVq1 1qMAU3bn8JA9+fTMPWAQXw7gMrLCMk4R52laUyXAMNP4EziCfNFPHPz1kKMtn09p nNH7nam7T+pef+nrs4fztm+Z7uPwSp5K4e8ShvPDoDSRh5NgLgpZ+rGXsEZDvZIo D86jqz1sW5bs/Z8tJEuTs3pDrQIVhSyH5IcJ7cXQ5GPvAhkOpDjmJUf/AEiwrLrz DWpZ66KQpaQdxRIYWUsbtqtAp3EH7v0D4AgXqQPn+5uLQpYnQS85squlAOl0CWn0 BXj0D4DrOblunm7o6dIXhSxVIq5hEiW/A7EOSR1A9RWQKkkfLqeQujrULqv9pT1c +cCa8Fi97R+wXIRrGnSOXfK66UkXrencoYwkauWUWurgXq876Fa23AR0UrR/M5dM qBYTZkiR82QltuaiRc6ujKQ0M+YK7SAB6BY9dTInxTbiwm0s0fXJQi+7XDgdQPn4 t6LtBye1z1C6Jalx1AowXHk95zkB9iPbmbY7oOTP0yD/DQdwhuaiRQ6nMlKrYb0Z sMpAeQ7YPUwXSSjs7jyUaF3yfjqAW+SmaLsSuzKSvx5GP4xXmjavWDLZDvwwlsvc nTl8ilU5Tx9a1/g8UxZaeQNOf+edm8cVJP8pmHeUv+219gO986ERbZ35wgAAAABJ RU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_536"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,726,207.00002)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_537",
    width: 8,
    height: 3,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAAAAACLoxGUAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAEUlEQVR4nGNggAODeiDIR/ABIqoCnH5d6ZYAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_539"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,316.2,275.40003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_540",
    width: 104,
    height: 28,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGgAAAAcCAAAAACoxKWqAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAVklEQVR4nGNgoBtgMXCgOTDhAFrkUE8H4A20yJ8eFsWDLcqndezE j1o0atGoRaMWjVo0atGoRcPBoup4GoNysEXu9GgFBQMtEvCntYfi44MlaB07CAAA +PAslYLpqIgAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_542"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,328.2,259.8)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_543",
    width: 66,
    height: 82,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAEIAAABSCAAAAADF6V2vAAAACXBIWXMAAA7EAAAO xAGVKw4bAAABnklEQVR4nO2TIZOkMBCFn4iIiIhARCBaIBCIFisQiK4aMQKBWIFA RCAiRqxccX9+mzBTdzvMbt3VuNt8RT146fDSBQlQKBQKhULhv8M5wFZPRYQZ6Pvn 2pgDVssiPdpGCGhkMGAZHAZh2EEcGNers9kf26AJkWjFcvJvDp2RARHtiEQRS6hX dftFv3z2xzbWep+hMhGCTIIoa1ONOvIe4zviJohuXn32ByhdF4kWc2WSI42An5n1 lpe8djFX0T9oAdD1bhHLeQGSzFsX45KMjmlLcovQSJ/9Pc7fnqIJqnYTQ9bZvUx3 0+/8Z87fFX8EVj+nPe64f4EFWPjZCE4cAgJZEWnRSaNbVNpaj40TqaE18ptWlOVB hIsvrFuRxdDSVe3JxYpP9LL6sSdfJWhNzx+zSZLlQcQcNOESL1qbPMYU37otkUGT 7eV3xHiSLMcIjeW9ixwxNdugWj3943k7J9eIRViyPIgwnyLCKpPb7OWcwvA6ruBZ 4mRZsyTLX3xgyr+YORigNvvY5L974wua5k83PLdzCoVCoVAo/Ag+AIbjXLQP4fw+ AAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_545"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,316.2,292.8)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_546",
    width: 104,
    height: 27,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGgAAAAbCAAAAAC1wZUSAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAVElEQVR4nGNgYOBRoDkQYAAClXo6ABOgRf70sCgebFExrUMuHWpR PgONQfyoRaMWjVo0atGoRaMWjVpEQ4vKHWgM8qEW0akVpFJNe3uqDWgdOwgAAHKN LQLN4dWtAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_548"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,321,280.2)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_549",
    width: 88,
    height: 70,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFgAAABGCAAAAABtIgwDAAAACXBIWXMAAA7EAAAO xAGVKw4bAAABZklEQVR4nO2SoY/rMAyHfyAgIKBgIGDAYCCgwOBAQIGlgIKCgoGC goCBggMHDr5//pxsZLcjT3oHnuRPkSUn9afYKWAYhmEYhmEY/yu7A46/LUoZ57lF TKOWJ90a6y5P3+SMyxyIyAcfg25EcnCkYbgHjxAeyw89B1iwXlqMnwxaqlZVh/gk dofbIm9SiWu5nZFK2cBlOjDPB8VNDseM+7pKz1W8ptr0rk6M5VQDyvjSVi57KxJi vfsCBLqpOF2x+5XWTNfEhUoTc5Weq7LupYlFN90NbxOu9CJ2n+kh1q5W5OUurv5A F5PXfjYVy87S8z6KPYI37Y3H91oPyPTde0o3PMRHu83Cl3fwm6+LzpF49iq+j+Ij sPS8i7U5/jPowaaj3WP4SFSexXLS0UfQwJPooLxwQhSJ2SENGCU7PW3rrO/acy0i uIzTpVXqrwE6I+Qm+hG91e8Qwi+JDcMwDMMwDOOf8QWHFUdqqTG5hAAAAABJRU5E rkJggg=="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_551"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,316.8,309.6)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_552",
    width: 103,
    height: 27,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGcAAAAbCAAAAABEys6fAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAVklEQVR4nGNgoBfwjqc9MGBgUKmnA6hmYDCor0+msW/y6+vB9gjQ OGYcRu0ZtWfUnlF7Ru0ZtWfUHqrZo6NAW+APtYcOgIFBgh7WFANDT4TGoQYCPAwA +egsb1EArZwAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask_554"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,325.8,297.6)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_555",
    width: 73,
    height: 69,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAEkAAABFCAAAAAAj2pR7AAAACXBIWXMAAA7EAAAO xAGVKw4bAAABDklEQVR4nO2RIW/FIBSFj0BUIBATFRMIBKICUYGoIKlAVCCeQCAQ FYiJior9/QHZlrw1Ey954on7NWly4PL1hAIEQRAEQRCvDp8AZh89xZyb2WDuF3eO yT9qEkX6VeT7Re2R3qx3N74sOTDMMWnY4mesLkJsyWIZYcb2dqrnaspQ218T9veI IBFEsFgnDG0sSFaQ63PjyLzuujog9Wl6rqbDf6qLSZ/62yRhHOQWq6nsju3NVRlC yUcdMMmZnnun4byY+IHfTl4hD2PrhKLX1mlE322dPoQzPXcTu5jmrNDuYOEh7gGw afWw3vvI4SFCCj/3pGFUz8BQq2n+74+qn34SWjzLRBAEQRAE8UJ8AfJ6Oa7PoorZ AAAAAElFTkSuQmCC"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,367.8,46.800039)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_2",
    width: 118,
    height: 58,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAHYAAAA6CAYAAABlPa0GAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAz0lEQVR4nO3dwQnDQBAEwcs/KT3FSUHJnMGOQEa4qUfNe6ED2DHG uJZt26593/ljq+Gn51hznud1HAcBK/A77Kr89DHcZ84pbJGwUcJGCRslbJSwUcJG CRslbJSwUcJGCRslbJSwUcJGCRslbJSwUcJGCRslbJSwUcJGCRslbJSwUcJGCRsl bJSwUcJGCRslbJSwUcJGCRslbJSwUcJGCRslbJSwUcJGCRslbJSwUcJGCRslbJSw UcJGCRslbNQ37Jqnj+FHYZennwFx70OlFx0yQ1vjtjzyAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip_3)"
  }, /*#__PURE__*/React.createElement("image", {
    x: 367,
    y: 46,
    width: 69,
    height: 33,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAEUAAAAhCAYAAACP6GZlAAAACXBIWXMAAA7EAAAO xAGVKw4bAAACLElEQVR4nO2Z6U4iQRRGff83cNRxibvGGGfUuGvcjQioLIIsogKC jc0mm/B5K9DuVFUEQqP143uBk5O+J11duq7D2IOxBx2JlyWhJZK4ry3OpiURo91p KUTvU4jQwvEUbuJpXMfSCN2lcUULRtPwRzO4jGTgDWdwcZuF6yYLB+3s+hGnoUfY rnI4CeZwHMjhMJDHvj+PXV8e25cFbHoL2PAUsHZRxAptyV3CgquE/84S5hwlzJ4/ YYY2ffaEKdrkaRnj9jJGaSO2MoZtFQxZKxikDZxU0E/7S+uzsAG9tJ7a/hxX103r +grIWyjaGyjx2qpAku+A3DIosVcoQVqAgPhqQDzhLNwfoNgJipWgWAjKEQE58H+G su4pYpWALLuLWHRxoBCQiWZD0etA+cqUmIQpQQlT7BKmMCimMCXBM0XjmxISmOIU mLLn45sy7+SbMtZOUwwoPFMMKDxTrBKmrMqYQkBMYEqqrinGR7aeKecEhGfKDgHh mfLP0WZTNIEpEQlTGBSeKRYJUxgUk5hSBfJdU/wcU9g55pmy5e1wU16gcExhUHim MCgiU9p3kk0Wb6Y5ySreGjjJonhjUETx9sNOsoq3lsabzEnuEFMEJ5ljSqPx1nZT ZE9yo/Emc5JFpjT9Q1v3HLco80Xx1vGZr+JNMt5+3P8UFW8q3lS8qXhT8WbCk6zi 7bfEm8xJbnW8dfxJVvGm4k3Fm4q3VsSbzGNYM+LNRI9hvzPengEq6yQdx7ps0QAA AABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#3366cc",
    d: "M367.59 516.39V548.64H435.62V516.39H367.59ZM369.21 518V547.03H434.01V518H369.21Z"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -542.95,
    x: 401.9
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -534.55,
    x: "376.13 380.95399 384.5756 389.9972 393.6188 397.24043 399.0404 402.05003 405.6932 409.31483 412.9364 416.55079 420.1724 424.3916 428.0132"
  }, "&#x041e;&#x0431;&#x0449;&#x0435;&#x0435; &#x0441;&#x043e;&#x0431;&#x0440;&#x0430;&#x043d;&#x0438;&#x0435; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -526.15,
    x: "383.48 387.0728 390.66563 394.2656 398.456 402.056 405.656 409.256 412.85603 417.04643"
  }, "&#x0430;&#x043a;&#x0446;&#x0438;&#x043e;&#x043d;&#x0435;&#x0440;&#x043e;&#x0432;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -517.72,
    x: 401.9
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,367.8,87.000019)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_6",
    width: 118,
    height: 58,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAHYAAAA6CAYAAABlPa0GAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAA0UlEQVR4nO3dOwqEQBRFwd65SzMUP3tycAZcgSBzqKCCzh4cbtxj jHGSNM51Xc99389t2/hzx3H8ws7z/PoxPOcaqbBBwkYJGyVslLBRwkYJGyVslLBR wkYJGyVslLBRwkYJGyVslLBRwkYJGyVslLBRwkYJGyVslLBRwkYJGyVslLBRwkYJ GyVslLBRwkYJGyVslLBRwkYJGyVslLBRwkYJGyVslLBRwkYJGyVslLBRwkYJGyVs lLBRd9hpmr6Ptw/iOfe/O9dql2Uh4Brq1fQDWXk+/f/X70IAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip_7)"
  }, /*#__PURE__*/React.createElement("image", {
    x: 367,
    y: 86,
    width: 69,
    height: 34,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAEUAAAAiCAYAAAAJfBTLAAAACXBIWXMAAA7EAAAO xAGVKw4bAAACF0lEQVR4nO2Z504CQRRGff83sJfYUGOMNSoajd2IYAFRpBeRZWFp giB83gmssYSZta0C8+O8wMnJ3i+zXZqmQSfNSNdJvZCBmsog2UAhEmqdezWLeDKL OyKmZBFRcggncgjd5xBgxHPwxfO4vcvDE8vjOlrAVaQAJ3ERfsBZ6AGOYBGngSJO /EUc+Us48JWw5y1h5/YRW55HbN6UsXFdxjqx6q5g+aqCRVcF884K5i6fMEvMXDxh mpg6r2LyrIpxYsxRxaijhhF7DcPE0GkNg8QA0W9jAH1Eb4OekzrdRNcbIdp7IRrU V1KYEOVFSOaNkCiTwoQQwYYUPwnxNoTcxApwkxTXOyl2kmIjKcck5JCE7Hs/SrGS kDV3GSskZMnVRAoJsRATPynls6XoUnil6FJ4pdgNlGI1UgoJMamUDKeULL+UePNS LkkIr5RdEsIrZcH5x6WoglJ0KbxSmBReKboUXilMiqgUi2mlpL5eio9TynmIX8q2 5x+Ukv5mKVFBKUyKqBQmhVcKk2JqKaJakgZqeS0l2G4nuVkpiqiUBL8Ud8uW8omT LBpvTIqolBY8yXK8/dl4s7VWKXK8yfEmx5scb+Z8aDvuPYU73gycZN54a/uTLMfb D4430Ulu6VJ0KWaMNyMnWY63dhhvRk6yHG9yvHXIe4ocb3K8yZ9hcrz91kkWlWLk PUWONzne5HjrvPHWKT/DngFtOx0GzEypBAAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#3366cc",
    d: "M367.59 476.07V508.32H435.62V476.07H367.59ZM369.21 477.68V506.71H434.01V477.68H369.21Z"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -498.4,
    x: 401.9
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -490,
    x: "374.4 377.99806 381.5961 385.18693 388.78498 391.77613 392.97547 397.18043 401.3709 404.96897 408.56703 411.5654 414.55656 418.1546 422.3451 425.94316"
  }, "&#x0421;&#x043e;&#x0432;&#x0435;&#x0442; &#x0434;&#x0438;&#x0440;&#x0435;&#x043a;&#x0442;&#x043e;&#x0440;&#x043e;&#x0432;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -481.58,
    x: 401.9
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,367.8,133.20001)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_10",
    width: 118,
    height: 51,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAHYAAAAzCAYAAABCMvzOAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAwUlEQVR4nO3cuwnDUBBFwdd/EypFob49ycgGVyAwPkww+cLhpjvG GBdJ49q27dr3nYB1XT9h53n++TE85x6psEHCRgkbJWyUsFHCRgkbJWyUsFHCRgkb JWyUsFHCRgkbJWyUsFHCRgkbJWyUsFHCRgkbJWyUsFHCRgkbJWyUsFHCRgkbJWyU sFHCRgkbJWyUsFHCRgkbJWyUsFHCRgkbJWyUsFHCRn3DTtN0Hcfx84N4zvcR9b3a ZVn4c+d5vlveTV+wbXb6+uxDjAAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip_11)"
  }, /*#__PURE__*/React.createElement("image", {
    x: 367,
    y: 132,
    width: 69,
    height: 30,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAEUAAAAeCAYAAAB6xNMdAAAACXBIWXMAAA7EAAAO xAGVKw4bAAACPElEQVR4nO2ZaU8aURhG/f//wH1JF1sbY7StsUVTU7VqXEAFQVQQ ZZFh2BEE4fG9YSaBWO47wjhh4v3w/IGTc+ee3BnJ5/MwlxPLtZc1pucK0LMFZIxp tLRewD0tlSkiSUto7d1pJdymS4jdlxClRVJlXCXLCCfaC8UrOL+rwE87vX2AL/aA 45sqDqNV7Edq2KP9u65h+6qGv5eP+BN+xMZFHZ5QHb+CdawFG/h53sD3QAPL/gaW zp6wSPt2+oSFkya+0OZ9TXyiffQ28cHbwtxxC7O0maMWpmlTtMlDMWCCNm5s7KC9 UdpIF5B8N5CsAUTvAKLpJpRiF5S4gCKA0G4ElFQJ1x1QLhIVBAlKgICcEZCT2Eso uwRkh4BsEZDN8EsoqwTkBwFZ8feG8vmtoPRjSpwxRUDhTBFQZKYIKI6awtmSsWBL J5ROWy6T/z8+whYvQTkiKAeRas/js05QfoeY40P7+pbHp5cpGmdKWm5K0LWm5HhT 0hZMiVowxecmU7IyU3S5KTHGlABjivjQykwRH1qZKbZ+aF9riglFZooJRWaKCUVm iseKKQRkCExhrmSJKeJKlpkiruShNsXKlcyZYiXeOFOsxJtDphT6NyUlN4WLN5kp jsXboJlvR7xxpjh+JQ8abv1kvriOXZ/5Kt5UvL3CFBVvzsQbZ4qL4q23KYPG29Cb ouJNxZu98caZYke8qTdat8Qbm/kq3lS8qXizM944U1S8vRdTrMSbHW+0QxRv6o1W /WA3oDwDFhg3uxWBLFIAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#3366cc",
    d: "M367.59 433.99V462.21H435.62V433.99H367.59ZM369 435.4V460.8H434.21V435.4H369Z"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -454.25,
    x: 401.9
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -445.85,
    x: "385.13 389.3276 393.518 396.5204 400.1132 403.7132 407.3132 411.5036 415.1036"
  }, "&#x041f;&#x0440;&#x0430;&#x0432;&#x043b;&#x0435;&#x043d;&#x0438;&#x0435;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -437.45,
    x: 401.9
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_12)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,367.8,177.60002)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_14",
    width: 118,
    height: 47,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAHYAAAAvCAYAAAA2Jj4uAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAvUlEQVR4nO3cuwnAMAwGYe2/hEdxafzYyUGBZIKAyXHF99eC6xUR sVOtdbfW9GPZ8OkZOXPOPcYQQAa+w2bl08foO713wxIZFsqwUIaFMiyUYaEMC2VY KMNCGRbKsFCGhTIslGGhDAtlWCjDQhkWyrBQhoUyLJRhoQwLZVgow0IZFsqwUIaF MiyUYaEMC2VYKMNCGRbKsFCGhTIslGGhDAtlWCjDQhkW6g1bSvGXIsgbNmetdfxz p76RLbPpBai3Vyjkc+EyAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip_15)"
  }, /*#__PURE__*/React.createElement("image", {
    x: 367,
    y: 177,
    width: 69,
    height: 27,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAEUAAAAbCAYAAAAqCUKuAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAB+klEQVR4nO2Y504CQRRGff83sJfYUGPsxhqN3YAiiqAgIALSdunS +bwT2agEZ1YQBZwf5wVOzuR+mZ54PA5GTCP2hlpFiSWgqAlEiQhDSSBMhIhgNIln IhBJwk/4wil4GaEUPIQ7mMbDcxqOQBr3gQzs/gxufRlYieunF1x5X3D5mIXJk8W5 O4dTVw7HDzkcEQfOPPYceezeF7B9V8CmvYB1WxGrt0WsEEvWIhZuSpgn5q5LmLWU YSCmrsqYJCbMZYybKxi7rGCUGLmoYJgYIgZNDGCA6K/SZ3yjl+jRpMS/kKJ+kKKJ 0aSElOQnMb5ICk81UlyEsyrmjqTY6ki5IClGdxZnJObEVV/KFrFhL2LN9rWUGWL6 J6V8LEVtspRHQSk3JKRrS2FSRKUwKaJSTJ1VSoJTSpJfSrDxUg5JCK+UZesfl6II StGk8EphUkSlMCm8UpgUUSmGXytFbbwUF6cUi5dfyr6jC0rxC0phUpothUlpm1Ki TZTi5JRiJiGNlrJoLbW+FN3jjVdKmF+KXVAKk9JWpXz3JNerpfb51NZS7/mYdYy3 HT0nmWjpSZYzv8XjTc58OfPfpYhmvp7xJipFz3iTM78TxpuolJ8Yb3Lmt8PM13OS Wz3z5XjrqvEmZ778o5UzX/7RdtjMF423Py9Fz0mWM/8fzPxX+cZLpY91KcsAAAAA SUVORK5CYII="
  })), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#3366cc",
    d: "M367.59 391.91V417.86H435.62V391.91H367.59ZM368.89 393.21V416.56H434.33V393.21H368.89Z"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -415.2,
    x: 401.9
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -406.8,
    x: 379.52
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -406.8,
    x: "381.1 385.2976 389.488 392.49043 396.68083 399.69044 403.29045 407.48085 411.08085 413.47846 417.07847 420.67848 424.27128"
  }, "&#x041f;&#x0440;&#x0435;&#x0434;&#x0441;&#x0435;&#x0434;&#x0430;&#x0442;&#x0435;&#x043b;&#x044c; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -398.4,
    x: "385.15 389.34773 393.5382 396.5366 400.1274 403.72547 407.32353 411.514 415.11207 418.7101"
  }, "&#x041f;&#x0440;&#x0430;&#x0432;&#x043b;&#x0435;&#x043d;&#x0438;&#x044f; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -389.98,
    x: 401.9
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,207,64.20003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_18",
    width: 203,
    height: 27,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAMsAAAAbCAYAAADSxXscAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAApElEQVR4nO3bQQqDMABE0dz/Um4U0XintIHS0iJhdlp4i0cg+09m k1JKaUCktGma2r7vbds24MdxHJ9Y+kWPBTjXH5SvWGqtl1cMdzGMpZ832IVwC/M8 iwUSYoGQWCAkFgiJBUJigZBYICQWCIkFQmKBkFggJBYIiQVCYoGQWCAkFgiJBUJi gdAwlm5dV+Bp+AcfOPeOZVkWwcDAa5pdvw3hHzwAF4iwPnXN3yYAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#6699ff",
    d: "M207.01 517.74H326.07V531.037H207.01Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_19)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,221.4,57.00002)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_21",
    width: 155,
    height: 53,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAJsAAAA1CAYAAABWd5kSAAAACXBIWXMAAA7EAAAO xAGVKw4bAAADiUlEQVR4nO2YW27jMAxFs/MupUvpT19Ju6cMboBTXBCUXQ/SYQfk x0EcWyavSIpScjqdTtdh+EeUCxj6UC5g6EO5gKEP5QKGPpQLGPpQLmDoQ7mAoQ/l AoY+lAsY+lAuYOhDuYChD+UChj6UCxj6UC5g6EO5gKEP5QKGPpQLGPpQLmDoQ7mA oQ/lAoY+7A96enq6vr+/Xz8/P39MiHycz+cbl8vl9v0XBGe4L9sDlHhHxXBvESqs j4+PG7L//Px8fXh4qA7McH/WD9XJvMAeHx+vb29vX890LdT19Ez36H58V9G8vLx8 3X99fb1917XelW29Lz/Y9K6m91V87sc1aiw6ZIt36ZQ+F93LNLoN0H1p5XvstGhl YWT+8LP1LNqJsSVWaFcMsq6fxUn3VjlxH8w30yqbukfuHd3fys2hYpOBVSejEwm2 PX3qOwHTtSYmG1zTvTQmdky/JqAUETawD3qud/Tpz7nPOF0rMJlGAuzdNWpiHAuG cbyz8relJbPDeO4TC4+1a/E4ZHFa5cR9EL+olWZDMa5itMrNoWLDYPaMJCCO7uBF xbsEy4XFRGusVgZj4/mQycbixyfBxiffWYUkeKWR+WKfcdIk4iLBJwnhefS3pSWz QxxjcZLIuGCz3SibR5yv28yKzQucZzFGe7k5VGw4y85PbH8uju5G4LxgKLL4Kdvx LOiT1zbihboqNu9CWXcgwXsaPUkx4ZovcXE9voiivy0tmR22K/cdi8u1wCpOq/l6 zLNi8066Kra93BwqNhnzts0ZIp6x/Nejt1SKlFXsHY5rtmp8EBxtMbG7Zj9Q6Bre 9lfdgeRnGledjTOd+yYJnFH2/K2eZXZW4ynEeI7OdqH4PM6Xsd4sfHtl0dIIVsW2 l5tDxeYG49mKlRWLLZ6L4srMrkmmn4+2/McW7isx6sqSn2lcFRv+2VLdp/M3xZbZ ycZn4+JusxUnn2+MtePHDO+Ae8W2ys3hYgN+kfgKzCBQdKYj8Etpy/c9+I5GxtBN Vnrv8X/gd+1o3FYcVnHy+VJs0Z8vjiMczM19EuiiVeG/+X+y72iM3eV/xue7VWz8 zfKD1AdjaEO5gKEP5QKGPpQLGPpQLmDoQ7mAoQ/lAoY+lAsY+lAuYOhDuYChD+UC hj6UCxj6UC5g6EO5gKEP5QKGPpQLGPpQLmDoQ7mAoQ/lAoY+lAsY+lAuYOhDuYCh CX8AxCxeSVuk9qsAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -530.63,
    x: 266.73
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -522.22,
    x: "224.13 227.72806 231.32611 234.91693 239.71434 243.90485 246.90323 248.69503 252.28585 255.88391 259.47474 261.87345 266.06394 269.06233 273.2528 276.85087 280.4489 282.84764 286.44569 288.23747 291.82829 294.82667 299.03163 303.2221 305.62083"
  }, "&#x0421;&#x043b;&#x0443;&#x0436;&#x0431;&#x0430; &#x0432;&#x043d;&#x0443;&#x0442;&#x0440;&#x0435;&#x043d;&#x043d;&#x0435;&#x0433;&#x043e; &#x0430;&#x0443;&#x0434;&#x0438;&#x0442;&#x0430;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -513.8,
    x: 266.73
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_22)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,207,84.000019)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_24",
    width: 203,
    height: 27,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAMsAAAAbCAYAAADSxXscAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAo0lEQVR4nO3cMQqEMBCG0dzco3gUG0Gjh8oiwoLgun9nilc8pk3z wTSTUkppQKS0aZrauq5tWRbgxjeWbduAH/Z9b+M4nrHUWl9/EPTs2L4usRyzg70Q ujDPs1ggIRYIiQVCYoGQWCAkFgiJBUJigZBYICQWCIkFQmKBkFggJBYIiQVCYoGQ WCAkFgg9xnJ4+xcN6MXjDT5wTywQGobhjAX47wOs1a79Co2a9AAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#6699ff",
    d: "M207.01 497.79H326.07V511.087H207.01Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_25)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,221.4,76.8)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_27",
    width: 156,
    height: 53,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAJwAAAA1CAYAAAC0q4JrAAAACXBIWXMAAA7EAAAO xAGVKw4bAAADoElEQVR4nO2YW04lMQxE785ZCkvhhzfsiVFd6aCS5YRmZhoj2R9H t0nScSWpOGkul8vlYxh+kHIBQy/KBQy9KBcw9KJcwNCLcgFDL8oFDL0oFzD0olzA 0ItyAUMvygUMvSgXMPSiXMDQi3IBQy/KBQy9KBcw9KJcwNCLcgFDL8oFDL0oFzD0 olzA0ItjDZ+enk4Vcnt7+3F/f3+N8/r6Wj0pw3msK29ubj6en5+vBhBvb2+nGO/9 /f3a98vLyye/YGKGc1hXYjb93t3dXTPQ4+PjtU5/y3xCzzKnm1FlgmdlsFguo+kZ s610EIv3jtTTt8d0zU6mOetXfWoclLsGj+dz4eVAH7RjbrK2u5irsXvZbl3Q4u/H OaI8touxdutz2HAygljVkfmEgukXQ/q7MhPHpH4lThNBxiR70s7N5zF413Ws6tUH 8dGqDRPbrzRn/ZJ9KXOdHo8xaU68HNAhM9EfG09l3nYXM9PIaeEnks+LPz88PHyO WejvbI68T3B96CI5nWI4BVDnfudCDGZi8tROf2NKvRPLmByE864vgOqyzJLVs9Ay k5sqTvpKc9Yv2rTb3ShHDOfZlEXl1GDBsrnexcw0uinJmCvDeVtPCqs5wqRx3LT7 6qT60nCr+5QPwg3HTtCvi9JiZpmFvv1uGCeILMAOywyX1XtWiB8hsf9Mc9avmwKd MkwWzw1HXcy0xKI8yw67mJnGOEcyqt+P/YSJet3wsV1cnzhuktOBO/7ecGQhgmmQ ZCfuBywoYuJu5W8WFaN6hnPTxsVgJ2eGW9XHDOfZIJvAqDnrlzYad9R55EjNDOeG WWW4VcxMo8owLu00B54cjmSk2I4+fWzZqRI397cM53eMVXaK/8aIR6ImyjOl7xyO ZRaAXeI7Pe7A3R3O6+NCZ7t3pXnVbzRHHPfKcMACxzucwEzRALuYK427I9rH7kcw a/FVu2jSGO+fjlRSMjuEDOf3ofjVE3chXzfZV2p85mvY47NoXIiP1qOVZzdY9kXr mlf9eqaWaRhTjMeYyUoQvwT5VTt0ZR8Nu5i7sce+srEz77qbefmqXXal+W9fqX/D 7kPjt3JU8yprnElFzJP5vx1+w+m/hqOaPYv9FBUxT6ZcwNCLcgFDL8oFDL0oFzD0 olzA0ItyAUMvygUMvSgXMPSiXMDQi3IBQy/KBQy9KBcw9KJcwNCLcgFDL8oFDL0o FzD0olzA0ItyAUMvygUMvSgXMPSiXMDQiD+doeGVevND9AAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -510.65,
    x: 266.73
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -502.25,
    x: "223.97 227.57 231.17002 234.7628 239.5652 243.7556 246.758 248.5508 252.14359 255.73638 258.13398 261.72679 264.72917 268.91957 272.51957 277.32197 280.91477 282.11717 286.30757 289.30995 292.31956 295.90516 299.50517 301.90278 306.09318"
  }, "&#x0421;&#x043b;&#x0443;&#x0436;&#x0431;&#x0430; &#x0430;&#x043a;&#x0442;&#x0443;&#x0430;&#x0440;&#x043d;&#x044b;&#x0445; &#x0440;&#x0430;&#x0441;&#x0447;&#x0435;&#x0442;&#x043e;&#x0432;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -493.85,
    x: 266.73
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_28)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,207,104.4)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_30",
    width: 203,
    height: 26,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAMsAAAAaCAYAAAAZmai5AAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAsElEQVR4nO3cSwqDMBSG0ezcpbgUJ4Koi0pJsdiHyD9T6BkcsoKP mwxySymlNsMw1GmagC9939etk1Lnea7LsgAHWh9d14kFEu3m9RHLuq6Xjzy4i/ch 8hNLO19vGPh34ziKBRJigZBYICQWCIkFQmKBkFggJBYIiQVCYoGQWCAkFgiJBUJi gZBYICQWCIkFQqex+FYMu9NvxcAxsUCg3bi23WHluRPp6pEHd7VNlfoAkBt8wPqe Zp4AAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#6699ff",
    d: "M207.01 477.85H326.07V491.147H207.01Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_31)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,219.6,96.60002)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_33",
    width: 161,
    height: 53,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAKEAAAA1CAYAAAAppovjAAAACXBIWXMAAA7EAAAO xAGVKw4bAAADiUlEQVR4nO2XWY7jMAxEc/McJUfJT9JZ7+RBDfCCGkLyLJ2EPej6 eLAdy1SRokhls9lslhCaaRcQQruAENoFhNAuIIR2ASG0CwihXUAI7QJCaBcQQruA ENoFhNAuIIR2ASG0CwihXUAI7QJCaBcQQruAENoFhNAuIIR2AQ+22+1yOp2W4/G4 3O/3dj3hbawP2O/3y/V6XS6Xy8+rEuQVQpR0t9vtMZeS8QsEJ7yH+UtVJpLvcDg8 EuXZImSXOb5AQML7mb9UUig5VA3rO1VEvRNKTK+Yes+zrqpquqfd6l5juD+fz4+r vhcaix02gubBvutgY5DM+oYN5NV1t9v9UnGZg3F6hw3HjwYjv2caZV8+MZ/suF7h 9jW+2nZfPaYCzXpH7Fyzj2cujwnoN+xpTfCB70a2ibfbqn6v+fLHSYjg0TsSiEXR sycQzx48ifaEZLwnCs7KCb79+Ph4BJEErhtF97KDXuyQWARWtrAj7QSfZ+xJJ1q9 Qo/8nmnENyU/49HlScjRw488JNEo5jXWo/hypKn2SS6fywuFf8fYkW3f9OhhHi8G fPOpJPSK4RBsRLIYumehSSR2E4vtu0cLxDNjPZlqRZslId/4rq82ZUfjua+VQcHz pMaOJ+HI75lGr4zVd9+ALJ77zQas52S3QeJTdWrx8PH8RgLVLlcTljlmtkk27Pm3 tTM8JQn9zwitTsYl0BfDA7kmyisewdXvJLvvNsYp4DVZPZi0Ob6rrds1cUWrV8q1 JJz5PdPIAlJVRa20XkGqf3QUNjjaqTS16mtDe/v044632bUkpNV6ix3Z9nlrEvoG /HQSckapfd+rTk1CAu8JQAA8kKOqMqpofk78XTv2eXyhvHLURCX5sb2WhDO/ZxrR 4BttZJ/Y0bLRW/+o+QbyVlgrJj7O2vFaErLJvB2PbDPGk/Yl7VhwmGdHyRhX3hMI ql5txRJNNWXRGKtn2fAEccF6h9Oy4Xbdht8TGGzqG1oXfw5YdBaaVuz20OsbYuT3 mkbN63+8qn2qFM9+dhz9MXE9une/vLuMxss//PXY10rIlc40su1xrH5wDh/N809J +Lf4Dn227fA6atV8M8816Lsg/D/Uqvlm+gMQvj3tAkJoFxBCu4AQ2gWE0C4ghHYB IbQLCKFdQAjtAkJoFxBCu4AQ2gWE0C4ghHYBIbQLCKFdQAjtAkJoFxBCu4AQ2gWE b84PTrvi4Q0vKQoAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -490.7,
    x: 266.73
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -482.28,
    x: "222.4 226 229.6 233.1928 237.9952 242.1856 245.18799 246.98079 250.57358 254.17357 258.97596 263.16636 266.76637 270.35917 273.36158 277.55198"
  }, "&#x0421;&#x043b;&#x0443;&#x0436;&#x0431;&#x0430; &#x043a;&#x043e;&#x043c;&#x043f;&#x043b;&#x0430;&#x0435;&#x043d;&#x0441;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -482.28,
    x: 280.42
  }, "-")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -482.28,
    x: "282.58 286.1728 289.7728 293.3728 296.368 299.96803 303.56803 307.75843"
  }, "&#x043a;&#x043e;&#x043d;&#x0442;&#x0440;&#x043e;&#x043b;&#x044f;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -473.88,
    x: 266.73
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_34)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,207,124.20002)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_36",
    width: 203,
    height: 26,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAMsAAAAaCAYAAAAZmai5AAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAn0lEQVR4nO3csQ6DIBiFUd7/pVg0RHkoWjtY0zbmbpr0DCeB7V++ AAullDKASBnTNI3e+1jXFfiwLMs7lm1z9UBwZ7XW71haa8DTaSyH4wb+3vY8EQsE xAIhsUBILBASC4TEAiGxQEgsEBILhMQCIbFASCwQEguExAIhsUBILBASC4TEAqHT WIDf9liuHgTubo9lW1z9kwbc1TzPr2vZA8Sh44G06lzaAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#6699ff",
    d: "M207.01 457.9H326.07V471.197H207.01Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_37)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,239.4,117.000019)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_39",
    width: 95,
    height: 53,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAF8AAAA1CAYAAAAnIzfJAAAACXBIWXMAAA7EAAAO xAGVKw4bAAACXUlEQVR4nO2WW44qMQxE2TlLYSn88IY9MaqWDiq1uhvmcjU1oubj SJ0QOxXHdlitVqv7HzHiApqJC2gmLqCZuIBm4gKaiQtoJi6gmbiAZuICmokLaCYu oJm4gGbiApqJC2gmLqCZuIBm4gKaiQtoJi6gmbiAZpYXnM/n+/F4HND3ZrNJC/4k lhdcLpch6KfT6X69Xgd+gehP4XnwlfX61iVovN1uHxWh+cPhMIyxud1uj0vb7XYP W9bz23gv/MseP5rb7/fDmH0Fa1SJGus3jZUkAp9TNq5BkFBUt2ywG38/00EsiNN/ C76+EapvBVYbaE5jza/X68c6DuPruRh8OlQWwcOP4HBchubYH9/4QMszG40JFNq9 zXqiCf3+zCf2+H47+CCHZCEbjQ+ACM+ysR8PLj50KH4jowgkGeWHoxWyHxfqwZ+z IbDag2+vPi4cPQR4yacH36v47eCTxVPzbMhGHGZqPSDQH3IqgkriEjxQfmhBS5gL /pwNmet6vWXiw4PvrXBJh7fZF97H19vOVPC1qTb0Ukc8PXvcpqYqY1zmrBfsQ5Vp rezFUtuZsvE+z8UTXNZ7RWiOCyHISzqokrl37VvB90dzPI/z8YNLL/QHidbh7cb9 uQ+C5I+dz2Pvv+ObzPRMdhuvVmAs3UsPLi13TsfY79sP7qcx1UL9j8G/Mq7AF8kH 5CdRDyeDgYx/N/hegX/B//3EBTQTF9BMXEAzcQHNxAU0ExfQTFxAM3EBzcQFNBMX 0ExcQDNxAc3EBTQTF9BMXEAzcQHNxAU0ExfQTFxAM3EBzcQF1PIF/l5i7djhS5sA AAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -470.73,
    x: 266.73
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -462.33,
    x: "242.45 246.04805 250.23854 253.25859"
  }, "&#x0420;&#x0438;&#x0441;&#x043a;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -462.33,
    x: 256.48
  }, "-")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -462.33,
    x: "258.63 263.4274 267.02546 271.21595 274.21434 278.41929 283.80915 287.4072"
  }, "&#x043c;&#x0435;&#x043d;&#x0435;&#x0434;&#x0436;&#x0435;&#x0440;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -453.9,
    x: 266.73
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_40)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,469.8,52.200025)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_42",
    width: 260,
    height: 27,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAQQAAAAbCAYAAACa//HwAAAACXBIWXMAAA7EAAAO xAGVKw4bAAABbUlEQVR4nO3dS5KDIBSFYXbuUlyKI9/uya6TBLwSksxagX/wdXWL J3HCLQS0nXNuB4CX84FxHIN5nvemaUJb27b7NE2hves6smTJFpJ9Kwjbtu3Lspzo Q3173Lau6+NLyJIlm3f2rSCoQeJA3/fhZFWXuN3myZIlm2f2VBBURXTChyEEgEKp 74tGF69jx1BC9xVXXyCA/6NRQtT3KQhArRJ9/6gSZtgAoALJgsAcAlAnDQZkGAZ/ 7PqLAnAbl18AgPt4bmjQbUNikwKAgqnPR1MFx6Si3dUEoHyJvs+yI1Cr5CoDBQGo E/sQAAR+y8Fp67ImFigGQH00oai+bxYUrr8oALfx/IUlRwBOP9i6DNSJx58BBDz+ DCBg2RFA8PPxZxWFT29l1Rtc7Vtd44lIsmTJ5pX9+vizTrIvYYyfb/CFI9VGlizZ fLPG8Ycqir998OxbW+MvE7JkyeafTRYE/6Hf/pGDbSdLlmw5WfkDo8MCrdkt90UA AAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeDasharray: "1.5,3",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#3366cc",
    d: "M469.64 529.56H622.71V542.857H469.64Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_43)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,507.6,40.8)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_45",
    width: 133,
    height: 67,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAIUAAABDCAYAAACya8aVAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAE8UlEQVR4nO2aW27jMAxFs/MupUvJT9/tnjq4BU5xQ4h2nCmGRIcf B45lWbqkSNmRfDqdTp/DECgXMPSjXMDQj3IBQz/KBQz9KBcw9KNcwNCPcgFDP8oF DP0oFzD0o1zA0I9yAUM/ygUM/SgXMPSjXMDQj3IBQz/KBQz9KBcw9KNcwNCPcgFD P8oFDP0oFzD049gNr6+vn+/v759vb29fx4+Pj2oDhsqgUEAoGHR8fn7+Pura3d3d 1+/7+/uLeyg/n88X5aoXy/Vb9XWknPt1PKI10wMezFHbqq2oy/Fy7y+zPdqb+URH by/6imtqA3viPSrfs+/moFBHzBArB/vs8fj4eFEOiHt4eLioT7mCjMAj+Ki36pdy Z0sPqH9dY1BUx/uN7aGLNl9eXr7b0iBS1/2T2U5/sY+VT+hX19Wnyj1BuYZ2L9d4 RZuyBLk5KGSkGo6PC4lnAHWOgykncrmXcv8tg6mDQ9yZq6CgnAFHQ6Znda8GFLue np6W7bkuEoP2vC9Pmsx2HzT1F+u7Twg210NQeH1sZNC5Rz7FH7H+jwdFnIo8Sn0Q YpTGqMZInSt7GBSyF8dkAxuDlD4zPXHWQxP1s/Zc1ypD+c0MoPsz27mHx6HqM3jR J+hxmKF8LLwdtAL+yxL6r4MC4ZrmcIJnNBGMQHeGItczwqdBH+SYCXtBscqcTM/K Hs/UrD0c6vbSnvcVZ5yV7T6D+O+VT9DjsxltulbGxW0gqWL9H398kF3+rFeAuGDK ecFiMHEeL0T+/EW4/yaoGIhVlEej3TErPVmQM8BZezHj0eVt+DsCL4vRdl7MGUy3 ceUT18OjhNkq1qcdD67VTHjtWF8dFAQG0x9ZTDZgtA+AgkblOq7KeeZhqL918yxV n7xzxEzy+sxgW3pWQcH1rD0Cx1/gaIMBVV3d4zNStJ3rKxtXPol63BZ8Ql1/sece 1dH51r+fHwmK34L/+9hLghuy7DdQLuCfw0vZXj0eBQeexb+FcgFDP8oFDP0oFzD0 o1zA0I9yAUM/9ivF/786ssTKb/9PzZG/crzF057fq2v+1zB7419puIatvq65fqt/ Mtv8vJMfDgUFK2++Lq9y1vlZ+o0bUL7+7it1rLytVhK9ru8sZhri0ruvMOp8q69r rkPc1fQ6e9riamhcgezgh0NB4RspPvi+N+FGUu51fE8i7p5iQNx48vb3NHh/LClj fNaXZ8/W9VUdbz/T5vsgvozt5538cCgo/PsAGtaSKiuCLkR1fKUQI4heRPJdgAcR m0YOUb6lgT2FmI08qrK+PMu3rrtNfGjjWZZpixtcqw2vTn44FBTxIw8i1XfmVtOY ZxHPMsTSTmzTjab8vPjQhPo4jEHzD1MIxKyvOPVn17Ep7p6uMi76h3L2i/x8q+8K PxyeKSCL2uw3z8XoTKI2tkk5Ee/ZGOvzDQEbX17fDc76itmaXff+Y8Zt+cc1sYHo 51t9V/jhUFDwBqxO2Q1kSiVb9AxkH4GtdBzj3w3yksmjhTY8YnGgT20rDWpHhupI JpKB/sa+1dc116NNsU7mH2ZKWJ138sOhoBj+W8oFDP0oFzD0o1zA0I9yAUM/ygUM /SgXMPSjXMDQj3IBQz/KBQz9KBcw9KNcwNCPcgFDP8oFDP0oFzD0o1zA0I9yAUM/ ygUM/SgXMPSjXMDQj3IBQz/KBQz9KBcwNOMPVn+Zr7q4vEwAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,BoldItalic",
    fontWeight: "bold",
    fontStyle: "italic"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -546.65,
    x: 546.58
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,BoldItalic",
    fontWeight: "bold",
    fontStyle: "italic"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -538.25,
    x: "512.45 516.05007 519.65 523.24288 526.8357 532.2357 534.0285 537.6285 541.22848 543.02127 546.0236 549.6236 553.81399 557.41397 561.0068 564.60678 567.6092 571.7996 575.3996 580.814"
  }, "&#x0421;&#x043e;&#x0432;&#x0435;&#x0442; &#x043f;&#x043e; &#x0443;&#x043f;&#x0440;&#x0430;&#x0432;&#x043b;&#x0435;&#x043d;&#x0438;&#x044e; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,BoldItalic",
    fontWeight: "bold",
    fontStyle: "italic"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -529.85,
    x: "510.6 514.19808 517.7889 523.186 526.784 530.3748 533.9729 539.36276 542.96078 544.16018 548.35067 549.55007 553.74057 557.3386 559.7373 562.72848 566.3265 569.9173 573.5154 578.9052"
  }, "&#x0430;&#x043a;&#x0442;&#x0438;&#x0432;&#x0430;&#x043c;&#x0438; &#x0438; &#x043f;&#x0430;&#x0441;&#x0441;&#x0438;&#x0432;&#x0430;&#x043c;&#x0438;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,BoldItalic",
    fontWeight: "bold",
    fontStyle: "italic"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -521.43,
    x: 546.58
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_46)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,469.8,72.60001)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_48",
    width: 260,
    height: 26,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAQQAAAAaCAYAAABRoyJVAAAACXBIWXMAAA7EAAAO xAGVKw4bAAABdElEQVR4nO3dS5KDIBSFYXbuUlyKEzW+9mTXSeXSQDDDIOQffFXp 0Cdh4i0QMM45d4b6vj8fj8fTcRxn2j4Mg2/vuo4sWbKNZF/if973/dy2zVvX1bfr ddgm9qFkyZKtN3tZENKAKom1p1+mv8POkCVLts5sVBBUOdSoDwyHFHqdDimsLddO lizZurKiqYWmGr4gWOXIzTkAtMumEcG177LDCwDty1z7FATgV2ULgqYMGjrk5hwA 2mW3C4LViPKdAlCGbiYmA4HynQJwG84vPdygMwDK+r+xME1T6c4A+CLdQ5B5nu09 VhmAX8WyIwAvWxBst1J4EAJA+2zZMSoIuqmoYnBxHBJAo3TdS7R1GQBeincAwH3E x59v0CEAX8LxZwAex58BeOxDAOBx/BmA9/H4s+YR4ZNZkz3Ob09tDTcykSVLtr7s x+PPCqdPbV2W5a2ahF9IlizZ+rPZgmBVxp7KOo5jtHvRliiufgiCLFmy9WblD/Bf IuWDW1i9AAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeDasharray: "1.5,3",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#3366cc",
    d: "M469.64 509.61H622.71V522.907H469.64Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_49)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,502.2,64.8)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_51",
    width: 151,
    height: 53,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAJcAAAA1CAYAAABMS3mcAAAACXBIWXMAAA7EAAAO xAGVKw4bAAADaUlEQVR4nO2YW44qMQxE2TlLYSn8wPDcE1fV0pFqrO6m4QrMGH8c EeVZdhwnzWq1Wt2a5kWkC2jqki6gqUu6gKYu6QKauqQLaOqSLqCpS7qApi7pApq6 pAto6pIuoKlLuoCmLukCmrqkC2jqki6gqUu6gKYu6QKauqQLaOqSLqCpS7qApi7p Apq6vGbi7XZ7OxwOw+87DVqv17fj8Tj8bjabofwBTv5Wm5Z1PJ1OA/v9flH/6/V6 O5/Pt8vlMgTZuwxSMGtdbYD0av0PcPK32rTcOBn1yKnRKSMo32mUgllIqzR8gJO/ 1ab7nRRYBIkHCvUq//z8DMEnw+UElemvfoxRoFKnPgQuJ1J4dpxq0xrM4br0S6bU RnDK1dfHKLOi497YOVtVT5vmRBtzC54GY7bHdcHXmNPlwad61nxUx5S2JX57OriY WIuRlmnzTMYGqx9GumEYxTVJWWIJHMqsoTfGWJuvQb3KbLYHC2szz263+zUnfebG TtmqsoJdOn0DmR/fuWbVsRbvKOwgOH39e7rcr8zv6y3RweH1fcHWe377r+Bygb6J ZBzPar7Zclo88f4Oc6GqIyN5f9aIbTIcHWjk2vAT6g7zeZiDOX0D4ljXEW2VjZ5V lW3wU7Q/2q469fG5gXk9a4zpguhzz2RLdHhmArLZPb89HVwIiWhRRTLGI84D0E9U PAX+FeknlEwVT2ls8zXQqF+CTn29Hq1+KMgSMWDjWPWZshV/qN0DHW0EiV83Ghc1 s0kKTs9+czbFBBCzyCM6xvbF7Z7z21PB5ane0y+R7F8tbrTfxwjn9DBGojEW5+EM nKr+U23ME98Tnv69fkyr6rkWpGdqrOses9Wzur83uZ7IApT9GaB65mMjmTsG85iu mATogy+W6sC3vi9Tdke/PRVcmixGMs4jc5EuMUbtwtOtf9l4m2e6KcdNtfnXKxsw Vz+m1ct+BcSxU+NlizINm8GB4H8of4PGen8w+7uH/r7GnK64L35tPaJjbF+W+u3p a/HVcNWN/b0x19b8GfIWJ02PnYC5tubPkC6gqUu6gKYu6QKauqQLaOqSLqCpS7qA pi7pApq6pAto6pIuoKlLuoCmLukCmrqkC2jqki6gqUu6gKYu6QKauqQLaOqSLqCp S7qApi7pApq6pAto6pIuoCnKP+YJ1uwiMrgdAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,BoldItalic",
    fontWeight: "bold",
    fontStyle: "italic"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -522.47,
    x: 546.58
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,BoldItalic",
    fontWeight: "bold",
    fontStyle: "italic"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -514.08,
    x: "505.27 509.4676 513.06759 517.25796 520.2604 524.45077 528.0507 531.6507 535.2507 540.6507 544.84109 548.44107 551.4434 555.0434 558.6362 563.43869 567.03866 568.8314 571.82669 575.42666 578.4291 582.0219"
  }, "&#x0410;&#x043d;&#x0434;&#x0435;&#x0440;&#x0440;&#x0430;&#x0439;&#x0442;&#x0438;&#x043d;&#x0433;&#x043e;&#x0432;&#x044b;&#x0439; &#x0441;&#x043e;&#x0432;&#x0435;&#x0442;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,BoldItalic",
    fontWeight: "bold",
    fontStyle: "italic"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -505.68,
    x: 546.58
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,469.8,88.800029)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_54",
    width: 260,
    height: 51,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAQQAAAAzCAYAAABxAHarAAAACXBIWXMAAA7EAAAO xAGVKw4bAAABwElEQVR4nO3bS3aCQBAFUHbuUlyKE/+6J3LK2GWDrUMN6Tu4OQg8 dZI62PCGYRhGgLvfjf1+Px4Oh5vj8ThuNps8KbZjXzke59ZvIisru9zs00C4Xq/j +Xx+Uk5qHYuMrKzssrPb7Xby+jYQVqvVeLlc8uTYjhPLG8b2/HhkZGVll509nU63 fXHlkAMB6FMZEpOBsF6v60sGoBPNgVAuJwwF6EsZCLvdruxrTgmgE/UdiSH+GAjA 3eMnQ6w4/oEvBHxI3G14ukKItYMYBrG4+O0vCHxOue1YXQx8/0sB39G8ywD0qTkQ ymXD7LcE8M+V//3Jo8ueQ4A+NcpQbjsCyUAAkjUE6FWz/hw8gwD9UX8GkvozkNSf gaT+DEyoPwOvqD9Dr9SfgaT+DCT1ZyCpPwNJ/RlI6s/AOwYCkKwhQK/Un4Gk/gwk 9WcgqT8DSf0ZmFB/Bl5Rf4ZeqT8DSf0ZSOrPQFJ/BpL6M5DUn4F3DAQgWUOAXr2t P8dAKOsJRT0k4rdGfTxel2OysrLLy76tP8eUqN9svtA4/7B4LSsru9xs47zHQIjH GGNixLQoq4/104sxbcqxQlZWdrnZ2Fef9wPRYMDTOjmohwAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeDasharray: "1.5,3",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#3366cc",
    d: "M469.64 478.34H622.71V506.286H469.64Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_55)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.59999999,472.2,80.4)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_57",
    width: 254,
    height: 81,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAP4AAABRCAYAAADy3BtqAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAKL0lEQVR4nO2dW3LcOgxEs/MsJUvxT97JnnILrmrnpC+hkWObUOz+ OOUZDgU2wJdkg5537969+xVCeHOMCwgh7GdcQAhhP+MCQgj7GRcQQtjPuIAQwn7G BYQQ9jMuIISwn3EBIYT9jAsIIexnXEAIYT/jAkII+xkXEELYz7iAEMJ+xgWEEPYz LiCEsJ9xASGE/YwLCCHsZ1xACGE/4wJCCPsZFxBC2M+4gBDCfp7X4OfPn3/9+PHj 193d3f37b9++/fr+/fu0kyGEP3legzXRa+LX658/f95P+vp5AUdDCL95XoM18YsP Hz7cT3ru9nU3oDuA+vnly5f78vqpsnr/6dOn+8VD1/Iz3kFUna9fvz6Uffz48eF1 lavdsq9yLURnr6Vfuv6sX2xf/nAh7K7r2qKNouJ0SwPLZad8LVu0d6YfyMrumZh2 PnSantrH9bp+qp3VWNIGVXep79+/v6+vOiu7R/7rOrV9NDZc361xdOmJz46r17UA VLk6ohyqAK86oKjA03ktINXhrKsOYnDrPQdG1a+21K5scVAcXSuqrSqrjtAklvYj v/xz2alO7q7r2nJ/2U5ni76XrarHMsbhVj8wHiu7Z/qj86HT9JQ+Vvw42buxpDYV S12/sluLzZH/ZVv29Ni7Ghtlj/o0X7pxdOmJL8FaocsRrZB6XwHSezqplbWuVQAU PF+N1SkaEL7aMmjcxYRs3rrW/dLvLXzRWvmla9m+OleT6ige3pb7y3Y6W14uPSzz eHb9wHis7J7pj86HW5r+po/rWpbX+24syR/emdXnK7s1YY/81/W0uxobK/tH4+jS E5/P9L5qKSha7bhisgO46us1b1FlvwamOkh1NEDYLjtCOs9ey/rUzlvUzi9dyx2D t5TddV1b3OFUnzvGypZunekL9ZVdxfNWP7gNt3smpp0Pnaan9DE3Dh+fPpZUzp23 s3vLf8VMNrux4fpujaNLT3zfHfR8Vq99ddMEUOcrUFwo2CkKxGriaLBUwHxicjUv 1EFnrhWsr11DdzKdXx4TPiuuVvuVX2xLunn7rXY6W3qtxURlGrga2Gf6wfvZ7Z6J aedDp+mpfaxJq+u6seSTWmN2Zbfzn4sBr+vGhutjTDptl5342pk4QNQ5fGbUHYEm QL3WM48GmSZ9levRgZ9rR9LAV6foFk9BqzZ0va45ey39UH3V0Wcrv3itdivpp67V dV1bmhC8E7qlQbelZUP9wHhWPT2f3uoH+rSyeyamnQ8rTU/tY7a38p0+EsZvZfeM /1qoj8aG67s1ji498cPLoOfR1V8b/hVegw+vjHEB4Qbdnci/xGvw4ZUxLiCEsJ9x ASGE/YwLCCHsZ1xAAPrzVs43vI54+1+wlMl6AcYFBKC/3a8SR8K/F2/9iU4w22+Y cQFhATP4wr8bb2VFKsd/2k9wXIGrFTOpCiXs8KAHD1l4faZsMm/aM/yYAcW2PVtO 9lnODCit4J2mTk+97zQp1VMcpVVyMLEtZtWJugVkUodnNzLOTGTxpBiV01fPRFS/ epqs34au7HRten+pnDHwAzCrGDDrjim5nf8rG6qrZCDF0VOQu3i7jxpfnS9dLM/E +Ewd97HT+cgU3+MKzKlnSi5TO1WHQnSayvPWOUl1KIGTbNXhynzjRPAUVJXLvl4f aVrpqdedJk2Eeq1TdEcJKdSp9pWhpZjyFlC2eTyT/mpgKG6yw/RW19UlzTDOXJTE yo76w9tUfU9H5XVcNNVvHgMtwJ2Nzn+3IW3Vno8zPWd38fYc+1UM6ItPcMbyVozP 1uGZgVv9/ywTXwaZNur5yhS/ykeWUzwIoboUzZRVTXZ1HgeCdgStirQp5z04K02d HvrtmrSb+A6xih2PlGrAaWC7bQ446uRE5ll9He5wOyznRPUd5GiwipUdTTxvkzsT FzvGgLtWFwPGuq6rvn+M/7Kha7gxSQePia/iTb+5u3a+dLE8E+MzdXwBdp1dXzxp 4nNVowCuqKtDGBw4/EcL6nQ/CaYdTwOrfvK2h8dY2QZXPXYsJ2WnqdPDDnBNvPVV m9rputtkPhowDhx8PIxU9larOR9BuHCtdgXp8j7wSa3bRWlgnZUdPtKxTfrcndDk rtzFQG0qd321CMv/zoa0y2+NGdfaxVuPA/4b+M6XLpZnYnymzq2NseuLJ018fy5l p+l2d3WCjM9pPHDhtngLz5WU5VyxvZwTnB2mQcpnRtfU6aFW1yS7Vcef3/12mgsD JxHtcPDwt8v6jAuXBrwmt09G7bJaqHz3XQ0434VZZ2XHtdM2Hwc16biAanD6iUuf QJxYR/53NnwTUN9x3DIGHm8+wsof3wzoSxfLMzE+U4ftapzqv/V0ffEsO752izvk WjPnWu99B1YQj2zpiCVPZnHXFfW5bHWnmHiSiievOk2dnnq/0uR+6z+t+D8XZafy 0YH2tUiqXIOJZ8S5w3EnZzsczCzn4rgaDIoJNaz+vryy07XJcj7WaEFcnfrzGNzh l3U63Xbk/8pGvac9PtP7Ar2KN/2uupqInS9dLM/E+Ewdtrsag0f9/NcTfxL+4u2q 8BdELxmHt3yi7a37/4KMC/gfvjtcFf4m+6V46yfa3rr/L8i4gBDCfsYFhBD2My4g hLCfcQEhhP2MCwgh7GdcQAhhP+MCLsWdnXjSqTnP5qu6t7IRWc6EJ9nxjCt9xozE Vf52oXbqtb6AofsKMH7uX2ChNldJSB6L7lScx4Mo6YSZd8x76Gx520dxe4xP4YFx AZdC6ak1mHRIxE8DKh2Uk0wpvMwsrHKm7sq+MtE831+Ty21JD/MaOEmY4sr6nBir FFjp83RUxkJtsL0uHrLL1F1OWE+zPrLl/dDFTbE/61N4YFzAZeCurTI/AMKB6xND A4/lqzPcShXmMU/u4CznrsfJ5xNJE8HrK+XTT/rRB51zYCx4epG5+kfxkB6V8zUn pefFuy3/tqKjuCkWZ3wKfzAu4DIwd1tlfhRVE8FPoWm37srrWg5O/8wnO09B+ver aXfVVztpYnl9Hnjh5/zHJKuTXowFb9WrXhcP/1orHnxhTLWYHMXW++Eobo/xKfzB uIDLwGds3+F0aEMTi6e4uMPyVJvK/dmTO6nf/jL/3/VogPuOKG207xNPh1c0GbgY cHf2WPC76em3x8M1reIn9D8WOlsrv1dxKxuP8Sn8wbiAS8F/qaTnQ/7LJv6ySOV8 dtaXM6rcT37peVU7qX6uTkHWe37Huk69qY5ssj4XHj7j1+tqW3cDPJ2ondxjQVv+ rbMeD2riWQvdLXBie7y72LIfVnGTH4/xKTwwLuBVwGf08Bv+XiJcinEBrwI9f07r uBo80x4uxbiAEMJ+xgWEEPYzLiCEsJ9xASGE/YwLCCHsZ1xACGE/4wJCCPsZFxBC 2M+4gBDCfsYFhBD2My4ghLCfcQEhhP2MCwgh7GdcQAhhP+MCQgj7GRcQQtjPuIAQ wn7GBYQQ9jMuIISwn3EBIYT9jAsIIWzmP0ecjrdc1Pz9AAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,BoldItalic",
    fontWeight: "bold",
    fontStyle: "italic"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -506.93,
    x: 546.58
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,BoldItalic",
    fontWeight: "bold",
    fontStyle: "italic"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -498.53,
    x: "482.43 486.6205 490.21858 495.04487 498.6429 504.66136 507.65974 513.67819 514.87759 519.06808 522.6661 523.8655 527.4563 531.0543 534.6524 538.8429 542.4409 545.43209 549.03018 553.85647 555.64828 558.6394 564.06539 567.66348 571.26156 577.27999 580.2784 583.2768 586.8748 590.46566 594.05648 597.0476 600.04598 604.23648 606.6352 610.8257"
  }, "&#x041a;&#x043e;&#x043c;&#x0438;&#x0442;&#x0435;&#x0442; &#x043f;&#x043e; &#x0432;&#x043e;&#x043f;&#x0440;&#x043e;&#x0441;&#x0430;&#x043c; &#x0441;&#x0442;&#x0440;&#x0430;&#x0442;&#x0435;&#x0433;&#x0438;&#x0447;&#x0435;&#x0441;&#x043a;&#x043e;&#x0433;&#x043e; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,BoldItalic",
    fontWeight: "bold",
    fontStyle: "italic"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -490.1,
    x: "475.28 478.87998 482.47999 486.67039 490.2704 493.8704 497.4704 501.0704 504.6632 508.2632 512.4536 516.0536"
  }, "&#x043f;&#x043b;&#x0430;&#x043d;&#x0438;&#x0440;&#x043e;&#x0432;&#x0430;&#x043d;&#x0438;&#x044f;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,BoldItalic",
    fontWeight: "bold",
    fontStyle: "italic"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -490.1,
    x: "519.4 521.2"
  }, ", ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,BoldItalic",
    fontWeight: "bold",
    fontStyle: "italic"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -490.1,
    x: "522.8 526.3928 529.9928 533.5928 537.19277 540.7927 544.38558 546.17837 549.7783 551.5711 554.57357 558.7639 561.7663 565.3663 568.96627 571.9686 575.5686 579.1686 585.159 588.759 592.3518 595.9518 599.55178 603.7421 604.9445 608.5445 610.3373 613.93728 617.53726"
  }, "&#x043a;&#x0430;&#x0434;&#x0440;&#x043e;&#x0432; &#x0438; &#x0432;&#x043e;&#x0437;&#x043d;&#x0430;&#x0433;&#x0440;&#x0430;&#x0436;&#x0434;&#x0435;&#x043d;&#x0438;&#x0439; &#x0438; &#x043f;&#x043e; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,BoldItalic",
    fontWeight: "bold",
    fontStyle: "italic"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -481.7,
    x: "511.45 514.4452 518.04519 521.64517 525.8355 529.4355 533.03549 536.6283 540.2283 545.0307 550.4235 551.6259 555.21878 558.8187 562.4187 566.6091 570.20907 572.6066 576.797 581.5994"
  }, "&#x0441;&#x043e;&#x0446;&#x0438;&#x0430;&#x043b;&#x044c;&#x043d;&#x044b;&#x043c; &#x0432;&#x043e;&#x043f;&#x0440;&#x043e;&#x0441;&#x0430;&#x043c; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,BoldItalic",
    fontWeight: "bold",
    fontStyle: "italic"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -473.3,
    x: 546.58
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_58)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,469.8,124.8)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_60",
    width: 260,
    height: 27,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAQQAAAAbCAYAAACa//HwAAAACXBIWXMAAA7EAAAO xAGVKw4bAAABaklEQVR4nO3cS3KEIBSFYXbuUlyKI9/uydRJN4h4TYYK/IMvlRZP 68RbNALOObcDwNf5QN/3+ziOv6Zp2tu2DW1d1+3btoV2IUuWbBnZS0HQycuynMzz HNrTtnVdwwXJkiWbb/ZSENTQNM0lMAxDOFlfrmPWxciSJZtv9lQQ1KAT1KUwTgBQ KD37ot7F99jRlbj5TQGgUL7HED37FASgVsazf1SJqNsAoAJmQWAMAaiTOgPJ4OPz NwXgNR6/AQDv8ZnQoJ8NxiQFAAXTM58MFRyDijcTFQAUynj2ee0I1Mp8y0BBAOrE PAQAgZ9ycJq6rIEFigFQH78kOnqh8PxNAXiNzz+8cgTg9Iepy0CdWP4MIGD5M4CA 144Agn+XP8e7sqZjCtqzLd6xNR2IJEuWbF7ZP5c/66R0Z9Z4fYMvHFYbWbJk881G jg+qKPGurKJ93n17ejEhS5Zs/lmzIPgvvetypO1kyZItJys/4hALCzqteeIAAAAA SUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeDasharray: "1.5,3",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#3366cc",
    d: "M469.64 456.98H622.71V470.277H469.64Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_61)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,489,117.60002)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_63",
    width: 195,
    height: 53,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAMMAAAA1CAYAAAD8tF+uAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAD+ElEQVR4nO2YW45iMQxE2TlL6aXwA81zT4wKqUbVniQ3lzvCVqs+ jgh5lh07Cex2u93TGPMiXYAxVUgXYEwV0gUYU4V0AcZUIV2AMVVIF2BMFdIFGFOF dAHGVCFdgDFVSBdgTBXSBRhThXQBxlQhXYAxVUgXYEwV0gUYU4V0AcZUIV2AMVVI F2BMFdIFGFOFdAHGVCFdgDF/+f7+fp7P5+fhcMhYf9wBwu73+6u83++f1+v1eblc 0p1mfieIr9vt9gKJ8eH1xx0giskAoShr1j4ej38yGUkTMxv9vr6+XmW0sR2faGMZ fbQd3zF/1IV21Oucs2N1PGnpHZ1Qcf2WXUqvz5LmVp+1Gkbl0VyjfRzZFftHG0bj 2I9JsSVeZjVOJwNvAghAIuitgDKzGG3MZJRRdzwef3zHJxyMMubl/CyzH2HyaX9N Ss4JA2fHklb/Jbu0HfWEm4Oy2oXx9Bs3Q9ea0cw5o86WD3oaRvVLc/X2cWSXHqTR vtE49TvjYku8zGicTgZOoGjG4zsdp7eGimOgMpHYHjdPx9EB7KcbyXV5cqPMz6Wx 0S5qUCf17FK7aafOE+fUZGC9+mjG3tiH41s+4Anc0tCr7/lT5+rtY8+uVnyoTb1x rMfBo4G7JV6WNK5KBk6GkyGeGjHL8B1OQl/Ua4DS+ajjqcormM7nGuoYPZG4VjwJ MOfsWD0J6URcq2pLz67eacc2aohtusmqZUaz9tFbuuWDkYZefc+fnGu0jz271E/x VMaY3jj1u94GW+JlSeOqZOCP5ygkXlfaRifEBGIdN1M3Au1arxnNYKWh8YrX63Vp bHzm0MYYcC27OJbXcFy3pYGBpU8qrjOjOb6bqaXlg5GGkbbeXEv72LMrHjhxn3vj 1O+n06kZF+/Ey0jjqmTQ7G693fidi6EPr3EGmWa+biTh/JyDc/eClYFM5+n7fWms BjT76MnTs6uVSFyfG6J9GUD8McoEikm1pFnf6HqytXww0jDS1pprZh97dkU/qQ3x QNFx9GVs2xovI42rkoFXkN4U+p3/CfOU4S95Pj/03wmWAeZA9vM9yXaW+WalhviP EK9v9MNaa8aO1urZFdH1W3OqXXHjljSoZozhyY4gZsK2fDDSMNLWmmtmH3t2EfTh M3HGHwAxEf26NV5GGlclg9kOn5oTV/QP+CzqJWQ279r17rgPacx37G+Gp+PacTgR +dditg3/0653x31IY75jjSlCugBjqpAuwJgqpAswpgrpAoypQroAY6qQLsCYKqQL MKYK6QKMqUK6AGOqkC7AmCqkCzCmCukCjKlCugBjqpAuwJgqpAswpgrpAoypQroA Y6qQLsCYKqQLMKYK6QKMKcEfg/gQhnpqpEgAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,BoldItalic",
    fontWeight: "bold",
    fontStyle: "italic"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -469.8,
    x: 546.58
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,BoldItalic",
    fontWeight: "bold",
    fontStyle: "italic"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -461.4,
    x: "491.97 496.1604 499.7604 504.5628 508.1628 514.1532 517.15567 523.14608 524.34848 528.5388 532.1388 533.3412 536.934 540.534 544.1268 549.5268 553.1268 556.7196 560.3196 564.51 568.10287 572.9053 575.90768 577.70046 581.3004 584.8932 588.49319 592.09317 597.49319"
  }, "&#x041a;&#x043e;&#x043c;&#x0438;&#x0442;&#x0435;&#x0442; &#x043f;&#x043e; &#x0432;&#x043d;&#x0443;&#x0442;&#x0440;&#x0435;&#x043d;&#x043d;&#x0435;&#x043c;&#x0443; &#x0430;&#x0443;&#x0434;&#x0438;&#x0442;&#x0443;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,BoldItalic",
    fontWeight: "bold",
    fontStyle: "italic"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -452.98,
    x: 546.58
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_64)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,498.6,176.40001)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_66",
    width: 118,
    height: 48,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAHYAAAAwCAYAAADEpo5gAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAzUlEQVR4nO3cMQrEIBQAUW/u0WwEjXgnF4XdFAspQkAyTPGsPwxq 90MIYQgpjJTSKKXo5Xrvq+UKG2Mcx3GM1pogVthZePcges68pH9hc867/wXd9H11 DQtjWCjDQhkWyrBQhoUyLJRhoQwLZVgow0IZFsqwUIaFMiyUYaEMC2VYKMNCGRbK sFCGhTIslGGhDAtlWCjDQhkWyrBQhoUyLJRhoQwLZVgow0IZFsqwUIaFMizUZdhp 99o43XO5wEvv9ws7j93D6Dm11jOseD4mBAk5eJ7BxgAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#8976ac",
    d: "M498.43 392.86H566.462V418.66499H498.43Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_67)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,508.2,167.4)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_69",
    width: 88,
    height: 81,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFgAAABRCAYAAABWmmH8AAAACXBIWXMAAA7EAAAO xAGVKw4bAAAERUlEQVR4nO2a3XLqMAyEefM+Sh+lN/1v34kz25mvs0djQ6EJC2ou dgBFVtZrW45Fdrvdbr9hVcQJdEecQHfECXRHnEB3xAl0R5xAd8QJdEecQHfECXRH nEB3xAl0R5xAd8QJdEecQHfECXRHnEB3xAl0R5xAd8QJdEecQHcsH/T5+Xn/9vb2 haenp3QH01g24OPj4/79/X3/8fHxLfLDw0O6kz0Evr+//xbWbfr8/Pz8El7X9Ino 2MDd3d23f7X7byBffWrV+ABjf3l5+S9e9Zev2tyEwBJtRNjF8RlOB19fX786rO9K Ke6v3/KVD99pz338nhIUgbGLF+3czqCvvMKWC0bnat5FeDoisfRbsxuxZNOnfPCX jZgMCL+ZmQiGjRXiq4NV5XZfOSuKu84MrqSZnZox+k1nERghmZX4s8TBOQK7mCM7 tpsQuM4OOuxLFPFqikA4+ZPLsWtFMPtnAs9ShOJoYD03e+qA080IXDcjiSSbOuFL FcHcV9fZFHnUQyT82aw8bx7a5EhXxKv+vrJuQuANm8CbwM0QJ9AdcQLdESfQHfOL ehTyB33wx4s3ywnsx1SeVS9QHOmG4wKPTk1+cOCQQCVMkA/XeKivFTI/UruNB/9R jENxODFig3f1VaxZbMWoXNQvv+eJx+vzBObE5DfVqU0+iK9TFOJDXN9rAYeqFuKo /SwGgo3icFqrNQl+00b3m8XmGu29LdcuKjCz1m9MZcw7WjsNaff3e89i0HYUB871 Xt6XY7GZNNQpZFdfYwJjr/VWOgConHk9wAs+lfQshotQ4/gsPSTwsdhs5KNBPaMC 9zuBvRRIivDNkM564caXNqnD45IfawwKSbM4DDL2mcDHYntNmpSC3eP8WmA6P6pc 1Rzsm1wVgs76BuSzTf4aHOy63yiGbIfiuMh1E/UVN4vtG6z3naqg7OTtRQQ+hJoi jqGuBAar2i4V54I4r6HXV3+C0QGFJXrKfZeKc/UCb9gEvhbECXRHnEB3nN94Vm27 4g3ntgSeVds2gRcWuJ70mMX67gUVDiL+DhvPsLVC5iXRWuGqf+F7RYyTGUdf3q8Y XfPDiB90TjxIZAQenfQgTkd9BeDvg+NC+NHYXxrhGZj3G4jjLxdSq/Brzo/vDNjC b/usKzBHz/rWpZ/rEWpUdXOBiY+otbCj1eLC4VMFxo6f2vlquymBmUkuMOW/kcAa EMqJo8HB12e1/5X1E4F9ZXlV7sxqWT5FIJjnu5nA3tbTBWLjy6zzArtSyk9ShBd3 KPDU1HEVAs+qbV7OREzPqV6i9I3LZ5UXwH0A64bGDCW+v3DI7GdwqJ/4W571b6BT ayyrCnwIdSb9YawTmJmwCZwn0B1xAt0RJ9AdcQLdESfQHXEC3REn0B1xAt0RJ9Ad cQLdESfQHXEC3REn0B1xAt0RJ9AdcQLdESfQHXEC3REn0B1xAt0RJ9AdcQKt8Q8J mhbM2qqmJwAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -420.3,
    x: 532.83
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -411.88,
    x: "518.63 522.23 525.82998 529.4228 533.02279 536.01797 539.618 543.21798 546.8108"
  }, "&#x0421;&#x043e;&#x0432;&#x0435;&#x0442;&#x043d;&#x0438;&#x043a; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -403.48,
    x: "511.22 515.4176 519.608 522.61038 526.8008 529.81039 533.41036 537.60079 541.2008 543.5984 547.19839 550.79837 554.3839"
  }, "&#x041f;&#x0440;&#x0435;&#x0434;&#x0441;&#x0435;&#x0434;&#x0430;&#x0442;&#x0435;&#x043b;&#x044f; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -395.08,
    x: "516.08 520.2778 524.46829 527.4666 531.05746 534.6555 538.25357 542.44406 546.0421"
  }, "&#x041f;&#x0440;&#x0430;&#x0432;&#x043b;&#x0435;&#x043d;&#x0438;&#x044f;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Italic",
    fontStyle: "italic"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -386.65,
    x: 532.83
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_70)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,197.4,153.00002)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_72",
    width: 118,
    height: 32,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAHYAAAAgCAYAAADHcIz7AAAACXBIWXMAAA7EAAAO xAGVKw4bAAABVElEQVR4nO2bSw6DMAxEfXOOwlHY8Ic7pXLAqjGkC6oqxJ3FkwAz NNKQj+NCRBSAS7aDpmkOgbquwziOYRiGiI3LdWaaplBVFbTP0lLo+z7M8xyRgJwL y7LEB3FsXddTnH8U2udoo7F8wRrLb4IV6TfFxrqug/ZB2qSxoHgodm8YWz7cm9VQ /R7L27bN3jhwDz0f74uo/I0C38OrYjGWj2GsEy6N1flQ7gaCe/DwK4tgHpajsVg8 +YDN3U3djEW64xIY6xSKaY7drgJlwXvI4uEh3eETvcEMygLpjlOSxtpyESgL9u9k 7FXZDpSHVHv2KRWrYqfAWKdg58kLKNs5BGU7pyCPdQrKdk5B2c4xKNv9BzDWKeey HXdn/WmB3keW7i4xmyJBm0cr6U6ybGf/fW57sp6PTd4EbUatvj+Z7nz6rEA+DtIP 1HVcaPNpzX3Z5wLwA154PVUueR2tIAAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeDasharray: "1.5,3",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#3366cc",
    d: "M197.51 425.92H265.542V442.048H197.51Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_73)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,208.8,143.40001)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_75",
    width: 83,
    height: 67,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFMAAABDCAYAAADgZDmbAAAACXBIWXMAAA7EAAAO xAGVKw4bAAADXklEQVR4nO2YW27rMBBDs/MspUvpT9JXsqdc0MAJCCH2TRqjTNh+ ELZljURRM3rMZrPZnP6wGuIEmhAn0IQ4gSbECTQhTqAJcQJNiBNoQpxAE+IEmhAn 0IQ4gSbECTQhTqAJcQJNiBNoQpxAE+IEmhAn0IQ4gSbECTRhucLr6+vp8/Nzeur7 4+PjdDgc0qQfFcsVJN7X19fp5eXldDweJyFV9gDEHxHLFSSkoHd5qLDdbqdveavE pRzv3e120/d+v5++NQn6xqM1GSrTu+ron5erP5W9v7+f2/YJVD/U0VPf19oC/jm8 /UvjWkVMNYyoNCxBnTjv+qf62PDtYuqJmLTvdtR10Bb9qkz9+vN/tg7qYju2f2lc d4mp0EZEiPna6eJSB69hbcUrIYX3vL29ne28HC/CZowOeT02CHetLaA+E+pizo3r bjGZGT1HwuOM0ykhLrEokw0DV1izBiO8bLycSVT52BeTKk6CPOlaW0B9BPNImRvX 3WIiIGskA0Fo9zz3St4JJQ8dX9fwGtognJgIH6x7Hf0yydfajuulr79Eyty4VhHT ZwUPcxK+CUg01hp5iG9CiOaDx4vHAfqmNB7NvF8m51rbS2KyUYnv3LiuFHJZzD/c jDiBJsQJNCFOoAlxAk2IE5igXfPGnfMREScwwW9aTyxqnMAZY0LkCfE9w7msy1jG NW08DHNIFjg4+2Hcy/1wzkGcW43nV6nrt5nR3ieNCOB7hdTi9zzIMzcIQTn3ea5y XC25pnHNRGTuwzwZqGeCyAsg5php8gwP9/5L9rqlecaIW9uNd/D1xJxLFCDmmHFZ Sh74/Z07PN6G4JSTvCBzxIQhrqfK5uzltfBRP2SJmJAfF9ND0VNqXi7v8IwRYnqK jkGP/2hrTLsxSZ5+wxvHhMacPXz8To8XR8LciXr6ywflGRfq+5Lgwrggvv6xdFAu D5Mw4yQRqoTunD1RIVsExl5PkjI/KqaHnAvrnjIu8HOZGMQGbEzunYSjbz4SwDcf skXwWrLnTDu+s1n+qJiXQIiuQOiZsZ6Y7lm/FHECTYgTaEKcQBPiBJoQJ9CEOIEm xAk0IU6gCXECTYgTaEKcQBPiBJoQJ9CEOIEmxAk0IU6gCXECTYgTaEKcQBPiBJoQ J9CEOIEa/AOfKFBcAT75LQAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,BoldItalic",
    fontWeight: "bold",
    fontStyle: "italic"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -444.33,
    x: 231.7
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,BoldItalic",
    fontWeight: "bold",
    fontStyle: "italic"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -435.93,
    x: "211.67 215.8604 219.4604 224.2628 227.86281 233.85321 236.8556 242.84601 244.0484 248.2388 251.8388"
  }, "&#x041a;&#x043e;&#x043c;&#x0438;&#x0442;&#x0435;&#x0442; &#x043f;&#x043e; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,BoldItalic",
    fontWeight: "bold",
    fontStyle: "italic"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -427.53,
    x: "215.15 218.75 222.35 226.5404 230.14041 233.74042 239.75962 243.35962"
  }, "&#x043f;&#x0440;&#x043e;&#x0434;&#x0430;&#x0436;&#x0430;&#x043c;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,BoldItalic",
    fontWeight: "bold",
    fontStyle: "italic"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -419.1,
    x: 231.7
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_76)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,287.4,153.00002)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_78",
    width: 118,
    height: 32,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAHYAAAAgCAYAAADHcIz7AAAACXBIWXMAAA7EAAAO xAGVKw4bAAABVklEQVR4nO2bSw7CMAxEffMepUfppv/2TkFTMHLSIBaA0phZPAFx J6o0JLVjVUQkEJdIaJrmwAb6vg/TNB3s+x7Fuq6LYvhN7bW00rZt2LbtQM1dliWs 6xoxjuNTlMahfRWjtoxW4LYG8B2D+MQkOo5J7D8inRBxjVF7DW3WWOIA7NtqbLqH k3rQ5zEerY8xCfM8R8uc1Iduy8bH8jdFPieTYJW/KfIjY5FNneogUhVqLB6rx5hN nmhuvSBpiqoaljtOobFOwVasR4qsY+tFjxjNseK9uKWpdcNyxylZY3NtO1IXp3In 17Yj9TEMQ9zhYVbsFBrrFLbtfMC2nVPYtnMK61insG3nFLbtnMK23b9AY52Stu2w HetrA4oVIJ3Wceznpm6itqD2bdsu91qBniHb1Z1b5dSW056Sp3QJI/DiwqCr205q T6uoLafVMXPdBZ4H5OvcAM8uSjAd0EV4AAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeDasharray: "1.5,3",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#3366cc",
    d: "M287.09 425.92H355.121V442.048H287.09Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_79)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,299.4,151.80002)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_81",
    width: 80,
    height: 39,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFAAAAAnCAYAAACYNs/UAAAACXBIWXMAAA7EAAAO xAGVKw4bAAACw0lEQVR4nO2ZbW7CMBBEuTlH4Sj84RvuRDVIDz1ZSZW2aRZL+bGK cdb2eDx2vMtms9k8V/uTlQPo3coB9G7lAHq3cgC9WzmA3q0cwEfYfr9/Wcrn8/m5 2+3mJXC73T4vl8vzer2+LOXUVU98Lrvdbu/5pfx4POYlMKuTju/3+2uglLNS1ROf yzK/zCt2Op1+0naaIyuTgaI8E8g7+8cn9QFzPB7fysXYLnmmH9dn+6CGKIHnUD+H w+E9PjsifuAxjpQ9Vvxa/B7vXwj0E8D8HlIsTwinHIAhirb0Sx3+Ubzr89tGO8YC T96N4cjY+CAG8BvHrAQCmEnFAOxJADAKGgPI5OxjhQ9NCGIoo9C0hRAT6EUBa8qo LsqlDb7Ms91NsxGIrLMdAAMwFNWSDIHeLkPkAByVpj8TSz+ZeDtR94mfFQx2fxxY APCnX483K4Fj29Crn3pWlbqANMFMPCBNFPX2t4Jcj8rwbxdizM842AUm0McT/c5K oA/uTB6AVkB7MAcsgFMXhXKgWzX0zweKyfnD4n7sz5ZFmfYzjjGcXlQfI7Nv4dVW AlcCP9TKAfRu5QB6t3IAvVs5gN6tHEDv9ruGjmm5hOYSzGXZl+74cPnlUtvGvMTF 9vUFntCL7At14GnHdZw+pX0JgdzaHScToxJtQAoxqeNXJwf8zmQ67PouA9MmOzzO lPaLE2ggJA2Ib50abwN+MiNuT38owukoJk09SnfayfEs/oRqU9ovTqCz045pSSYA yqvc5uGsCt5HtZA7lIgYS3MxbhbMcfrU9osTSMaXMwoFUk8+kDQW28qKsApRapso 9TgkVK0sCMCPviBpavvFCWTF2aZDh7Y/GCGTbIkVkbb8OQUBHPJkVdpUu8eBjPYP r6G/Gr5rvziBq60ErgR+kJUD6N3KAfRu5QB6t3IAvVs5gN6tHEDvVg6ga/sCoC14 dwPmmN4AAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,BoldItalic",
    fontWeight: "bold",
    fontStyle: "italic"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -435.93,
    x: 302.13
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,BoldItalic",
    fontWeight: "bold",
    fontStyle: "italic"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -435.93,
    x: "303.7 307.89045 312.69285 316.29283 319.89283 323.49284 329.48323 333.08323 336.68324 340.28324"
  }, "&#x0412;&#x044b;&#x043f;&#x043b;&#x0430;&#x0442;&#x043d;&#x043e;&#x0439; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,BoldItalic",
    fontWeight: "bold",
    fontStyle: "italic"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -427.53,
    x: "306.05 309.6428 313.2428 318.0452 321.6452 327.6356 331.22837 336.62837"
  }, "&#x043a;&#x043e;&#x043c;&#x0438;&#x0442;&#x0435;&#x0442; ")), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_82)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,159,213.6)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_84",
    width: 107,
    height: 45,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGsAAAAtCAYAAACpvpV9AAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAsUlEQVR4nO3cOQrDQAAEwf25nqZQx6fWKLENxrHUUEHlA53PGGNM MsZclmUexzG3beNh9n2f67p+Yp3nycOJFSJWiFghYoWIFSJWiFghYoWIFSJWiFgh YoWIFSJWiFghYoWIFSJWiFghYoWIFSJWiFghYoWIFSJWiFghYoWIFSJWiFghYoWI FSJWiFghYoWIFSJWiFghYoW8Y13vMneP4b+rzzvW5bqcufv6hl9fV0DzBcc0awTZ EyH6AAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip_85)"
  }, /*#__PURE__*/React.createElement("image", {
    x: 158,
    y: 213,
    width: 63,
    height: 25,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAD8AAAAZCAYAAACGqvb0AAAACXBIWXMAAA7EAAAO xAGVKw4bAAAB4UlEQVR4nO2Y6U7CUBCFff83cF/ijjHGGBN3jbthU1Q2FVlFK1D2 vce5sSUNkbSXEijSH+cBznw3M1/umCiKYMkoyYhIt5JFKp3FtxyB8pXK4pOS/M7h g5IQcogJeUS/8oh85vFOCSULeP0oIJgoIJAowhcv4jlWxGO0hIdICe5wGc73Mu5C Fdy8VXD1WsHFSxVnwSpOAlUc+Ws4oOz56tj11rHzXMf2Ux1bjw1sUjY8Ddgemli9 b2KZsuRuYtEtYcElYZ4y55QwS5mhTDskTDmASTkT9t+MU8aU8qKqvHoAKdUAOpWP swGw8pQwG0AyjzcawIs8gE7l7aEybmkA1zSASxrAOQ3gNKi//BplRR6AofJ85HOG yLuovMMg+XWzk9d69n+R53n2CnnD5bXIs+JCyhh5D5W/7wF5W3/I61t47eT1Lrx2 8rwLr2fkO9Fvf/Z/0ddaeH4q76XyTzJ9rYV3HKjhkMrv+2r9WXiigVPXKs956tTl uzl1rHxfF56avN5Tp5DXe+oU8iY9db2RHFZ+qCRH6EJy/JySw8ibWHIsvdVFnldy LL01k97ySg4j343kWHo7zHo7MpKT5JQcpremlJxB6m23p25g5C3JGTW9tf7wekB+ aCRn5P/w/qPe/gAq+TygWKrrHQAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#00b050",
    d: "M158.96 357.38H220.37702V381.424H158.96Z"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -383.9,
    x: 189.8
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -375.48,
    x: "170.65 174.2428 177.2452 182.638 186.23799 188.63559 191.63079 195.23079 198.22599 201.82598 205.42598 209.01877"
  }, "&#x0417;&#x0430;&#x043c;&#x0435;&#x0441;&#x0442;&#x0438;&#x0442;&#x0435;&#x043b;&#x044c; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -367.08,
    x: "168.2 172.3976 176.588 179.5904 183.78079 186.79039 190.39038 194.58078 198.18077 200.57837 204.17836 207.77837"
  }, "&#x041f;&#x0440;&#x0435;&#x0434;&#x0441;&#x0435;&#x0434;&#x0430;&#x0442;&#x0435;&#x043b;&#x044f;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -358.68,
    x: "173.05 177.24773 181.43822 184.4366 188.02742 191.62548 195.22353 199.41402 203.01207"
  }, "&#x041f;&#x0440;&#x0430;&#x0432;&#x043b;&#x0435;&#x043d;&#x0438;&#x044f;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -350.25,
    x: 189.8
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_86)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,45.6,213.6)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_88",
    width: 146,
    height: 45,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAJIAAAAtCAYAAABF5zIuAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAxElEQVR4nO3csW2EUBRFQTqnFEohAgQU9S2828DaR7IsTTAvfsGJ 7zRN04DANPZ9H+d5wse2bXuFtCzLuO97XNcFP7Ku65ie89eP8L8JiYSQSAiJhJBI CImEkEgIiYSQSAiJhJBICImEkEgIiYSQSAiJhJBICImEkEgIiYSQSAiJhJBICImE kEgIiYSQSAiJhJBICImEkEgIiYSQSAiJhJBICImEkEgIiYSQSAiJxHdIz2q7wXZ+ Y57nV0iP4zjgY++IxhfyWdpuAxXFDQAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip_89)"
  }, /*#__PURE__*/React.createElement("image", {
    x: 45,
    y: 213,
    width: 86,
    height: 25,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFYAAAAZCAYAAACrWNlOAAAACXBIWXMAAA7EAAAO xAGVKw4bAAABsUlEQVR4nO3Y504CQRiFYe//Duy99x67xm5EUYpIL7Is4tIRZNHj 7M6nohgl6g/R78d7A09OZjLTlE6n8VTqqZQsWZWWykBLZnBDJahrTRbXslBvsohR SiKLqOjqOoeIKBzPISQKqjkE1Dx8sTy8Io+Sh1spwBUt4OKqAIfIHrnFefgWZ6LT UBEnwSKOA0UcBUo48JewL9r1lbDjvcOW5w6bonV3GWuXZayIll1lLF7oWBDNOXXM OnRMOyqYslcwIRq3VTBqdH6PYdHQ2T0GqD7rg1nPqazL6OQBnaIOUbtF1maBWSvV cvxSs6ipHtQkodbAPqNmTFT1LWoiZ8KGCTZIsH6CNVCNLqMS1kmwNoK1ClQD1kKw hwS755Ow2wS74ZawqwS75NJN2HmnhJ0h2EmCHSPYEYIdJNR+q4TtJdRugu2sgX2N +iEsL7bBFhuhxYZosQaqsVgvL5Zg31tsFWz1Yg1YhY+C+o6CL6/2vx8FvFi+vHix vFheLC+WF8uL5cXyYhtxsd99HPBiebGNtdjPPmF4sXx5/SwsfxvyYv8SLF9e/EDg xfJiebG82N+z2EdC8Fe8pTMEXgAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#cad318",
    d: "M45.435 357.38H130.474V381.572H45.435Z"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -379.75,
    x: 88.025
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -371.35,
    x: "46.475 50.0678 53.070199 58.462999 62.063 64.4606 67.4558 71.0558 74.051 77.651 81.251 84.8438 86.0462 90.84141 94.44141 98.041408 102.231807 105.2414 108.2438 112.4342 116.034198 119.029399 122.03179 126.22219 129.22458"
  }, "&#x0417;&#x0430;&#x043c;&#x0435;&#x0441;&#x0442;&#x0438;&#x0442;&#x0435;&#x043b;&#x044c; &#x041f;&#x0440;&#x0435;&#x0434;&#x0441;&#x0435;&#x0434;&#x0430;&#x0442;&#x0435;&#x043b;&#x044f; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -362.95,
    x: "50.375 54.572725 58.763227 61.7616 65.352428 68.95047 72.54852 76.73902 80.33707 83.93512 85.13447 89.32497 92.92301 94.71481 98.91254 103.103038 106.70108 110.29191 113.88995 116.91 120.47916"
  }, "&#x041f;&#x0440;&#x0430;&#x0432;&#x043b;&#x0435;&#x043d;&#x0438;&#x044f; &#x043f;&#x043e; &#x0444;&#x0438;&#x043d;&#x0430;&#x043d;&#x0441;&#x0430;&#x043c;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -354.53,
    x: 88.025
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_90)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,25.8,252.00002)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_92",
    width: 92,
    height: 37,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFwAAAAlCAYAAADPwo5RAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAArElEQVR4nO3bSwrEIBBF0dq5S3EpTgTxs6dqKk1DZwEm4eUObhBH 4VA4UjMzp0szr7V67502ttb6gsdijEGbm3N6ztmttXbavHsS1PpHL6WcwWP9gDNO qjiuAQdcN8AB1w5wwLUDHHDtAAdcO8AB1w5wwLUDHHDtAAdcO8AB1w5wwLUDHHDt AAdcO8AB1w7wJ4HT3g7w+Nz9I28o7t6nlGLq7ZCPSad9/Z6cfAB473oYQYuJqAAA AABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#cad318",
    d: "M25.512 323.61H78.236V343.167H25.512Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_93)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,33.6,243.60002)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_95",
    width: 66,
    height: 67,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAEIAAABDCAYAAAAoCNNNAAAACXBIWXMAAA7EAAAO xAGVKw4bAAADCklEQVR4nO2ZW24iMRRE2TlLYSn88IY9MapIB9V4mtADgSqN5qMU t9uxj8vXjm9nsVgsrv/1pThAi+IALYoDtCgO0KI4QIviAC2KA7QoDtCiOECL4gAt igO0KA7QojhAi+IALYoDtCgO0KI4QIviAC2KA7QoDtCiOMDL2mw21/1+/1U+HA7X 9Xr9XiM0wOl0uul8PsdNkI7H441Hulwu7zVCrmtAua7yHOfVZrVa/VH35Kp9O85c ph8zgjBE2+32t0hRqApIqzNGD31oFVnB5XJ5q2civB/rEX36e/VD3xEjgAZQRigK gFcEqd77UHm3232V1faRETJbZaJrygiMrzNCBvBuNMIjxSNifEc9fegnZ5W/1089 a7yIEZqEBqYOIzBA0HqeiggmpMNtXHm2ja847elvNEr9YMbHjfAJuxGKBqBY4bEP n8CjreFnylREMPmPGMFe9oNLE/Y/VypLRIrKnOhEEBOnLdGhOr3XsyJDZwjbhvZu FCyMx7mj332rEf+44gAtigO0KA7QojhAi+Y31l8NP/EL4D9vBFfYF29vzZrXkIvR lEH3jJtr8E9E13ccM1keD6Itwe0QQwRPmYHIB7j58ZFkTIq4ffqz+nLg8R2J25jN 0g9Riqlj3qLff9kIJsNtjkGZHDc+JshEaEck+bXYs9Pxd3n2REp1pPs8qw+/UrtB tKONNH4X+WsjNFESIlbBV16DsDIM5l+zPCHzPIXkzKNE9aTnYxJ1zzCXm8JYzvuS EbrHC4jwApC8wUHcPCLCVwk43z68Y4IeRXOMmDpjPDpgfNkIgIByOJIrB2LLaJLs bQ93b+N7XhNk9aayydEITGPLjsY679RB/5QRhJgGVOh6PSk3GaBnhESN6sYvzGSV Ep/3VPbs0bNJMlHvQ3V8Q/X+MVNjqx62HzHinsZt0aCpL2lvNYJvFG03zSf+v5GH LlEcoEVxgBbFAVoUB2hRHKBFcYAWxQFaFAdoURygRXGAFsUBWhQHaFEcoEVxgBbF AVoUB2hRHKBFcYAWxQFaFAeo0C+JcNA/0OIHVAAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -343.65,
    x: 51.9
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -335.23,
    x: "38.75 41.7524 45.3524 48.9452 52.538003 56.138 60.9404"
  }, "&#x0413;&#x043b;&#x0430;&#x0432;&#x043d;&#x044b;&#x0439;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -326.83,
    x: 36.175
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -326.83,
    x: "37.75 41.35 44.9428 47.945199 50.342798 53.935598 57.5356 60.530797 64.1308"
  }, "&#x0431;&#x0443;&#x0445;&#x0433;&#x0430;&#x043b;&#x0442;&#x0435;&#x0440;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -318.43,
    x: 51.9
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_96)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,26.4,279.6)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_98",
    width: 89,
    height: 51,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFkAAAAzCAYAAAD8ZKSTAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAwUlEQVR4nO3cMQ6DMBBFQd+co9EgwMCdHJGEIk2qWChfU7zG5dja bl1KKU3dK21d11Zr1Y+bpumFPM9z27ZNnTqOo5VT+zrY9/3220/odLxMl2X5RB7H 8e7ZFdEJCxny/wcZckaQIWcEGXJGkCFnBBlyRpAhZwQZckaQIWcEGXJGkCFnBBly RpAhZwQZckaQIWcEGXJGkCFnBBlyRpAhZwQZckaQIWf0Fdludafdar8E9O05HYZh 8II79h4h98+w9B6mQbE2pnkLfgAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#cad318",
    d: "M26.079 288.01H77.103V315.549H26.079Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_99)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,24.6,271.2)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_101",
    width: 95,
    height: 81,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAF8AAABRCAYAAAC0RnqFAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAFNUlEQVR4nO2aW27rQAxDs/MupUvpT9/tnnrBAOeCETRjO3GrtMoH kcSWNRTnEQ/tw+Fw+LqhDOUEOqOcQGeUE+iMcgKdUU6gM8oJdEY5gc4oJ9AZ5QQ6 o5xAZ5QT6IxyAp1RTqAzygl0RjmBzign0BnlBDqjnEBnlBPojHICnXFZgpeXlxM8 PDxUF/SbcP7Fn5+fX+/v7ydQB1xBUb8Fl4vPaI/i67x+Pz4+ft3d3R2PKdZnimLu 7++P55+eno7H3t7eTuKfn59PZpbisxmX5RBeX1+POeDF+ViLc1U+j9F5uO44288X X0VJcBGK4qvYj4+PYwE6ru8UznF9co0K0zGOe7zPLB1Xbo/VpwTIcsBDEE/FkQvR Mq60S636ro6hU2LbPy4+jTtBxPdlyGeIF4UQcbZQnHcWs8PbjO1nOSQYXPSd4/qt WTLiSm5GN9ePav9x8SGdie8jAzBlM/ElBCM0ih/b0IzLBMhy+ExzUQXyZFzjsasS H0IqwEeHSDFC9dvX7iimi08+BI4jX0sD8RqdmQBZDl/a6BjliTMoch0tO+Xi+7qZ QSSzO6E14oMovp+jI0fiew4f4R5PxxwO47u2qxY/+6OJJFXY2j8kxcVYRODP8pwc a7GF607YV3yNCBf/UsQR+MdQTqAzygl0RjmBzign0BnrAtkgxd3hDd8svjYffu+s +2b8nBu+WXzd/+oWEuePW0x1At/VQbh++mRmYHi5G8jmhHyxM935HDmJ7HLdUCMH 7Xsez632BDh7Luojzs8LWR2j2F3Ed5cQC8HdPQrm3h+3k2089/7MHJYt3EPPQ6d6 ex7DzhK7Qb+JxyLAQIOrPhXPIPKdOLy8To/z6xUT64BDFruL+O6JqOdZeiDiIjML 3ALWeS/S4eRjZ0fXcxSHD0+s81KcL5lwhCex7oQSh9fj9kisYxa728gfNegjBQ+F 0TsjzWj2keidjU8+Ez86mFyTCeRteW1uOXuHZ9dndcxidxUf7yM6ghTFSKMzOK7f kbTPFO9cTVmm7pL47vUzi1wgHn4wMIhnTY8d5TPJ47zebBCNYncRXyPcHUN/zIf3 Eh+qICyCZaMxcz0915L4vmR5m7TFOeVj4Hh7cVDwv8X/UZwRmfgZhw3m3Op/5v9r fjwWxV+LzEU8x1XkLoXfCMSz2DXtjvJe4sjuKn4Gn3aX5toLoz/3K0Q5gc4oJ9AZ 5QQ6o5xAZ5QT6IxyAp0xPhnfaXRX0zdC/q6kbvPcdeQagNuJA+ixjug2zmJijnit m3+jNv3tNN+pZxy8Tt9wLtW0SXx3J/Fx/AUpOohdKJaBu3vuqbD1Zsfsnksky67Y X8Dy87Mc/voK/GbxbBSd/4wDO2F3WdfUtEl8ts4qAM9FCbFw1SDF0VF4KL7d9w6K AmomZOcofGSIzXIgjL9wNYtHfJzNKH7GQbFo4txnNW0SHwI+KnSMRt3TcMF9BGTi u1fknv2o3eiqLuVwD4rvs3gGE8uPiz/i4M841BFratosvr+1G9dVnkK5ccZ0d18l is9vN7tG4scHHmCWI1t2RvHxeUImfuTAMqzvdMCamjaL7z2a+TdeXHQq+XON4rv1 Ssdm4vN8IBN/liMTfxTvozcTP+PgyxNP6dbUtFn8SGgJPONcMtrWvnu5Z44sPnNq 18Dv8i6oabkRHwE37IpyAp1RTqAzygl0RjmBzign0BnlBDqjnEBnlBPojHICnVFO oDPKCXRGOYHOKCfQGeUEOqOcQGeUE+iMcgKdUU6gM8oJdEY5gc4oJ9AZ5QTa4h/W rVaIiBCqtwAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -316.2,
    x: 51.625
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -307.8,
    x: "31.4 36.1974 39.79545 43.393499 46.98432 50.58237 53.57352 56.571897 61.961748 64.96012 69.15062 71.54932"
  }, "&#x0414;&#x0435;&#x043f;&#x0430;&#x0440;&#x0442;&#x0430;&#x043c;&#x0435;&#x043d;&#x0442; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -299.38,
    x: "28.475 32.075 35.6678 38.670206 41.067804 44.660604 48.260606 51.255804 54.855806 58.455808 61.46541 64.453418 68.64382 71.04142 74.641429"
  }, "&#x0431;&#x0443;&#x0445;&#x0433;&#x0430;&#x043b;&#x0442;&#x0435;&#x0440;&#x0441;&#x043a;&#x043e;&#x0433;&#x043e; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -290.98,
    x: "27.475 31.0678 34.0702 37.670206 40.6654 43.6678 45.4606 49.651 50.8534 54.4462 58.0462 61.639 65.239 69.4294 72.4318"
  }, "&#x0443;&#x0447;&#x0435;&#x0442;&#x0430; &#x0438; &#x0430;&#x043d;&#x0430;&#x043b;&#x0438;&#x0437;&#x0430;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -282.58,
    x: 51.625
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_102)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.59999999,88.8,252.00002)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_104",
    width: 98,
    height: 38,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGIAAAAmCAYAAAA/bE50AAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAs0lEQVR4nO3bOwoDIQAAUW/uUTyNiJ87GQwkW4Qk3TrgFK+xEsZP oyGEMIUQZs551lpna003G2NcIXZP5mRrA3yE6L3PUopu8DcE4Kw8wusqMIQhZAgQ Q0AYAsIQEIaAMASEISAMAWEICENAGALCEBCGgDAEhCEgDAFhCAhDQBgCwhAQhoAw BIQhIAwBYQgIQ0AYAuJniDW4+7n6Kdai/xpCkI8q2uMdIqW0faueKsb4DPEAxWhU JN/lHO0AAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#cad318",
    d: "M88.735 323.05H144.648V343.32099H88.735Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_105)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,90.6,244.20003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_107",
    width: 95,
    height: 67,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAF8AAABDCAYAAAD6WNkVAAAACXBIWXMAAA7EAAAO xAGVKw4bAAADnUlEQVR4nO2ZW24qQQxE2TlLyVL4SYA89sRVIZ2oZHnIg1GKi/ko JUy32zXVtps2m81mc3oghjiByYgTmIw4gcmIE5iMOIHJiBOYjDiByYgTmIw4gcmI E5iMOIHJiBOYjDiByYgTmIw4gcmIE5iMOIHJiBOYjDiByYgT+G/x9PR0OhwOn//v drt1xf/4+Di9vr6e8f7+ftrv9/GXvhVIm7e3t9Pz8/P5r/RZTXztpBYUtMPaADmR 0/SL3wpeXl7OmkibX+iyPMii2+32/Fl/eabPZIRDz5WC2jA2i3RkDmsoYoggH5M9 83khZRzr1zHs5Ue2x+Pxcz0y1edrHvMvjXWCEoTys8RhFfEpNf6MTPBxEZJogm+a nmuc5y68b4zmKYIklObzQu6f1K7cCAjBeWgtSgFCshbzXPxurHt/ePh45bCK+C70 JfGrOES9lyoXnwijhBFFbBYv8B3xWZMXd3tqsjbWs5OAqBlZx3xtorwTv3JYrexU 8WvZ6cTRX6W+iAhdhLn4ng1swnfEhx9RviQ+JYGxTvxurIvsKn7HYbWy06X0V+Jg J0KaW8uIRxmboM3SvC7y3bfmuQ/5ZY3KcY2y4xkpdOJXDquIj6gelX6gLB2IEMFG ae/pXQ9cygLi8rwe5n6u+AHvh2T1/dWhemms+taceuB2HFYTf010B9hPUEvPHeBv xb/mjqCoouzcCeIEJiNOYDLiBCYjTmAy4gQmI05gMn5nyGUDcDGqY37Vr5emS5ei ernTV8x68cFvZ48//2rK7dovQpVr18bQBdIvVd2F80/F91ZA1xIQYVq76o34PG6M dDO5OSIOonhLwW+Y9F9oXXT2WpeWAJvsfpe4evNPoH3Ar1buOyZ+bSHzQrXD6G3j 2tH0rKjtZzbJI5DbsYu8ZM+GeVZ4f2aJa+0/IX7NnljZUSQ7iS6a6GgKRH4nvvdN POp8Puviz30v2cNDwiGsdzmXuNZnNyW+t1e940cNpBwp7TVGzV0Sn85j/UHGP7t4 VYAle2xULpgj7n4OdFzrpt+U+AjnqelRxgv6QSk7P8hqF9IPvFp2vBZ7mandxGrv vlkDWzax47p04Ha+Y+LXw6ZGyLWoEXin+JkBpz4/cgO+Cq5F7A7bx9eL/8BD/HtB nMBkxAlMRpzAZMQJTEacwGTECUxGnMBkxAlMRpzAZMQJTEacwGTECUxGnMBkxAlM RpzAZMQJTEacwGTECUxGnMBkxAmMxT/l+p374syWCwAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -343.42,
    x: 116.77
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -335.03,
    x: "93.1 97.902408 101.50241 105.10241 108.70241 112.29521 116.48561 120.08561 123.685619 127.87602 131.47602 136.27841 140.46881"
  }, "&#x041e;&#x043f;&#x0435;&#x0440;&#x0430;&#x0446;&#x0438;&#x043e;&#x043d;&#x043d;&#x044b;&#x0439; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -326.63,
    x: "96.875 101.07995 104.678 108.27605 111.866878 115.46492 117.86362 121.454448 126.8443 129.84267 134.03316"
  }, "&#x0434;&#x0435;&#x043f;&#x0430;&#x0440;&#x0442;&#x0430;&#x043c;&#x0435;&#x043d;&#x0442;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -318.2,
    x: 116.77
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_108)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,89.4,318.00004)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_110",
    width: 101,
    height: 64,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGUAAABACAYAAAADHblKAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAA70lEQVR4nO3cuW3EQBQFQeafBEOhR4JHThQILXRAWHsaUBnljNv/ uTNN03Q/lmW5t21joHme71eP6T6Og4DzPO91XUWpeRbzK8pTavSE/6u3UV4PDCBK kChBogSJEiRKkChBogSJEiRKkChBogSJEiRKkChBogSJEiRKkChBogSJEiRKkChB ogSJEiRKkChBogSJEiRKkChBogSJEiRKkChBogSJEiRKkChBogSJEiRKkChBogSJ EiRKkChBogSJEiRKkChBogSJEiRKkChBogS9jfLY950B/kR5fu7+GYZxruv6jDL6 Svhey1cUWj4A072q2Y9+lKMAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#cad318",
    d: "M89.256 241.78H147.483V277.448H89.256Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_111)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,94.8,313.2)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_113",
    width: 85,
    height: 69,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFUAAABFCAYAAAA7I6rBAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAElUlEQVR4nO2bUW7CMBBEuXmP0qP0h0KB3olqkF41Wq0hhcCGpR+j JPbaHo83xmuH1Wq1Ov5jdpQT6IhyAh1RTqAjygl0RDmBjign0BHlBDqinEBHlBPo iHICHVFOoCPKCXREOYGOKCfQEeUEOqKcQEeUE+iI6cZfX1/Ht7e33+fdbnd8f3+v 7sASMd1YIkpY3X98fBwPh0M1+aViurGE3O/3J2+VuALibrfb0/NmszmlfX9/n541 EHpWeaXJVum698HxAfv8/Dw9K135ak/P2OhZ6ev1+reO7F6c1E5W3vsU+UcnUp/p w+yi0hDi6NUXGUF56oygZxFBSO4RSPekeXmmEwaCPNrEnjYol93jAAxYLE9/Mv4M rJeB711EdbIjUp4me3WKe428k0Q01cdboKsPmIA4gjpMHZSNoipdXMiL5S+J6ukM +N1EFXgtz4mKaHqdeK3dY7JBUb7s6QB5Ku9CjLzTvQoeTDex/CVRfTq6q6fipT5q PodJEAFPAQyA8uikTwl4qdLd61QvUwaeJjsNzLk51X9MmVNj+XP8dU8Z3sq7zqlT EF+dF8T8lfIjs4DO9RH1H/UEOqKcQEeUE+iIcgIdMc5k0cs6jXWq4Itp1pa+SGZv QHke58fyRFi+Fox27DUojzWqR2rOwRfpBA4eu3s+9+fSRn2+WlTCRXVKV+J9FsZs +41IsXCnnqw8wmjR7dFWtEN0xPPojDK6RqHZfCH/nIDU62mjPl8lavSEkWdMGX0X Iqb59ZwHejTn+wSRm+8zeLzvomZpHgVGO+cyMbLKMxgZXfFU78hUT3XbrLyL4GUz u7hN53sKtBVFyN6+jKvKsUUYPRUNbvZUCHr8rhiZ+NnnlxFRyNL5rLx7H3F3tHNP ZE6lk9j6nI6YyqP+S28VU0kUla3L2ebUW/DHXZ2rwdQQneERbT9cVLzzEaLGV/IP HvVcor44ygl0RDmBjign0BHlBDpi3goJS4mSSPf1nh/0EW5m+YLXxZlTZqd8Ii3O nDLbWN9TiOqREetFYnffQ5iS7zYeWo7s1DaR26U241H1okUVUQ8fdY1eiwCX8vEs xOQcP7PzBT8RVGbr9T2Np3rMHzc3dE94OSU/DoyHoNHOd9R8R2vUZtzgWayodNzj cI/Zied9TqVslo+Ne9bIzneVeK1HbT6Vp2a7Qo+KwxcQ799HVN80Bo+Kw/2jswWg nEBHlBPoiHICHVFOoCPKCXTEbRXo15342teK/gEvh3Qx5IzH2LqqjH7Jidv9uwEv S3qsCxvuOdOK0Zd/tAy3GVcQ1xf2E1Ldc6wRQ0ZEkS1/tNCzRz10jHg9hqocCpJO yJnV5WVZ5PvhpR+v097M39ReX9j/JOGIorpX4IUuIrZ8ZY2QpPufH9xTGbBYl+f7 PoMGBu9HQL1p7G4tQlTfkcJbM1F9283LuHex/RfP+RE7eirpWV0jT41fuWDLJ/WL EBUvyuY0F9W9Rml4Fp7m23T8mcG/Ycrq8/9eeV1RVJ9TES1+O8CgLGJOnQLv4Avh vg1o9F/w/6vlBDqinEBHlBPoiHICHVFOoCPKCbTDDyfdvs+TL6pjAAAAAElFTkSu QmCC"
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -275.5,
    x: 118.45
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -268.27,
    x: 98.6
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -268.27,
    x: "99.95 102.974 105.998 109.616008 112.634 115.05801 118.082 121.1 124.717998 127.742 130.76 131.95999 135.578 138.602"
  }, "&#x0423;&#x043f;&#x0440;&#x0430;&#x0432;&#x043b;&#x0435;&#x043d;&#x0438;&#x0435; &#x043f;&#x043e; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -261.08,
    x: "97.225 99.625 103.219 106.219 109.219 112.219 115.213008 118.213008 122.407009 126.00101 128.98902 132.00102 135.00102 139.79503"
  }, "&#x0441;&#x043e;&#x043f;&#x0440;&#x043e;&#x0432;&#x043e;&#x0436;&#x0434;&#x0435;&#x043d;&#x0438;&#x044e; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -253.88,
    x: "104.95 108.544 111.544 113.343997 116.937999 119.338 122.932 125.932 128.93199 131.92598"
  }, "&#x0434;&#x043e;&#x0433;&#x043e;&#x0432;&#x043e;&#x0440;&#x043e;&#x0432; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6.025,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -246.68,
    x: 102.6
  }, "&#x0441;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6.025,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -246.68,
    x: "105.12 107.511928 110.512378 113.506809 115.904758 119.501689 121.89964 124.89407 127.89452 131.49146"
  }, "&#x0442;&#x0440;&#x0430;&#x0445;&#x043e;&#x0432;&#x0430;&#x043d;&#x0438;&#x044f;")), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_114)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,89.4,277.2)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_116",
    width: 101,
    height: 65,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGUAAABBCAYAAADIQWrvAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAA8UlEQVR4nO3dMWqAQABFQW/u0WxEUQ+1QVOEFIE0wQeZYpqtFh67 7Z+maRrkTGNZlrHvOy9b1/Uzyh3kuq5xnicBx3GM6S709kX4cvf4FuU5eP8//ZdE CRIlSJQgUYJECRIlSJQgUYJECRIlSJQgUYJECRIlSJQgUYJECRIlSJQgUYJECRIl SJQgUYJECRIlSJQgUYJECRIlSJQgUYJECRIlSJQgUYJECRIlSJQgUYJECRIlSJQg UYJECRIlSJQgUYJECRIlSJQgUYJECRIlSJQgUYJECfoxCu97ohggaHkGCO6ns23b r+ck+Dt3kHmexwdNudNfAx3Q4QAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#cad318",
    d: "M89.15 281.58H147.483V317.83299H89.15Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_117)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,90,269.40003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_119",
    width: 102,
    height: 94,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGYAAABeCAYAAADR9mGiAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAGFUlEQVR4nO2cXVLjQAyEuTlH4Sh54R/uxFan+KhelcYsS4KsoIeu OGONRqP2OJasydXV1dXbYJcoN2AwxLRCuQGDIaYVyg0YDDGtUG7AYIhphXIDBkNM K5QbMBhiWqHcgMEQ0wrlBgyGmFYoN2BQQczhcHi7vr7++P76+vp2c3NTPekOOO8A T09Pb4+Pjx/fX15ejmTtYOJ7x3kHEAnPz8/HVcOxVowIA6wivotIyFO/h4eHY/vt 7e2xTbLS46RLXnJAbff390c5yUiP+iGvY43LMbqlh/bY/6KIEXCgIKdp8lo5Oocj IU1O4RhHQZL08J3+6JRjgb5Lj+TpR1/66Zjz3g7hWf+LI4aJZ45wYmjDQU6sOxdZ yeiT1aZ2iNGn2lhtEI6ezB6RzPms/8URIzDxLWIgg1uVjuUQnMLvU1wxOFq3m2zF xAtktWIYM66YIpx/tXAVcp/eIoZVcHd395cszndiuJq5siUPMRor/mZtEcNvH8Rk /S+KmK8Q6LeyQb0BH8QU3Mf3jHIDBkNMK5QbMBhiWqHcgMFXiNFTkp7f9Xzvz/AE Xh5NS44YgIhZx8Qn6OOpK7Z7LOOyiiWwQXmrmGMjhaNPYpfVuASdURY9ng8jxvEU UfRFNofV2OTl0PdtYmJQxkQ89SGHeXrD80rkrojkPQgkaeg5rihLVC+HaRxsINDk IoAwMguZrkwW/dgd+/tY0RfZHFZje0rHU03/RYwUS6mnKpgA2ViPvIm+ZUA0nsSg E0ObPp0Yl129InBicAjyq3EzWdcfnU5fcnHRF9kcVmPTV5/fJsbTEJ668NUAMQzI UvcJkiNDfmvFRFkyx1vEcJVzu1qNm8n6HNWWrRifl/tia8XEsUn5aOWfhBjuvZ4S 96sEaFLKbWE0E+HKcSK3iImy3Jdj2t2J8Swzt4tMVybL6uaWhvP9iuc2FH2xRUwc 24n9NjEZYi7LnV0Bd8gpZXeCfxeOTxT8IFYZrwcCfyg4lexOUG7AYIhphXIDBkNM K5QbMNgDMZ7v8kdtf7d/eK/eRE4xUjyvPgRsxBrUrkU56sliNiEbM+r7NcR49iBW qciBHMdiiXg+0+UplCgXCzk+G7OoZKmOmJg41KdWhK8eIuWt8zicSJ4IfiXnmQO1 r8Z0fZUx2o8T47cYfz1Ankq3j3j1Zuejw3kdsZLjmNvVZ2N6PdvFE+MVkBx7Opxz /KbEq9zP43BPrZOXyuTI73kNdDZm1PdriPHv8V3PuRBJboKfGywmEb3ifogpJGYw xFwCyg0YDDGtUG7A4CeI4T06KQ3fF3l4r89SzBDLmbze62B1WtR18WQV96rE3WaZ Pn8i86dAP6b6h7Fd35Z8G2KIoHEok+A8QR51V/rklS9FE8iJQHaKodf7IYfTGCfq i+VXbgttnj9jZ1p8vM/kWxAjZ2UBY+YMJ5EV5auIKDzLArhTvGqHtqjPK17iPk+v xPHV4rViW/ItiFnVTUVifEudR/9edUOdF/VYWTWoEw15fnF4+dDKFnTx6ZWbGTFR vgUxTDxewZkzyFN5m1dzeo0aCUXPd7k+nE9SMurbIoYLwYmB1IyYKN+GmM/whYK3 344hZqcoN2AwxLRCuQGDIaYVyg0YnIoYj9b9/8FIoXjZEVvsfJ9mlKPNo20qXnyD UdRFjRoZAvXz+CL+7xj7Ib0GwP+/LOryjIP/w5OfZwzsOuGr8q93itvq4t9axeCO ADHuOPPkI1G7b5WI2/MyXRTm8R39kIhuyfjmWA9u6Rd1uRx6vc0LEj3w3BUxpE/8 3/hcDidkcmxUjeOs9liii5UVk4pkuCHDI3gnhgwBFZdRl+8xpdbM91OSjfBUzgnj tNMQo6smFla4oVy5mdyq6jFbMa7L+8XSWlaX+iNDP7ef1xCZrtWKIZ3kOTNW/O5W DInGeMWxT1Ntuk1lckwaZ28R47qww3Nz/i6FhClVmqv/O+O9UaZrRQzvjejvpJYR 8z8E7klXE5xPuT+17ElXE5QbMBhiWqHcgMEQ0wrlBgyGmFYoN2AwxLRCuQGDIaYV yg0YDDGtUG7AYIhphXIDBkNMK5QbMBhiWqHcgEGCP6O10CEOS/owAAAAAElFTkSu QmCC"
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -319.23,
    x: 118.4
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -312.03,
    x: "103.05 106.05 109.05 112.644008 115.63801 118.03801 121.03801 124.02601 127.63201 130.632 133.62001"
  }, "&#x0423;&#x043f;&#x0440;&#x0430;&#x0432;&#x043b;&#x0435;&#x043d;&#x0438;&#x0435; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -304.8,
    x: "92.075 95.092998 98.117 102.335 105.953 108.977008 112.00101 115.01901 116.81901 120.43701 123.46101 126.485019 130.10301 132.52701 135.545 139.16301 142.18701 145.205"
  }, "&#x0430;&#x0434;&#x043c;&#x0438;&#x043d;&#x0438;&#x0441;&#x0442;&#x0440;&#x0438;&#x0440;&#x043e;&#x0432;&#x0430;&#x043d;&#x0438;&#x044f; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -297.6,
    x: "104.9 108.494 111.494 113.29401 116.88801 119.28801 122.88201 125.88201 128.882 131.87599"
  }, "&#x0434;&#x043e;&#x0433;&#x043e;&#x0432;&#x043e;&#x0440;&#x043e;&#x0432; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -290.4,
    x: "100.25 102.65 105.044 108.044 111.038 113.438 117.032009 120.02601 122.42601 126.02001 129.02 132.01399 133.21399 136.21399"
  }, "&#x0441;&#x0442;&#x0440;&#x0430;&#x0445;&#x043e;&#x0432;&#x0430;&#x043d;&#x0438;&#x044f; &#x0438; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6.025,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -283.2,
    x: "96.425 99.42545 102.4259 105.42635 108.4268 111.42123 113.81315 116.8136 119.80803 122.20598 125.20643 128.20085 131.19527 134.19571 137.19615"
  }, "&#x043f;&#x0435;&#x0440;&#x0435;&#x0441;&#x0442;&#x0440;&#x0430;&#x0445;&#x043e;&#x0432;&#x0430;&#x043d;&#x0438;&#x044f;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -275.98,
    x: 118.4
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_120)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,88.8,357.00004)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_122",
    width: 102,
    height: 49,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGYAAAAxCAYAAAAoVNwtAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAyUlEQVR4nO3cPQrFIBAA4b3/paxE/LmTQR6+NEntQKb4EKwWBi03 ImIKKWbOefbeZ2tNh60OpZRfmFrr8YF0ewyzLnXGa5h1Av7WzzIMlGGgDANlGCjD QBkGyjBQhoEyDJRhoAwDZRgow0AZBsowUIaBMgyUYaAMA2UYKMNAGQbKMFCGgTIM lGGgDANlGCjDQBkGyjBQhoEyDJRhoAwDZRgow0AZBsowUIaBeg2z95gIthlDDP8w Y4zjw+i2esT+31JKx5+yyo4yL0UAMoV9pA93AAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#cad318",
    d: "M88.851 211.54H147.483V238.42H88.851Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_123)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,88.8,354.60005)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_125",
    width: 105,
    height: 58,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGkAAAA6CAYAAACzmHdjAAAACXBIWXMAAA7EAAAO xAGVKw4bAAADFElEQVR4nO2ZXZLiMAyEuTlH4Si88A93Yqup+qoarQOZZWYNnn7o iqPIdkttm0QsFovFNXh7dCcQRKQh0J1AEJGGQHcCQUQaAt0JBBFpCHQnEESkIdCd QBCRhkB3AkFEGgLdCQQRaQh0JxBEpCHwt3G5XF7P5/Pd/el06k30N6P94Hg8Xi+X y62tq+4fDbRer5s2CfzM9r/xFa4/Nf8XczA9ELtJu0j3Ekvt/X5/e6arIAEPh8Pt GcJut9ubTX4IrGfcszPlo3vZfQ7sCkZzbDabm7+utN0On1Z/YprLFZ6yqQ+Llrzg 4/NgJxbZWdzES3w1B/8sEsTAVFIEESJYggIEQ38CZ0wWAiLpuebARzbaXKtIAnxa /V2kOVxdHCC7BEeMqXmIo7aZr5WDl0RiN7HipkTCttvt7pLArnOR6EfQLpavRsZG JB/LRcLfE1b7u0hzuFZxfcdX1HlcGB/Hxak5eOm4UyD+AjElksisVqu7I4SgNY6L JPBi4ivWdxJjcHY/Ou44RhCp1b8ed8+4cpzJr+4o30mteVwkjl/satcczPzde7yL 6krkXhP6UURwtT/HAjZIavX6bwZJ0T2rVjZEYl5dPQluJ/jav4r0jKv6+O+v50Uc 8WnNQxxq46NxFG/NgTbBy8fdHPgqf3d8EtdvFclX9rvjk7h+q0hBRAoi0mNMvSVG pDcCr+mt76aINAN6zeVV96fA6z876leIxPeB2tTK6nO+4r2yQD3MKwteAcBHffCr tTTd822GPzz0vVL9vWzU4jq8SCSkJRKJ8cqC1/D8O8eLwK1FgOBqC3zlU0nx6n71 9ypEi+vQIrFaqQbPFcnLQyTO64K1v9f7vDJBtcEr2C1/r2C3uA4tEkcP7Wci1dof x119Vvt79V1++v3yncO1/g2DP8JMcR1WJIKvbX9OkqkO1EoyCac468dfrXpT3aao qmOOOb2e6H8neBX8EddhRQoi0sjoTiCISEOgO4EgIg2B7gSCiDQEuhMIItIQ6E4g iEhDoDuBICINge4Egog0BLoTCCLSEOhOIIhIn48/6WPi8uPYQS4AAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -233.63,
    x: 118.25
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6.025,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -226.43,
    x: "90.85 93.85045 96.8509 100.44782 103.44225 105.84021 108.84066 111.84111 115.43201 118.43246 121.43291 122.63188 126.228809 128.62676 131.62117 134.01912 137.01956 139.4115 142.41194 145.40636"
  }, "&#x0423;&#x043f;&#x0440;&#x0430;&#x0432;&#x043b;&#x0435;&#x043d;&#x0438;&#x0435; &#x0440;&#x0430;&#x0441;&#x0447;&#x0435;&#x0442;&#x043e;&#x0432; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -219.2,
    x: "103.57 106.57 108.364009 111.364009 114.364009 117.35801 119.75201 122.740009 126.94601 129.34601"
  }, "&#x0438; &#x043f;&#x043b;&#x0430;&#x0442;&#x0435;&#x0436;&#x0435;&#x0439;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -212,
    x: 118.25
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_126)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,25.8,310.80003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_128",
    width: 90,
    height: 40,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFoAAAAoCAYAAAB+Qu3IAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAArUlEQVR4nO3bOw4DIQxFUe+cpbAUGiS+e2IEkUg5DZOMnm5xG5dH ljubmQ36STa896O1NkopdLic8xd6Dmqt9FAhhA90SmkP/70BKt1Cv+CWSRRjBBpo oYAGWiuggdYKaKC1AhporYAGWiuggdYKaKC1AhporYAGWiuggdYKaKC1AhporYAG WiuggdYKaKC1uoWm821oflieaz5hzWesBe2cW99Dc7PpbL33dUousrICStVm+I8A AAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#cad318",
    d: "M25.998 262.91H77.021999V284.414H25.998Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_129)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.59999999,24.6,306.00004)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_131",
    width: 97,
    height: 58,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGEAAAA6CAYAAACgTzeXAAAACXBIWXMAAA7EAAAO xAGVKw4bAAADS0lEQVR4nO2ZW64iMQxE2TlLYSn88IY9MSqkMyosd664A2r34I9S B8dJKqk8zWq1Wt0bs2N2Ao0CBBoFCDQKEGgUINAoQKBRgECjAIFGAQKNAgQaBQg0 ChBoFCDQKECgUYBAowCBRgECjQIEGj85nE6n+/V6nZvk/46xw/l8vl8ul/t2u32y H4/HB7DfbrcnH+WRdrv8MjvpKd/YFu1jF5Rer9dPdZIfy/zESz7YMp4Zr5Ht1yKo Iq2E/X7/EAP7ZrN5CKPGWCWIpbT8ZacT2OVP2u2eznxVt6A61bbqVVqQn/LE0zlI DNngGMvQh4yX1zviDC+4uU1+Pma/FgES6pA3LnFowL/yUedEiLIQp9O+teHjHY2+ asvb9tnmHc8GSbzx2+12T2VGvBCB9jOeEnUknPLfIgJqMsCHw+EvAc12BkCd1Vc2 zT7KqePUI0RiUyK4L6txJEIcDCaKr4ApETJeDKjvApFn5KUyGh/3fWFLyjNUoTeC 8nyVT6fYflwM8iEYV87UdhR9Vad3kI5FEcRVA+0zVf58MxGmeCEC50jG03mp7sj1 LSL4wUSj3JT8gIMkq0SE5MvhJpuLyeqIHSed+TIYXpbDloGR8Oz1+GATNw5v79OI F1sLEyvjDC99uRDQ77eIMIXsuvrC3vcRZGfGwjA7gX/Gi9fBipidQKMAgUYBAo0C BBqfqtivbbo2+v3er3DyIe4U403xmpfZVHe8EvJS5jpKG15PtLlvvJ4vWgTu3uqU 7uy8Ynk0eViC+Iu/kvFDROXxaGOQ+E0si3s9DyjeCP6Spg1s/tiKZRctgseXeE17 xz02E1+hPsMZMI/heFSXFzovYl70pGP8hzCEhzWYBFnZRYvAABGDQZhMhBhKiLM+ E8FDIspDBEIobFFsdZkIDL4ER8xYdvEiEMvx/wqmRFCHifNoMDxOFUUgTuSxIH77 luciTG1HvqKysosXwWP2/PY/SnyA2A44zPmt1aByHKQeQ9KXQSTP09Tv7aoelZON SDB1ZWUXLwKzc+QTt6MvxecqZxaOfOJV8UsxO4FGAQKNAgQaBQg0ChBoFCDQKECg UYBAowCBRgECjQIEGgUINAoQaBQg0ChAoFGAQKMAgUYBAl+PP38nOBpsvjgWAAAA AElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -282.35,
    x: 51.55
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -275.15,
    x: "26.9 30.494002 33.494005 37.688005 41.282 44.282 47.282 50.276 52.076 55.670003 58.070005 60.464 64.058 66.458 70.052 73.052 76.04"
  }, "&#x0410;&#x0434;&#x043c;&#x0438;&#x043d;&#x0438;&#x0441;&#x0442;&#x0440;&#x0430;&#x0442;&#x0438;&#x0432;&#x043d;&#x043e;&#x0435; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6.025,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -267.95,
    x: "36.425 39.419424 42.419874 45.420324 48.41475 51.409177 54.409627 57.410078 60.41053 63.41098 66.41143"
  }, "&#x0443;&#x043f;&#x0440;&#x0430;&#x0432;&#x043b;&#x0435;&#x043d;&#x0438;&#x0435; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -260.73,
    x: 51.55
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_132)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.59999999,156,271.80003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_134",
    width: 116,
    height: 49,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAHQAAAAxCAYAAAALD434AAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAzElEQVR4nO3cPQpDIRAA4b25R/E4/uCdDCaQ5kHgkYBxmOJrthIG djsjIqZQYqaUZq11llJ0qNUv5/wK2lqbvXcdbkV9Bl2Fdz9G31sdL0H/4AboJoPC GBTGoDAGhTEojEFhDApjUBiDwhgUxqAwBoUxKIxBYQwKY1AYg8IYFMagMAaFMSiM QWEMCmNQGIPCGBTGoDAGhTEojEFhDApjUBiDwhgUxqAwBoUxKIxBYQwKY1CYj0F3 /1mn+y5Bxxjvoc5lUJjVMXbvf/3WA680uw8ETTJzAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#00b050",
    d: "M156.15 296.92H223.09799V323.31404H156.15Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_135)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,162,262.80003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_137",
    width: 99,
    height: 81,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGMAAABRCAYAAADGiRgzAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAE6klEQVR4nO2aXXLbMAyEc/McJUfJS/6TO7mDTL/MZgvacq0UcAcP O7EgClxyAYaEdHNzc3MYtEE5gcGI0RLlBAYjRkuUExiMGC1RTmAwYrREOYHBiNES 5QQGI0ZLlBMYjBgtUU5gMGK0RDmBwYjREuUEBiNGS1zu5P7+/vD8/PyFu7u76kFd Ky4X4u3t7RtCkAYDu0bsIwYCuBhx//Hx8fDx8XG4vb39smkmaTZx7+np6ZsP8PLy 8uVrqw/ahl19hg1OGVfacB8fx/ouFeP19fVTAAaqYoTt/f39E2GPtmGPwXLNvYeH hz/sMfFMAjb+0tYzMvNBwMR1TFpMJv0iWMY1/MVvxkofP7gaXC5GDMAJx++YCJ8k oo1BMrAQQyMXkRGDZ5lIhEIgjW73EdHOREc/XNPviqtONBx00r3vcjGckBLWaAYx 0JUYEaUecSqG9kEAeP+ZD51oBFLbiqv7aS0GExkTfCwz/LmVGLqUrTKD5YR2WTC4 DyZXl6L4HTYyLOO6WqbaiZGtmwqWHZ0QonklRtiZLJYRbY+NycwmJPOhvjTjVLiM 69WJERHlO4sgyFoc/zCxM4FEePxmZ+I7obimjWaG74oiK/U686Ft/LdmtXNVnvA4 1XepGNkuQv8x7gGP0P8Y5QQ2Cb9zBHZFOYHBiNES5QQGI0ZLlBMYbBHDq51Z5ZOT rbaP/XrYtfLqZxHd35/ri7Zaz/JKsJ419H7Gx/vMziQZR/ejVWlvd7EYXsTT0gen VE63Wh1VQEqveY5+zvXFyRcbgnlbuGuVVselJ3W2z3pG0hP2Fo6I4O12FYPaDhOI nWiNDhmQlhi0dKGDvMQXzxCVTIJfa59aqtc+eefhYlA+15rWMY6Ma9VuVzGYiCg9 h52iXjYJSm5lVzHO9RVZoBmmVYBMDCbkVGawJGXZuJXjqt3uy1SQ9QjSJUvJedV0 S2Zs9RUBwX3K5cfE0CJklhksRyqGL1OnOHpmeLsf+Z+hL3U0esgajTjuqT0T41xf BIXaj4lxrFKsmaFv8LL/Gcc4ah0ua7eLGFlFVXdBWTVWIxH7KT/n+OKeVlbZxVB1 jWv61B1O5kPbOE/fTa12X/7+29vtIsa5yCKlg68rwn7OVpFS7euKUE5gMGK0RDmB wYjREuUEBnuLwYmY80NWpWWvz/ey/jzt+M5Vzxy6Z48dVrTTqi026kr+Da36Vpu2 AWrXL0j0bPIXZ4h/Iwanc47/2XewWmXVAmI8r1/xab2JNl5X0gotbUIYKgTcW/kO O3UkxkCfatfTPid499NODCaOky+TnA2eE7OW0fUswaCjTSac96WlchWA35lv5aPf eqkY4VsFpw3nn7Zi+PsJta8ikWjVzNJM0uf1qz2PSvyQGfqdLIGR+YaPQsVgTGRC iJr5aScGZWr9gm8lRvxfYWBMcjyfVXq1IEhmaF+8VNIyN+LyTOY7C45MDJZEf7/S OjN8HadSmYmh378iGmuzf/2tX5pryd3fpoWNz/x1aYvMyHxvEcPfaGo2tBaDSfJ3 27oLYpBUVn03wvNkl++mdIej38R6xXWL78yn9unVXd0J+rhainEKHomDQjE8EgeF YgxGjGtDOYHBiNES5QQGI0ZLlBMYjBgtUU5gMGK0RDmBwYjREuUEBiNGS5QTGIwY LVFOYDBitEQ5gcGI0RLlBAa/8QuTuAvsB5BixAAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -324.55,
    x: 189.77
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -316.15,
    x: "169.52 174.31742 177.91547 181.51352 185.10434 188.7024 191.69355 194.69193 200.08177 203.08014 207.27063 209.66933"
  }, "&#x0414;&#x0435;&#x043f;&#x0430;&#x0440;&#x0442;&#x0430;&#x043c;&#x0435;&#x043d;&#x0442; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -307.73,
    x: "164.95 168.54279 172.14278 175.74277 179.93317 183.53316 187.13315 190.72594 193.12354 197.31394 200.90673 204.50672 208.1067 210.5043 214.6947"
  }, "&#x043a;&#x043e;&#x0440;&#x043f;&#x043e;&#x0440;&#x0430;&#x0442;&#x0438;&#x0432;&#x043d;&#x043e;&#x0433;&#x043e; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -299.33,
    x: "170.78 173.7896 176.18 180.37039 183.37279 186.96558 190.56557 194.15836 197.75115 201.35114 204.95114 208.53675"
  }, "&#x0441;&#x0442;&#x0440;&#x0430;&#x0445;&#x043e;&#x0432;&#x0430;&#x043d;&#x0438;&#x044f; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -290.92,
    x: 189.77
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_138)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,156,301.2)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_140",
    width: 117,
    height: 51,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAHUAAAAzCAYAAACpBUfNAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAA1klEQVR4nO3cMQoDIRQAUe9/KRtlXd07GWxikywEAskfpngoVsKg dqaU0hROmqWU2XtXYGOMWWvdUc/z/Pmm9J2wL6Mex6FgVsy3Udf4B++BPnR7Uo0a k1GBjApkVCCjAhkVyKhARgUyKpBRgYwKZFQgowIZFcioQEYFMiqQUYGMCmRUIKMC GRXIqEBGBTIqkFGBjApkVCCjAhkVyKhARgUyKpBRgYwKZFQgowIZFcioQEYFMiqQ UYFuo67FNVcst38TKrbW2o6ac35ev4pp9buua0cVywM/FvZ45bmthgAAAABJRU5E rkJggg=="
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#00b050",
    d: "M155.99 266.45H223.171V294.22203H155.99Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_141)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,160.2,295.80003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_143",
    width: 102,
    height: 70,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGYAAABGCAYAAAA+c+FUAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAEl0lEQVR4nO2aWbLqMAxE2TlLYSn8MFyGPfGqqTq3+qnsJLwBxVx9 dCUxliyr5Ul4s9lsHoVVIt2AQhEzFNINKBQxQyHdgEIRMxTSDSgUMUMh3YBCETMU 0g0oFDFDId2AQhEzFNINKBQxQyHdgEIRMxTe09Dtdnvs9/vfvne7XXbn14z3NHS/ 3x/X6/X5LoL0LmLO5/M3VK4yPVVfZa7jdDo9yyF4u90+LpfLs0xAt+vzMurQBu+t cummXM/D4fBs/+OIERg1euI83uVgykSavvX8+vp6ylJHzpEMZcijW/X5ljMJAslJ 3olzHbxTrjLXTfsfSYwiT45rOUJO9NFDpLszJH88Hr9HnhOqMkW59ON86WSkUoeR iBwEuD2S+1HEEIl0cI4YOZG6IsQdFUeMnM5oFEFOjI9Gpk/kYqBgn+vSt+p9JDFE MZ2dIkYO0DdTmn6XYwQR5MR6NKu+O5mpjDqsT1NTGaQgR7v6nZH6UcQQqb4z88UW Z/h0Ehd/kcIGQN+MDJwuQDr6eGeTENudW/zZkKDn44hZCo/mH450AwpFzFBIN6BQ xAyFdAMK/4uYuDX1cs9RUU/b3pjHmstv9eQFtsoq8y20n118e8wWWOcTz73FfvRs cZt9Kx3tTSdGZw4/zGEoJ25yXBwaOSTqqTJPj6AnytJOlEcvJ3yIIaVCG4J0kJ6J 7Xo/eCdQev3g9569qyCGUzdnEDeQfJV3HBK9zB0WZaPjYhCQ38ImtwU50i+04zk0 7wdl0dGtfvT6uhpiZBxQGVnePyGmJdsjxnNhU8SQWvHMgkc55HoZubSpfvT6uhpi BE0j5MJIs8cpgOnFyyIxLVnaifJeb4oYss8tYvjLoDWV9frhxPTsTSfGF0rPVxHN LIg+suYW3Cjbk1dbrEteV+++MLcW/9aGY4kt/pu3F+1NJ+bVkZUlPxjSDSgUMUMh 3YBCETMU0g1Igd89EHpnD/7znzubsFvknNOrx90B386/TAznkfhfOTmiXu6L7au+ /a9b32bGXBNlflhr6fNt6ty7dHPuiNtbUjaU+80bvzZFv+cuYtAPv0AyhdZf54uJ 8dMvTHuOiDQMBziX4S6XyPUbLMhxJmkdCv3v5ajPI7cV8Z6q0ZPDX4xisgbIYSM6 +W61NYWYgYhwomOwLCJGERAbcMPdGd4RDm4Q6FEo2ajXHRDvcWGH6+PpOS70qK6T 7Rf9WsQQJP5ENjpuCTFkPqYc7sTMnMn+LTEepZEYTuNzxOBcOur6nJioB6d4vo61 pEcMpNAXZgamsqXEMDMsvUgiP8ysW9NTGQlAOhGJYSrDkT7lyEjPn/kVWcn4HTEn hqmzpW9qKsOZfmFP362MQVxffI0Bap8IxzZGcCSOGcFl+VvCA5s1tEX+YmLIQ/k9 Lh+mPi/HxQ8iPYfFN0YL5NV8mHvUtfR5/d57b9Phelt30HrE+GaltcDHeoy+2G6r jy8TM4c330xcDZauN3+Z0MzvaKGIGQnpBhSKmKGQbkChiBkK6QYUipihkG5AoYgZ CukGFIqYoZBuQKGIGQrpBhSKmKGQbkChiBkK6QYUGvgFMc4+R1+KBBkAAAAASUVO RK5CYII="
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -292.63,
    x: 189.72
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -285.43,
    x: "174.43 177.454 180.478 184.096 187.11399 189.53798 192.56198 195.57999 199.198 202.222 205.23999"
  }, "&#x0423;&#x043f;&#x0440;&#x0430;&#x0432;&#x043b;&#x0435;&#x043d;&#x0438;&#x044f; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6.025,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -278.23,
    x: "168.97 171.96442 174.96486 177.96532 180.96576 184.56269 187.56314 190.55756 192.9495 195.94994 198.94435 201.9448 204.94524 207.33718 210.33762"
  }, "&#x043a;&#x043e;&#x0440;&#x043f;&#x043e;&#x0440;&#x0430;&#x0442;&#x0438;&#x0432;&#x043d;&#x043e;&#x0433;&#x043e; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -271,
    x: "162.68 165.07999 167.474 170.474 173.46799 175.868 179.462 182.456 184.85599 188.45 191.45 194.44399"
  }, "&#x0441;&#x0442;&#x0440;&#x0430;&#x0445;&#x043e;&#x0432;&#x0430;&#x043d;&#x0438;&#x044f; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -271,
    x: 195.75
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -271,
    x: 201.9
  }, "1")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -271,
    x: "204.95 206.15"
  }, ", ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -271,
    x: 207.8
  }, "2")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -271,
    x: "210.85 212.05"
  }, ", ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -271,
    x: 213.7
  }, "3")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -263.8,
    x: 189.72
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_144)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,696.6,301.2)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_146",
    width: 127,
    height: 47,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAH8AAAAvCAYAAADKMxXkAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAv0lEQVR4nO3cSQrDMBAFUd3/XBrQcCcFEUhsDN4Zg6oWD3pff90h hDCF9T1ijLOUos2llM7xa62ztSaI1dv4UL33a/zDIrQh44MZH8z4YMYHMz6Y8cGM D2Z8MOODGR/M+GDGBzM+mPHBjA9mfDDjgxkfzPhgxgczPpjxwYwPZnww44MZH8z4 YMYHMz6Y8cGMD2Z8MOODGR/M+GDGBzM+mPHBbuMvb3+I1HNW9Nv42t8p/hjjtwrt bXXOOf/ji+kDuAJHGwo3Za8AAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#7030a0",
    d: "M696.62 268.67H769.754V293.80903H696.62Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_147)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.59999999,707.4,283.2)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_149",
    width: 93,
    height: 109,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAF0AAABtCAYAAADDC21uAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAEw0lEQVR4nO2a3XLqMBCDefM+Sh+lN/1v36lnxIw66p61A0NAgHKh aXDWm8+qE+wlu91u97Pp4rIDJMoOkCg7QKLsAImyAyTKDpAoO0Ci7ACJsgMkyg6Q KDtAouwAibIDJMoOkCg7QKLsAImyAyTKDpAoO0Ci7ACJsgMkyg6QKDtAouwAibID JMoOkCg7QKLsAImyAyTKDpAoO0Ci7ACJsgMkyg6QKDtAoo7v9PT09PP5+flH39/f 7oHcko7v9Pr6ujca5uMzjt/e3v7E4DPPQw8PD/s2Ss/huGuDHh8f9+fwt+aA0LaU Qz93k0P7dX2Wrn0R0z8+PoamY1A4//X1tdf7+/vvwOrdgTacZ6zmwV9t5/UOzcHr gQXmwDieJ3fHyn4cK46fn5+H176o6YBUMAJwABwUB6mD4QA4wzhjaJKazpmnjzC0 M475ag4YRXNwZ+IzTdc8lRXGd6bzc732xUxXczrTdTbQuJnpzFdNr4OnQZ3pNYfe KTASbTBW+3asNF1lN73Oumq6mqMamY4BqAmjmY7j0UzvctBozHLemXrdEevo8WIz nYOvM0FXMBgkZ5g+hkam67O4M52G0rRu4F0OHuOxo48RZepYr9J0QLy8vPz3Ta5w iMMxb2m20TSuBLgqQD5IY5gT/TFrdUWBtroyqjk0l65a6gqmstbVS10R1WtfzPTu onVGnKo64+5Mhwdzhnbr0zpDTtXa+a5MdoBE2QESZQdIlB0gUXaARM0DWGXr1qej yh7X7ujXrXsPycHPzDGLr9fV9Xm3Ajo1P/rMYk82nTs73XmiHRsR7ua4k2O81ixq 5VDX+dwFMp47Pe3DHDjWWN2hMtcsTx1Tl3/E041rFruK6SyPqmm6HZ4NtJZa2Z/b c/bTcvHIFN3Rav1HP3dcvP7M9BlP7bMUu4rpdaZq2bTeAZ3pWj8hHEup3MUyd1d3 15moM5rX0Z1yNV3vDGXs6kYjnjqupdhVTCcsy54cZHdLdabrjwvsj+eizlY8rmYz ne0cqMaMKpXVtG5iMP+Mp/ZZil3F9O6ZrtU5HXRnOgc1eqbzL39lGpmi3yH8HuGs G5nOc0v5ZzzduGaxqz1eWMXTugsfE5B+o89WIrV2g3O1iqh9uEKosSo1Q1dZPHdo /hFPN65Z7GqmH5l00ymmj9a6m85o+qbN9HuRHSBRdoBE2QESdb7k3HkeW6Hs2rS6 x3aNY7/ufckulsdgW+HdxOsxve5muWur1UL+U3SHV3eV9ZW4ribUvZMzisX19FoX 3o+c1/SuQlmrhdiK45gzbVRW6KqZtXrJc/o6yCh2VBq4edPrDNNX6WhArdZBKDnU mY4+amx9W3dmehdbWe7G9FGFUquF9SUlmrw007vq5cj0LpaG8337uzG9Pme7aiEM 0ncXD60UjqqXneldrL6UelemdxXKrlqIdl15MIeuSOo7iKPq5dJvrrrSGfW5edMv NJBb0vmSbxVKg+mbNtOvSXaARNkBEmUHSJQdIFF2gETZARJlB0iUHSBRdoBE2QES ZQdIlB0gUXaARNkBEmUHSJQdIFF2gETZARJlB0iUHSBRdoBE2QESZQdIlB0gUXaA RNkBEmUHSJQdIFF2gETZARJlB0iUHSBRdoA4/QMnlpWG597/zAAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -304.05,
    x: 733.73
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -295.65,
    x: 733.73
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -287.23,
    x: "713.48 718.32559 721.90396 725.5039 729.09677 732.6967 735.6919 738.69436 744.10879 747.11117 751.3016 753.69918"
  }, "&#x0414;&#x0435;&#x043f;&#x0430;&#x0440;&#x0442;&#x0430;&#x043c;&#x0435;&#x043d;&#x0442; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -278.83,
    x: "710.88 714.48 718.07998 720.4776 724.66799 728.26797 731.868 735.4608 739.0608 742.6536 746.25369 750.44406 752.8417 756.44168"
  }, "&#x0440;&#x0435;&#x0433;&#x0438;&#x043e;&#x043d;&#x0430;&#x043b;&#x044c;&#x043d;&#x043e;&#x0433;&#x043e; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -270.42,
    x: "719.88 723.48 727.0728 730.0752 733.668 737.268 740.2632 743.86318"
  }, "&#x0440;&#x0430;&#x0437;&#x0432;&#x0438;&#x0442;&#x0438;&#x044f;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -253.6,
    x: 733.73
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_150)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,697.8,333)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_152",
    width: 125,
    height: 25,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAH0AAAAZCAYAAAAc5SFpAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAApElEQVR4nO3aOw6FIBBGYXbO0mgghMeeMBOVTqt7JeE/xddYkZzM 2Ixzzg2I8d6PWisEhBDO6Cml5Y/BN1prZ/QY4/xYShk5Z2zGYj9Gn+OPrbxOOtH3 RHRBRBdEdEFEF0R0QUQXRHRBRBdEdEFEF0R0QUQXRHRBRBdEdEGv0e10avWVB37P LqIeo2NvM7qt9NWPwTds4q+V70bvffkKwv/d//gDSY80n8nVXA8AAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#7030a0",
    d: "M697.47 249.86H769.753V262.295H697.47Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_153)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,716.4,325.2)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_155",
    width: 64,
    height: 53,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAEAAAAA1CAYAAADxhu2sAAAACXBIWXMAAA7EAAAO xAGVKw4bAAABtklEQVR4nOWVW46DMBAEuTlHyVH4gSQ87sSqkVrqeA1itUkqUj5K NsZ2yjNj0jRNs345uAANLkCDC9DgAjS4AA0uQIML0OACNLgADS5AgwvQ4AI0uAAN LkCDC9DgAjS4AA0uQIML0OACNOcmdl233m63rf0A6fcGYFmW7fDTNK3jOG7PHyD+ ngDc7/ft4PM8P7Qa1/usisvlsj3XKifnHa1p2/bX/DP75Lw/Vun+S22kA2cFqNWz +nqvtu/7bb76Ig/jMVeP5+2t0e9lsPUbZ/bJ9bnfvwPgQ2cAsm8JSZWH8Xq1el+K 19b4ejnIwzAc7pNJeUkAnJHy0BpT+TojmTmv1yH1rHmleG2NMq2r5TEH6mgfX0e1 CsJTAyAsWpagMlNmwaLlWvdrmcs1mWlXgCtlbx9fAQfz6QHIw9TunKshM66+s3K9 XqvitTVZcZ7j/t4+Oe8lFWD8tVab4znmL7XvcP5d5td5b00+e37e73Kf2j/DU/8F vgRcgAYXoMEFaHABGlyABhegwQVocAEaXIAGF6DBBWhwARpcgAYXoMEFaHABGlyA BhegwQVocAEaXIAGF0D5AREfgDjDjMuHAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -262.05,
    x: 734.15
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -253.63,
    x: "719.8 724.6024 728.7928 732.39279 736.5831 739.5856 743.18557 748.57839"
  }, "&#x0424;&#x0438;&#x043b;&#x0438;&#x0430;&#x043b;&#x044b; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -245.23,
    x: 734.15
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_156)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,237.6,248.40003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_158",
    width: 110,
    height: 44,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAG4AAAAsCAYAAACEy42cAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAA1ElEQVR4nO3cMQ7DIBAAQf7/CT/FDRI2PIroCmJbSax0ZqUtpqFC Wh0dl1JKXUipL8vSW2t933dNrNba13U9wo1DzW/btiNcTFscOnXzOjf6CBcmeLv1 xehjOBjDQRkOynBQhoMyHJThoAwHZTgow0EZDspwUIaDMhyU4aAMB2U4KMNBGQ7K cFCGgzIclOGgDAdlOCjDQRkOynBQhoMyHJThoAwHZTgow0EZDuo2XHwSL6VoQmMz xs+J09wu4XLOj19I/4npe4cLsbHm6edA905bhfoLD6LFF9Cn9XQAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#99ccff",
    d: "M237.71 323.1H300.558V346.78303H237.71Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_159)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,244.8,242.40001)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_161",
    width: 88,
    height: 67,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFgAAABDCAYAAAAYhMJsAAAACXBIWXMAAA7EAAAO xAGVKw4bAAADjElEQVR4nO2ZXW7jMAyEc/McJUfJS9L83imLCfAtBoScdb1uJyDy MIgqm+JoREoWu9lsNo8PfhRxAt0RJ9AdcQLdESfQHXEC3REn0B1xAt0RJ9AdcQLd ESfQHXEC3REn0B1xAt0RJ9AdcQLdESfQHXEC3REn0B1xAt0RJ/D2uN/vj/1+/2zr d7fbrSOwBjqdTn8HFw6Hw+N8Pj8ul8vjeDzGJ/8buN1uz/l+fX0929+c9/RDCXu9 Xp+i6m85kQP1qc1vWoCfBjporsJ2u11fYEVyFVRiC4p0pRGrjPjeTxawSGrrOaQF vav+VzZkj9riRNtFICD8HUFtH1ugPeXzFZfVBHbU7YI+FoBJIj79bDVkQBWFNESU KRt/z/0jhhag2voC+th6V8+df/X5isuqAhOVnh4jgRXBeoYd/Zqcj+P2GnMk8MiG CcqmPped4JFHJnlEq48AIGumfL7isuoWgQOPYJzVCBgJ7JHqYpFuI4FHNhw0nlUe tUB84exB4WOTYa98vuKyqsAiiaCkmjvzPVqnbCXIPka/xkBUHwuBRjaVn2eQ85J/ 9WkxGIfto24RbjfyOZfLYoE5uKb2TKKjRgYTZwwipaaaH3KMO2VT+XGgkk1kRD2U 4IXwPCdovL/6nMtlkcDfQd0i/gUnDXzLaIR1BvLImCswBwxQygpvIMr7CfzBR+CP wE0RJ9AdcQLdESfQHfNf5lMMeNVKH+tetRq971UsqmJ+/fbKl5cGa598jey5CPmn Xn1nxNWrcgKXkpHvud/5iwTmtsTVlksB114KLJQwucoyAa7dTLCOw/tMpl7L8e2T dXsv5NTql5dCK1euzC6w7CVw9T33O/+/BIaE12jr/V5tBPPoIuqZ4FR1rfqoNYAp e/+HgF/LieoR11EdxCN1Qf1hmcCQrZP3yhnwCK4CU4edEtgnNhJ4yh5BlSFwRXTn XbnWalxEYCZCRcrrqZ52RG4VzAX2tB0J7CVIIq+WOUf2vm/DD7+j7QyudWEjAkOy Vr7Yq5hord36v3SozPneOBKYCBXYLryKNWVPHRixWRwWQu0RV+eJrR/gCypoywSu J+jCU3USNZKaYP4WUatffDKtRaZGUhPECXRHnEB3xAl0R5xAd8QJdEecQHfECXRH nEB3xAl0R5xAd8QJdEecQHfECXRHnEB3xAl0R5xAd8QJdEecQHfECXRHnEB3xAl0 R5xAa/wBcZnDCGzPkYIAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -345.2,
    x: 269.32
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -336.78,
    x: "247.72 254.33679 257.9368 261.5368 265.7272 269.932 272.93443 276.53443 279.54405 283.12965 286.72966 290.92005"
  }, "&#x042e;&#x0440;&#x0438;&#x0434;&#x0438;&#x0447;&#x0435;&#x0441;&#x043a;&#x0438;&#x0439; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -328.38,
    x: "249.4 253.5904 257.212 260.7976 264.3904 267.99043 270.38804 273.98085 279.39524 282.39765 286.58805"
  }, "&#x0434;&#x0435;&#x043f;&#x0430;&#x0440;&#x0442;&#x0430;&#x043c;&#x0435;&#x043d;&#x0442;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -319.98,
    x: 269.32
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_162)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,238.2,276.00004)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_164",
    width: 110,
    height: 44,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAG4AAAAsCAYAAACEy42cAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAxklEQVR4nO3VMQ7DIBAAQX7up9FgEOA/EYGTVHGUzllpi2mokJbj QghhCGjbttFaG7VWAaSUznD7vq9w4ljhZsHXQe/99hela5fhYoz3/936aA6V4YAM B2U4KMNBGQ7KcFCGgzIclOGgDAdlOCjDQRkOynBQhoMyHJThoAwHZTgow0EZDspw UIaDMhyU4aAMB2U4KMNBGQ7KcFCGgzIclOGgDAdlOCjDQX0NJ4YVrpRy+0X0uzl5 zykMI+c8ZkD9t+M43uvsAS8rNyq8IksBAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#99ccff",
    d: "M237.83 295.41H301.326V319.277H237.83Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_165)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,250.8,261.6)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_167",
    width: 68,
    height: 94,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAEQAAABeCAYAAACaXrJPAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAD+UlEQVR4nO2ZW1IjMRRDs3OWwlLyA4TXnjKlFIfSuNzQHRqkYuZD Fce+15blR1/bh8PhcP6PvxAn0IY4gTbECbQhTqANcQJtiBNoQ5xAG+IE2hAn0IY4 gTbECbQhTqANcQJtiBNoQ5xAG+IE2hAn0IY4gTbECbQhTqANcQJtiBNoQ5xAG+IE 2hAn0IY4gTbECbQhTqANcQJtiBNow8cGT09P58fHx/f/z8/P54eHhzTpnCDH4/Ei ws3Nzfn29vaSVv7pdHrH6+vrJU+/sr+7u7vYeh1uJ9zf31/sVKb/qp/6yFMdslGe 17U2PfP/siDMElWsmcJseXl5uTSkjimNnTotIBxiCLJDFPz1qxlHWvUrLYFUn8qU rzRtOK8xLZ4M4Mx/F0HUKSpFfRqg7COyshEx5TFaIq20fplVlLuA+pVI1IefMLYn seWDzcx/F0FokFFfIwi2IklHIegzRGXsUz6bEGtcRviNgjBgLOsl/10EoTNe6UwQ SDlZlfvUHQWRECJOHXRAU54lJuC3NAvpPOkl/90E8Q2RjupXDVOGGNpXlO/+ypMd m62PHFC+ysdNUb74XbOpuv9uS2btstqzvhDiBNoQJ9CGOIE2xAm0IU6gDdscxuBJ n1fl6bNGcCU7PnkCn2CVEROMZx2PgrfYwWPJ5tsFIZgi+IKUB1+E4kSpfiCUL3bK U7mfa6hvi52ffUabHxHEo81xlPy84qE5/4lm/bDGDOKQt8XOZ8fMpkIQjdosjPcR 9ZGnExzVt9gtCXLFsX9fQRCAPC0TXzYuCKdS5XGWmS2FNXbe6ZnNtwvCBqq0CHOx Q8c517CpcrjCl06s3Sw/sxvPKD++qX42a34B4gTaECfQhjiBNmx3IpL8JfcfXxOE G3WeHAo68HOC8On0hynEGL8q2LpIyvNP4OwtZ/Tz60Q+6zM7zlC0pfQsj18+/361 uUkQv6Ql4OFCmWiUM8rsDQR/3WciyviWM/NTuTquegmuZnbEG/Ad83if8XZXxifz At5RvEGu9n22MPJ+i87jE1EmozTe1M/8COa8kzM7omF/kqANf58h78uCjJsmS8UF 8aeD8Q1k9F8SZPRjmfE0gSCjndfhnR3fZxCWh7CrBdE0VYWa3n5AYwQ8b/YGQh4z bSbIZ28nvmRGu6Ul42cYXzJe39Wb6vHtXsOJLj0gL72hIKBveP6W89HbyWxTxW7t prq0SV8lyD+KOIE2xAm0IU6gDXECbYgTaEOcQBviBNoQJ9CGOIE2xAm0IU6gDXEC bYgTaEOcQBviBNoQJ9CGOIE2xAm0IU6gDXECbYgTaEOcQBviBNoQJ9CGOIE2xAm0 IU6gDXECbYgTaEOcQBviBKrwB6j/FrOwiCBaAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -326.88,
    x: 269.77
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6.025,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -319.68,
    x: 269.77
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -312.45,
    x: "254.42 257.42 260.42 264.014 267.008 269.408 272.408 275.396 279.00199 282.00199 284.99"
  }, "&#x0423;&#x043f;&#x0440;&#x0430;&#x0432;&#x043b;&#x0435;&#x043d;&#x0438;&#x0435; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -305.25,
    x: "256.52 259.52 262.52 265.51399 268.50798 271.50798 274.50196 277.50196 279.89595"
  }, "&#x043f;&#x0440;&#x0430;&#x0432;&#x043e;&#x0432;&#x043e;&#x0433;&#x043e;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -298.05,
    x: "253.22 256.22 259.814 262.802 265.214 268.214 271.202 274.20799 277.19599 280.20799 283.20799"
  }, "&#x043e;&#x0431;&#x0435;&#x0441;&#x043f;&#x0435;&#x0447;&#x0435;&#x043d;&#x0438;&#x044f;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -283.63,
    x: 269.77
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_168)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,238.2,302.4)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_170",
    width: 110,
    height: 52,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAG4AAAA0CAYAAABrTg1qAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAA2klEQVR4nO3cMQrEIBBAUW/uUTyKpaiHMriFG0hYNpX58ItX2Qif mXJCCGEIKYyc8yilCGC2WuFqraO1JoDe+zfc7s/omUu4OYov2N26MSfNcECGgzIc lOGgDAdlOCjDQRkOynBQhoMyHJThoAwHZTgow0EZDspwUIaDMhyU4aAMB2U4KMNB GQ7KcFCGgzIclOGgDAdlOCjDQRkOynBQhoMyHJThoAwHZTgow0EZDspwUIaDMhzU z3DzcfdZP907Xzi8hBPDCnceQ73bnLwVLqW0fRXoPzHGT7gD4QakTGUOAvgAAAAA SUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#99ccff",
    d: "M238.07 264.3H301.323V292.72H238.07Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_171)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,238.2,290.40003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_173",
    width: 112,
    height: 94,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAHAAAABeCAYAAAD7RpANAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAEmUlEQVR4nO2aa1LkMBCDuTlH4Sj84Q13YktT9c2qupx5sAvNTOuH Ko7TdmQrdmwlNzc3N5/BRaOdQBABR6OdQBABR6OdQBABR6OdQBABR6OdQBABR6Od QBABR6OdQBABR6OdQBABR6OdQBABR6OdQBABR6OdQBABR6OdQBABR6OdQBABR6Od QBABR6OdQBABR+P7Kn97e/u8v7/fn7++vn5+fHx0N/ja8H2VSzyJSFoC3t7efj4/ P++h/Lu7u91RUF6tgzide3nyVL7mUY4HRjGkVcex/FoerPhvcb14AQVGIaNPDXx/ f98ddY2O0PWXl5d9Hh2iMoLKKM/L66hrKqtywsPDw/5+T09Puxg6ljp0Xuvz9Ko8 7Vnx9zofHx93+Sp/FQLSGasOU2cjIHkaEaQFF92FUEfpqBGh+nVN9QkIWh8SOn7F h1ilV+WrgM5faT18iCZO3oaLFlDwd98xAb3x3oFVQK751IyAdKZPcwinI+JzD+XD Ufmr8ucIKFyFgHSuL2a2BFQco4eOYFrVVMYoqwIy7VIfUygxEuWUKZQ4HpRa/piA XsbbcNECskDwDvBFgy9cmLo0OohlelSeyuicPAnHtKk6vT7SiuH6VxYxXv4Qf67x vr6qRcwp8Kc6uEABgwg4Ge0Eggh4PWDbUhdIEfBCoC0TrlK1Fc8SkOU9YImN7+ge IbEs11deocfonLq45mkvV+NqfXUZX+s89T6r9tc0bVtdg5t7pav+JP5Q3Cp9toBa 1rvnyEYVv1FH9j2+CYeoW1g1hvoh7w3R3ovNsG+O1WDuzf21PyRuq85V3lZ5BzzF HaOA/aeOPAjEuStEGyjn3Oi3rbjVfb8sIA2v7oQ3hjy3tpyI1+Ux/oBgW/HUuYlM DI6LOh8P1HnUh446t/JqefhRF8JiTJOu/cR16q6icR+lmR5xp1Zx9b4/KiAj5ZCA xOA51lHCCPavAVhdjB5vMN4n96l1buXV8nWKwxliVMFl1U+M6GpIVAH9IT4U5/f9 7wLWzyxu+voNa7rGbE2h+ItMcdyTOK7D4ytT6Fb5OrJ4z/uoUBm3y9y3ha9/4tp6 iLfi6n2/LKC//PEh+YxTFzFOjLzaKTVma3Hh781VHPWuOv+cRcwh8Sp/X6gwmus1 /yjNw1H7sy7qVnH/bRFzbFQGvwbtBIIIOBrtBIII+Be4JVqtdnOJgGfC/2Wpq7sr RjuBo8Cyc6OAc9/OsDf15ffKc2TT7vnEnbh0/01oJ3AUblcprWmSPRQbX7efcG9U Fg/WbS7cHEYr/9ngP/7gD0kzBHTbic5lFLE3rV6l22arenz0eT3198ALQDuBo/AO dTf/FAG3/tWsAtavJ91tvioB8Q35IuEebDXYPQ77D9vMBXYB+RtcZRV7YW5TO4Gj 4H2ndxeLGHmyOnev09+NlN3yHPEuaxxfJrrbfHUCdnP4xWgnEETA0WgnEETA0Wgn EETA0WgnEETA0WgnEETA0WgnEETA0WgnEETA0WgnEETA0WgnEETA0WgnEETA0Wgn EETA0WgnEETA0WgnEETA0WgnEETA0WgnEETA0WgnEPwD/gB9FOmkwMVROwAAAABJ RU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6.025,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -298.03,
    x: 269.9
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -290.8,
    x: 269.9
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -283.6,
    x: "250.73 253.73 256.72999 260.32398 263.31797 265.71797 268.71797 271.70597 275.31196 278.31196 281.29997 282.51194 286.10594 289.10594"
  }, "&#x0423;&#x043f;&#x0440;&#x0430;&#x0432;&#x043b;&#x0435;&#x043d;&#x0438;&#x0435; &#x043f;&#x043e; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -276.4,
    x: "240.3 243.3 246.3 249.28801 251.69402 254.68202 258.28804 260.68803 263.68803 267.282 270.282 273.282"
  }, "&#x043f;&#x0440;&#x0435;&#x0442;&#x0435;&#x043d;&#x0437;&#x0438;&#x043e;&#x043d;&#x043d;&#x043e;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -276.4,
    x: 276.63
  }, "-")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -276.4,
    x: "278.45 281.45 284.444 286.844 290.438 292.83799 296.43199 299.43199"
  }, "&#x0438;&#x0441;&#x043a;&#x043e;&#x0432;&#x043e;&#x0439; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -269.18,
    x: "261.02 264.02 267.01399 270.01399 273.60798 276.00196"
  }, "&#x0440;&#x0430;&#x0431;&#x043e;&#x0442;&#x0435;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -261.98,
    x: 269.9
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -254.77,
    x: 269.9
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_174)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.59999999,316.2,472.2)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_176",
    width: 107,
    height: 49,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGsAAAAxCAYAAADdqledAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAA40lEQVR4nO3cMQrEIBBAUW+eo6VRQqJ3yjIuyS6EzZbmwy+ehZXw ccpJKaVdEPM877XWfds2PVC0WZblHauUMvxB+h+sx8o5n5fruvaKeobocbS5xIqR OHwu6xTBjAVhLBBjgRgLxFggxgIxFoixQIwFYiwQY4EYC8RYIMYCMRaIsUCMBWIs EGOBGAvEWCDGAjEWiLFAjAViLBBjgRgLxFggxgIxFoixQIwFYiwQY4EYC8RYIMYC MRaIsUBuY8VqoNFbVfTxvVPrEkvP1WPF6Bv9EN07F23F0Vob/uX12zRNPdYLNWTU Dy0P1oEAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#ff3300",
    d: "M315.84 96.278H377.554V123.158H315.84Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_177)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.59999999,324,454.80003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_179",
    width: 83,
    height: 109,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFMAAABtCAYAAADdwl3dAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAEgElEQVR4nO2aW07kMBRE2TlLYSn88IY9MbotnVZR4wQEzRRdw0cp HceP44oT27dzcXFx8fqrkykO0KQ4QJPiAE2KAzQpDtCkOECT4gBNigM0KQ7QpDhA k+IATYoDNCkO0KQ4QJPiAE2KAzQpDtCkOECT4gBNigM0KQ7QpDhAk+IATYoDNCkO 0KQ4QJPiAE2KAzQpDtCkOECT4gBNigM0KQ7QpDhAk97PdH9//0Y/APqnaj/D7e3t 69PT0xv9GvpJM19eXg4GXl1dHUx0M6+vr18fHx8PRy3jo/ny8vJ4beT551zror3V E+F1kFfr9PMVq9YxfFNm6tpr+0tmPj8/HwAAVDPv7u6O1zXfHH0005H5rUfyaz2a 5yN1jClTbqScI27iihV531ZPo9+Yk5upj/0c6YxC3tzcHGEUSDuPMTMiJs/8ng7R BvkYXV7Hw8PD8fdc51xNWLFi7KRNGX/qvO0vmTl3lcb2zPS7vGXmjCA64GaSHzOn 3KpDqzrUnGGbI6Nrj3U1+r/NTO7wdGDLzMnj5bbM1BuzMnPyYMI8lqsOrerAyGkL o2cg+Ah31q3H/ORmrt4bfgf1XeXvzJWZpOsjpu9M6tYO+PmqDoxiVJN/fjMQVqz/ zExM8FnNH5/pANfmnQe4z7RMBMyyPPY+MjUv9fvL3+vQPKwEVmWddWs232v7S2Z6 Onf/lGtNHSFnrjjAX+vOM1YcoElxgCbFAZoUB2hSHKBJny/M2myWUeyrdU3K+Vxj Ua3lWSfO2pXyW+vTOc6uiMCGt69rRC/r7e21EzGT7dpelGcrjY7pToT9OLsW3SHR lrZHmI/dD9c0VOg3jzxb7cTM1G0i5mj6/KZTjCTdco5BjCTfv2Mc5bwtjfboVpU9 OekEPjSWgHGrdmJmArxlsubBBDqA+T5yeS3Qad2CalvUo3kxT+vQ+j1MuGonZiag Az8weyNz8vKoMjIJPEw6dfHYcU6URx9LHeF6s2aUEyXSdA3pqXmrdmJmAunvwi0z 6YhG6X30EPKjbm4CcVWNXTLB7Y1MLaN5uZHeTszMEe+nVWRGzWSy8HeTzvbUQx6P INHW6r8e/5/J07U9ZvOtdmJmvqetWbVY31f5iddw56A4QJPiAE2KAzQpDtCkOECT vqdiZnIiOszoug5VsVtZfefjEZ7Vv6GsY3ULuqrjLM3U7Rs7HE33/Oyfua7i6w79 koP02T76f+nUt6rjrM3EBDfTR4ybqSa7mbrfntGpo1HDaVvBmLM1UwMK02k1E3P4 bPE9MzW6RLqH7bRsnZnzm87PcZX+ETM1mKxmEhj2J6DKTD6j0aiQmqnvP8Jze2Zq +EzN9O8tK83UKI/O3lvpzOY+2+t3RR5B8tlc46pa59mb+Z8qDtCkOECT4gBNigM0 KQ7QpDhAk+IATYoDNCkO0KQ4QJPiAE2KAzQpDtCkOECT4gBNigM0KQ7QpDhAk+IA TYoDNCkO0KQ4QJPiAE2KAzQpDtCkOECT4gBNigM0KQ7QpDhAk+IATYoDNCkO0KQ4 QJPiAE2KA9ToDy3EK2vz83ofAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -132.35,
    x: 346.95
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -123.95,
    x: 346.95
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -115.55,
    x: "326.7 331.5263 335.12437 338.7224 342.31324 345.9113 348.90245 351.90083 357.31959 360.31797 364.50846 366.90718"
  }, "&#x0414;&#x0435;&#x043f;&#x0430;&#x0440;&#x0442;&#x0430;&#x043c;&#x0435;&#x043d;&#x0442; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -107.12,
    x: "331.17 334.17964 336.57005 340.76045 343.76283 347.35563 350.95564 354.54844 359.35084 362.94364"
  }, "&#x0441;&#x0442;&#x0440;&#x0430;&#x0445;&#x043e;&#x0432;&#x044b;&#x0445; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -98.725,
    x: "335.9 339.4928 344.2952 347.89518 351.49519 355.08799"
  }, "&#x0432;&#x044b;&#x043f;&#x043b;&#x0430;&#x0442;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -81.9,
    x: 346.95
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_180)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,315.6,502.19999)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_182",
    width: 108,
    height: 31,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGwAAAAfCAYAAAAC0CiiAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAqElEQVR4nO3aQQpCIRgAYe9/CY/iRtCn3skwoqKi2j0HZvEh4kYY /FeGEMIUSpgxxllrnaUUbWqM8Qi2Nq01bW49rGuw3vvpl9FvKaX3YBvMaD3JORuM xGAwBoMxGIzBYAwGYzAYg8EYDMZgMAaDMRiMwWAMBmMwGIPBGAzGYDAGgzEYjMFg DAbzNdhaj+PQRj7+S3w90J7uwdYXYF/X/m5j8vw5rf9dAELhZA2na/emAAAAAElF TkSuQmCC"
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#ff3300",
    d: "M315.71 77.484H377.667V92.911H315.71Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_183)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,322.8,494.40003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_185",
    width: 84,
    height: 58,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFQAAAA6CAYAAAAulX7rAAAACXBIWXMAAA7EAAAO xAGVKw4bAAADFUlEQVR4nO2Y3W4qMQyEeXMehUfhhn94J44G6aumVhaVLaeztXox YjdrO5OJQ+KsVqvV/Q9vRZxAN8QJdEOcQDfECXRDnEA3xAl0Q5xAN8QJdEOcQDfE CXRDnEA3xAl0Q5xAN8QJdEOcQDfECXRDnEA3xAl0w/cCbLfb++Vy+Xhfr9f36/Wa HtTvFVSQoLfb7fG82+3ux+NxUnz9Ylu/8Z2JmYpT4fEUQ7563mw2n549tr+P+EQF 1SDIyvP5/HiXGGrjlzaJLxv9IuDpdHq0yU6/asNP77TJhxijePgxEfrVBNd22TLx 1X8RgkJSwowG5oKSDRpEzQy9u6CKdzgcPmLyjUlzYXwi5ceEVEGZPLWP/BcjKFnq 2TESlDb/ayBDGJgLShZpmVZBmRTiahn7ykA4j4eIwsh/EYJqcCLmm9GUoHqWrf/v MjBEcn8NUj4Sw+2xxZ7serbk1afiuaDVfxGCMghfwnr3TYjsIesYKIMho4hBTEHL Xu1sMPJlwyGefmu/U89sgCP/RQj6qvA/2WcAP9eZsuJN/1NLRpxAN8QJdEOcQDfE CXTD9EeOGV4T0+6bi5/hps5z+NTvr2xUsvvKPQC2o7G8ihmnkmkxOfRyMNez1746 u7mdQHVCHc75T/b4em3usWrfVDwSh1jOBVuvshDXOcGr2lKI1P68zYsRH9MsQb2q oc0HDkmI1NLRyXkVhV+NxbP65MBNwTCaXI/N4RxBEQ5bhPDKCE61P9eB60gvNGZn KJlTqxdsGBzknwnqgrm9x3Jx6wDI5ClBuexQVeUiq22/3z8VdNSfZ+jo+7eWvC8l r8u9pq6ZNspQDdav32ost+U+lCx7lqHO0+8EyC7q9lE/o/7gT7snwGxBuUSgcxeH ZSgbtxOmfLjgqDW1x8K/9uWbjtuyJP1qTu/ehoCKqxjwY4Mb9UdcbqLw9e8vC/pO jDaJxvj/nWi25x5bfiHiBLohTqAb4gS6IU6gG+IEuiFOoBviBLohTqAb4gS6IU6g G+IEuiFOoBviBLohTqAb4gS6IU6gG+IEuiFOoBX+AQqWq3rre8c6AAAAAElFTkSu QmCC"
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -93.7,
    x: 346.95
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6.025,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -86.5,
    x: "331.6 334.60047 337.60093 341.19786 344.1923 346.59025 349.5907 352.59117 356.18208 359.18254"
  }, "&#x0423;&#x043f;&#x0440;&#x0430;&#x0432;&#x043b;&#x0435;&#x043d;&#x0438;&#x0435;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -79.275,
    x: "325.27 328.26399 331.26399 334.26399 336.65797 339.65797 343.25196 346.25196 349.24595 350.44593 353.4399 357.03993 360.03993 363.6339 366.0339"
  }, "&#x043a;&#x043e;&#x043d;&#x0442;&#x0440;&#x043e;&#x043b;&#x044f; &#x0432;&#x044b;&#x043f;&#x043b;&#x0430;&#x0442;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -72.075,
    x: 346.95
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_186)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,315.6,520.2)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_188",
    width: 108,
    height: 51,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGwAAAAzCAYAAAByvu3vAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAA40lEQVR4nO3cPQrEIBQAYW+eo+QoaQz50Tu5iCG7adwyDkzxgXbC 8CxfCCEUobRDzrls26YB1TbLsnyD7ftezvPUwFJKZZ7nFqxe3n6Q/rum7BlsgD9a P2KMBiMxGIzBYAwGYzAYg8EYDMZgMAaDMRiMwWAMBmMwGIPBGAzGYDAGgzEYjMFg DAZjMBiDwRgMxmAwBoMxGIzBYAwGYzAYg8EYDMZgMAaDMRiMwWAMBmMwGIPBGAzG YDAGgzEYTDfYcRyvby7TU23SnTCN6w62ruvrj1FfnbRpmlqwygWXY7t2JZYPxCsH MitcDuUAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#ff3300",
    d: "M315.71 47.148H377.667V74.796H315.71Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_189)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.59999999,327,508.2)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_191",
    width: 71,
    height: 93,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAEcAAABdCAYAAAD3/XviAAAACXBIWXMAAA7EAAAO xAGVKw4bAAADwklEQVR4nO2ZW1LsMBBDZ+cshaXwwxv2NLdEcW6JLmd4BgmKD1Wc TrstK+2Zdnw4HA7HP2wiTqAZcQLNiBNoRpxAM+IEmhEn0Iw4gWbECTQjTqAZcQLN iBNoRpxAM+IEmhEn0Iw4gWbECTQjTqAZcQLNiBNoRpxAM+IEmhEn0Iw4gWbECTQj TqAZcQLNiBNoRpxAM+IEmvG60/n5+fHq6uqF7e7uLk28Qxzh4eHheHFx8dTW9f7+ Pk28R5zHx8f/2YJQl5eXTzaADfvt7e3x7Ozsqc/Nzc0LP4+peOrjNkEZK+i5XgY+ uhJDbcWedvW/vr5e9v9ycVwUXZkwxHiGCLJJHJ80Wcfz2d+viKjragxsujIGdo2F GKv+u4jDoJr0KXH8TdLWM/Vz8dTmrXpWuji6Z4LyEwf6EcvFUbaQtbKv+u8ijpaI BvClshJnLhGfrPpuZY7aCO/izLd9KnN8ySPOO7Pl/eKI9Fy3p5YVQEj1J0v4Mccm P9nU5s0iju7xWYmqK/+kLCmyVlj13yVz3gIn/gvwtQH9H+MXIE6gGXECzYgTaEac wAvwDyXwt/4nzjOogz5Zn3y/OBR1qkm0Z5HNq8+5Z8LP6x6vk6iGvf1WG1lGXFXG PPeaZuWzmzi6Kt29kuUZz6efRJKAVNgISzFIofaabbb1XLEUl/b8WrDy2UUcvXWf LIN72b7ymxPCj2yTLyJv2SguEcw3sM7Dx9ry+XJxfCDf6XrmMLHp50vO3x5LwPdb K9sqc8iEKbr7bvnskjn+2+F7IMAeZ/qxn2LiPlH//nLKtlpW/HB73LmsVj67iPNR /OCvhvsP4qn9wxAn0Iw4gWbECTQjTqAZcQLNWD/gGy7fhWWjZuHrvmyqbfzfyKtn P6OSjXjEWN3L18/D2KdRMXutsoo/+3Ia4fur6fNhcTzALND8Y7p8OC3Y+kiOP6cQ xPd79fPrFGVW5zP+7Ovzob3l8y5xqGqxeZsjEfkoe5i42r4pZfvgezAfZ1UDcURD dTszhJ39Kv7suxJny+dTmeP7IgUnZXk290T+XcbF4biGo1q/J5ZsfqxCtmhcz96t +L6rn+Js+XzoN4cATnZ+stiyubCcMRFDz+a9C+17IjD3VjP+7LslzsrnzeI0wZfV NyM/+T9xfibiBJoRJ9CMOIFmxAk0I06gGXECzYgTaEacQDPiBJoRJ9CMOIFmxAk0 I06gGXECzYgTaEacQDPiBJoRJ9CMOIFmxAk0I06gGXECzYgTaEacQDPiBJoRJ9CM OIFmxAk0I06gFv8AKdc9sGt5FMQAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -80.25,
    x: 346.95
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -73.05,
    x: 346.95
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -65.85,
    x: "331.6 334.6 337.6 341.194 344.188 346.58799 349.58799 352.576 356.18199 359.18199 362.16999"
  }, "&#x0423;&#x043f;&#x0440;&#x0430;&#x0432;&#x043b;&#x0435;&#x043d;&#x0438;&#x0435; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -58.625,
    x: "332 334.994 337.98799 340.38798 343.98197 346.98197 349.98197 353.57597 356.57597 358.96995 361.96995"
  }, "&#x0430;&#x0432;&#x0430;&#x0440;&#x0438;&#x0439;&#x043d;&#x043e;&#x0433;&#x043e; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -51.425,
    x: "329.1 332.094 335.094 339.288 342.288 344.688 347.68199 350.08198 353.67597 356.67597 359.66996 362.06394"
  }, "&#x043a;&#x043e;&#x043c;&#x0438;&#x0441;&#x0441;&#x0430;&#x0440;&#x0438;&#x0430;&#x0442;&#x0430;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -44.225,
    x: 346.95
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6.025,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -37.025,
    x: 346.95
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_192)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,479.4,243.60002)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_194",
    width: 89,
    height: 38,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFkAAAAmCAYAAACvfze7AAAACXBIWXMAAA7EAAAO xAGVKw4bAAAApElEQVR4nO3aMQrEIBCF4Xf/S3gUS1EPNcGwW4SQalfEl7/4U0wl H2GqkaSg6SlqrdFaowmllEI55+UPca6UEhqf76D3fg7pt4bjI/I5WL+/tu9mCjLI WwYyyB6BDLJHIIPsEcggewQyyB6BDLJHIIPsEcggewQyyB6BDLJHIIPsEcggewQy yB6BvBqZ09lJp7Mcgc/tsx10kaf/Nn5ird5fb+gAsfhCd5Ej7bgAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#7030a0",
    d: "M479.14 331.64H530.164V351.80003H479.14Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_195)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,481.8,226.80002)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_197",
    width: 81,
    height: 95,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFEAAABfCAYAAACQhStGAAAACXBIWXMAAA7EAAAO xAGVKw4bAAADD0lEQVR4nO2YW47qMBBE2TlLYSn88IY95aoi1ajVMlyJQTqmNB9H 5J3jSjvE3mw2m+WPX4MLJIALJIALJIALJIALJIALJIALJIALJIALJIALJIALJIAL JIALJIALJIALJIALJIALJIALJIALJIALJIALJIALJIALJIALJIALJIALJIALJIAL JIALJIALJIALJIALJIALJIALJIALJMAKnE6n5X6/L/v9fl3Xr9a1/Xw+L7fbbeV6 va7sdjs6sPlCPBwOa0g1RK1ru/cdj8flcrn8hEk7f2WI3qcAVaW087QhdmqICs44 0MmYI0R1Wb0D9dtDVAX6d7vdruc57Ekqc44Q/9edH4/HT9g+TqFPUpnfEaL2uUvT ztOF6Iryp4t+XWF9nz97aOfpQgwBF0gAF0gAF0gAF0gAF0jg9QH6vPCIoc6oTCA+ E68P8EhB32eempr0W23eEPWBW0cNNUSNY2uFeruDr2ib9ruqNfJwRWtk4nUf75FL xePrfg1dW8vaVsfW2qZ9z1w9InJbdbw/9Ef3fjtEz+N51FDDqhOlnjiQgOX6hIJH IRZ2A+pEgwPRsgPzss/v1/CD1rruV0Nw40eu7llua23b6N5vh9hnSuqNajW4Qf0J 17Gw36+14mqItSJ8zxq2GF1D52u9Ttz6PFfiyNW/o940uvdbIUq4drseoqRHEwLP QnQjdf6oEmu1PwtxdI36rvYDqBX9zLX2mNH7/tchqkF1zq4/fb+ftCzB2jVeheju MarEOnfoChqF2K9Rw3KI9R3o7tldew/4eIhuvF+2FW/TcZ5ZERL0ufXPx+8Uz9AI nefj3Rj/+dSXeD3OD7dfQ8c7dC3relrWNi+PXKunj6/r/d5vhzj6nPn0Z06viC9k vKNWUN/np/gpiV4RXwgukAAukAAukAAukAAukAAukAAukAAukAAukAAukAAukAAu kAAukAAukAAukAAukAAukAAukAAukAAukAAukAAukAAukAAukAAukAAukAAukAAu kAAukAAukAAukAAukAAukAAukAAu8PX8A9BtAHKjplelAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -360.38,
    x: 505
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -351.98,
    x: 505
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -343.58,
    x: "499.75 503.94999"
  }, "HR")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -343.58,
    x: 508.13
  }, "-")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -335.15,
    x: "484.77 489.5724 493.1724 496.77238 500.36518 503.96519 506.9604 509.96278 515.3556 518.358 522.5484"
  }, "&#x0414;&#x0435;&#x043f;&#x0430;&#x0440;&#x0442;&#x0430;&#x043c;&#x0435;&#x043d;&#x0442;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -326.75,
    x: 505
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -318.35,
    x: 505
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_198)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,479.4,267.00004)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_200",
    width: 89,
    height: 19,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFkAAAATCAYAAAD7yKGlAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAfklEQVR4nO3YOwoAIQxF0ex/U1YifvaUIYIDw7QGMdziNpZHsXgi IkruieactdZKDk3kMYa21siplJJKKeU96L0fv/kImeMyNd8P8jw4/39d388UZJCv DGSQYwQyyDECGeQYgQxyjEA+jUz7m8hMnb7NqdOet432Jk57W6P9A0dzV9/MNrqO AAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#7030a0",
    d: "M479.14 319.29H530.164V328.16053H479.14Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_201)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,484.8,259.80003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_203",
    width: 71,
    height: 46,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAEcAAAAuCAYAAAB6SwSNAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAB3klEQVR4nO2VW27DMBADffMcJUfJT97JnVzQwBSEYRd124BE0A9C lixrZ7mrZBiGYfzXquIAzYoDNCsO0Kw4QLPiAM2KAzQrDtCsOECz4gDNigM0Kw7Q rDhAs+IAzYoDNCsO0Kw4QLPiAM36esPhcBgvl8s0FsD2mPN8Psf7/T4ej8fx8XiM 1+s1Ddthzn6/nwzxtdvtNhmm0aW9PKvL2K9n36M1dSBrOsvjaU3PKob27Xa7xXPn 8TSHS8X0Lj+fz9OactEenak532u+2RwdOjdHcyA1+jOJMQpQECTLugD51hPGNMEq jkaJRD3peTy+1SjBzTPn+F4v9mZzPIib44Akp+smA9yc0+n0WVmH0F69WzJH51NV 1rWfyq/F84QxEgaPgcEate75bL5WOoTrwDWjDT05r6p3ztJvFMmsdY7H4arMu3Ye zwtJ58EIA+tupM7/UefgPJV0ODeHd9xh7jZJUHVdU70Hds0coEma74m/FE9nMtd+ cXu3+G8ORadznGGTOd+Rt/PadfxLLcXDmBfE+90B3H3EP8erzFmKV2vOmysO0Kw4 QLPiAM2KAzQrDtCsOECz4gDNigM0Kw7QrDhAs+IAzYoDNCsO0Kw4QLPiAM2KAzQr DtCsOECtPgCKgdnceQXD8QAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -328.85,
    x: 505
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -321.65,
    x: "487.38 491.574 493.374 496.968 499.956 502.968 504.16798 507.16197 510.15596 513.15597 516.74996 519.74996"
  }, "&#x041e;&#x0442;&#x0434;&#x0435;&#x043b; &#x043a;&#x0430;&#x0434;&#x0440;&#x043e;&#x0432;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -314.45,
    x: 505
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_204)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,479.4,279.6)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_206",
    width: 89,
    height: 37,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFkAAAAlCAYAAAAp60UVAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAApElEQVR4nO3auwoDIRBG4XlzH81G8PZQhtllN6RImiiJP6c4OKV8 DFaamQ1ano0Y48g50+RSSk/k1hotyhf4QK61/vwyqvlGvyD7+Qfv1/Y5LMgg7x/I IGsEMsgagQyyRiCDrBHIIGsEMsgagQyyRiCDrBHIIGsEMsgagQyyRiCDrBHIIGv0 Ebn3fsz0Xe74Fpnmd/9P9uF6LmhepZQRQjiRaW0PeY6IF8GoyJIAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#7030a0",
    d: "M479.42 296.45H530.16006V315.509H479.42Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_207)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.59999999,482.4,266.4)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_209",
    width: 81,
    height: 82,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFEAAABSCAYAAAAsGziYAAAACXBIWXMAAA7EAAAO xAGVKw4bAAADLklEQVR4nO2YbY6CQBBEublH8Sj+8Vvv5KZIypSdIWGB3YKKP15U GGbe9DQjTdd13evLbOwCCdgFErALJGAXSMAukIBdIAG7QAJ2gQTsAgnYBRKwCyRg F0jALpCAXSABu0ACdoEE7AIJ2AUSsAskYBdIwC6QgF0gAbtAAnaBBOwCCdgFErAL JGAXSMAukIBdIIHhk7vd7nW73d4cDge37FoZPnm/31/H47H/jgDityuQOi4Wt+Xx fD4XGw9jgFlB3O/3fdD0GLIRQYXs4/H4yFC0vVwu/XFtf71e+2On0+kdDF6rbdke /QBcp4vJvtEPzrEt2+Ac2uA4/PCp4zHI1bvVTu8+ek8Kog5AGMA6KIPICet5TIzy 2q9er4Hg6uN7zTZdxPP5/OHXCqJuRzqvutDaDsnD8+iPd+JimYgMqBmF78yOGkRm ECengWgFUSfLQGOC6IeZxyAykzXomq2aSTqPVhBrO/ZD18lB1NsIAzObKK0yuldS BO00m3C9HmsFEddiMprZemtiofBbg4vF1gWAL9rhnPoNBbG2o+MimchAUAgdUpiZ igkxy5hxoN7S+I3bDwHidsDrayZyD9VbmQuI6zke+tTrcR23DvSN31xw3V/ruLUd twoGceQf6bx/sdZANcPGUvfgDTGvA95aemzqo8aGn0PtAgnYBRKwCyRgF0jALtCD Rw99hPoNY/+Q/vCPa5mO9FlRqxPCZy/Wxlof87lP3xRpHY0+ea2Ox2OsMHhtqz5v tVtdEOsEWSPzqV8DW+vj+lxZ63acR5bqQrXqblYXXMih+nxkFbKOILKe1fKpttOX ExrEWt/W/liCMsO0zkWGa30+1G71QeSbEe5zfADHpFj/MsNYA7P60WMa5NZC6dsj BKdVn7farTKIWp/qi1xMAuieyMDU12oIor7g4HtD7mGtMbjv6RbSqs9ru1UGcUrG BvG/A264Pl5PEEOxCyRgF0jALpCAXSABu0ACdoEE7AIJ2AUSsAskYBdIwC6QgF0g AbtAAnaBBOwCCdgFErALJGAXSMAukIBdIAG7QAJ2gQTsAgnYBRKwCyRgF0jALpCA XSABu8Dm+QENxamXS0BlTAAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -321.9,
    x: 505.15
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -314.7,
    x: 505.15
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6.025,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -307.5,
    x: "485.07 489.26344 491.06489 494.6618 497.66227 500.66273 501.8617 505.45863 507.85658 510.851 513.24899 516.8459 519.2378 522.2382 525.2326"
  }, "&#x041e;&#x0442;&#x0434;&#x0435;&#x043b; &#x0440;&#x0430;&#x0437;&#x0432;&#x0438;&#x0442;&#x0438;&#x044f; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -300.28,
    x: "491.65 494.65 497.638 500.65 503.64399 506.64399 509.64399 512.638 515.638"
  }, "&#x043f;&#x0435;&#x0440;&#x0441;&#x043e;&#x043d;&#x0430;&#x043b;&#x0430;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -293.08,
    x: 505.15
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -285.88,
    x: 505.15
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_210)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,315.6,550.80007)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_212",
    width: 107,
    height: 31,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGsAAAAfCAYAAADgDDPbAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAnklEQVR4nO3bQQrDIBBAUW/uUTyOGr3TlLQ0BArZdj78xdsLn3E1 U0opIYwSrbUYY0TvXQnNOaPW+om1947jOJTYGewda63198fo2TlhP7ES/Mu6MRaI sUCMBWIsEGOBGAvEWCDGAjEWiLFAjAViLBBjgRgLxFggxgIxFoixQIwFYiwQY4EY C8RYII+xlNMVy/Xp/K71aQ8TcvseJrwAeUIVCJDGg/0AAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#ff3300",
    d: "M315.71 28.332H377.262V44.331H315.71Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_213)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,328.8,543.60006)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_215",
    width: 66,
    height: 58,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAEIAAAA6CAYAAAAEJY9EAAAACXBIWXMAAA7EAAAO xAGVKw4bAAACnklEQVR4nO2YW27jMBRDs/MsJUvJT97JnjKggVMQgpNJ6wnIdvpB WJatq2Pqqr3KarVa3X81KQ7QojhAi+IALYoDtCgO0KI4QIviAC2KA7QoDtCiOECL 4gAtigO0KA7QojhAi+IALYoDtCgO0KL5B9vtdhL3m83mfrvd0rAZIy6Xy8f9+Xz+ P42QZIQMWa/X9+v1Ol1Pp9NkiqS23jsejx99btZut5v6GIuh9JFxmkd9iqN7xVAf 86uPuV5pz41fZARZsd/vJ1Cg3Siuh8Nh2j5q6woQVyCJoz59OHPoyjOZpBjqU/vR vN5WfN6dG7/ICCZyZx8ZQZ+vtMzRx+k5q63navMe2YQRGKN+3vOsIZucAaOfjV9s BGn2bDU8CwSjtgSEtghGeEYALMMwQluId8YFmWtrDh/3aPwiI+b22SMjWCnfs7oH 1I1Qm9hA+9Zgdbn+bWvA92z84ox4RQ72jfVrxD8z4ocoDtCiOECL4gAtigO06PFD /t9TsdFPhTdWhJKX0iqq5mKon4rTY0kqviiK/OyifhVeXqX6e14vUNF+8qD4+CFB vNiRKGIEJECdRbyk9ZPrXAwHHytO2orJh2IolarM5vzjRRRzwcJhcbERHFpGxwmO EcDzrld7czHGDJszwitQDmiYRslOSe0fT5uq1ivdLxsBsNfvvtoY4aBjRszFcCP8 eO4ZN6a0mz4esjDHs8wPeZyDFv+N8DOHnxHGZ56+7M8xhq+Y/6bhRngW+Zjxtwx4 /ODl8f1ovsiIua2C027WJ378+LJ8ld+k11/mj9YI+GLqLZJS/82Gv/cDvpHiAC2K A7QoDtCiOECL4gAtigO0KA7QojhAi+IALYoDtCgO0KI4QIviAC2KA7QoDtCiOECL 4gAtigNU6A+IDlmq0QPjuQAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -44.775,
    x: 346.75
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -37.575,
    x: "331.4 334.4 337.4 340.994 343.98799 346.38798 349.38798 352.37599 355.98197 358.98197 361.96998"
  }, "&#x0423;&#x043f;&#x0440;&#x0430;&#x0432;&#x043b;&#x0435;&#x043d;&#x0438;&#x0435; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6.025,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -30.375,
    x: "331.6 334.59446 337.59489 341.78828 344.7827 347.18067 349.57258 352.57304 355.57347 359.17039"
  }, "&#x0430;&#x0434;&#x0436;&#x0430;&#x0441;&#x0442;&#x0435;&#x0440;&#x043e;&#x0432;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -23.15,
    x: 346.75
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_216)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,617.4,247.20001)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_218",
    width: 105,
    height: 36,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGkAAAAkCAYAAACKRBSIAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAsElEQVR4nO3bSwoDIRAAUW/u0WajyKh3MphAPiQwSy1SiwcuGwp7 1yGEMLS9MI7jGK21UWvVRs7zfEUqpSwfSL/ND/QVab611mWkDfbv30spGWl3RgIw EoCRAIwEYCQAIwEYCcBIAEYCMBKAkQCMBGAkACMBGAnASABGAjASgJEAjARgJAAj ARgJwEgARgIwEoCRAC4jaS/PSO/ltI952BdjfESacs7L73L0qfd+b3MDUwxFxgr+ C9QAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#7030a0",
    d: "M617.54 329.03H677.634V348.207H617.54Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_219)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,621.6,230.40003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_221",
    width: 91,
    height: 94,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFsAAABeCAYAAABM+2gqAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAD8ElEQVR4nO2YW1LrQAxEs3OWwlL44REee+JWp+qkhO6MTQxJB5qP rjhjzfhInoel3W63e//TxWQHSJIdIEl2gCTZAZJkB0iSHSBJdoAk2QGSZAdIkh0g SXaAJNkBkmQHSJIdIEl2gCTZAZJkB0iSHSBJdoAk2QGSZAdIkh0gSXaAJNkBkmQH SJIdIEl2gCTZAZJkB0iSHSBJdoAk2QGSZAdIkh0gSds6Pj8/f9DT05PbkZ+grwVb QX55eTlcX4Ez167TO93e3h4CvN/vPwSe+29vb++vr68HG2b83d3df6tB/dUuO+wZ R2Po+uHh4WgvW9l9dgyudb+POWPFhj7Vt9Gzzx5snBNYB+Le/f39wSldPz4+HleA AHUte8FrDP2nTTY3NzdHe9loLO6pv34JjsYejcGEUH9eOM8kSCNW+tc++DZ69tmD LTg9cPT2AaINMIKHEwRC19xnhmncbs+9+vzK1Meo21v9j2as/DKL+e2+X2wbAaL+ 78HGeWkUPBzSrGTG0ndmPwv2aAxs6jahe5V9xMoMZ0X08+iiwa6zoc5YHGNpcp89 dRZs3devluRoZo9mWHd4NAYvgMnAswl43UYqK2OPtpGLB5vA9sOuzhgOGdrkFG3s 8wRa+zOBrIdT3ePrPsyWUQMwGkNBgYfZqmu9kH6YV1buj86j0bPPHuzRN7VA69by VfWV8Et0Wge+Jnq7ZgKz4TvUP8F+iewASbIDJMkOkCQ7wLdJ+zt7fL2+ItkBvk0k MPxuqF38BfsUkaAo4HyXX5HW4UliSEJoV+Kgaypz9OnVMZwmq+tJSk1C1E5Vbql9 jal+OpIY1eRlZrvkW03matGrc2wOtgZRVkUWhsM14SABqcGumR9O0A5odYLqHsmR wGfta0yUYnk2WWHNfme2S77V1F4vaMaxOdgkKzyUN97BAaLeIPtaHaw1517rqM7V PrP2JaZavq0BrOXUNduZbz2jnXFsCjZvvVbAKmxfTixBZuAo2MxsZlUdq24RtUjU 29eYatVvKdgz25lvNdhLHJuDPSpdzpZahavVQLWxLeCExukVwFpLnrWvMWHzmWDP bJe2kRrsGceXthEOAKpizDT2KA4Rivf9MAK2H5C9Vs29vpx7+xITDvPi6aPDGMY1 25FvvX2JY3OwT9Go/NgPz5Fm1b34qt9asPtSoja91K/Oss+0/2DZAZJkB0iSHSBJ doAk2QGSZAdIkh0gSXaAJNkBkmQHSJIdIEl2gCTZAZJkB0iSHSBJdoAk2QGSZAdI kh0gSXaAJNkBkmQHSJIdIEl2gCTZAZJkB0iSHSBJdoAk2QGSZAdIkh0gSXaAJNkB kmQHSJIdIEb/AEvsUD2Hgi+NAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -357.28,
    x: 648.05
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -348.88,
    x: 648.05
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -340.48,
    x: "627.82 632.61746 636.21548 639.81356 643.40438 647.0024 649.9935 652.9919 658.3817 661.38009 665.57058 667.96926"
  }, "&#x0414;&#x0435;&#x043f;&#x0430;&#x0440;&#x0442;&#x0430;&#x043c;&#x0435;&#x043d;&#x0442; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -332.05,
    x: "624.97 628.5628 632.16287 636.3533 639.97488 643.5604 647.1604 650.75326 654.9436 657.3412 661.53158 665.1316 667.52926"
  }, "&#x0430;&#x043d;&#x0434;&#x0435;&#x0440;&#x0440;&#x0430;&#x0439;&#x0442;&#x0438;&#x043d;&#x0433;&#x0430;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -323.65,
    x: 648.05
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -315.25,
    x: 648.05
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_222)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,617.4,271.80003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_224",
    width: 105,
    height: 30,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGkAAAAeCAYAAAAvpTBDAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAsUlEQVR4nO3aOwoEIRBFUXfuUlyKiSJ+9uRQ82m6YegO9cENjoGR cCmjcs65aUIIs5SCTcQY56+Ns8Mueu+ztYaNWJMjkpVb/SD8952oa6TVY44ya633 kU7/IBZJKRFpd0QSQCQBRBJAJAFEEkAkAUQSQCQBRBJAJAFEEkAkAUQSQCQBRBJA JAFEEkAkAUQSQCQBRBLwGAl7OSKdy2Eftmbsvf9EMjnn5ZubuBpjvNu8APpPWxbP E5P2AAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#7030a0",
    d: "M617.54 308.01H677.634V323.647H617.54Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_225)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,617.4,260.40003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_227",
    width: 105,
    height: 70,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGkAAABGCAYAAADPeLrZAAAACXBIWXMAAA7EAAAO xAGVKw4bAAACdklEQVR4nO2WW67CQAxDu3OWwlL44Q176pWRLIUopfSCcBX54wg6 pBMnnqYMwzCMZvXIBRib1AK5AGOTWiAXYGxSC+QCjE1qgVyAsUktkAswNqkFcgHG JrVALsDYpBbIBRib1AK5AGOTWiAXYGxSC+QCjE1qgVyAsUktkAswNqkFcgHmGybt drsHKxD7U1j3drsd7/f7Ok2CwNvtNl4ul/F6vT4+N5uNvHm/AuagbnA8HtdpEgyK TxBMAqfT6QnExHUayRMI8J374Bpx+/3+KR/vj4cB3/l7js85q3yHw+HRYOqcWqvy n8/np1zYs6q9iqt0Uy+vq3oXm4QTFK+xOYXhEybikyeOayyca2haFM374hqbR8P5 W9SQ43POKh8nAOPQjGqtys/c2A/fOf6q2nNcpZv64mHJ9X7NpJw8isIartkMnpZY CAqsms4G8L5YWNyjyskG5dh4TzSzmhY5PxuO/aupEvuU4+a0TNX78bjDZvEFSqHx JNAk3p/3xO/x8a/yxcMw9SRVOat8uJ9PCvVXa1V+vo9owCuTctzUkzRX72KTOJKi 4NxwCopxTIg1zOv87uL7Ymp8ca8pk6Zy5nyxgXmE5rUqP67jgXplUo57x6Sq3sUm AZy4/ILNj2tsDOd1jsE++a983pOxMDGOoBz/KmfMx0bkvNValT9ODY7wSnsVV+l+ p95/mTQHTlBOMPMS/JglOfPpnVpbOXIBxia1QC7A2KQWyAUYm9QCuQBjk1ogF2Bs UgvkAoxNaoFcgLFJLZALMDapBXIBxia1QC7A2KQWyAUYm9QCuQBjk1ogF2BsUgvk AoxNaoFcgLFJLZALMDP8AZzcHIuJU/UhAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -328.15,
    x: 648.05
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -320.95,
    x: 648.05
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -313.75,
    x: "620.22 624.41397 626.214 629.808 632.79598 635.808 637.008 640.002 643.596 646.596 649.584 652.596 656.19 658.59 662.184 664.57809 667.57809 670.57809 672.97207"
  }, "&#x041e;&#x0442;&#x0434;&#x0435;&#x043b; &#x0430;&#x043d;&#x0434;&#x0435;&#x0440;&#x0440;&#x0430;&#x0439;&#x0442;&#x0438;&#x043d;&#x0433;&#x0430;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6.025,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -306.55,
    x: 648.05
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -299.33,
    x: 648.05
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_228)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,617.4,292.80003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_230",
    width: 105,
    height: 30,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGkAAAAeCAYAAAAvpTBDAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAApElEQVR4nO3aOwrEMAxFUe1/U24Mxp89eVAYMo2ZlNIjtzhgUhmu o0pmZhvp2S6l7DnnHmMgCe/Re/9FWmuFXwpn/gNdkVpr90c/I9ZjpATz9/VqrUTK jkgCiCSASAKIJIBIAogkgEgCiCSASAKIJIBIAogkgEgCiCSASAKIJIBIAogkgEgC iCTgMZIv5CHWcaWL5ci87kh+iH49OPuOwPgZjP8+I7VkEQd9H8cAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#7030a0",
    d: "M617.54 287.36H677.634V302.51399H617.54Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_231)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,628.2,277.8)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_233",
    width: 70,
    height: 82,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAEYAAABSCAYAAADpaaIJAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAC3klEQVR4nO2YW47CMBAEc3OOwlH44Q13yqqRCo0sA0l2s90r7UdJ ie3Y5bEdJgzDMIz/dLELpGIXSMUukIpdIBW7QCp2gVTsAqnYBVKxC6RiF0jFLpCK XSAVu0AqdoFU7AKp2AVSsQukYhdIxS6Qil0gFbtAKnaBVOwCqdgFUrELpGIXSMUu kIpdIBW7QCrzHthsNuPxeBz3+/242+3c8hmBUVBut9t4Op3Gy+XyuFaQAibhDYyC cT6fn/faMQrOdrt91IHaHA6H5/39fn8+Q1BVX/sF9UW52ojr9fqo08JQrn50rb51 rzr61mKpjEWrzqsERoII1TKuFSSOF9c6cjxDwAgGAVMfBLkeTz1H/0yaa46yynSv vhhH5bRROc+tFhhNrD067wKjVayBURkTadu2z9cAcM3KU66xCYj67QW17fNXjhLH pQ2MIGDtjmklWfVXgWE8jcUOY9K6p392neo5VqprHVcJDC9fVr59JzAxSfJe4Frl bGugbd1RbWAYq9bVY0VgCA59193Ge3C1wEyBd0UtQ3xuX3VyBn62Q61M/RVigkvO uYJiTAcsg/4F7AKp2AVSsQukYhdIpV+hxIhfEn4daln9XiEnIVdRmer0CzW1n147 6nVPfqJcao5bzZ10Ta4z4VeyX0Huoc6Ul9REinpyDNLymurXb5wp/fTaUU9epCz4 VdtXbrWcRavZ9qLAaCWINIOTiWriNfkiO6WuZqlT+um1ayfG9Ry3NjA1a18cGP57 0SCfdkz7cVi/hKf002vXjqMdI+a41XIWTMfxW4Ghw0+DE4y67ZGY2k+vHfWscB1n qltbXr/fFgUmhaXfWT+Af/LvMP637J98KHaBVOwCqdgFUrELpGIXSMUukIpdIBW7 QCp2gVTsAqnYBVKxC6RiF0jFLpCKXSAVu0AqdoFU7AKp2AVSsQukYhdIxS6Qil0g FbtAKnaBVOwCqdgFUrELpGIXSMUuEMkXIchCDjysfZkAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -310.85,
    x: 648.05
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -303.65,
    x: 648.05
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -296.42,
    x: "633.65 637.844 639.64407 643.23806 646.226 649.23806 650.43807 654.03207 657.03207 659.43209 662.4261"
  }, "&#x041e;&#x0442;&#x0434;&#x0435;&#x043b; &#x0440;&#x0438;&#x0441;&#x043a; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -289.23,
    x: "630.63 633.63 637.224 641.41799 644.41799 647.41799 651.01199 654.01199 657.01199 660.60598 662.40597"
  }, "&#x0438;&#x043d;&#x0436;&#x0438;&#x043d;&#x0438;&#x0440;&#x0438;&#x043d;&#x0433;&#x0430;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -282.03,
    x: 648.05
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6.025,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -274.83,
    x: 648.05
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_234)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,692.4,213.6)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_236",
    width: 134,
    height: 49,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAIYAAAAxCAYAAAAfttFcAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAuklEQVR4nO3dMQrDMAxAUd//Uh5tJ7mTiwtOE5qlUJEhb3gYNH88 Siml1OFC6tu29WVZemuNB6u19pzzJ4x1Xd9hwIhjD2MO7y6W+8zPYbxfYRyGPMxF A8JAGAiDXwgDYSAMhEEEYSAMhIEwiCAMhIEwEAYRhIEwEAbCIIIwEAbCQBhEEAbC QBgIgwjCQBgIA2EQQRgIA2EgDCIIA2EgDIRBBGEgDP4UBpzCsGSe6bRkfpylKKXA fpbiBUSgLvTNEbhZAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#7030a0",
    d: "M692.37 354.69H769.756V381.57H692.37Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_237)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.59999999,703.8,204.6)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_239",
    width: 98,
    height: 81,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGIAAABRCAYAAAApS3MNAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAEOUlEQVR4nO2aW27bUAxEvfMsJUvxT97JntyOgRMMWF7VaJSSsfkx 0Ium5nKoa2mkw+FwOA1aoJzAYIRohXICgxGiFcoJDEaIVignMBghWqGcwGCEaIVy AoMRohXKCQxGiFYoJzAYIVqhnMBghGiFcgKDEaIVygkM9hDi5eXl9Pb29on39/fq Af1UfC2BCi88Pz+fXl9fz2I0GNRPxNeFkACsuxCPj4+f+7S8v78/w68gQb/XfmLZ d3d3dzoej5/b5FFeth2rHOx7eno681LTcHzF9ePj47z+8PBwPs6Vr/Xs3KVCeJGi EDpG0SiQBue/UUEQUgXToLWkUFrGeIqgXBRHS22vcvAbeLpQK67kRggfW3buUiHo Gg0kkqUQFJopjMIyQB2jIHQ6eVwI4snr61p6Z3sOXQUIp33ahtMW16zrvfOzc5cJ ES/vTIjYLSshiNd+YlwIdV6cImIxshxap1l8iqPgK66rK7GdEN4xFNO7SdMD2yKr AqobV0J4wcnrQvj8vRJilQMh4Kxzc6WIZ8bVY2OTtRMC4g6fajR4dRnHtM38zXSm qYTBal3HtFQxFENxycN/Afk9V5ZDBadY5OAmgPUVV8+tPFyVq3OXChH3I8ZO5P64 gq4Y//ZDdRy3g7FwOrYXwXgFXTHKCQxGiFYoJzAYIVqhnMBghGiF7QD3bfyJ098/ RHeU29rMDV05l5c4tXhb3B6TK/Of/IEx5s3G5c8rblLGWMYXufHkHuN2EQKjDKK4 p+48YhW4m0pRMjdUcdG5dPeT9cyp9WIhijusUYhV3tW4yK39GJSRT7RknFsWt5sQ 3l0gs6kzd5SOjI5q9Gk4j7ufsUsV53aHO6QYe1qyjwJnebNxkRtgZ8TYaCLCbRW3 ixB0+yVCbLmj0VGNQrhV7edZCeFvBTHumDYRXLGrvNm4ojtL3hhLE0Ruq7hdhMCV 9K5aCbHljkY3NApxqVPrXevTXdYkGIxZ3mxcfi5vLs/hy8htFbeLEAzeHUnf9zd3 lKkpc1Sjf+TuJ/Ns9JniNnkyvvwpZ3mzccXcKiI3BR7rhc/GEON2E+ISoW7EHf1u fC3BDbmjvYUYjBDXhnICgxGiFcoJDEaIVvi/J3QLQU+fPPyt/KpVvODOLvGrPHqY 2/p+Nua+CSH01Bu/rtsSIovHZIt2AnmIJ49y8KyD+bfKfRNCqBPdk6L48R2Fv6fI 4t3tdMvZva34dR5GHKbdKvfVC+EOZ7RGsncaW/HxM3kXwgsbhfAv0Fe5r14Ifz9A 17sQcWpaxfuLpUwIphwXQq6rf+zs/w2Ry9ULQUFwY+lGiu/rFDmLp6jkVAFdxMyd dWdUuSXUistNCDEYIbqjnMBghGiFcgKDEaIVygkMRohWKCcwGCFaoZzAYIRohXIC gxGiFcoJDEaIVignMBghWqGcwGCEaIVyAoMRohXKCQx+4xeP8MzuDQxsxgAAAABJ RU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -382.63,
    x: 731.58
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -374.2,
    x: "711.35 716.15237 719.7523 723.3523 726.9451 730.5451 733.5403 736.5427 741.93557 744.9379 749.12838 751.52597"
  }, "&#x0414;&#x0435;&#x043f;&#x0430;&#x0440;&#x0442;&#x0430;&#x043c;&#x0435;&#x043d;&#x0442; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -365.8,
    x: "707.15 710.1596 712.55 716.74038 719.7428 722.738 726.33798 728.7356 732.3356 735.9284 739.5284 742.53799 746.1236 749.7236 752.1212 755.7212"
  }, "&#x0441;&#x0442;&#x0440;&#x0430;&#x0442;&#x0435;&#x0433;&#x0438;&#x0447;&#x0435;&#x0441;&#x043a;&#x043e;&#x0433;&#x043e; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -357.4,
    x: "719.2 722.79086 726.38888 729.9797 733.57778 737.7683 740.167 743.7578 745.5496"
  }, "&#x0430;&#x043d;&#x0430;&#x043b;&#x0438;&#x0437;&#x0430;  ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -348.98,
    x: 731.58
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_240)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,316.2,357)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_242",
    width: 104,
    height: 37,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGgAAAAlCAYAAACu2qwTAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAqUlEQVR4nO3bMQrAIBAAQX/u02xEQfyTwSSYwiJlFrLFgHYHi3YX QghDaNeh9z5qrYKYPVageWmtCaaUcgWaxb4eRruc8x4I8Of+WkrJQGQGgjMQnIHg DARnIDgDwRkIzkBwBoIzEJyB4AwEZyA4A8EZCM5AcAaCMxCcgeAMBGcgOAPBGQjO QHAGgjMQnIHgDAT3GkgcK5ALXExrgSvGeNb6eu1Pj/v1jANjsIv4AbAuUwAAAABJ RU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#ff3300",
    d: "M316.4 218.58H376.01899V238.036H316.4Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_243)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,317.4,340.2)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_245",
    width: 104,
    height: 95,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGgAAABfCAYAAAAEY4K0AAAACXBIWXMAAA7EAAAO xAGVKw4bAAAD+ElEQVR4nO2aXW7jMAyEc/MepUfpS//bO2UxAb7FgJDS3W5Shot5 +JDUtsQRR5JjuofD4XAMN027gBCDRtMuIMSg0bQLCDFoNO0CQgwaTbuAEING0y4g xKDRtAsIMWg07QJCDBpNu4AQg0bTLiDEoNG0CwgxaDTtAkIMGk27gBCDRtMuIMSg 0bQLCDFoNO0CQgwaTbuAEING0y7gv+b+/v74+fl5vLu7O32+vb1dxqDn5+dTZ5WH h4f2QU9CBn18fBxfX19/5/AiBsmIl5eXU4fv7+/Hp6en098K2D3oaWjlKHcy6Rv5 O3/B4+PjySBfOfquY4JVpcDMEC1nX3US5u30KTSz9DczzOPSPzFov2pTr/WYSoyu 1afHp52StxoPieW4+mBcHlfH9X0Xc3f8qgb5UnWREqLv1SjOSxh9cZyVSrI8Bv3p HMdWbYiHCVynSUOCdY42JIjvu/EQm+2eSYgGnyS7mLvjVzUI4Wx/DEiGcI5k+0ri HINDKDNYsXwFsa1i0K6NTwJPFtpICm10Xn3T3248TDbPR70nfxVzd/xHDGJWcq5u FT4g9mA3iGvYSjCVv32l1IR5m5VB/qPGk+I362pQHc85g3w3OBfznJarGsTgEOHG 7ZLng6IPzrMl+qzzNh63tlkZVFfNKikcPzcej+fbp4/3XMw/1fJtg/gF4r8+lBRW gz4Jrk9fBdpGZDDHuEZ9eR8+a2s8klbjehuPwd+Kre/qx6910L4aj8fz7cxj6d7E tbuYf6rl2waFdtoFhBg0mnYBIQaNpl1AiEGjaRcQfsognqypO/GwqQc6r0d5ecQr 0Tyh1+q0HhjpnwKq0EMgD5h+/bn2tEOXx91p1ac/gHtxeFV1v2mDeOqmpEMFWAOj olvL9V4S0XElkFcSXqMjEZ5YXaMndfrl6X3V3hPPBPG4O61envHSE9USj32zBvm7 Fq/fcdzN89I+A/e6FgaQPGa8X7+Kwblz7b0Q63U2H0PVulqdddx/WV/7eYO8yOjJ 88JprRavDGLA1MRqgonhlXFP0lft/VW+YmIm/zuw0uor3SfSGIPYl+uM4y1kfT+y WhG1Es4Lu5pg7iNQk7Rr7yvcX/b5NrjTutvixhjkbyrBZxorCQO5J3ilWse4N7Gv k2Rfcf7WluO1Srxq75V0vnOPrO+0qlbX6d9XsW/WoPoLps60S3DlmXqr/Hsnmj3a y/2YZpa/wr7URIhB4dZoFxBi0GjaBYQYNJp2ASEGjaZdQIhBo2kXEGLQaNoFhBg0 mnYBIQaNpl1AiEGjaRcQYtBo2gWEGDSadgEhBo2mXUCIQaNpFxBi0GjaBYQYNJp2 ASEGjaZdQIhBo2kXEGLQXH4BEgWm2HPmO0gAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -246.85,
    x: 346.45
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -238.45,
    x: 346.45
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -230.05,
    x: "320.08 323.6708 327.26887 330.26725 333.8653 338.0558 341.65385 345.2519 347.6506 351.8411 354.83946 358.4375 361.45756 365.03395 368.63923 372.8297"
  }, "&#x0422;&#x0435;&#x0445;&#x043d;&#x043e;&#x043b;&#x043e;&#x0433;&#x0438;&#x0447;&#x0435;&#x0441;&#x043a;&#x0438;&#x0439; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -221.63,
    x: "326.55 330.7404 334.362 337.9476 341.5404 345.1404 347.53804 351.13084 356.52363 359.52604 363.71644"
  }, "&#x0434;&#x0435;&#x043f;&#x0430;&#x0440;&#x0442;&#x0430;&#x043c;&#x0435;&#x043d;&#x0442;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -204.83,
    x: 346.45
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_246)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,316.2,247.80002)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_248",
    width: 104,
    height: 45,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGgAAAAtCAYAAABCiS5+AAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAvElEQVR4nO3bOwoEIRAA0b65RzMUP3dyMJmdBZcNLZgKHjSaCAWd GRExhRYzpTRrrQIZY3wCrYPWmkBWkztQKeXrQuc8I20DAXbuq21aGIjEQHAGgjMQ nIHgDARnIDgDwRkIzkBwBoIzEJyB4AwEZyA4A8EZCM5AcAaCMxCcgeAMBGcgOAPB GQjOQHAGgjMQnIHgDARnIDgDwRkIzkBwBoIzENzfQGvWOc+f3ttA4rgD5Zxn7/34 g/QjkLguxajkCaVkrVcAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#ff3300",
    d: "M316.38 323.21H375.742V347.40199H316.38Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_249)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.59999999,323.4,237.6)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_251",
    width: 83,
    height: 81,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFMAAABRCAYAAACuepoLAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAEjklEQVR4nO2aW3KrQAxEvfMsJUvxTx62kz3lVrvqpNq6GhsMhRyV P7qAQWiaHs1LsNvtdj9PrIZyAp1QTqATygl0QjmBTign0AnlBDqhnEAnlBPohHIC nVBOoBPKCXRCOYFOKCfQCeUEOqGcQCeUE+iEcgKdUE6gE8oJdEI5gU64bfT5+fmL /X5fTfiRcd3geDz+nE6nCzwFXSDm19fX+VyRKTF15P739/d/EUuZg3tcy4YyPSu4 L2GqD2ydAz78XSJX6tT56+vr+d7Ly8vVuheJKfFGYr69vZ3vEb2UZ9GML/zp+P7+ fmHvz83xgS08Pz4+Lq5HXLNAkZCyzepeLCakMzF5aRckRjPEiARvpMPhcPGsokKR 4kNJ7AmZDxdJ9/1aETfiqqMg//ITh7BY9yIxRcRfOoqJ0JByspmYEgo73cfG7fUy stdz2QtlPnTuoupIvXTjjOut+WBVMSFIBVFMXiI+NxJTZbyc23gUYT+KzMwHNipH UAJBXX7EddTNVxczGzdiC2LjEXJLTLd3MeN4OXqhzAeRyBCBaJQ7D+e6qZiMJw4N +F6pz9yMTz5LMjPqXGOiz9YxwvAlO3jEWTnz4XXH2Xq0ypD9aDYf1b04MmM5Y9qa a02PkD+O/AYtl92bGfo34RHyx1FOoBPKCXRCOYFOKCfQCeUEOuG+B2OmJq7J/Npt WSc6WNtl2R/Wf1mWKavX16BxNULdvibFr44rLPfmPyQSvg8mucC6lKwNYrktCYW4 m/IEhe+O2CSonPSYP+f1+r7ey70RskSNxPXcwqZiepZHRATIizCCkOaKtvhw8n7N hkHPIL78qZHYfyMKDeC7M8SEg3zQYC4mjYEP3/1sJmaW4/OsjL/gKB84EtNBw3hW iP22H2OkRzHhFcX0wFhpB3ZfZHrKzLsb2Z8sAevj2LXIzBrOE7749yi91s091xkj 05MfJWOmXszFczFj6iyzzcTDDrgQdMGYmfIUXBQzJo0zMXlWvj25vamYAhkYzw6N Ztxom9lTFr+CjmZun7HjbE5eIfrKZnPnWBKZTzzFfIr5x1BOoBPKCXRCOYFJYGbW EuaBs/LlBG6Cr47+4a2a02IxWad55od7vq5jHeflca031QeLdT7ZRvBM/Bo6+qfJ y/xLJ/cXrjWnG3vGxr9xe8bHMzFKPMTyuT58y8fR/9LwHROfp903W9nM1ndMnC+M +vlisqVzsr6TiJ+CXai5PrK/SHxryB8bnlCJPxSMbJ0LZQszR/PFpMtBWgRitMWX R8i5PqKYpN3izxDYZWKObL2X4HOBkMsjk64BOc7jt/XYzaf68MnHIxlB6JbXInNk 6w3rie5NxfQskLIzpMK8PAqB7Vwfqtez8wjpUR8jK/tvKLPNxsyF2fb7unn2p65/ f/H/juJsO9cHAkX7UXn231BmG7NI9IrNxby3wjV8PDCmG8eWvAdr+HhglBPohHIC nVBOoBPKCXRCOYFOKCfQCeUEOqGcQCeUE+iEcgKdUE6gE8oJdEI5gU4oJ9AJ5QQ6 oZxAJ5QT6IRyAp1QTqATygl0QjmBNvgHqFRtQHjbrsIAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -349.75,
    x: 346.3
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -341.35,
    x: "326.08 330.8824 334.4824 338.08238 341.67518 345.27519 348.2704 351.27278 356.66557 359.66798 363.85838 366.25599"
  }, "&#x0414;&#x0435;&#x043f;&#x0430;&#x0440;&#x0442;&#x0430;&#x043c;&#x0435;&#x043d;&#x0442; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -332.95,
    x: "329.77 332.79005 336.36643 339.38648 342.35597 345.954 350.7514 354.34947 359.7393"
  }, "&#x0441;&#x0438;&#x0441;&#x0442;&#x0435;&#x043c;&#x043d;&#x044b;&#x0445;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -324.52,
    x: "328.88 332.48 336.0728 339.07524 342.67524 346.26805 349.86805 353.46806 356.46327 360.06327"
  }, "&#x0440;&#x0430;&#x0437;&#x0440;&#x0430;&#x0431;&#x043e;&#x0442;&#x043e;&#x043a;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -316.13,
    x: 346.3
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_252)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,316.2,330.6)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_254",
    width: 104,
    height: 35,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGgAAAAjCAYAAAB4g08OAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAv0lEQVR4nO3bTQrDIBQAYW+eo3iUbBTJz50sj5AQKLR0URzILD4Q t6Ouniml1IWWes65b9vWl2URRPSYpukIFBvrugqm1noEaq1dm6NPztPFzTlblFLe AwHe3Eeb59lAZAaCMxCcgeAMBGcgOAPBGQjOQHAGgjMQnIHgDARnIDgDwRkIzkBw BoIzEJyB4AwEZyA4A8EZCM5AcAaC+xoo1hrn/pHhCrTv+8+T9/q/K1Bcq/tUvcaL HtEljX5z9dkLRkOTbSmafIUAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#ff3300",
    d: "M316.4 246.54H376.022V264.634H316.4Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_255)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,318.6,321.6)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_257",
    width: 99,
    height: 67,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGMAAABDCAYAAACIl7ujAAAACXBIWXMAAA7EAAAO xAGVKw4bAAADyUlEQVR4nO2ZW67bMAxEs/Ms5S4lP3kne0oxQc/FXEJu7TxKpuDH wLFMUSMOJUf0arVa3RplkE6g0WKURDqBRotREukEGi1GSaQTaLQYJZFOoNFilEQ6 gUaLURLpBBotRkmkE2i0GCWRTqDRYpREOoFGi1ESzzs5HA4/sNlssif1qXjOwfV6 vZ3P5x+QIAUm9ol4zoEC7wJEMbRKJNh2u719fX19t/lK0nM9W6/Xt91ud287nU73 e+zV7v30bLQiRz6E4/F42+/337xk42OMuOpe/TzxhKmx08XQhCQAZFwMtV0ul7uN roILSDt9NFG3Vzv23AOCia2uBDP6kAi66l428HLeI67wZK76LaFkOxo7XQxlTiSM GDwj0Pqtq09Sk4irSTaI7OKR+QoAGUswIi/3oQAiBkHkmUSd4urbLhzkizGmxk4T A8IjMTxzAFvNSAwFxu2jGD7GlBgjH76VOhcBPyOuCOS+yorhk/XsEUn2ad37uyIG 18VwAVxk7JWx2Ov3KCAjH9iwhbFded8R16ltqpwYBGUK7K3eBvG/ieFwewfCTokR x2UFIE78PeL6cWKMXlyRNO+JuX6jT4Ki1TbnRTnyMRdLuL4B7xfjWcQM/Y+RTqDR YpREOoFGi1ES73Ouv31eD6oETuh+GM3m9FYxXv2v6pVCeP1JHL1gWFIMr1pSqSSD lPHUdfRME6Ku42KoP1k4mrD80M/96ySMTxfUK7fOZYkPSh/44tSNUBxAOa/ECi3z iLYxLhQuXyIGBTYvDXAgisU67nVla/JShFdhHfT10gVJ4JVdr3dRxeX0vNRHtOdA SYGQZ8wl1q0IcrSNJZYHTujTD5UxbDUeANpFlMOfJu61KcTwIFIlJcPkh8lwuvay CdnlgVcf9fVq8VIfXj/D3guM9HE/COJJNLJlnJgAT4vhWUTm+6CajH8r8Bcik2Z7 YJV55TRmEn2Udayy0bcQX2mU1Jf48N/OMwZ8VIGOW120jWL4Fvi0GP5hxzMsZgVB 9/oRwqnNRRqJvfn9NY8s9az04OEbG+c014dEUrsChR3vtbhi2HKnxIi2xOZPc35Y DAbyrIrbQKyU8gLDLrZHMeLeq4nEyquP75nOyljiY/TxiLk6X//kGsWYsvVEdcFe IsZcsJeP/q+rbWq5xk+mc/rFcR7x4assgu/cc+a9xPafifEoXvFN4A3fFbKQTqDR YpREOoFGi1ES6QQaLUZJpBNotBglkU6g0WKURDqBRotREukEGi1GSaQTaLQYJZFO oNFilEQ6gUaLURLpBBotRj38Au6D9ZZeyD86AAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -265.75,
    x: 346.45
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -257.35,
    x: "326.23 331.0324 334.63243 338.2324 341.8252 345.4252 348.4204 351.4228 356.81559 359.818 364.0084 366.406"
  }, "&#x0414;&#x0435;&#x043f;&#x0430;&#x0440;&#x0442;&#x0430;&#x043c;&#x0435;&#x043d;&#x0442; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -248.95,
    x: "321.7 327.08265 330.71684"
  }, "web")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -248.95,
    x: 334.2
  }, "-")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -248.95,
    x: "336.35 339.94807 343.53889 346.53727 350.1353 353.72615 357.3242 360.92225 363.9134 367.51145 371.10227"
  }, "&#x0440;&#x0430;&#x0437;&#x0440;&#x0430;&#x0431;&#x043e;&#x0442;&#x043e;&#x043a; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -240.53,
    x: 346.45
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_258)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,315.6,440.40003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_260",
    width: 113,
    height: 48,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAHEAAAAwCAYAAAAmepUZAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAx0lEQVR4nO3cOwoDMQwGYd3/Yn4dykEpkoUNG0iT1TDF1xsG/6Ui IrbKi91732utPedUEdlrjPGO+O8H6XeniFm3taabO67mx4g32Hd9YUQAIwIYEcCI AEYEMCKAEQGMCGBEACMCGBHAiABGBDAigBEBjAhgRAAjAhgRwIgARgQwIoARAYwI YEQAIwIYEcCIAEYEMCKAEQGMCGBEACMCGBHAiABGBDAigBEBLiPmmSnVcIroXbea DssZz1NT/sRasld2e0VUbQ86GXfkhiDjZwAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#ff3300",
    d: "M315.54 129.06H380.49403V154.954H315.54Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_261)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,313.8,422.40003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_263",
    width: 119,
    height: 109,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAHcAAABtCAYAAACbdP53AAAACXBIWXMAAA7EAAAO xAGVKw4bAAAFbklEQVR4nO2ba1LkMAyEuTlH4Sjzhzfcia2e2o9qtHKYCRRmx/2j axJHtmW1Hxkpurq6unoLLhbTFQhCbhByg5C7CKYrEITcIOQGIXcRTFcgCLlByA1C 7iKYrkAQcoOQG4TcRTBdgSDkBiE3CLmLYLoCQcgNQm4QchfBdAWCkBuE3CDkLoLp CgQhNwi5QchdBNMVCEJuEHKDueQ+PT29PT8//3N/OBxmG+PS8POdPj4+fiBT5L68 vByvHx4ePsDrIa/y6+vr9/Kbm5tjWZ0cuu/Kt/D6+npE7ZNr79efSQe/r+0sQ64M 5KtVv7q/u7s7Xjtub2+PdfTLJFC5fmU8kefymjgYl3Z98qgdl1efVSf6QBbSdM2E 82cilnpdO0uRK7B6ZQCM0hnTyYU8GRPDSbbbAZDn2g2vayYV7VMuGZ7VHWZELhNF 9bt2Jh43c8j1Ga7farARuU6kANG05YT6CqUP7iu5EFnr1LJKLnpAatcOu8My5Aq+ +k4ll/O2EsC5W8nVNUTe39+/E9CtXCYAoA2Ro7b1vJKr9njGJKvtTMTPd1rPyWrM LXKZEJCls9W3Q9rj/HbDA7Zyb592fBfg3N7alrmnj66dpbZlrTwZQYOvb59epuu6 qkVofQOWnFaj2uSFSiuZFy79Sp4Viw5+T/8qUx31wz36aMLwBoyu1EWvrp1JxM4h dw/qqg4uiFz+N/pKDy6E3CDkBiF3GUxXIAi5wX9HLp4l3oLrXx2PrLgs16DWU5lk Rm3RFzJ+3emxFXWqfZ0bibpIcuUU8CiPyvwaP62MVWWrD5c6uBjdNehtIYf3CY+W P/P/1N6e+6ip4z7nLdnlyMU9p5UICR7Ow1C4EF2WVYO8BxRoCxegE0HEpro/R+T6 hwWUswNAIPpsyS5FrsdxvbyuRhz3o5Xg/t1a38ljFdMeE6iG7RzV/8w9UR6fEJ/J LkUuq8d9tW4wQdsc/uROdkQu/uU6CVTuAQaPt/oqrB8S0H4XSIDcqkuVXYpcN44H 2X2bZaX59uuyHblMDM5Y35YJ3dVyiBhty95vPXNdly3Z5cgVMDgzXPdc6w2UgHwn i0HrucYbLFElIkBqh48E/IxWfe+3RoOI+EjGfdteB4xklyQ3CLlByA1C7jqYrkAQ coOQG5xO7igPRxhFRbpvnepXht6+/790mVPzcvhUterURZtqntFnulT5rs9qj1re 2fArY+0iXmeTW78vdm/M6BkuO3fmIyPSuxwbORLOzcvhE1iPwtQsA8pGeUZbunTy 0sUzJZDn4z3ua2JbtdOesXoUy33mu8n12Vndfn4/GgzfC2MkeX26HJtzyPU67gN2 4Ppjho/yjD7TpcozVjc+Yx/lJnU23DNW/OIu8yVyR3k4gjrryCWCUzMBuO5ybLzc sZWXw4C7QXpaSTUY+p6iS5XXdc3cG+mPfGfDPWN1//e3rNxRHg5bE9EXJ9ejISji inU5Nm6cU/NyfPvrztWOXI8Zu5FHulR5Hyt91nH50UTgodpwz1hpyyfKl8gd5eH4 WeQdclb5LMcQbCtdjs2p23Kt4xOISbRFLvroWg7+z3Sp8hDn4+fdostNUnlnwz1j 9Un1Ldsyjdc8HM4jfytlpnl+zOHvZypcE0WpOTZ78nK8XV6OeIMkylPJrXlGo3a3 8pKoh0141uUmjWy4Z6y03cnsJreDzywfQC37LTg3z+iC8pLOr8SbopfV2fqbcG6e 0QXlJU1XIAi5QcgNQu4imK5AEHKDkBuE3EUwXYEg5AYhNwi5i2C6AkHIDUJuEHIX wXQFgpAbhNwg5C6C6QoEITcIuUHIXQTTFQhCbhByg5C7CKYrEITcIOQGIXcRTFcg CLlByA3e8QeK/o0tAGJ2VgAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -164.67,
    x: 348.25
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -156.28,
    x: 348.25
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -147.85,
    x: "329.9 333.49998 337.69038 341.29039 344.88319 347.88557 352.07597 355.07838 359.26878 362.86878 366.46879"
  }, "&#x0423;&#x043f;&#x0440;&#x0430;&#x0432;&#x043b;&#x0435;&#x043d;&#x0438;&#x0435; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -139.45,
    x: "330.83 333.8396 337.48283 340.49244 343.52366 347.14527 351.97648 355.59809 359.8173 362.24369 365.86528"
  }, "&#x0441;&#x0438;&#x0441;&#x0442;&#x0435;&#x043c;&#x043d;&#x043e;&#x0433;&#x043e; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -131.05,
    x: "316.7 320.29084 324.4958 329.29319 332.89125 337.08174 340.67979 343.69984 346.6693 350.26737 353.86543 358.0559 361.65397 365.24479 368.24317 372.43367 376.0317"
  }, "&#x0430;&#x0434;&#x043c;&#x0438;&#x043d;&#x0438;&#x0441;&#x0442;&#x0440;&#x0438;&#x0440;&#x043e;&#x0432;&#x0430;&#x043d;&#x0438;&#x044f;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -114.23,
    x: 348.25
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_264)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.59999999,542.4,247.20001)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_266",
    width: 97,
    height: 50,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGEAAAAyCAYAAABMHLX6AAAACXBIWXMAAA7EAAAO xAGVKw4bAAAA0UlEQVR4nO3cMQ6DIBhAYW7O0VgIRDgUDbXWoUm3ykt9wxeJk/Hx MxJCCEPLhZFSGrVWXSznfEZorWmRUsoeYdu25R9zV69pOCPMJ+B8/Hvz+DeCEWQE ACMAGAHACABGADACgBEAjABgBAAjABgBwAgARgAwAoARAIwAYAQAIwAYAcAIAEYA MAKAEQCMAGAEACMAGAHACABGADACgBEAjABgBAAjABgBwAgARgAwAoARAL5G6L0/ 1/qt+Z8/IhwvdL33BSPHeKzeIXcUY9wjaK0HeHjZeVuXx9kAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#7030a0",
    d: "M542.42 321.05H597.979V347.93H542.42Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_267)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,543,229.80002)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_269",
    width: 95,
    height: 109,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAF8AAABtCAYAAADH/r1TAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAFCklEQVR4nO2aUXLiMBBEuXmOwlH4CQkJ3ClbQ9VL9c5KkCWEdmg+ ugB7LD23xgINWq1Wq4+HbLIDJMsOkCw7QLLsAMmyAyTLDpAsO0Cy7ADJsgMkyw6Q LDtAsuwAybIDJMsOkCw7QLLsAMmyAyTLDpAsO0Cy7ADJsgMkyw6QLDtAsuwAybID JMsOkCw7QLLsAMmyAyTLDpAsO0Cy7ADJsgMkyw6QLDtAsr7XwG63+3h7e/tLC7ip 36LvNfD+/n40/PX19WO/3z/Mv5X5T09PR/PL+PrcM5+nomJKFb/ZbI6DxDEGr45r LO0Qr4M7aqP6mrVR7yu+zsNZx56fn6esFcurJlm9H/V9c/MBPBwO/5hfx4AnDuMA LkPrGMaUGTVAmNCvrXg1krjtdnvsb9QGHPRZ5xhETJuxzhJr1PfNza8b1exQQOA4 RvZyc9wUZmJCGUJmqRlqQn0e9T9qgwHj9eXl5bPPU6xcT1yfUkd939R8oPQzgJUR 3GzdeGm9Xk/NJ/vqujKvm092cW5kwKgNjcFANXnG2p/QRZmv817PGOA1+5hyZuZj gM69Gl8xGIoJ3YBRGxhHX8rTv1f0HAM5+z6zmq/zsEozpG4AaDK/xOCQyT2ryUB9 UjCjXmvexjTi4Opt1CtzO/H9/YiV83CW2foFPer7puYrvD4R1/y52Z+UO9NlF5Ih /XhlUD3+1wLsT8qdyQ6QLDtAsuwAybIDJMsOkCw7QLKu36gWwFgJdrEe0CpiXdsr lrp6pqBV71lo6WqWmPq5q7WZc/HaJ6vhUdzizddFUa0uqTbqcp8BqZuqGC2WzSqT lBdY+usgU3/R8gEDSiGNFemp+FqfsFIfxS3efMoAZBrCcDWNbCLrNJYyAXG0q1ms g6bt6JOnxp2L7/X+HneX5muFkffUWvSPjT5F9b4wnPbrPDE8hafiz7W7ePP1z4jK XopaI/MxmkdczWeu55yWhbX+z/Uaq+1zHPNPxav5o7jFm88AMEfrFym1IG6WAdEb q2zTuvyo/Ku1Hv0SpqZEDCrjlW0WrxXKUdyvMP+ceqYF6/adXqkWfg+yAyTLDpAs O0Cy7ADJsgMkyw6QrPlJLSohFhy6Ou1VP60GahWzlwd6O/qHfC8psMVEr9c9PMXV 92Oivi3wXN/Kr6tdZdH70vbVky+siucnWYGy0gSSm6jzVCX77q86Vue0fMDnDquF s74BSvcC9Y1KWnPRc6PygibTqb47f9+PpPevnLVm0Z0bfTffxebrzbLc1wzSDOyd ntvP2es4Cq/VSDVf90928+tV6zJ9J5q2Oep7ZpoOHH31ug9l8F5Nvbr5sz2aM/Op wfcNqlQVkVYSNU7N15pPN1/r/tT+1eBufu/7f8yvbOe9PiFakb26+bp/smesztV9 ruwVTG0H8P6vkma4lphn005/WmYGzvru/L0YqH3VMeZ/DFfmb5nfazCMLufYiq1V wxJzO3PkqdKsTgfsn+fm+x5QzIBH93l21r63kr60/1HfnZ+B1mt71RRP2F1HJfQL Wxx/9ufUJbt5mbv1mM7vd6Sf7eCSCqb+T4v45bEAw36P+Q89zF+q7ADJsgMkyw6Q LDtAsuwAybIDJMsOkCw7QLLsAMmyAyTLDpAsO0Cy7ADJsgMkyw6QLDtAsuwAybID JMsOkCw7QLLsAMmyAyTLDpAsO0Cy7ADJsgMkyw6QLDtAsuwAybIDJMsOkCw7QLLs ALH6A6E/4ggs9qp6AAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -357.35,
    x: 570.6
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -348.95,
    x: 570.6
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -340.55,
    x: "550.38 555.1774 558.77548 562.37356 565.96438 569.5624 572.5535 575.5519 580.9417 583.94009 588.13058 590.52926"
  }, "&#x0414;&#x0435;&#x043f;&#x0430;&#x0440;&#x0442;&#x0430;&#x043c;&#x0435;&#x043d;&#x0442; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -332.13,
    x: "553.92 556.92959 559.31997 563.5103 566.51278 570.1056 573.70559 577.2984 580.8984 583.296 587.4864"
  }, "&#x0441;&#x0442;&#x0440;&#x0430;&#x0445;&#x043e;&#x0432;&#x043e;&#x0433;&#x043e; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -323.73,
    x: "546.08 549.68 553.87039 556.26797 560.4583 564.0583 567.6583 571.84878 575.4487 579.04159 582.64157 585.6511 588.0415 591.63436"
  }, "&#x043f;&#x043e;&#x0441;&#x0440;&#x0435;&#x0434;&#x043d;&#x0438;&#x0447;&#x0435;&#x0441;&#x0442;&#x0432;&#x0430;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -306.9,
    x: 570.6
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_270)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,542.4,307.2)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_272",
    width: 98,
    height: 36,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGIAAAAkCAYAAABypO9/AAAACXBIWXMAAA7EAAAO xAGVKw4bAAAArklEQVR4nO3bMQ6EIBBAUe5/KToIcCg2U2w0MW63zk/8xVMTO/5I haWUskOtdffe9aBY8+/6l7iMMfacU0kMAXEJsdZK/1zf4jz8lxBxP+1Z+qMYekMA GALCEBCGgDAEhCEgDAFhCAhDQBgCwhAQhoAwBIQhIAwBYQgIQ0AYAsIQEIaAMASE ISAMAWEICENAGALCEBA/Q8TLeNYzbkMo+Vh+/LmSPR1v1Vo7QijfB/eYcchDToi5 AAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#7030a0",
    d: "M542.42 269.39H598.263V288.33003H542.42Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_273)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,552.6,301.2)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_275",
    width: 66,
    height: 57,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAEIAAAA5CAYAAACCsf3qAAAACXBIWXMAAA7EAAAO xAGVKw4bAAACnElEQVR4nO2YW47qQBBD2TlLYSn88IY9ZWSkg6xWGA1kNPZF98NK v8vl7nSqslqtVtN/3BEn0II4gRbECbQgTqAFcQItiBNoQZxAC+IEWhAn0II4gRbE CbQgTqAFcQItiBNoQZxAC+IEWhAn0IL5ju12O+33+0d9s9lMu90uTfbvhViv19Pl crkLovr5fJ5ut1ua7N8LIZxOp7sAKl+v17soqqusp4Sij7rKzJdwtB0Oh4egjOeE aYzq2JId5o324UXZ29k4nWS1+/xFQnAq5AQOumEnyWkRSZx2Qcb5OOvreN2dEw+3 O1eWXY09Ho8PW15eJASOPSMxt1syzk7ryXwXgjYJ5IL4U+sA3U++wy4Up42TpvEI 73YXCyGDvtgzIfyYcyLmdmYU1V8/f9UYo9Pw7BRQpo4QWg8Rf0UIKTtekuziKAR3 hL+TzGeXvE0CQBRnEWJ0arQ7ljXO23Fe5Rcu+OU3ru/QP4zli0h1vccFzmSF+BDE CbQgTqAFcQItiBNowXwH32MiOc8RFDARCJETKBYgRvDcgk+r6v6dJ5bAHjGFt4/r eY7xrExUqnxjzFfeEsLDWDdCv+cXiEOf5xYkXhojsXxdlUn1PQcZiXvI7BElgZTn GwRweuqT/kJ0Od/hTs+1OSmF14KcGnMLHB7DaOYhpucgODiuN+YbLgT5BqE1ieIL +cZ8hzsK2VGIMb+g33fBQ2l22zPVcVfdzrjedyeCPoTAzuITQVboP2dGIfzewDGO p0iQxuvJHeH/KDwPYJ6evC7jej/JN7Q5b+Yb792yH5JfLBfiQ/KL5UJ8IOIEWhAn 0II4gRbECbQgTqAFcQItiBNoQZxAC+IEWhAn0II4gRbECbQgTqAFcQItiBNoQZxA C+IEKvAFbOtAjY5vQsIAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -287.55,
    x: 570.75
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -280.35,
    x: "555.47 558.47 561.47 565.06399 568.058 570.458 573.458 576.446 580.052 583.052 586.046"
  }, "&#x0423;&#x043f;&#x0440;&#x0430;&#x0432;&#x043b;&#x0435;&#x043d;&#x0438;&#x044f; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6.025,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -273.15,
    x: "554.9 557.298 559.6899 562.69039 565.6848 568.08279 571.6797 574.67416 577.0721 580.669 583.66946"
  }, "&#x0441;&#x0442;&#x0440;&#x0430;&#x0445;&#x043e;&#x0432;&#x0430;&#x043d;&#x0438;&#x044f;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -265.92,
    x: 570.75
  })), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#3366cc",
    d: "M367.59 492.19H358.38V524.39H326.07"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_276)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,499.2,156)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_278",
    width: 118,
    height: 31,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAHYAAAAfCAYAAAAyXDmDAAAACXBIWXMAAA7EAAAO xAGVKw4bAAABV0lEQVR4nO2bXQ6CMBCEe3OOwlF44R/uVDOaaZZaY6IPtes8fEFp B0nGbbddCCGEKFwS4jiOcdu22HXd/eQwDHHf9wTa5nlOovM843Eclz5sk/Y3tKHv +9TIBhytiEKK8h/Dd1xH2t/RBus8IpcN+Lwsy511XdMF+W9hG7HDgLT1tS+NFY2D eRUhDGNhcvUbEh9BD81w/Ah5mdo2RWNF+7w09jLxiuYoGstUWsNxuyAzhqkpc1ZW 7BQZ6xRr7DRN9W9IfAQ3M8x0+hifMcdyr1i0R2E/uf5Nie/ROtYpRWPzsp1ojydj S2U70R4ISuRKKTi13HGKjHWKynY+UNnOKVruOEVlO6eobOcUle3+BRnrFJXtfPC2 bIeozZ8+5zYVjnlb/pC5tHW0b8t2eSe7cZG/LwLwBLq09bXMik2/q7FY9jC7ykL7 EvLMwuwySdp6WpzDS1zsdwNaUfWvy9InTwAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeDasharray: "1.5,3",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#3366cc",
    d: "M498.98 423.24H567.011V439.36799H498.98Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_279)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,511.2,150.00002)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_281",
    width: 77,
    height: 53,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAE0AAAA1CAYAAAAEeGYcAAAACXBIWXMAAA7EAAAO xAGVKw4bAAACHklEQVR4nO2VWY7CMBBEuTlH4Sj8sMOdMiqkh3paZIilkYqS8vEU x1uXy217s9lsppVh7AISsQtIxC4gEbuAROwCErELSMQuIBG7gETsAhKxC0jELiAR u4BE7AISsQtIxC4gEbuAROwCErELSMQuIBG7gEQ+dzqfz9Nut5sej8ezXNnv9+4F fJ9pMuV2u02n02m63+/PckV1X7CI7zLtcrk8zVGmVROv1+vb/tvt9pWZ+q/ZSFvP UJX7P336fPSlvsfocwFxmWd0/JBpZBf/OqL6n5tYAmiXsRqPkJ6hmkv1xMAMxh0O h1/x1KZ6baTi1Mzvp4BNJW5tx7Al4//FNIIpcM0KdksLUruOswITHDHaaRYiUwQx ZBCZjanEqwaojn7H4/G1UehkLsroZTNUXjp+2DQtUBMoAHX9HiM42TB332FCzVYJ pp8WpLn4Yk7d9XpV1EWqnfhoIBYbQh+O5NLxw6YhmkAEqCZ2ENjH1jLZyNGUeRhX za9Hi+Nes6Gb+e766JvedX4aP2za6CNABujI6Qi8Oyag48uLrHH1LqTMHVbH1kxT nH6F1CuBtr4hI+OHTesvCYvDxA4XbL3v5l7F3j5XJqb+eTj+ikOffmLeveJLxw+Z trKatpq2mpaHXUAidgGJ2AUkYheQiF1AInYBidgFJGIXkIhdQCJ2AYnYBSRiF5CI XUAidgGJ2AUkYheQiF1AInYBidgFxPEDNGwE9V8DE1QAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,BoldItalic",
    fontWeight: "bold",
    fontStyle: "italic"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -437.45,
    x: 533.38
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,BoldItalic",
    fontWeight: "bold",
    fontStyle: "italic"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -429.03,
    x: "514.35 516.1504"
  }, "IT")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,BoldItalic",
    fontWeight: "bold",
    fontStyle: "italic"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -429.03,
    x: 519.7
  }, "-")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,BoldItalic",
    fontWeight: "bold",
    fontStyle: "italic"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -429.03,
    x: "521.85 525.4428 529.0428 533.8452 537.4452 543.4356 547.02847"
  }, "&#x043a;&#x043e;&#x043c;&#x0438;&#x0442;&#x0435;&#x0442;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,BoldItalic",
    fontWeight: "bold",
    fontStyle: "italic"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -420.63,
    x: 533.38
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_282)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.59999999,543,366.60005)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_284",
    width: 97,
    height: 43,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGEAAAArCAYAAABoxeapAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAtElEQVR4nO3bPQrFIBQG0bv/dQniz54MaZIHeaSLDskUB1txwO6L iBhaLkZKabTWRq1Vk+zv3Xs/I5RSll/qq/5GyDnrYb+/ziXCfgL+x9czAoARAIwA YAQAIwAYAcAIAEYAMAKAEQCMAGAEACMAGAHACABGADACgBEAjABgBAAjABgBwAgA RgAwAoARAIwAYAQAIwAYAcAIAEYAMAKAEQBuI7hZA2zWNN8RwR3zfJcds9baAAd+ a7oFiQ/KAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#7030a0",
    d: "M542.99 205.69H598.266V228.768H542.99Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_285)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,552.6,358.80003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_287",
    width: 67,
    height: 70,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAEMAAABGCAYAAACXBynAAAAACXBIWXMAAA7EAAAO xAGVKw4bAAADpklEQVR4nO2ZW67iMBBE2TlLYSn88IY9MapIB5VaCTdAZroumo8S jh+dcrntdJvVarW6/8cD7QSS0E4gCe0EktBOIAntBJLQTiAJ7QSS0E4gCe0EktBO IAntBJLQTiAJ7QSS0E4gCe0EktBOIAntBJLQTiAJ043n8/m+3W4nn78Q04232+1+ uVyGskS4Xq9D+Xg8PrDZbO7r9XpoFzTGbaiOflN1Go89lelX+7AQKvMer8e2fjVO 419cvOcdJACTPJ1OwwtU57+U1S7x9AsxHwNxxuFp+/1+GCfsdruhn8reBxtjC0NZ Y+mvX7WxmIuIgQgyygqOeQgv1Yo4AVbIJ+VEEUzv0WQEiYOIDsapvYqh8WoXDofD g4OeFxMD72C1p8Sgjv6soEhB0sWAMH30ixisMLbdMxjvHHgHHoEIwmKe4Z7A3nvm GWwnCLnb0u5bRgIL7uYCk8LenG3CmYXQtC/mGbi4jPsBxeEFScTA3TkEOejYArKH TUF1GoPQTKjaroezbDgHr5dN8aVOz4tuk59Qt8kvxudGfKV+OdoJJKGdQBLaCSSh nUASnnfQp4sw2j91U/kIn05yCv/Uetk/o/6umse4vZqH/IX8ZLxBL/AojpCcMoGP 4HWE0YTvHmnKlgh6OE4cMJazVHuavAdeBFQehE3lJzMFGW/wSBIQIUKAUJfEirJP SHUeLiuvUDt96+RqxOv2an5SxSDLrknaC1cP4w1Eh8/E8ECLlau5iNp8ddyGMCYG GWu1V/MTFwOvdY9h7Mee4eQgPyaG2tlCrJbnIniYC0IfXLqKy0SrvZqf1LF4nAu3 iGcI2u+4ZD30IEg+wgHHM3WywRhIYVd9OVBrzsIWcXtjeQhlOLJoNT/xQ/ktMZ6h bpMvwXsD/erti9BOIAntBJLQTiAJ7w/2z6SedYL7rZhDp7nfpU7ZIzbwL00F8Qd9 Y8QgHNczcQg35ARiavML3il7GoewRJRT70Wohf/YWkYMjy6ZdA3paZtj24Oonzxp yoNaxIBUveb3KPEVMTzvmQJCc9MeI4bK7F9N2P/QcReeI4Znt3M4ELZHiUGZ/z38 7sMn6RlpDZPdw3xsFZAQvx7grWLUW3ER07P/uTR2gJJTSBgXY2ysp/kumvdbSIjP xPgEWt057o2I/4hXjxihaCeQhHYCSWgnkIR2AkloJ5CEdgJJaCeQhHYCSWgnkIR2 AkloJ5CEdgJJaCeQhHYCSWgnkIR2AkloJ5CEdgIx+AOZDwOIjjTktQAAAABJRU5E rkJggg=="
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -229.45,
    x: 571.03
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -222.25,
    x: "555.75 558.75 561.75 565.344 568.338 570.73806 573.73806 576.726 580.33206 583.33206 586.32608"
  }, "&#x0423;&#x043f;&#x0440;&#x0430;&#x0432;&#x043b;&#x0435;&#x043d;&#x0438;&#x044f; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -215.05,
    x: "555.17 557.57 559.96408 562.96408 565.95809 568.3581 571.9521 574.9461 577.3461 580.9401 583.9401 586.93417"
  }, "&#x0441;&#x0442;&#x0440;&#x0430;&#x0445;&#x043e;&#x0432;&#x0430;&#x043d;&#x0438;&#x044f; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6.025,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -207.85,
    x: 560.53
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6.025,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -207.85,
    x: 566.7
  }, "1")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6.025,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -207.85,
    x: "569.72 570.9202"
  }, ", ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6.025,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -207.85,
    x: 572.58
  }, "2")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6.025,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -207.85,
    x: "575.63 576.83029"
  }, ", ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6.025,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -207.85,
    x: 578.48
  }, "3")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -200.63,
    x: 571.03
  })), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#3366cc",
    d: "M367.59 492.19H358.38V484.5H326.07"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#3366cc",
    d: "M367.59 492.19H358.38V504.44H326.07"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#3366cc",
    d: "M367.59 492.19H358.38V464.55H326.07"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#3366cc",
    d: "M435.62 492.19H444.13V536.21H469.64"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#3366cc",
    d: "M435.62 492.19H444.13V463.63H469.64"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#3366cc",
    d: "M435.62 492.19H444.13V516.26H469.64"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#3366cc",
    d: "M435.62 492.19 469.64 492.31"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#3366cc",
    d: "M367.59 448.1H231.53V442.05"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#3366cc",
    d: "M401.61 433.99V417.86"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_288)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,156,331.80003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_290",
    width: 117,
    height: 41,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAHUAAAApCAYAAAALSGYwAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAuUlEQVR4nO3cOwoDIRRA0bf/TVmJv0UZLPKBSQJDiomXWxwsLC9q 5YuImMKJmXOerbXZe9emxhiz1vqMalCOt1FLKdrMOqUfo671D94DnWRUIKMCGRXI qEBGBTIqkFGBjApkVCCjAhkVyKhARgUyKpBRgYwKZFQgowIZFcioQEYFMiqQUYGM CmRUIKMCGRXIqEBGBTIqkFGBjAr0NeravPpXtM57nQRwiKr9GRXoEXVJKV1+jeg3 95Y3u5LhKDA/MMkAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#00b050",
    d: "M155.99 241.52H223.313V263.562H155.99Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_291)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,154.8,334.2)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_293",
    width: 124,
    height: 34,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAHwAAAAiCAYAAACdmr05AAAACXBIWXMAAA7EAAAO xAGVKw4bAAAC5klEQVR4nO2ZXZLiMAyEuTlH4Si88A93YqtT+0319DgkO0ONCauH LoJtOS215ICyWq1W98J/he4ECiV4oQQvlOCFErxQghdeWvDz+Xzfbrcf32+324De vN4I3Ql8gsSV6Lper9f3y+UyfPbm9UboTuALrtfrUOW73e5+PB6HayWBoDnmuVZS 7Pf7j4TRd9YqWVirvbA9HA7DOkHjstU1e2of7DQHB64Zly3jad87josRnCrneM8A I5qfBMy3Egf7zWYziKL9T6fTYE9SCYiPiFOCeyK27HvHcTGCI5YC6AFOwV1kF4PA p+AIgeB+iugT4QSvcOxScPYicdK+dwwXIbiqVZVI8B4JTrVyrXkEpOrzhJDQ7OHr /bcD93xU4YhMsrXse8dyEYIjtoTxMSrGq5Nnpj4JsNYyxrEs8alQf1SQQP781xz7 +X3hleIjeMu+dywXIfhc5JFeeHPBVbUv/Jx8ZXQnUCjBCyV4oQQvlOCF7wruTYvs eNFlornB/156174mmx9uy33SXv+NvfXJ/15s1QdnX+1BkwYb74/7OrpmU36M+eqx Sc4aT97w0Hf9j9ea5Njy41/8hYv3Lb4tOC8i/EbesJBTBJEx2SQ5HEhbF8Ht4ZD/ tRHDhSRo+WIEu5bgY354s2SM7xTn5E3DhjXJseXHXH9JJO8c/khwMojs9O6SAsA8 gdFYBs8FT9sUBHvNUQmPBPeEw2m6dNyPsQzUIz/GfM3gO2eq13n7yxVPOufY8mOu v/hC4jzlSPcesRP3t0k5P1XhrQD4OO/AOS3GAsBR64LTSmXtVIW3OI/5mvfOueTt 9n6iOceWH3P9pcX8lApnM645qshM+s+cBP42yW05dlq2Y/Ykmcb9uPQq46UJVbb9 ++Yrn+HpB3bJxdeN+fqIc4u39+55zifHlh9z/WWe9ws/EnwusjJ+274Hlsj5aYLr xwfP+B72PbBEzk8TvLA4dCdQKMELJXihBC+U4IUJ/AGm+zZCdWja9wAAAABJRU5E rkJggg=="
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -254,
    x: 173.75
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -254,
    x: "175.13 178.13 181.13 184.724 187.71799 190.11798 193.11798 196.10599 199.71199 202.71199 205.7"
  }, "&#x0423;&#x043f;&#x0440;&#x0430;&#x0432;&#x043b;&#x0435;&#x043d;&#x0438;&#x0435; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -246.8,
    x: "156.8 159.794 162.794 165.794 168.794 172.38802 175.38802 178.382 180.77602 183.77602 186.77 189.77 192.77 195.164 198.164 199.364 202.958 205.35799 208.35198 210.75197 214.34598 216.73999 219.73999"
  }, "&#x043a;&#x043e;&#x0440;&#x043f;&#x043e;&#x0440;&#x0430;&#x0442;&#x0438;&#x0432;&#x043d;&#x043e;&#x0433;&#x043e; &#x0440;&#x0430;&#x0437;&#x0432;&#x0438;&#x0442;&#x0438;&#x044f;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri,Italic",
    fontStyle: "italic"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -246.8,
    x: 222.77
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_294)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,157.8,242.40001)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_296",
    width: 111,
    height: 37,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAG8AAAAlCAYAAABMBrdqAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAvElEQVR4nO3bQQrDIBBA0bm5R3MTDUbvZDHQ0i5S6Cr98BcPxFXg O7NLRMQUVswxxmytCSSlNCPnPI/jEMwauNj3/XXRe7/9Rena6vNstW3bZ7x1/oM9 rgvvW9J4MMYDMx6Y8cCMB2Y8MOOBGQ/MeGDGAzMemPHAjAdmPDDjgRkPzHhgxgMz HpjxwIwHZjww44EZD8x4YMYDMx6Y8cCMB/Y1njjOeOsnvbs/RL+rta5pjPOwJlAM pZRzjT4A8nNGV/T1JHEAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#00b050",
    d: "M157.51 333.19H221.801V352.813H157.51Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_297)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,165,234.00002)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_299",
    width: 87,
    height: 67,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFcAAABDCAYAAADpj5nhAAAACXBIWXMAAA7EAAAO xAGVKw4bAAADeUlEQVR4nO2Za47CMAyEuTlH4Sj84Q13YjVI32pk0lLKUhcvP0Z9 JLEnE8ekZrFYLK5fvA3pBCojnUBlpBOojHQClZFOoDLSCVRGOoHKSCdQGekEKiOd QGWkE6iMdAKVkU6gMtIJVEY6gcpIJ1AZ6QQqI51AZaQTqIx0ApWRTuBjcDgcruv1 +na/3+9/70eJezwer6fT6e75crmkTzQD5/P5Nn9dhZfE1UrJGEYw2jdmuVz+9m85 14qvVqu7d633j+Bj4oK3fHufrnvnoHu3wzNR+5K4EopolSFdN5vNdbvd3u4deq8x uvp7LYbIixArL+hZ/bElP7TrPX5jf3hE34yLfhQgzmvovfzA6VHbKHGJXiJWkODu SGiJK+daaY0hV7HSnm7i5CAMecREXF3VJh66j+IiKhFJYDwrLhxb4sa20eJ69Lai oEtc2jTWhfaIbEU6PniO4iKYR2eXDcTX9Rlx3UcUt9U2WlyBiRB5Q8SNUYoNicyk W9tN97vd7tZfbVFcPbMbsOk29C6mnGcjFxuttNBqGyUuInikDRXXc6jE4plIjhNy wvTjx9HFZXxXWvDxnsOdF/OJed25eGqKPGPbKHGJMibDe22N+GvLs0eunwVlS9Em qK9sug+B3OzjENF3ghaLKMa38xEHjVHkxrm04EdMUgqRj6++tpfSwjOIUf0JeCPn vzUYo+gTEM+zsxX3i6+4X3ELIJ1AZaQTqIzpnMVfZE4VXkXr+tX2E4j6cO4eWJ26 6zPE5yzFjV8+kPdiB+VMvrL8i8oP6xLV66j0x45XzWK1LI73L6w+n7MXlzJjS1zq A1EUvs74WsJWFAQ7XjvwserTqsB5lazP52zF1YGcekJL3IgYiV7JatVuI2LEeZ2D 8XwGu+0un7MWV5ONhZUYuURjTAvqQzQSRd7mAnr5z3OmiysObssjvc/nLMUVSa98 ea50oXwrelrwojw2eSZHx0J1rNi5uHFBvUrW53OW4vIXi1ecEEXtngsRmDTCFqew 7naJdEUWf7GwhSln0rdV2yD/e5Xskc9Zihu3sBfGu+CROBUm8vl3xlpnRnJv3ziP xKkwkc/pJvQPkU6gMtIJVEY6gcpIJ1AZ6QQqI51AZaQTqIx0ApWRTqAy0glURjqB ykgnUBnpBCojnUBlpBOojHQClZFOoDLSCVRGOoHKSCdQFj88DKOec7BmgwAAAABJ RU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -353.25,
    x: 189.8
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -344.85,
    x: "167.77 171.37001 175.56041 179.1604 182.75319 185.75559 189.94599 192.94838 198.34838 203.74837 207.93877"
  }, "&#x0423;&#x043f;&#x0440;&#x0430;&#x0432;&#x043b;&#x044f;&#x044e;&#x0449;&#x0438;&#x0439;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -336.45,
    x: "175.3 179.50496 183.10301 187.2935 190.29187 193.88269 196.87384 200.4719"
  }, "&#x0434;&#x0438;&#x0440;&#x0435;&#x043a;&#x0442;&#x043e;&#x0440;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -328.03,
    x: 189.8
  })), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#3366cc",
    d: "M401.61 516.39V508.32"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#3366cc",
    d: "M401.61 476.07V462.21"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_300)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,156.6,396.6)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_302",
    width: 116,
    height: 36,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAHQAAAAkCAYAAABYFB7QAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAxElEQVR4nO3bQQrDIBQAUW/uUXIUl5ronSwWkrbQUtouUodZPAxx ExjMXxlCCF0ooccYe865r+uqCZVS+rIst6Dj5bZtmthoeAQdp/N+Q/OotV67jfVp 0D+YAfrA3s2gEAaFMSiMQWEMCmNQGIPCGBTGoDAGhTEojEFhDApjUBiDwhgUxqAw BoUxKIxBYQwKY1AYg8IYFMagMAaFMSjM26DjWfPYbw6+DKo5PQRNKZ3+QfrNuPR7 BN2jnv370Hdaa8dMvQAy2h51egMKkwAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#00b050",
    d: "M156.79 179.73H223.121V198.54599H156.79Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_303)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,160.8,388.2)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_305",
    width: 102,
    height: 67,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGYAAABDCAYAAABuvnDnAAAACXBIWXMAAA7EAAAO xAGVKw4bAAADoElEQVR4nO2ZUW7jMBBDc/MepUfJT9s0be+UBQO8gjsruQvUhTy7 /CBiK+MRJY5kmz6dTqdbcEgsJxBEmFZYTiCIMK2wnEAQYVphOYEgwrTCcgJBhGmF 5QSCCNMKywkEEaYVlhMIIkwrLCcQRJhWWE4giDCtsF+yy+XyBw4wwK7YL9n7+/sd 1+v19vb2dscBBtgV+yWTIBJGx1otLsz5fL69vr7eYz4+Pm4PDw+f11So/fn5+fPc V57yv7y8fAqvvPV6OIxyPD093c91nc7FRedq3+KqnMrH2OA567uNMGrXuQaqXwbG seKJIZ6JVRuTomNWJb9MLmJpUmc5/DpiwBZX/bq48FSRjPo+jDCPj4+/TbgLowqE OAK4MAzYhVGVatDkoaK9D000q4Y+vPJHOeDBdeqT1bHF1QuobtOjvg8jDINWlVVh qDwNkocC4kbCuMgjYYhnSxsJM8uhPuDqK07nEnLGtaUwEIM4e7BXt28H/sQ2Esbz MSkuDFsUE6sJrZMzyqGVQX9saWojlvvOiOtsKzu0MP405vDK8nuI30h9QEygC0AO rQ7ayc2DAJOjds5HOeDFCqOQOEaYEVfnyX3Fhal9H0YYJwpqZe0Br9x/HN9P4jdP R62svYTZecs4KpYTCCJMKywnEESYVlhOIIgwrbAdUF8csVLcgdWvu8W8KPrb9Cze 7Q49BhNT3eZZXtxid5B5s1e8vzxWJ5ocPkZdC7dRbueiYxyI2k5fsoY4ry+53xKm ur/uyuLYYm0QP/omM4rHTnfD0J1ifK2tvOR020R5fRLcf8MD49jHqL6rwVpz0+5F 4Fx0Tl8UEOPUmKv39y1h3MvyyvVBVhufCsJOGcWThyoDVJdX6Siv4jQJbr1Xe4f8 5MQ28Rxu2TifWW4vVv7zufJcLszIlN1VGAbjDqx7WcS7GTiKHwmwJUzNi23vE/GV MNWInNn8EmWWe0uYWry+5Y5y7SqMSHOv8Ekm3resrXgG74PcEqbm9VXAwPXrW5lv Kb5t+ke9Kp7aZ7m/2sr4z4UXH79f7iKMf3Zl/4eQO7D+fcU/s/oARvE+0S5MvUHO 8o5caLYfv+F7u3+hrLm9ymcOt8+JG7UUn46dgz+MEPcXTvS+j3k/5f7+R67yzwjj 1dQh74GxnEAQYVphOYEgwrTCcgJBhGmF5QSCCNMKywkEEaYVlhMIIkwrLCcQRJhW WE4giDCtsJxAEGFaYTmBIMK0wnICQYTpg18Vr+FATsGDjQAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -199.25,
    x: 190.1
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -190.83,
    x: "169.85 174.6524 178.2524 181.8524 185.44519 189.04518 192.04038 195.04277 200.43558 203.43798 207.62837 210.02597"
  }, "&#x0414;&#x0435;&#x043f;&#x0430;&#x0440;&#x0442;&#x0430;&#x043c;&#x0435;&#x043d;&#x0442; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -182.43,
    x: "163.83 167.43001 171.03 174.62999 178.22998 181.23958 184.22039 187.82038 191.41316 194.41556 198.01555 201.60834 205.20113 208.80112 212.99152"
  }, "&#x043f;&#x0435;&#x0440;&#x0435;&#x0441;&#x0442;&#x0440;&#x0430;&#x0445;&#x043e;&#x0432;&#x0430;&#x043d;&#x0438;&#x044f;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -174.03,
    x: 190.1
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_306)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,238.2,341.40003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_308",
    width: 112,
    height: 43,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAHAAAAArCAYAAACgqQx/AAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAx0lEQVR4nO3cMQrEIBQAUe9/iRwljaBR7+Tym7jsQmC3SQameJWN MGrnTymlKbQ0t22btdZZShFAtNr3fQXsvc/WmkCO41gB796M/vMVMK7nA950XYhG BgQzIJwB4QwIZ0A4A8IZEM6AcAaEMyCcAeEMCGdAOAPCGRDOgHAGhDMgnAHhDAhn QDgDwhkQzoBwBoQzIJwB4QwIZ0A4A8IZEM6AcAaEMyDcZcAQn+f1XO+tzoCfC3q+ mCxyBhxj3H6y9Juc8woorheK2MDFLArm4wAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#99ccff",
    d: "M238.09 231.03H302.578V253.62H238.09Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_309)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,249.6,326.40003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_311",
    width: 77,
    height: 95,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAE0AAABfCAYAAACtF0ogAAAACXBIWXMAAA7EAAAO xAGVKw4bAAADxklEQVR4nO2ZXW7jMBCDc/McJUfJS/6TO3nBAiyI6SjuplqwDPaB cCPZ40/U2LKmm81ms/zXX8sOkCg7QKLsAImyAyTKDpAoO0Ci7ACJsgMkyg6QKDtA ouwAibIDJMoOkCg7QKLsAImyAyTKDpAoO0Ci7ACJsgMkyg6QKDtAouwAibIDJMoO kCg7QKLsAImyAyTKDpAoO0Ci7ACJsgMkyg6QKDtAovqO/X6/nM/nL23QL4B2q+84 nU7L7XZbHo/Hx+/tdrtcr9flfr+7gX+Dxp0wiCbBPJjIbEMWUpp97Ifph8Nh2e12 H+04Ho/H5XK5fE4Ez8dkoK3G6eKzD3HYjiNj8jpMcu1DG/rIVONMMY1G8QihHUcM FNJ29qloOicAovk1Fvo4QF7PezA+Bs0YOGJi9D78rfHZx1icjBpniml1sJiVCoKb V9PQh1lFZml28hxmFs9nNtEktuN6Dkx5cA6uodG8jm2dabgfz6VhNc4005hlCNrN 3sg07VMwHrnIaEahHY81DcRRTWN7zc6a3V0mc9Lxm9lY40wxjRnSPYLfyTQaznMA ywVFTePfmtHMuC7T9J2IeGuPJ6WT2MWZYpq+l/Tx+o5pCltjjTJNrx2ZppmPI7Nn zTS8/NW0Ls60TNPVpmZg/VtNq995XLkAqytlXSV1tevi0zhdVTUeWLvVXBk4nhpn immvSGf9jTU3YM2UN5UdIFF2gETZARJlB0iUHSBRz0+o32r8SNSqAj4ou+oFzkUb 9pBaWRh947HqUCsWtdqh15EH32A1Nr8Tu4rJiHuKafoVj99dxWNUvdCdAa/nFzkG qTsD3WyzssIv+G53oVsv3lfbuTPg+RSrGSPuKabphpYD1Q2u7hYqFKG51eHANAba NK5WIJgRGldN0423xtYJqCZTI+5pmYZB60CZbbixVi+qaZpFumHW/aYao1WHNdPU fDVtLTM1GTruKaZpLYqDIaBWMVhtUNNwLvd79RHSAiczras6PDMNk9nF7h5PNe0Z 949NUxAWFBFcTdP3EP6upukAR+8jzUZeo4vByLTRhKyZxiek4/6xaYTi7/o3+rl6 ceXShYDtep2eU/8vMKo6cCXuYoxWT612dJWSEfeUx/NVde+RN9K/CfzC7CXJDpAo O0Ci7ACJsgMkyg6QKDtAouwAibIDJMoOkCg7QKLsAImyAyTKDpAoO0Ci7ACJsgMk yg6QKDtAouwAibIDJMoOkCg7QKLsAImyAyTKDpAoO0Ci7ACJsgMkyg6QKDtAouwA ibIDJMoOkCg7QKLsAHH6AwFSarPfhH3/AAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -260.9,
    x: 270.52
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -252.48,
    x: 270.52
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -244.08,
    x: "252.17 255.77 259.96043 263.56044 267.15324 270.1556 274.346 277.34843 281.53883 285.13883 288.73884"
  }, "&#x0423;&#x043f;&#x0440;&#x0430;&#x0432;&#x043b;&#x0435;&#x043d;&#x0438;&#x0435; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -235.67,
    x: "252.72 257.5174 261.10823 264.70628 268.2971 271.89515 274.8863 278.48435 282.0824 285.07356"
  }, "&#x043c;&#x0430;&#x0440;&#x043a;&#x0435;&#x0442;&#x0438;&#x043d;&#x0433;&#x0430;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -218.85,
    x: 270.52
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_312)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,25.8,336)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_314",
    width: 90,
    height: 27,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFoAAAAbCAYAAAD8rJjLAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAk0lEQVR4nO3aMQrAIAxG4dzco3gUF0FQ75QS2lK617b8vOHt8hGy GDMzp1cyTyl5rdVba/RwpZQLes7pvXda0BjDc847dMh//SDljqm+Q/9gl0kUqxho oHUCGmitgAZaK6CB1gpooLUCGmitgAZaK6CB1gpooLUC+i/QtPBzlnODdcW5QdzN 2Dnqgf31sYli4Rq+GysjnHBMfRQSAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#cad318",
    d: "M25.998 245.63H77.021999V259.07H25.998Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_315)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,34.2,331.2)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_317",
    width: 63,
    height: 45,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAD8AAAAtCAYAAAAZQbNPAAAACXBIWXMAAA7EAAAO xAGVKw4bAAABXklEQVR4nO2UW46DQAwEuTlH4Sj88IY7seqRSrLQ7JLMRpAo/WHh TMZ2l22oqqrav9huF2B4wxve8IY3vOENb3jDG97whje84Q3/f/i2bZPhj+N4t9Dr 4AXbdV3y53ne+76/W+j18HVd7+u6pqfO1AgZW6E7Z/62bclvmiblUjyN5X/y6o7u LsuSjI3TfQ1Ad+IZNXQ+DEM2tgieJBKHSD1VQMW4R5HffAErZpqmdEZDES4fAMTz 2sU6+MqjRlCD5qkZudjiyaubJCFhFCKfacZu5+CJpbE08whPTfIe80kXv7kLfC62 GJ5Ok1TiNLmSycfXBWMjIjwbcpw8epg0jaeW/s/FPg2vAhRjUkrMhGVn8HSfSShn 3BIJjOsPPN+Y3NpjfINiPenNxT4N/2p7QMifFkFfaNfAx697afzxlfkY+De12wUY 3vCGN7zhDW94wxve8IY3vOENb3jDP2w/kgv/ZNylbGAAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6.025,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -257.43,
    x: 51.55
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -250.2,
    x: "36.175 39.175 42.169 45.762998 48.762998 51.750997 54.762998 57.757 60.757 63.757"
  }, "&#x041a;&#x0430;&#x043d;&#x0446;&#x0435;&#x043b;&#x044f;&#x0440;&#x0438;&#x044f;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -243,
    x: 51.55
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_318)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,618.6,439.80003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_320",
    width: 110,
    height: 44,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAG4AAAAsCAYAAACEy42cAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAy0lEQVR4nO3cOwrEMAwAUd08R0sT5+fcSYvSbRHYVN6BKR4YV4LB Kh0RkfM857ZtAqhW1Szq0HvP8zwF0VrLqIqjB9E71ewr3L7vw1eBnj2Guy9qf+ov GQ7KcFCGgzIclOGgDAdlOCjDQRkOynBQhoMyHJThoAwHZTgow0EZDspwUIaDMhyU 4aAMB2U4KMNBGQ7KcFCGgzIclOGgDAdlOCjDQRkOynBQhoMyHNRjODHc4a7rGj6I 3jmOo15g5Lquw//w0G+WZclpmvIDwBdC2I5uM3MAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#7030a0",
    d: "M618.29 131.58H682.06997V155.772H618.29Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_321)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.59999999,619.8,420.6)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_323",
    width: 109,
    height: 109,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAG0AAABtCAYAAACr+O9WAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAFOklEQVR4nO2bW27rMAxEu/MupUvpT9/tnnIxBc7FgLCTtE1Ku5yP QRJbokYcUbIo5+bm5uYQ7A7tBIKINgLtBIKINgLtBIKINgLtBIKINgLtBIKINgLt BIKINgLtBIKINgLtBIKINgLtBIKINgLtBIKINgLtBIKINgLtBIKINgLtBIKINgLt BIKINgLtBIKINgLtBIKINgLtBIKINgLtBNrw/Px8eHx8PNzf37dz2a1oct7b29vh /f398/Ph4eEq7cgubejz6empve+7FO329vbw+vr66URFgL7LqdcYGGrj4+PjcHd3 197vXYum0S+R5Mx6TyLqHpGh3/qUsLqvOvotQSirQaDrCP/y8vJZhk/VBSrrdmgH +xtEO4FPEFlLox8htP4wbRKViMN3pliVpZ5s6JM6LgpCqozqMmgo0+2X3YqGwxFE ovHdo8NtuThEqepIIC/rdX2Kpk63XzYtGtOjIoRrEhBHKmpcNByO2DxMUN6jCSH0 6VHJgCDSKLs0EDaGdgL/nY2jcZg7XIJV0YgaX5e45usbAhOZvj5S1kXzp8tuv2xa NEGRhVPlfESS87lPxOk3T4JEisB6p+8q6+sVdbku+OO+7CMma2K3TzYv2ldBJG3Y uRGtQlEiwZgaB6GdQBDRRqCdQBDR9gE/XdAT71L6rkU09ljdDtoiPAdKPjWibRye 6fnGlmX9JptbwrjmAD2TUDe4ZB3YrPrZmMqSasIOG2WEJgtS2/XBwMZY1z115Skv t8EUtNavNW5LdejzMV+ca8vb/7FobF490croqESJKAh5vg/ijCocKKf7PT+U5Dr2 qKMR6nZpk0FBPTIr7hhG9Kl+VW61jvf51PVTtrz9i4pGAhVnuYM9Mpy0Z8xJDy0d bpLjq5330emDQAu4t+vRjQPIT54SrfZrjZvXqX1eu36Ordr+RUVDqCoa+TkXzbPo nuwln0gEeJb92Ij1iHEuTD1eVnxw1jmi1X6tcfM6tc9r18+xVdu/uGiMllPTI6L5 GuNrlE93fgjpbVHXT5fr1OcZfNokWeyieQTU7H/t1xq370yP59iq7V9ENM+M4xwO IHWdA8u6z+DBwEXGRr3P+RkdwfHqoEYpU6rKaG3whwmcoHJMjYx4hHUg7Fq/1ri5 L2qfj/nilK2l9n8s2k/xlUf+OmKvAT+L2zmuZ/wrO/06Yq8B3zbsHO0Egog2Au0E gi2IxrscPKltoJN/DZc16Lk2z/cFGxVN+6i6Jwk2Llp9MZTNL7lHgKieK2QDzUa5 5uT8fUUyHb459XtsHfyanwSoDqcKcFlrt9qpbcHF7f7CDHNZ0WraSOQ9cVzfwfds BvcFRa3/KcOzK5Qnl6iyclY9ASAHyH5xybl+OrDUbrXDfrLmHrHrpxa7Ec0z257Z d0cy8nGKZ048+Vyjt2bJ/SVWP+JYyti7bbfnr5gvtbtkx+9Tt/Z1N6J5x3nNm2y8 n9IyrfGU6Wdn7iSPnGOiefLWnV2TsB6t/g+cOuBqxC4lc6toNfJ2IxqO8Aw/EeUO 885qOvL37+spAddPieaZ/XpSQNlj0+Nau0t2jkWazzC7EK0K54txPW7RNTL6rCVL Zf1hY+m9fBfA16Rqh/8J+MNRPX1YanfJDtxdcH/dgqOm3YgW/AraCQQRbQTaCQQR bQTaCQQRbQTaCQQRbQTaCQQRbQTaCQQRbQTaCQQRbQTaCQQRbQTaCQQRbQTaCQQR bQTaCQQRbQTaCQQRbQTaCQQRbQTaCQQRbQTaCQQRbQTaCQQRbQTaCQQRbQTaCQQR 7e/jHzrJ0YWvPL4CAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -166.35,
    x: 650.65
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -157.95,
    x: 650.65
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -149.53,
    x: "639.13 642.73 646.32998 649.9227 654.7251 658.91549 661.9179"
  }, "&#x0421;&#x043b;&#x0443;&#x0436;&#x0431;&#x0430; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -141.13,
    x: "622.97 626.56997 630.7604 635.56277 639.1627 642.7627 648.1555 651.15798 655.3483 658.9483 663.1387 666.7387 670.33877 674.5291 678.1291"
  }, "&#x0438;&#x043d;&#x0444;&#x043e;&#x0440;&#x043c;&#x0430;&#x0446;&#x0438;&#x043e;&#x043d;&#x043d;&#x043e;&#x0439; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -132.73,
    x: "630 633.598 637.19607 640.19448 643.7925 647.983 650.9813 654.00137 658.17739 661.7754 664.7954 667.1724"
  }, "&#x0431;&#x0435;&#x0437;&#x043e;&#x043f;&#x0430;&#x0441;&#x043d;&#x043e;&#x0441;&#x0442;&#x0438;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -124.3,
    x: 650.65
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -115.9,
    x: 650.65
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_324)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,698.4,352.2)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_326",
    width: 125,
    height: 43,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAH0AAAArCAYAAABVV4fPAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAvklEQVR4nO3cPQrEIBQAYW/uUTyKpfhzJ5esEFKly2ZxpvjgaSVM YfdCCGEKJ8yc86y1ztaaNtZ7n2OMFf0Y3n6QfqOUsqIfw/VS+7mN/gf/jR5gdCCj AxkdyOhARgcyOpDRgYwOZHQgowMZHcjoQEYHMjqQ0YGMDmR0IKMDGR3I6EBGBzI6 kNGBjA5kdCCjAxkdyOhARgcyOpDRgYwOZHQgowPdRtfezuiuE+M4V4rFGL+Htzcg 6XkppRVdLB/4g7GJ2YjInAAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#7030a0",
    d: "M698.61 220.29H770.893V243.10199H698.61Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_327)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,697.2,333.00004)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_329",
    width: 133,
    height: 109,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAIUAAABtCAYAAACPzaLTAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAF30lEQVR4nO2cXVLtOBCD2TlLuUvhhX/YE1OiRpRo7JxTzLklwejh KxLHact2x85xx1xdXV29lTKwCyh52AWUPOwCSh52ASUPu4CSh11AycMuoORhF1Dy sAsoedgFlDzsAkoedgElD7uAkoddQMnDLqDkYRdQ8rALKHnYBZQ87AJKHnYBJQ+7 gJKHXUDJwy6g5GEXUPKwCyh52AWUPOwCSh52ASUPu4CSh11AycMuoORhF1DysAso edgFlDxOZ3p8fHx7eHj44P7+3i26uJ3i+fn5naenp7eXl5d3AoQXl1Pc3Nx8OMTV vw6iToHrGEkAjpmmIwv58+fPez7YApof6RiBYB95r6+v315fX8+2gbwA9+H87u7u PT/SdlpZN9jEddi7vb39sDfLnnam3qP6oc2QRj1IYz7aUtuqiXWbenZ5VT/ts10u 4hQwzIpPp9DKAlyjQ9CR9H7mp1g6Gs6RjnyoAO+lTZ6jo1c22LlIRx40AEc02Ntp ZVnsPK3bqmxtk5XeXf2QB87GvHRYtsuq7WY7rvTs8sIh5n2s40WcghWhN2rD4Zo2 Aq6h8iqW99CptAJAHY/5p8Mwnz6pakOPAZ9gOsFOKzuWzjunxlXZp/Su6scnlxr4 FE/t0zan611b7PLCPo7RDn/FKVgYz9Up2JA6pGmFp1PQg+loO6fQ6Wo2xMoGnhqW oR19SqvmWb0vnesU8wmd9VPdqkE1c6RhOutxjlOs8rI+1HExp9BhSBuSDQBPZCX5 DoC/O6fgvcjDDpmVo81dQ6xssBNwnR07h/CVVo4oq+njHKeYenf1g32MtPp+praZ rg8UR+dznGLmVXsYuS/qFDqHKfpE6VxHcRRFIRwydZjjUDorp/MzHXO+2E4bdABO E2w4OrU61GqaUZ18B1mVveoM1burH+3MvPqE82WQ6dTEF9ddW6zyav9gFNU8F3EK vo0fTSn/lTmypPPT9H6D/UV0/mqhSn/6XII5sqTz0/Re1CnK/xa7gJKHXUDJwy6g 5GEXUPKwCyh52AV8rILO5XJc06Vo/jzGAhl/EnJBCGmMu6gNzYt7kWdGKs+xjWu4 T2MJmhd14IIY0nUBDmmMzHIhKfxnrV3ApyinLiEzXVcQtUF1hZXnukrIVVQNyHEp mEvRzMdl4Z3tGXTS5WSN66g+jQzzGu+fS+ph2AV86ThdMcVTp8ErNjQ7ceafq43T 4TSSOCOkR7YZdNMnW20zBqPpjIvwutoLHiWynUJjBvyrHbdyoiOn0PgNO1mDfUe2 V4ElHVXoVLNMHRlwTSOodYpvOIXO36uRQqONp5xiTh86UvC+OX2o7TmyzKlJP9hR p9DIJ6csBq5WEdgQ7AK+vHSx4XQ+1vcM5lemE+zONerISOaMXu5szy+u1DY7XJ2W X2vpOwvLoVNcMob0q5ziu06k303+BNs/CLuAb3fc35iTw38q1imKDbuAkoddQMnD LqDkYRfwq+H6he7Wcms6A7uAX41+ev+DftXYBSwbUhd8eK7L0fzKXBuaO6J2Nmb+ 3bEuLul2wV1ZQKOi/Fl7lB6OXcAXdEMPj2cchB2i2xB0s8zKxsy/O9Y4ie4F2ZWl 19ShjtLDsQv4hEYYcc6G1E1GutrIpei5UXdn45RTzKiqBttWZU2n0CjoUXo4dgGf WG3eXX2nMJ1Cd38d2TjlFBoE41RF51qVpTo4wugutV16OHYBn+CLGf97ztyTuXKK OaQf2ZgRUD2Gnbl/k864K2s6J993tLxVejh2AV/gtw7sNP18br7B8wMYHOve0Z2N uS9W4YjA/ZfqNEdl8RrL4P1H6eHYBZQ87AJKHnYBJQ+7gJKHXUDJwy6g5GEXUPKw Cyh52AWUPOwCSh52ASUPu4CSh11AycMuoORhF1DysAsoedgFlDzsAkoedgElD7uA koddQMnDLqDkYRdQ8rALKHnYBZQ87AJKHnYBJQ+7gJKHXUDJwy6g5GEXUPKwCyh5 2AWUPOwCSh52ASUPu4CSh11AycMuoITxD1X5lS5WC6dOAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -254.45,
    x: 735.27
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -246.05,
    x: 735.27
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -237.65,
    x: "700.4 705.19747 708.7955 712.39358 715.9844 719.5824 722.57357 725.5719 730.96176 733.9601 738.1506 740.54928 742.34109 745.9391 749.5299 752.5283 756.11917 759.7172 762.7084 766.30648 769.9045"
  }, "&#x0414;&#x0435;&#x043f;&#x0430;&#x0440;&#x0442;&#x0430;&#x043c;&#x0435;&#x043d;&#x0442; &#x0440;&#x0430;&#x0437;&#x0432;&#x0438;&#x0442;&#x0438;&#x044f; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -229.23,
    x: "716.13 719.73 723.3228 726.9228 729.91799 733.518 737.118 740.71798 743.72756 747.3132 750.91317 754.506"
  }, "&#x043f;&#x0430;&#x0440;&#x0442;&#x043d;&#x0435;&#x0440;&#x0441;&#x043a;&#x0438;&#x0445; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -220.83,
    x: "718 721.6 724.59518 728.1952 731.79519 737.1951 740.7951 744.98556 748.5855"
  }, "&#x043e;&#x0442;&#x043d;&#x043e;&#x0448;&#x0435;&#x043d;&#x0438;&#x0439;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -212.4,
    x: 735.27
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -204,
    x: 735.27
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_330)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,88.8,387.6)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_332",
    width: 102,
    height: 45,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGYAAAAtCAYAAABcQB7NAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAx0lEQVR4nO3cMQoDIRBAUW/u0WwUWfVOE9wiIZCt/ZBfvMZK+Djd mFJKIaCcc1zXFWMMAcw5Y60VqbV2/DL61nuPVGt9H+yXsw91xmOYUsr52frHDANl GCjDQBkGyjBQhoEyDJRhoAwDZRgow0AZBsowUIaBMgyUYaAMA2UYKMNAGQbKMFCG gTIMlGGgDANlGCjDQBkGyjBQhoEyDJRhoAwDZRgow0AZBuoxjFvLoK1l9/x57jB7 fO3fGE5fRh/3zxin56p+ewEF5tqjF0JisQAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#cad318",
    d: "M88.446 183.51H147.483V207.702H88.446Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_333)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,88.8,384.00004)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_335",
    width: 105,
    height: 58,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGkAAAA6CAYAAACzmHdjAAAACXBIWXMAAA7EAAAO xAGVKw4bAAADXElEQVR4nO2ZXY4iMQyEuTlHmaPwwvA7d2JVSN+osNzMLqvBYPmh RNpxHNuVpDtmtVqtLoOXR7kDgyGpBcodGAxJLVDuwGBIaoFyBwZDUguUOzAYklqg 3IHBkNQC5Q4MhqQWKHdgMCS1QLkDgyGpBX5/ks1mc/n6+lp8HrwAScL5fL6So/bh cLjs9/vrs35pq+/j4+ObyGhDxNKPjsa6TDqS+SJYr9c39pba0luSZ/60I0lJOx6P 14SKMMn0DEkuO51O11/JSBzESr7b7W7GS0+/kmms2vrV83a7vbalI33G4ZfaEIBc PmqM5Nn4tiQJJFMJj8kiqRDp+uhIrrGRZMm0CEQoNrGHDQjOFkckiTkkz8a3JkmJ zJISSUJGMkk2u8tJ0q5CT3YjSewsEElixyDXznGSsvFtSeJjIZKQkUTCnVD1ZzsJ 8tXvCXd7yLLFEY87+pg7G9+WJK3Q+OKXjLYfgdodceXyQfD5+fn9UaA2epJl9vzj RPpxXrXxSW2IwNdsfFuS/haF5/4ro9yBGxR/6r4qyh0YDEktUO7AYEhqgeXO+BLn czR7ucd6GOUcPp29Rnfv3pHNGe1mMq+7xbGxuBt1fpJ5PFmf5ybLzz1b/0WS18UI EhkXRYFn3UtiKYYKAzpeiuHiyKWRskss1XhpyMffkyH3Sy91OO5PSzFy4XZ7Hg99 2KDNJdv9z2JyW57Hh0hiEk1OYPGmT5vLpzsCadkt35MiPQhDN85JcdWTkMmwi+/4 y2LRHL7jdFllAcWquS6uXn3weLys5DpOaqxWEFOWm4dJwgkMK6ClKrIfZwqQhKnP d6GTREBUInxVIUMXfV+VmYxCqxNH0ikbeYwcxVlpKJaIPB4Woi+2jKQspiw3D5Pk VWW2eVa9pijpZywOu6ORpLjaPAGetH897pgzHncshHgk0u87dxPqjEvxLC08jy3G lNl6mCQl3leZn+Ve+xKRHD3o4BjtOIYV6PUwt8P/RdEWwWUyr/fRz0LDB8m8/kaM mpdj0Ot0+JzFE/9YjDo6ebKYMlsPk/SbiC/5d4R/3DwBzw8wVsPfEU8kqIakwZDU EeUODIakFih3YDAktUC5A4MhqQXKHRgMSS1Q7sBgSGqBcgcGQ1ILlDswGJJaoNyB wZD0/vgDNy8jYHDzpEwAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6.025,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -204.23,
    x: 118.05
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -197,
    x: "102.7 105.7 108.7 112.294 115.288 117.688 120.688 123.676 127.282009 130.282 133.27"
  }, "&#x0423;&#x043f;&#x0440;&#x0430;&#x0432;&#x043b;&#x0435;&#x043d;&#x0438;&#x0435; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -189.8,
    x: "90.8 93.2 96.79399 99.78199 102.193988 104.58798 107.58798 111.181987 114.181987 117.181987 121.375988 123.775989 124.97599 127.96999 130.96399 133.36399 136.35799 139.35799 142.35799 145.35199"
  }, "&#x044d;&#x043b;&#x0435;&#x043a;&#x0442;&#x0440;&#x043e;&#x043d;&#x043d;&#x044b;&#x0445; &#x0437;&#x0430;&#x043a;&#x0443;&#x043f;&#x043e;&#x043a; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -182.6,
    x: 118.05
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_336)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,238.2,373.80003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_338",
    width: 112,
    height: 49,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAHAAAAAxCAYAAAAC5C2CAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAA0klEQVR4nO3cMQoDIRBAUW/u0WwEXT2UwRTJwi6SVO6HXzxshc9M OSGEMIQWRs559N5Ha00QtdZvwOM4tn9I/7sNWErRg51bXQLO9wE7XQszogHBDAhn QDgDwhkQzoBwBoQzIJwB4QwIZ0A4A8IZEM6AcAaEMyCcAeEMCGdAOAPCGRDOgHAG hDMgnAHhDAhnQDgDwhkQzoBwBoQzIJwB4QwIZ0A4A8IZEM6AcAaEMyDcMuC8l7b7 EpHWzjftLgHFYkCwOYmfgFNKaft60O9ijO9uL9XUsGuBtv4jAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#99ccff",
    d: "M238.19 194.72H302.577V221.6H238.19Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_339)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,247.2,364.80003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_341",
    width: 84,
    height: 81,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFQAAABRCAYAAABMpoFyAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAExUlEQVR4nO2aa1LkMAyE5+YchaPMH95wJ7aaqm+raeQJLAHNCn50 TR6K1O7Ijq3x4XA4PP9iV7QTmIZ2AtPQTmAa2glMQzuBaWgnMA3tBKahncA0tBOY hnYC09BOYBraCUxDO4FpaCcwDe0EpqGdwDS0E5iGdgLT0E5gGtoJTMO20fF4fL69 vX2FMyB+rtg2ur+/f354eHgFiXwG5M8R20aPj48vIur46urqjaBksF97enp6ldHX 19d/be/u7t5kuu7rnn71Ai8vL9/0DMVe+VA8PQeHi4uLF/vsTcmVuNyTD7fL2LsJ SqAUVMF0rga6na7p2LPbr/OSaLBnv+4JEil7xspH2uhZT4QVV+J523i+iv3lgnJP ZGkkjeaYhmSmpKCrGDquMsR9uDjKbnjBYcWVuO7DY6xi/7OgkNYby8Zyz7NxS1Bs IO+Cpr3f80ZVPuDoGajurHOGj4prZuGXCioiBL65uXn1FnXOW/dxyrMqBfKXI99V l2ccW2Xoyod+GX8RG4FJhorrqst/iaA5NlVvMruOsuNUhubYlRmKb/xUjUofskVY YvFh85dWcf12QRnXKqE9k3WNTODt60urY/3611e2dEP9uqC65n6EPK98uM2KR8XV OVSx8vxbBN0Dnin/OdoJ/M2UIYuFdgLT0E5gGtoJTEM7gW+H5qt8ADV1qj68v4J+ ALlq2rkcuc8b13ytqpvquibGrLp07PNC3acyxZeeOabuewVJcL8en+s5U1jZYwcv 59QqqL9pX7X49awi+RzWixisanzpyGQf27TnuseiVLiyz9XTzvXdz3cdX2f79VOF j2yA+0JU95GxWKezvJQwqi+wnN2yJ3OJcxaCbonjgnLs1Sp1s6xt6r6PcVl35dz9 ZG9g2Niy95rAWQiapT2vyle1TmUHpTXW91kKpOHZTTOWf509E+nmW/YUYKp/INoE FXKMPNXlsaORdD9/3jOTbkqpMGP5WOlj9Ja9V8vOTlAETEL+VUVcZgJuR/VHGct9 t8lqUc4C/FpVGars027nGsJujpbwbP0B+PogWXMcjnYC09BOYBraCUzDaQOmL8wL h1TVewQ92l+6rK1/0Mdlf0FzKZdis9Jgnsi1nG/yYnSP67n3yV+W/FFB8r9wecZX ZBzrGfe/ipt++Ae1AvZU0z4t6GoFI2RliRfguzIg61Umhg2vKmUhxDcr8KvVj6+q /D94xPMl6Cpu+snqmNcEEP+D8+jtDPWtLJTUKMx6EQIBEVXnvj1H52wCczFy6w3g +dzUpesei2xzQVdxKz+eDM6HxMkdJ5/KUP97gEZ7JgJE96xKQfHBVsSVoBLF/eS+ KVDtbKkE9biVn5WgnuG7ZaiLRfE2STH2+fhINtNQry6RVStBsxjsgsLFS3RVl1/F rfysBOX53QT1r7yPlUyjqr2fWWPE1scnuutK0NwZ59V7H8tPCbqKW/mpBGWI8J75 aUG9a1Xzz6wMUTmqbLMaRIa4r/TNl597vqfpPT6quJWfbEvl9wP/Ob3L6BfvRzuB aWgnMA3tBKahncA0tBOYhnYC09BOYBraCUxDO4FpaCcwDe0EpqGdwDS0E5iGdgLT 0E5gGtoJTEM7gWloJzAN7QSmoZ3ANLQTmIZ2AqPwB2xDxu91yEkfAAAAAElFTkSu QmCC"
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -222.48,
    x: 270.58
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -214.08,
    x: "250.35 255.1524 258.7524 262.3524 265.9452 269.5452 272.5404 275.5428 280.93559 283.938 288.1284 290.526"
  }, "&#x0414;&#x0435;&#x043f;&#x0430;&#x0440;&#x0442;&#x0430;&#x043c;&#x0435;&#x043d;&#x0442; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -205.68,
    x: "255.08 258.10005 260.47706 264.66755 267.66593 271.25675 274.8548 278.44563 282.04368 286.23417"
  }, "&#x0441;&#x0442;&#x0440;&#x0430;&#x0445;&#x043e;&#x0432;&#x043e;&#x0439; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -197.25,
    x: "249.92 253.52 257.12 260.1224 263.7224 267.9128 270.9152 273.9248 278.108 281.708 284.71763 287.10804"
  }, "&#x0431;&#x0435;&#x0437;&#x043e;&#x043f;&#x0430;&#x0441;&#x043d;&#x043e;&#x0441;&#x0442;&#x0438;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -188.85,
    x: 270.58
  })), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#3366cc",
    d: "M321.1 442.05V448.1H367.59"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_342)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,699,381.6)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_344",
    width: 124,
    height: 46,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAHwAAAAuCAYAAADqWH1CAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAA3klEQVR4nO3cQQrDIBBAUW+eo+QoWZoY72SZUEJKaVdtBP9fvM2s hC+6m5RSavM8t5yzBrYsS4vWaZqmtu97K6VoYNH4iB71ex9G94jWL8HXde3+9Oi3 ounH4Mcg3nkN462vwcdmcBiDwxgcxuAwBocxOIzBYQwOY3AYg8MYHMbgMAaHMTiM wWEMDmNwGIPDGBzG4DAGhzE4jMFhDA5jcBiDwxgcxuAwBocxOIzBYQwOY3AYg8MY HMbgMF+Dx/K2bds0kOvSxSN4rfUcaGzP9Zup+y3U/12+6/7/jO7zAN7j7hCz9AcA AAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#7030a0",
    d: "M698.75 189.05H770.75V213.914H698.75Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_345)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,699.6,385.80003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_347",
    width: 124,
    height: 33,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAHwAAAAhCAYAAAAbDs+XAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAC40lEQVR4nO2aXXLCMAyEuTlH4Si88A93SmeZfp2tKqcZYOqE6mEn jm3FK6/sEIvVarUaCv8K3QkUSvBCCV4owQsleGFpgm+322G/33/dbzab4XQ6def1 RuhO4Aeu1+tdeJUldgn+5oLfbrfhfD5/E1/3KusqqM7vL5fLsF6vv+x1r3aVVUcf XQkg7hkLO91jp74efFlZ/Y/HY2o/Q3QnkEJiHQ6H+9WFZ4IR3AVV/xg40Z7goQ7h /bne38dVWcJ6u4SXveoz+97zuBjBESubQBecut1udwftrGQX3HcJ/TZAeARHOKA+ 6u87iQuuAHObzL73PC5CcG3NCEpdS3AXDTHY3nWf7RBq998GLjh9EGtshQvq54JH +xmiO4EfkBC+PQpa8S3B/T1MO23+LqYecXjnI7iemb3XGbdV1s7C6yLazxDdCTyM Gb8n54zuBB6GVtmMt865ojuBQgleKMELJXihBC88KrgffOgb1o8w/dSJo0rOrpXp 8u9RPxyJtowzZs/3stpUBs6PZ2DnfbJ+LT8Yk2xdxrfFmXrnrZO4OAcZx4zfFH/1 heLf/RM/UccFdxJ+cuXtuvrpmJPDJrP1cna6JvjplQ44PFA46YoJFYK0JfiYH4zb 4juFc+SNyNlCUrBEP3jGFH89gJ8WnOgkgp2AO+UOx4ln4jLbbDI9cllBY4IjrI9L IoPTMCaIlTbFjxbfFmddM974zw4ZOZIgcj/GBPd+CjjPFr5kheuhbKuk/9ROmeiV s3HiXfDM1qPf7RVgWeTGCfBUZxyXtmyFt/xwEVt8W5xV3+LNHMZg8VeG+9ESPPM3 y/Q9LDhRqYFJPZKB8nek55qp84j282y3dUeiPavEHREHMmLbz9RktjMQZAjiXJjQ zI+Yw874tjh7IMBbAUD6lGdHjqqPflD+zV/X5WnBpyKujL+274Elcn6Z4IrYZ/7d 8ax9DyyR88sELywO3QkUSvBCCV4owQsleOEXfAAutbBiGsBwnwAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -202.9,
    x: 719.25
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -202.9,
    x: "720.6 723.6 726.6 730.194 733.188 735.588 738.588 741.576 745.182 748.182"
  }, "&#x0423;&#x043f;&#x0440;&#x0430;&#x0432;&#x043b;&#x0435;&#x043d;&#x0438;&#x0435;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -195.68,
    x: "702.3 705.294 708.294 711.294 714.294 717.888 720.888 723.882 726.27609 729.27609 732.2701 735.2701 738.2701 740.66409 743.66409 744.8641 748.45809 750.8581 753.8521 756.25216 759.8461 762.2402 765.2402 768.2342"
  }, "&#x043a;&#x043e;&#x0440;&#x043f;&#x043e;&#x0440;&#x0430;&#x0442;&#x0438;&#x0432;&#x043d;&#x043e;&#x0433;&#x043e; &#x0440;&#x0430;&#x0437;&#x0432;&#x0438;&#x0442;&#x0438;&#x044f; ")), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_348)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,394.8,263.40003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_350",
    width: 107,
    height: 35,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGsAAAAjCAYAAACTtPQNAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAsElEQVR4nO3bsQ3DIBQAUTZnNDoQZigiImE7ipLW/6QrXgN0B1SQ UkpTGGmWUuZxHLP3rmBWl1rrFWsPKqYxxhXrPvH0TtLnqdq+YrXWnr6TdbN6GAvC WCDGAjEWiLFAjAViLBBjgRgLxFggxgIxFoixQIwFYiwQY4EYC8RYIMYCMRaIsUCM BWIsEGOBGAvEWCB/Y60H8GuBYlg9fsZSXGcsv/zEd8ba96Niyjm/G70AXG/QR9UT 8cMAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#ff0000",
    d: "M394.7 313.52H456.18003V331.75999H394.7Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_351)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.59999999,405,250.20001)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_353",
    width: 73,
    height: 81,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAEkAAABRCAYAAACe9osqAAAACXBIWXMAAA7EAAAO xAGVKw4bAAADFklEQVR4nO2YW47qMBBE2TlLYSn88IY95aoinVHLcsgwulGlUD6O iB23Uy53HJvdbrcbNmaxC0jALiABu4AE7AISsAtIwC4gAbuABOwCErALSMAuIAG7 gATsAhKwC0jALiABu4AE7AISsAtIwC4gAbuABOwCErALSMAuIAG7gATsAhKwC0jA LiABu4AE7AISsAtI4PeNX6/XsN/vf8qn02k4HA7uAazLpPv9Ptxut/Fa5jweD7f4 9Zl0PB5HY5RNMkuo7vl8DtfrdSxfLpexTmWZKlRWvDJR8dTTp+KpU9/qQ9eq17Xq VFYsz1ecMpk+etfSQPa38YuZRDbpwRoAZgjdkzihMmI0SDIOs4TiGQjx6lsZirGq V381g6mrcb1rzGcC2vhFTSKb6kN7JlGn9m3WKLaaVLOLWZdZ1ZCabZqkGkcmVz2q Vyz32vhFTSILyIp3maS6mkmk/7tMqq9izSTawLtM0vNac9v4xUwiK+oD6xogQ0Rd j+qaRHzNpLqmsW5U01mTFMOaoph3a1LNXNakNn7xTJqjzuyX8P87ZdFdweDWa9IX YheQgF1AAtM39VXgU/qHvcU3MX2Tz3XdxX7SOZ/ipdrPwQQvZhL7lt5A2v0GexM2 bso6CWTPwy69Hg/oi7javv1ngXhxPp/Hsvqpu2fFczZUfxzA2XnTz1Qc+7aPTOrN gjZ2DLJ2zIZQr6cGQRtMlmAOlZjbO9NNZZLaqX01rMaw5eC53G/HMBX3iwzu39Bg 22COHZRbk8hArqtJzCDiOG5MvW605R+BenKvu/k6WAxhB9+aNBf3sUntjClzqnHV mCmT+JXYdpYZfM2kqZRvX+3e0aJnkjRX4+fiPjaJ14s1g9epdwbijNReM2OkNP0Q R1818+pZD1hr6prU/gWiiagTyvmu/kMwF/cnkzY2kzaTNpM2k1aJXUACdgEJ2AUk YBeQgF1AAnYBCdgFJGAXkIBdQAJ2AQnYBSRgF5CAXUACdgEJ2AUkYBeQgF1AAnYB CdgFJGAXkIBdQAJ2AQnYBSRgF5CAXUACdgEJ2AWsnn+iSvWQBwq33wAAAABJRU5E rkJggg=="
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -338.58,
    x: 425.75
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -331.38,
    x: 425.75
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6.025,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -324.18,
    x: "410.4 413.40046 416.4009 419.99784 422.99229 425.39024 428.3907 431.39115 434.98207 437.9825 440.98298"
  }, "&#x0423;&#x043f;&#x0440;&#x0430;&#x0432;&#x043b;&#x0435;&#x043d;&#x0438;&#x0435; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -316.95,
    x: "407.45 410.45 414.044 417.044 418.84403 421.838 424.238"
  }, "Contact")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -316.95,
    x: 426.42
  }, "-")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -316.95,
    x: "428.25 430.65 433.638 436.65 439.044 442.032"
  }, "center")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -309.75,
    x: 425.75
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -309.75,
    x: "427.1 428.3 430.09397"
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -302.55,
    x: 425.75
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_354)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,479.4,306)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_356",
    width: 88,
    height: 47,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFgAAAAvCAYAAABnsg1NAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAtElEQVR4nO3bMQoDIRQA0X//S3iUbQRx9U6Gv4GUqXYxE6YYESt5 ip0REcseLVbv3W5uzvkGzsl5nvZAx3GsaK19FsYY20+e3lfgnP/Am4Wu1iqwwOAE FpidwAKzE1hgdgILzE5ggdkJLDA7gQVmJ7DA7AQWmJ3AArMTWGB2AgvMTmCB2Qks MDuBBWYnsMDsBBaYncACsxN4J7Dd2wWcw+6N/GP5a7aUkrc6ro/LeZPt3tL2BR1z 1mfDDPcHAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#99ccff",
    d: "M479.16 263.55H529.428V289.28999H479.16Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_357)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,481.2,296.4)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_359",
    width: 84,
    height: 81,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFQAAABRCAYAAABMpoFyAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAEMElEQVR4nO2aW04rQQxEs3OWwlL44Q174sqRDip83QkoGSop8VHK ZMbtrq5xP8e73W738Yezwk4gDXYCabATSIOdQBrsBNJgJ5AGO4E02AmkwU4gDXYC abATSIOdQBrsBNJgJ5AGO4E02AmkwU4gDXYCabATSIOdQBrsBNJw3Oj5+fnj9fX1 E29vb27Sl4zjRiVg4enpaf9bourzu7u7/TO99/7+vr8Hyqbb39zcfLHnF1vsvuPj 9vb2y3N8aR0TV+otlO136j5Z0JeXl32U1nU5V0HrPiKXHQS5B+pZ3SfC639d02Du Y19+fuKD687zGNe6vr+//69tq7pPFrTe/ESUt0jjaSh2SpTGU4bIKBuiBdIlDj2i bB4eHj79Us/kg/IMR314WnFdCbqq+2RBe8O1Uo0CcEzQKlPXRJQKin391v8SASG0 m04+eAH9v9Y7ce33NKKnuk8WtFcyRejj4+NYrguq9p2sXmtX7naTDyIJIemuCHyI K5E9zQ9nF5SGTaArIRa2iDgJSgMpz0Sn46KOXVOjJh9EGhMJIlOWIWLiuurymwgK AZ3t+pusKCrydb9+a8yFnI51XOusWcCeLlioBjJZ1W/ZYzf50JlbZ3/Kqq/OVXni i3qmuk8WdFpz9jd5DmikXDnWDyuyptmtv8lzYFXXFcJOIA12AmmwE0iDnUAa7ATS cB5HtWbT9VrN2PW/7uvsrdf9REfv9/Vg/Wdd2Otd+Z98req8OEH7llR3QrpmZb3J LkTBFpKyfR/ODod9eq938q++pjo3EPW8gnJaRGNWDaYMJ0Rc62lP306y45rE7v4P +dI6+3npRQlKQydBFbojUnGmswMVVEVjB7fyv/LV69wA5xVUj9FUUMasQ4Ie2+oy jk4R2v2vfF2VoP206ViX743TsVK7LPc18vWwZfK/8nU1gk6zKWNePxxWOz2J0nJq pxFa19NKYfI/+ZrqvEhBt8QWp1sbwk7gKCqa+LRyBbATSIOdQBrsBNJgJ5AGO4E0 bOO4n+qwZ9bsj/41sa8pV/6mL5PTl0vNd5pOqq5G0Gl/jRjTXr/K9G/+/ThPn7PL If9JfbIrqjJ8d1fbDQ5Dfk9QoqPvtYlYtoWVzbHaqxc41quIo0yPwJ44VkDQXi5O UD310RQayveUGN2Ld0F7hOoL6FH/w4SF6xGU7owYpNLQYBVNI64/Ixmsymk0Tik6 0RGqOUzkIOm4WiCpSyOMSNTMOh03Sec5NIZueCiynaDkDDEBaP6RiquZcERRCaKN RjBdMWgeaImmp1o6y+uqAU6/0O037wLLyP0OppynQ4fHF4Dfq4yI+cnSpZ+zFi48 D8pOIA12AmmwE0iDnUAa7ATSYCeQBjuBNNgJpMFOIA12AmmwE0iDnUAa7ATSYCeQ BjuBNNgJpMFOIA12AmmwE0iDnUAa7ASi8A+8CibfZCR7DQAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -290.83,
    x: 504.65
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -282.4,
    x: "484.43 489.2324 492.8324 496.43238 500.02519 503.62519 506.6204 509.62278 515.01559 518.01797 522.2084 524.60598"
  }, "&#x0414;&#x0435;&#x043f;&#x0430;&#x0440;&#x0442;&#x0430;&#x043c;&#x0435;&#x043d;&#x0442; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -274,
    x: "490.75 494.35 498.5404 500.93803 504.53804 508.72843 512.3284 515.9284"
  }, "&#x0438;&#x043d;&#x0442;&#x0435;&#x0440;&#x043d;&#x0435;&#x0442;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -265.58,
    x: "492.67 496.27 499.87 504.0604 508.2508 511.26039"
  }, "&#x043f;&#x0440;&#x043e;&#x0434;&#x0430;&#x0436;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -257.17,
    x: 504.65
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_360)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,396,415.2)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_362",
    width: 106,
    height: 47,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGoAAAAvCAYAAAALtF9IAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAA00lEQVR4nO3cMQrDIBhAYW/uUXKULNGgOZTFBkJKaTrqgzd8iy7C Q93+EEJoAliWpdVaNaHjONq2bWeolNLwA+m3UsoZqhe7L+77rgk8hlrXdfxbrLce yFAAhoIwFIShIAwFYSgIQ0EYCsJQEIaCMBSEoSAMBWEoCENBGArCUBCGgjAUhKEg DAVhKAhDQRgKwlAQhoIwFIShIAwFYSgIQ0EYCsJQEIaCMBSEoSAMBWEoiMdQfVJI 39B4vcVHqJzz17QQzeMKFWP0Jk3s9h2Nf4/13wsMYK1i0Fi5OQAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#ff3300",
    d: "M395.65 154.8H456.595V180.202H395.65Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_363)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,399.6,405.6)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_365",
    width: 96,
    height: 81,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGAAAABRCAYAAAAtvqMwAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAEiElEQVR4nO2aW27jMBRDu/MupUvpT9/tnjpggFMQd+SZpDXKtMwH EUfWg7qUZIvW1dXV1fsFUcQJtCNOoB1xAu2IE2hHnEA74gTaESfQjjiBdsQJtCNO oB1xAu2IE2hHnEA74gTaESfQjjiBdsQJtCNOoB1xAu2IE2jH5ws/PT29Pz4+fuDh 4SHdmZ+Izxd+eXk54Pn5+f319fWAM+jQT8PnCt7e3n4EHzFcAN3XDBF0TZrPGHBz c/P+9vZ2qEv1eH6V18zSPeW9vr4+5D2mDvIKulad9/f3h/xK2+JK31Sn7qvOu7u7 w/Wq7YgAalgkIeACqAO6VoeYHQQf0by8oDz61T1EJZ0y/HLNf4I66yCQSlceicBM FbctrsrrA8H7tmo7IoAIiwQjy0nqngdD9wjS7BgCukCCi0z+KQ75fCR7HVzDVTMJ ntSz4kp+BspcXldtf7sAjBb+uwA+GgFTdyWA7nnHtwTwJW8GYVWHj+Q5k/7F1fOs nm9xAegsI8Snve5ppIkway+/WwJQVnnovHdUUB0+cmcQVnUghg+YucytuDJTVkvQ WQjga6DDR4qvlTzQGIlzSdF/yrMkTAFob7UcsfzMOgj2nLEMIBfP22FW0JYLv2o7 IgBvBY65LH0Vc8b8UpxeSIFebbpYgvYix1vMRYALLgL8YsQJtCNOoB1xAu2IE2jH 9k12hLpm84JDqHtseDCklKZ3d/3XK6kbXtNB9NfVU+tyQ8532Q7MNdpQGnsXr8M3 d95fAf8IN3bGh1dkf/3Gkd1FAN9y+w4VoqQRCDeuSFen3fkkcATj1LokCB+CsAg0 KHw37gKpDZWb/o87slv2hru1K+sBTm6B+2DZTQA6xubLDTOBAJEfh9T9F/KzuUKA U+vyGeVB9rLO3T2klQG3clg96H7t9osLQNu0A+fdBGD0rLz/VdB8hBwjwCl1MVPm KN8SYOVougD0z81Cr3uK4aPd++EO6u4CzEAxqvjaRGC8A0x7T18JcGpdPpK3Zs8U QAGZS5C7pAT0f0vQdHTpB89H57mLANO2pWERYSSuLGIH9jB5cERZzk6tC5Ecztc/ CvkD1r+CEbA5s6fLyX++K/gs5D4P6NVA/bIAp2JPn3xnz/2csV9l/qZ0TnWdOeIE 2hEn0I44gXbECbQjTqAdcQLt+L7GcDgd2ihhaHGOx09caBPE5mceBJgu6zxTOo9F ssli161r2q4QgJ2rn/l019PP5xCwme4nJNyv4VfpBN+9G3bQbkXPXXqFANOrQQCC gG8z0yk/rQK3APyksp/Q84O6K4SPvZyHACsTbKb7aOWks1vD7um4C8pop76LABsC sDZzzVKikYzT6F/A+ILmzqcfxHWRsDZ82albguZHFQ8Y99zO9WWDNd3T/bsA5SWU MJ8d7lK6jV0lwDEz4xhsHVmcb1A/BHECf33ZOkYA9/pdAH8Q/xDECbQjTqAdcQLt iBNoR5xAO+IE2hEn0I44gXbECbQjTqAdcQLtiBNoR5xAO+IE2hEn0I44gXbECbQj TqAdcQLtiBNoR5xAO+IEqvEHIEr3InFKTZQAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -181.8,
    x: 426.42
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -173.38,
    x: "406.2 411.0024 414.60243 418.2024 421.7952 425.3952 428.3904 431.3928 436.78559 439.788 443.9784 446.376"
  }, "&#x0414;&#x0435;&#x043f;&#x0430;&#x0440;&#x0442;&#x0430;&#x043c;&#x0435;&#x043d;&#x0442; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -164.98,
    x: "402.5 406.0928 409.6928 413.29283 417.48323 421.08323 424.68324 428.27604 430.67366 434.86405 438.45686 442.05686 446.88087 450.47367"
  }, "&#x043a;&#x043e;&#x0440;&#x043f;&#x043e;&#x0440;&#x0430;&#x0442;&#x0438;&#x0432;&#x043d;&#x044b;&#x0445; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -156.58,
    x: "414.45 418.04808 421.64613 425.8366 430.04158 433.03996"
  }, "&#x043f;&#x0440;&#x043e;&#x0434;&#x0430;&#x0436;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -148.15,
    x: 426.42
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_366)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,696.6,414.6)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_368",
    width: 130,
    height: 45,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAIIAAAAtCAYAAABiSbPGAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAlUlEQVR4nO3cKw7AIBBAwb3/pTAYPneiQbQcoAISRgwCtQkvyI2I GBDz6L2PUgqXqbWOlNIK4b3kPvPtvxB2D4MQEAInEAJCQAgIASEgBISAEBACQkAI CAEhIASEgBAQAkJACAgBISAEhIAQEAJCYD8hIASEgBAQAkJACAgBISAEfobQWts+ EAeEYOHmneYHkHNeIcAD88OqT5IZrTUAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    d: "M696.48 156.44H771.59799V180.632H696.48Z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#7030a0",
    d: "M696.48 156.44H771.59799V180.632H696.48Z"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -182.83,
    x: 734.58
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -174.43,
    x: 713.55
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -174.43,
    x: "715.13 719.9324 723.53237 727.1323 730.72518 734.32516 737.3203 740.32278 745.7156 748.71798 752.9084 755.30599"
  }, "&#x0414;&#x0435;&#x043f;&#x0430;&#x0440;&#x0442;&#x0430;&#x043c;&#x0435;&#x043d;&#x0442; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -166,
    x: "715.57 718.5796 720.97 725.16036 728.1628 731.7556 735.3556 738.9484 742.54129 746.1413 749.7413 753.32687"
  }, "&#x0441;&#x0442;&#x0440;&#x0430;&#x0445;&#x043e;&#x0432;&#x0430;&#x043d;&#x0438;&#x044f; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -157.6,
    x: "709.65 713.25 716.2452 719.838 722.8404 725.8356 728.84518 731.23556 734.82839 738.42837 742.0284 746.2188 749.8188 752.82839 755.80917 759.4091"
  }, "&#x043e;&#x0442;&#x0432;&#x0435;&#x0442;&#x0441;&#x0442;&#x0432;&#x0435;&#x043d;&#x043d;&#x043e;&#x0441;&#x0442;&#x0438; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -149.2,
    x: 734.58
  })), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M158.96 369.4H153.49V189.14H156.79"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M88.735 333.19H84.31V299.7H89.15"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#515151",
    d: "M88.735 333.19H84.31V259.61H89.256"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M88.735 333.19H84.31V224.98H88.851"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M88.735 333.19H84.31V195.61H88.446"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 9,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -559.38,
    x: "267.5 273.50303 278.30003 281.89103 286.09403 290.89103 295.68803 299.88203 304.08503 309.47605 314.27305 319.07005 323.86705 328.66404"
  }, "&#x041e;&#x0440;&#x0433;&#x0430;&#x043d;&#x0438;&#x0437;&#x0430;&#x0446;&#x0438;&#x043e;&#x043d;&#x043d;&#x043e;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 9,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -559.38,
    x: 333.85
  }, "-")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 9,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -559.38,
    x: "336.63 340.833 346.22404 352.812 357.609 362.406 367.797 371.397 374.988 379.785 383.988 387.579 392.376 397.164 401.961 406.164 410.952 412.75199 416.94599 419.943 425.334 429.53703 433.74 437.331 441.534 446.331 450.534 452.92799 458.328 464.33103"
  }, "&#x0430;&#x0434;&#x043c;&#x0438;&#x043d;&#x0438;&#x0441;&#x0442;&#x0440;&#x0430;&#x0442;&#x0438;&#x0432;&#x043d;&#x0430;&#x044f; &#x0441;&#x0442;&#x0440;&#x0443;&#x043a;&#x0442;&#x0443;&#x0440;&#x0430; &#x0410;&#x041e; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 9,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -559.38,
    x: 466.58
  }, "&#x00ab;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 9,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -559.38,
    x: "471.45 476.238 481.035"
  }, "&#x0421;&#x041a; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 9,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -559.38,
    x: 483.3
  }, "&#x00ab;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 9,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -559.38,
    x: "488.15 492.96498 497.18598 502.60398 506.222 511.055 515.276 518.903 521.315 526.742 532.16006 538.78408 543.00509 547.8381 552.64407 557.4681"
  }, "&#x0421;&#x0435;&#x043d;&#x0442;&#x0440;&#x0430;&#x0441; &#x0418;&#x043d;&#x0448;&#x0443;&#x0440;&#x0430;&#x043d;&#x0441;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 9,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -559.38,
    x: 560.85
  }, "&#x00bb;")), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_369)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,316.8,213.6)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_371",
    width: 102,
    height: 45,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGYAAAAtCAYAAABcQB7NAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAsklEQVR4nO3cuw2EQBAFwc2c0DARENSe4D7SRUAbZZQx3kjtvzHG mCSNua7rPI5j7vtOwLIs7zDned5haLji3GGefoR/27YJUyRMlDBRwkQJEyVMlDBR wkQJEyVMlDBRwkQJEyVMlDBRwkQJEyVMlDBRwkQJEyVMlDBRwkQJEyVMlDBRwkQJ EyVMlDBRwkQJEyVMlDBRwkQJEyVMlDBRvzAGGFqupZLx3S65jqsUz/pEmS/6Huss JLI/0wAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip_372)"
  }, /*#__PURE__*/React.createElement("image", {
    x: 316,
    y: 213,
    width: 60,
    height: 25,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAADwAAAAZCAYAAABtnU33AAAACXBIWXMAAA7EAAAO xAGVKw4bAAACEUlEQVR4nO2Y505CQRSEff83sBtbjMZuTFRsMdaIIgLSu0jn0pQ+ nhtYvay7BiIiAj/mAb58k7OTHVEUBWpSLCkFyUYSqTQSyTTilJiaRBpRSjiewQsl FMvgmRKMZuGneCNZeMI5uF5ycIRysIfysD7nYQ7m8Rh4xYP/Ffe+N+i9b7j2FHDp LuDcVcCZs4gTRxFH9hIObCXsWcvYfSpjx1LGlrmMDVMFq48VrFCWjVUsPVSxSFkw VDF3X8MsZYYyfVfDFGVSX8OEHhhvZOy2nlHKSBNwSgv8CcuAVdgIBxyMZRFQgQnW G87CTcDOBrCNYJ+CdWAjwRoI9o5gbz3NwKcEe2wv4tDWDLxNsJvmCtYlwPOG2g+B WzDMA38YjogNM+CeM9yS5QSznPmA1lbap7GsrbSFgE0c8A0BXxHwBQesI+B9a+kL 8JpJDKxa/jXDokqrwAGJYW2ltYb5SjNgvtIM+FcqrQiAk5KjxQzzR4sZ5o+WRVBp ZpivtE5SaZnhDh6t1gw3Ha0WDIuOlgosOlo9ZVj0LPkkz5LMsOho/bnhtp6lBrDo WVKBZc/Sd4a7+izJDHdieMgM/+HwUNofHhH58PjOsGx4dN3wcHgIhkdoODz6eHjI pqXoWZIZFj1LPW243eHxrw335fDo22nZzvCQTctODA+Z4e4Mj0Gblp340+rZ4TGc loM0LYfDo4+m5Tt1IyxZT4blyAAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#ff3300",
    d: "M316.72 357.38H375.458V381.572H316.72Z"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -383.98,
    x: 346.33
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -375.55,
    x: "327.18 330.7728 333.77519 339.16798 342.76799 345.1656 348.1608 351.7608 354.756 358.35603 361.95603 365.54884"
  }, "&#x0417;&#x0430;&#x043c;&#x0435;&#x0441;&#x0442;&#x0438;&#x0442;&#x0435;&#x043b;&#x044c; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -367.15,
    x: "324.73 328.9276 333.118 336.12043 340.31083 343.32044 346.92045 351.11085 354.71086 357.10847 360.70848 364.30848"
  }, "&#x041f;&#x0440;&#x0435;&#x0434;&#x0441;&#x0435;&#x0434;&#x0430;&#x0442;&#x0435;&#x043b;&#x044f;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -358.75,
    x: "329.58 333.7777 337.9682 340.96659 344.5574 348.15547 351.7535 355.944 359.54206"
  }, "&#x041f;&#x0440;&#x0430;&#x0432;&#x043b;&#x0435;&#x043d;&#x0438;&#x044f;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -350.33,
    x: 346.33
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_373)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,396,293.40003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_375",
    width: 107,
    height: 44,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGsAAAAsCAYAAABi4kbYAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAA1ElEQVR4nO3cMQrEIBBAUe9/iRwljUmM8U4uCsuyLMmW+uEXr7Ea +IzlhBBCXZalHsehSbVGXSmlXtdVc86aWI8VYxw+iP5b1/U71rZtw1deH+d53sfq D+//UcP9tDHWvIwFYiwQY4EYC8RYIMYCMRaIsUCMBWIsEGOBGAvEWCDGAjEWiLFA jAViLBBjgRgLxFggxgIxFoixQIwFYiwQY4EYC8RYIMYCMRaIsUCMBWIsEGOBPMbS vHqsfd+HD6Jn7ahMuwIU2rqllIbffNC9dgWodXoB+KfTkC218EIAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#ff3300",
    d: "M395.63 277.89H457.446V302.082H395.63Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_376)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,401.4,283.2)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_378",
    width: 91,
    height: 81,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFsAAABRCAYAAAC9rdr/AAAACXBIWXMAAA7EAAAO xAGVKw4bAAAEnElEQVR4nO2aW1IrMRBD2TlLYSn88IY93Vui6lBKV3sIkESEzocq g8fukeXHTAtfXV1d/bvgZIgTmIQ4gUmIE5iEOIFJiBOYhDiBSYgTmIQ4gUmIE5iE OIFJiBOYhDiBSYgTmIQ4gUmIE5iEOIFJiBOYhDiBSYgTmIQ4gUn4WoPb29t/z8/P O3h7e0t34lzwtQYS9uXl5UNoXd/d3aU7cS74WgMEvrm5eZ/lLvb19fXOjNd92lTo 3uPj486gsUL0q3tPT087q2ffGJTpF15MEF2vuKrt6+vr+31WMOXds48utgRwQi42 RNRJOqdy1RdUrl/dU1vEpD5xqcMvsbyerjXgXQxE4zn39/cfg1EngHOljfdN9xnU +uyji90RQmwXFZFUx9twj06rbTc41GdWMksRxTnVGED1EFmD4nE6rt4GDtRfPfto YiMuonRiQxBU8VxsZgqrZUts1ek63MVAPLYTlfM8zfIVVx8A4kTEZg/zJe0d868U 3ze3xKb84eHho+1qG/Hl7x3uYvi+SnsGhvdCx3W1jZxc7G6Z+oup7qH+glq9ePzl VsX2gfVPy/p3F8NncF0VrMKO64rn6tlHF7u7V2fAT+Ez7I9hv4p8/nT3Dp3Y8C3/ C8TJiH3BRexzQ5zAJMQJTEKcwCTECUzCdoXqcpFEkChUfxtXTahJkMdUxqdrTKJa Xj81V23qPSUtngXW53tdL3fruMs03QHs6h1EbNJdMqsqrKe9eBSqh6fhxDymRHF3 zst17V7JVpvajuTLuWlwSLo8DjZA7Yf3130Wt1prvYOJjcmDX4CD5n9Xm5R7bk/W Ge/exz5id21ckOrVdJmt162GmjuLHgNOW/V+LLYHxxFz+xIRsTgZ/boNdGJ3s/4z sbdWirt8GFOdEL5SPxOb1fmZ2L51/lhsli7bhC9Btyq1XFWGA1ftSjpHZxXH91gX jbgM3qrNahuBG+aTP1t/e99kSrl7uFptW/UOIrZI6iGI5v8m0nV9CXknqxMHMfZR XTMw9X3gK2irDfe6F2S1XWtdJgOD5Fzd0qX+Vr2D7NnfAavAy+ps/G6cM8fhg2rm 108i/uf40zhnjjiBSYgTmIQ4gUmIE5iEOIFJiBOYhK83cuPG02QHfknn+nXn8zzD rI6fG0B8PpIV+lGEVWyV4+foWkkayYofp/P0nDod/5OKDUEEFWk/xuUpOomJn+Wo 5/MQkY6SDiM0aboLWI+PIVgXW+WrY3Ne7taDX0fFXj3cyzsb1B04zCtSe7dkvV01 nTyNX4lRY8OnnuNzsTUR6vEzrNSo2KtDNPuKzT0/kcTWVFP0LbGr0bWK7WJ7fcQG rCpOrnYOYWRmQ0CdqsdwvdO+jbB/0taXuptb7rTxLN9GMLsQjy0IV+4724j/s8Bn tiZBVGw/J1cdMu8cg4GYtK9OIXWqwPVZtY6D+DU2fLZekO5J+3uj8+ZPLvY++MPn 9X6f2D6TLjiy2BdcxE4jTmAS4gQmIU5gEuIEJiFOYBLiBCYhTmAS4gQmIU5gEuIE JiFOYBLiBCYhTmAS4gQmIU5gEuIEJiFOYBLiBCYhTmAS4gTG4D+CcR9JKdhvyQAA AABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -304.4,
    x: 426.85
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -296,
    x: "406.63 411.4274 415.02546 418.6235 422.21434 425.81239 428.80354 431.8019 437.19178 440.19017 444.38066 446.77937"
  }, "&#x0414;&#x0435;&#x043f;&#x0430;&#x0440;&#x0442;&#x0430;&#x043c;&#x0435;&#x043d;&#x0442; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -287.58,
    x: "404.55 409.3524 412.9524 417.1428 420.75 424.9404 429.1308 432.7308 435.74043 439.32603 442.92604 445.32365 448.92366"
  }, "&#x043c;&#x0435;&#x0434;&#x0438;&#x0446;&#x0438;&#x043d;&#x0441;&#x043a;&#x043e;&#x0433;&#x043e; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -279.18,
    x: "407.85 410.85963 413.25004 417.44044 420.4428 424.0356 427.63563 431.22843 434.82124 438.42124 442.02125 445.60685"
  }, "&#x0441;&#x0442;&#x0440;&#x0430;&#x0445;&#x043e;&#x0432;&#x0430;&#x043d;&#x0438;&#x044f; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -270.75,
    x: 426.85
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_379)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,395.4,470.40003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_381",
    width: 106,
    height: 45,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGoAAAAtCAYAAABGfP5DAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAwklEQVR4nO3cMQ7DIBAAQf7/KUoEPIrkLNu4SkrfSltMA+VydFBK KUsIZdVa1xhj9d6VTGtth5pzHqGUUwzSEepaePv0aHsOzzlVO1RsJriL9RVxDAVg KAhDQRgKwlAQhoIwFIShIAwFYSgIQ0EYCsJQEIaCMBSEoSAMBWEoCENBGArCUBCG gjAUhKEgDAVhKAhDQRgKwlAQhoIwFIShIAwFYSgIQ0EYCuJvqFjU+36+ildOd6jn mCmX+HPi/hBE+X0AeH++eWbHPs0AAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#ff3300",
    d: "M395.37 100.6H456.35V124.792H395.37Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_382)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,403.2,471)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_384",
    width: 83,
    height: 45,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFMAAAAtCAYAAADSmlexAAAACXBIWXMAAA7EAAAO xAGVKw4bAAADLElEQVR4nO2aXa7iMAyF2TlLYSm88A97YnQqfaMzlgNXgHDrOw9H TdM4sU+cYrusVqvV/T8+hnIFOqFcgU4oV6ATyhXohHIFOuF14fV6fT+dTv/0nc/n aoOWSaZwuVzut9ttah+Px+l+BkYtk8ztdnu/Xq9TW1fdi1yRKi/VVSQLek6/xklm v99P93qGl+seWe/TGGQF5mKM1tjtdlNbV9rq1zrMI/0y+XIy8U7IikZBJMBQvDnO 4/IYDAlsnK6+IfQ9IlNtTo6umfwsyMRI3pcjMr0PbzgcDn+9w8nEK9kgnjmZAnND pp+IuJ7LZPLlZOpHaLPZTMqr/YhMJ5s271z3QpdXn45ofJVInqOr9bX2I8+UnNbB QzP5cjKloBSTh9EnhbnnuLrXCCivcfHdpTl5h+JleA7Es4E8172vq6vrAHHq030m X07mT+Fe0xjfI/ND76U5o1yBTihXoBPKFeiEcgU6oVyBTsgfKMbjF5gAO+bcihXJ fDx+JHOhL8vXiTNH8uTiig+JZRlLEE90QGDP3GQ2zE+b5CHTxXUe2foymSihRQh+ KRKwmOJGjYsFBTfAM5Yoy/OsICH4RrJ+1E+ypI70EfSPyBzZwbiRrW+RCcgOvLxG WuZKUMDIyMxko7HI6+qeOCKTcZDqOjPW7ylyPLNjZOvbnskRYwEmxWO9dKY2fRmZ UZbnmbyO1TPPJM10Mn3dkWeO7IhkZvq+RCY5sO+S1wA5Ar7zLO6ytDPZkTxHl/do Rqbm8PFefeJdG3WhTpDp4uNGtr5M5k8Rd/Tb8jPDexPEHf22/MxQrkAnlCvQCeUK dEK5Ap1QrkAnfH5SMgqyGGI74kYCas90/KMa4COZx5OezXgeHseozZqMXSyZMdD3 5xgLKFJAikjUvdJY/xRLgM8a8QtoHMO8ai+aTDzFixwyiDSQsXwvl+H+PZtqkxcn nv3RIY7RZvgJWSyZlNPI7b3PvVZXH8Mm8PnYqzz+V5xI5mgMef+iPTN+k3bPxECv QcY6I8TjnZBPnuzfyEdjsvrCIslslG/Xkume8stQrkAnlCvQCeUKdEK5Ap1QrkAn lCvQBn8AvVRXRD7RkOEAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -117.62,
    x: 410.13
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -117.62,
    x: "411.5 414.5 417.5 421.094 424.08799 426.48799 429.48799 432.47599 436.08198 439.08198"
  }, "&#x0423;&#x043f;&#x0440;&#x0430;&#x0432;&#x043b;&#x0435;&#x043d;&#x0438;&#x0435;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -110.4,
    x: "405.42 408.414 411.414 414.414 417.414 421.008 424.008 427.00199 429.39598 432.39598 435.38996 438.38996 441.38996 443.78395 446.78395"
  }, "&#x043a;&#x043e;&#x0440;&#x043f;&#x043e;&#x0440;&#x0430;&#x0442;&#x0438;&#x0432;&#x043d;&#x043e;&#x0433;&#x043e; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -103.2,
    x: "414.6 417.6 420.594 422.994 425.98799 428.98799 431.38197 434.97596 437.37596"
  }, "&#x0440;&#x0430;&#x0437;&#x0432;&#x0438;&#x0442;&#x0438;&#x044f; ")), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_385)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.59999999,395.4,443.40003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_387",
    width: 107,
    height: 43,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGsAAAArCAYAAAB/53ZgAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAu0lEQVR4nO3cOQoDMRAF0b65jqZQaLlTG5nBxsk4HBVU8HJB0Qp/ REQKI7KUkr33bK3pQGutb6wxhg4258xaq7Eo9oX9xNoFD/iXddmBjAVhLBBjgRgL xFggxgIxFoixQIwFYiwQY4EYC8RYIMYCMRaIsUCMBWIsEGOBGAvEWCDGAjEWiLFA jAViLBBjgRgLxFggxgIxFoixQIwFYiwQY4HcxtK5PrH2BsbTj9G9awsj3hsLTw9z 6P9oyQsQqQ9rQPJEqQAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#ff3300",
    d: "M395.37 128.55H456.917V151.60501H395.37Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_388)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,400.2,443.4)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_390",
    width: 92,
    height: 46,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFwAAAAuCAYAAAClBX6SAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAECklEQVR4nO2aXY7rIAyFu/MupUvpS//bPXV0ovuNjiwgmcwkTsV9 sEIcDPbBEGzY7Xa7939aldIV6I3SFeiN0hXojdIV6I3SFeiN/r7R4/E4EO+Hw+H9 er2yDd0KLQP44/H4fr/f7+/z+Zxt6FZomYYFuIDf7/fv5/M5PAX89Xod6Ha7DfVO p9MwGHoXH3nxJKeZIVnxVFa7qqdZIx7tqR0GGx6zjG8i+o186Ya8yurbZ+nmAcfL BRzG8GRAeMpw6ju4AAowyOsbgDKw3geg00epX+erfQGsMs4hng/I5gHHOBHglQyP PLwKL8Wj+e7eB9D+1DeVqedyzqNvZg16aAaojCN8FOAYEz3KARcALA+Apnf3NAD3 ac9AXi6Xb8BZvqIeNQ9ncHyGiKc+9f5RgEtx99gW4Hier696F9Cs+85j5gByXFKo 15pZlH0wvZ2PW1LkpXhuiwCttG1sbSVbbW98G5qrgHtfJ5SuQG+UrkBvlK5Ab5Su QG+UrkBvNL2ytlvsTQk4VI75C9VTSM8+mpwKdXyPXMp91OS1TycwUT2CIsj1I2gi GPJ9vtfzctQl6lzTdzHAY4BB0EFUSGQJT08NTAwqpCzfoyz9lOQx0N9Lob7qEKLT FnIAFZNVLTuQqem7KOB4C+lWPJE6MZkkApAIeEk2DizyeDQ5EeQ89EcOng80AyOP 9pwLzyl21PRd3MNdEXkgU5Xp617lvAh4SdYH1vnyKOridSXAAdBnAm1JXlTy8Jod DnhN39WWFHLVeBDpWOqR7yD9GgEvyXo/Lq++3CtbHh6XHs/LxKXHE181O7C/pu9i gLfIDwrc8Ck/FpdtybMc/JXOU3SZW2dxwGszIUN+45SuQG+UrkBvlK5Ab5SuwOqk f4QfUIz9iIk6x+poJzThZ5oPwNrkka7e/Qcdd0Xa/o1dmdDgqQ2i21mAc0ylRriW 4DkE8djjel7EQ2E/OuPAF57q6N2V5oyx1p74HK21ymwn2XvH4zb48foGPD/Mjnv7 MZoNuIwnKgMgNz6Wj//yHgLUIzICFw9C9F3GuCGlfEhszz2tVHa94FGOgHsd+iNU jwfIUwE/hhtnPwJ87LqBG8xlHfcqD83dy+K9EAwjR+OheWzPv5cGK57Yu1wJcOq4 h2twS7cNxgCPDjQL8PgDqAGOotHTMI51MLYrgwmPkdU3v0Lh7bU8vBTGA2oNcGTp r7TUTQH8B2DXAWcZ8B9BBJzvgOg3ozxXgqeqrtr1m1CA757rUzx6dw1wT2wx+OSz W4B7mpX7jZ6OxWFKeRjHwm0auaLRnia1UcPg2PiUUSaPPsEbJtdbizxrOZPmd7w1 MNYC/Jdt5BvRGaUr0BulK9AbpSvQG6Ur0BulK9AbpSvQFX0B7YWp1l0CaJ0AAAAA SUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -145.03,
    x: 410.5
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -145.03,
    x: "411.85 414.85 417.85 421.444 424.438 426.83799 429.83799 432.826 436.43199 439.43199"
  }, "&#x0423;&#x043f;&#x0440;&#x0430;&#x0432;&#x043b;&#x0435;&#x043d;&#x0438;&#x044f;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -137.83,
    x: "405.7 408.694 411.694 414.694 417.694 421.288 424.288 427.28199 429.67597 432.67597 435.66996 438.66996 441.66996 444.06394 447.06394"
  }, "&#x043a;&#x043e;&#x0440;&#x043f;&#x043e;&#x0440;&#x0430;&#x0442;&#x0438;&#x0432;&#x043d;&#x043e;&#x0433;&#x043e; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -130.63,
    x: "402.35 404.75 407.14399 410.14399 413.13798 415.53797 419.13197 422.12596 424.52595 428.11994 431.11994 434.11393"
  }, "&#x0441;&#x0442;&#x0440;&#x0430;&#x0445;&#x043e;&#x0432;&#x0430;&#x043d;&#x0438;&#x044f; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -130.63,
    x: 435.42
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -130.63,
    x: 441.6
  }, "1")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -130.63,
    x: "444.63 445.83003"
  }, ", ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -130.63,
    x: 447.48
  }, "2")), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_391)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,696.6,442.2)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_393",
    width: 132,
    height: 29,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAIQAAAAdCAYAAABrLcQsAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAjElEQVR4nO3bsQnEMBBEUfXfhEpxKCGrJx3Ch7mpwAd+wcs3+Ey2 pZSy4EdZvfd1nucaY/BSu4E7CDGwHcdxBfH0IfwHQRAEQRAEQRAEQRAEQRAEQRAE QRAEQRAEQRAEQRAEQRAEQRAEQRAEQRAEQRAEQRAEQRAE4Q7Cow67gVrrFcScc7XW eLHvOqwPJ2LFpEFoQncAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    d: "M696.48 138.19H773.015V153.125H696.48Z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#7030a0",
    d: "M696.48 138.19H773.015V153.125H696.48Z"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -154.23,
    x: 735.27
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -147,
    x: "699.4 702.4 705.4 708.994 711.98806 714.38809 717.38809 720.37606 723.98208 726.98208 729.97006 731.18209 734.1761 737.1761 740.7701 743.7701 746.7701 749.7701 752.7641 755.15817 758.15817 761.15219 764.15219 768.3461 770.74618"
  }, "&#x0423;&#x043f;&#x0440;&#x0430;&#x0432;&#x043b;&#x0435;&#x043d;&#x0438;&#x0435; &#x043a;&#x043e;&#x0440;&#x043f;&#x043e;&#x0440;&#x0430;&#x0442;&#x0438;&#x0432;&#x043d;&#x044b;&#x0445; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -139.8,
    x: "725.38 728.38 731.38 734.974 737.974 740.968"
  }, "&#x043f;&#x0440;&#x043e;&#x0434;&#x0430;&#x0436;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -132.6,
    x: 735.27
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_394)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,696.6,460.80003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_396",
    width: 132,
    height: 45,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAIQAAAAtCAYAAABvV8OBAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAvElEQVR4nO3cy4mFQBBAUfNPwlDcCKIG5aN5n+FG4IBncXpdUJde 1jRN0zUsy3Jt28YDjd1/O5jGc57ndRwHDzYa+AVx9zD8D5+fQhC8CYIQBCEIQhCE IAhBEIIgBEEIghAEIQhCEIQgCEEQgiAEQQiCEAQhCEIQhCAIQRCCIARBCIIQBCEI QhCEIAhBEIIgBEEIghAEIQhCEIQgCEEQvyD2fb99GO41DpfO8/wOYpy3HVHwXOu6 /l2yha8X2tpV9Z9alAkAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    d: "M696.48 110.48H773.015V134.672H696.48Z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#7030a0",
    d: "M696.48 110.48H773.015V134.672H696.48Z"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -123.9,
    x: 697.83
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -123.9,
    x: "699.17 702.17 705.17 708.764 711.758 714.158 717.158 720.146 723.752 726.752 729.74 730.952 733.94607 736.94607 740.54006 743.54006 746.54006 749.54006 752.53408 754.9281 757.9281 760.9221 763.9221 767.5161 769.3161"
  }, "&#x0423;&#x043f;&#x0440;&#x0430;&#x0432;&#x043b;&#x0435;&#x043d;&#x0438;&#x0435; &#x043a;&#x043e;&#x0440;&#x043f;&#x043e;&#x0440;&#x0430;&#x0442;&#x0438;&#x0432;&#x043d;&#x043e;&#x0433;&#x043e;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -116.7,
    x: "723.72 726.72 729.714 732.114 735.10806 738.10806 740.5021 744.09609"
  }, "&#x0440;&#x0430;&#x0437;&#x0432;&#x0438;&#x0442;&#x0438;&#x044f;")), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_397)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,396,321)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_399",
    width: 108,
    height: 36,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGwAAAAkCAYAAABsbd/MAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAxklEQVR4nO3bMQrEIBQA0X9zj5KjpElITHInF7NbKAtp48AUD8RK GLX7ERFFKFHWdS05Zw3suq5vsLo4jkODO8+zTNNUYtu2bvPtm6ReG22e5z5YXQ/w R6uxLIvBSAwGYzAYg8EYDMZgMAaDMRiMwWAMBmMwGIPBGAzGYDAGgzEYjMFgDAZj MBiDwRgMxmAwBoMxGIzBYAwGYzCYx2D7vt/RNI52IOIvmMZ2B0sp3WNGbx9Gz+pL q62i/pN1UOztp69nv1jlAzz7E1SAYPUxAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#ff3300",
    d: "M395.75 255.33H458.04103V274.146H395.75Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_400)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,400.8,322.2)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_402",
    width: 94,
    height: 34,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAF4AAAAiCAYAAADWMm7UAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAC90lEQVR4nO2Ya3LCMAyEc3OOwlH4A4TXndLZznzMokmCIW3VVP2x E8eWlfXKkR9d13XDP1KQTqAq0glURTqBqkgnUBXpBKoinUBVfL3T3W43XK/Xh/fL 5ZI90N+G73F8Pp+H2+32UFYA+r6/Y7PZ3OtPp9PdXthut8N+vx8Oh8OnHQGkr9pj nQdafbGR32dl9aEsX85/VcIz6yUas13vElgDUxkbDVICqxyDJahMf9mpzn0iFP30 LuG9H4EZK0tw+YMXAfe/djXCIwIDioNWG8JTp6Bo0PRnJruAKvtsRJwYCEF1fIP6 MeFlB0/5Xr3wDFrPV4XnLxDijD8ejw/9p4R3gfnT+COo9zYP2GqF14zUgBBtTnhS jAeJmRdnvKcaFxHhXdyWVOP9PAXGDcJqhGfRY2EkGL6YqQ0xFSREp53gUO8LKYuy 23vZ21sXV/8WC//qhG+Fz8BiSCdQFekEqiKdQFWkE6iKdAI/Du6O2MHEKwcHZwY/ 2I3543DHaX2R8NpOaasX71jYqmkrxpaPPhx4fAvody34jXch3NdooFP+4tZyrCxO Xh/5ITSnVRfezwdw4ywyJzxbUsED+pbwRFoD98MFpESEPbjqZE+g/LTp9nrilwOO 3mXH3QqieODxJxsEmCrjg+C6PxferxT8nfshCe72c8I7/BD4lvBj+2t36oMlKMwy gkI/7lc4MOGX0yr+/KLK/wT8uY2eUXjqCeoz4Uk58dTK5HhVePXxgL0tfIzclPAi Gu9IEE9ie+7zG8goPELxnejPbfz311MDxsZFFbcp4UkNiE9q0runjxbhmRSNok8L T74jhYwJz2USKYO0gtD4IUjePpdq+E70N5dqxEWB9fsdeM8J77Ne9v43qJ0cTxpC B/fHxIP/olQDKV+c9GEWSoTydgbOXQk+3J/7jYtrHHT017K4xkU4chB8AaZddWPC x00Ff3DUye0WC//s12pdcP4S4q5rAfIHUxTpBKoinUBVpBOoinQCVZFOoCrSCZTE BzbfyRQAeObKAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -266.2,
    x: 411.25
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -266.2,
    x: "412.6 415.6 418.6 422.194 425.188 427.58799 430.58799 433.576 437.18199 440.18199"
  }, "&#x0423;&#x043f;&#x0440;&#x0430;&#x0432;&#x043b;&#x0435;&#x043d;&#x0438;&#x044f;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -259,
    x: "403.13 405.53 407.92399 410.92399 413.91798 416.31797 419.91197 422.90596 425.30595 428.89994 431.89994 434.89393"
  }, "&#x0441;&#x0442;&#x0440;&#x0430;&#x0445;&#x043e;&#x0432;&#x0430;&#x043d;&#x0438;&#x044f; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -259,
    x: 436.18
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -259,
    x: 442.35
  }, "1")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -259,
    x: "445.38 446.58003"
  }, ", ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -259,
    x: "448.25 451.25"
  }, "2 ")), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_403)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.59999999,395.4,343.2)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_405",
    width: 110,
    height: 43,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAG4AAAArCAYAAACZzr0kAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAxklEQVR4nO3UOwoDMQwAUd/cR3OzYPy5k4MC2U1IIOnigSmmUSV4 SCmltAxZWqWUNcZYrTXbuDAKqxMuhr13AxRWJ1xIxtCr27dnoze4aIPfbR96+AgH SzhowkETDppw0ISDJhw04aAJB004aMJBEw6acNCEgyYcNOGgCQdNOGjCQRMOmnDQ hIMmHDThoAkHTThowkETDppw0ISDJhw04aAJB004aMJB+wpne/cCV2v9+0L2W3PO Cy7nvI7juAPavoVRWIXZDVSkXvp6edQFAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#ff3300",
    d: "M395.46 228.82H458.318V252.011H395.46Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_406)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,398.4,336.00004)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_408",
    width: 102,
    height: 69,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGYAAABFCAYAAAC455P6AAAACXBIWXMAAA7EAAAO xAGVKw4bAAADvUlEQVR4nO2aXZLiMAyEuTlH4Si8wPB7p9lqqj6qV+UEmGVKEauH rmQc2ZbVljNqslqtVt+NRSLdgUYTUwrpDjSamFJId6DRxJRCugONJqYU0h1oNDGl kO5Ao4kphXQHGk1MKaQ70GhiSiHdgUYGMdvt9gb+vl6v319fX9mLroDfJ+Zyudz/ Pp1O34fDIXvRFfD7k4gMZcp6vb6TpKvahfP5fGs7Ho836JnsvT92ZJ/sRLBsacNO YFPIzvsx1zP3o/4fRQxZo4BpoVOBIAAiUPebzeben8DTn+DrWBSJsqE/zzSnxvKs fUSGyJ7r/1HEEEhhbud6m2eCyCBjOAb1nIzRVQTpCjG+GQQnJrbRDilz/T+OmP1+ /3C3+pGhQChjfLf6+8mPK4LtxDBG9GPOB/VThsz1/yhitGjPgDliCJC/Y2hX5ux2 u78CqXEZH6IIrGydtEfEMOdc/48i5hUCs31YENIduIMXe2NhxDSamApId6DRxJRC ugONV4jxws3/W6Lgi9IFNYAqcC/+aPf6YtQ+Zas2jY8PqAAAfU33qNZT449s0ea8 uFVhixLA2mIsXlmbila0vRd0t/EDDYZW5YNp0liIIV1wH6t2tC93PhaEI9u4YHxT 4UeVj6YWxxyNFW21jimfotoQYzFaw9TcvoldlvoxMQzqVbv+dmJYMJUzFTrCIqS5 cyyEyj1qU65ZjSpuJyb+pODB8bFGtoxDm6vKrpPhr8ditIapuYllVMh/RIy0LSbz wZjIieFokENaLD+G+XE4ClzMmGirhfnRMUUMCvBIP3M/oy2Bntr1zOWBfyZj5ub+ 54xhMNe5+G1CC2I3cCQwqa4ixYlxIufeASNbV5bxTWMrYHFns/tHY03Zjnayji1s XcX2WIzWMDW3NrnwlqNshKi2aoLMXyPj8fQu24XgeWNXfNlZmcRo/ujTO2wXgnQH Gk1MKaQ70GhiSiHdgcaSiXH9i5oFycS1OOoE188ANQc1CbVW/MhDV+og/9ZtYUh3 4E5MvPdizLUtdKv40UbsR18Vd15Qqg9FMgVs9vrLEUNbVLQFgqt7LyBdKvLq3e3I Oq/SF4Z0B2aJ8YxxzYnnZAzCqbdDFBmiez/mBNcEF4Z0B2aJ4aghsCjYqNhqQ0Al 2J4NCIp6p/jHfLxjICt7/Ysl5hFZc4jyvbDQF/pnEMNXl4/gL3pQTBerRcx/jnQH Gk1MKaQ70GhiSiHdgUYTUwrpDjSamFJId6DRxJRCugONJqYU0h1oNDGlkO5Ao4kp hXQHGgP8AfZLYH8B1Ma7AAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -252.67,
    x: 427.2
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -245.45,
    x: "411.85 414.85 417.85 421.444 424.438 426.83799 429.83799 432.826 436.43199 439.43199 442.41999"
  }, "&#x0423;&#x043f;&#x0440;&#x0430;&#x0432;&#x043b;&#x0435;&#x043d;&#x0438;&#x0435; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -238.25,
    x: "400.88 403.874 406.874 411.068 414.662 417.662 420.662 423.65599 425.45597 429.04997 432.04997 435.04997 438.64396 441.04396 444.03794 447.63194 450.63194 453.62593"
  }, "&#x0430;&#x0434;&#x043c;&#x0438;&#x043d;&#x0438;&#x0441;&#x0442;&#x0440;&#x0438;&#x0440;&#x043e;&#x0432;&#x0430;&#x043d;&#x0438;&#x044f; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -231.05,
    x: "417.3 420.3 423.3 426.89399 429.89399 432.88798"
  }, "&#x043f;&#x0440;&#x043e;&#x0434;&#x0430;&#x0436;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6.025,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -223.85,
    x: 427.2
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_409)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,157.2,418.80003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_411",
    width: 115,
    height: 59,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAHMAAAA7CAYAAABISLXnAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAA7klEQVR4nO3dMQoDIRQAUW++R7ORXdS9k0HDBpJAiiQgDlO8ykYY /ZaGEEITRmg553YchxZ0nmeLMd5j7vveSila3IiZUpq+Ef2mT9a3mI/rqiX0iMaE MCaIMUGMCWJMEGOCGBPEmCDGBDEmiDFBjAliTBBjghgTxJggxgQxJogxQYwJYkwQ Y4IYE8SYIMYEMSaIMUGMCWJMEGOCGBPEmCDGBDEmiDFBjAliTBBjghgTxJggxgQx JogxQYwJYkwQY4IYE8SYIMYEMSbIx5i11rGgNfReTzH7VwpXTK1rxNy2bfoJ0/de nsf5s1//cQO8g/NcmsLLMQAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#00b050",
    d: "M156.81 144.08H223.216V176.336H156.81Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_412)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.59999999,165.6,412.2)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_414",
    width: 86,
    height: 82,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFYAAABSCAYAAADOxyPhAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAFI0lEQVR4nO2bWXLjMAxEffMcJUfxT/bkTpnq1LxUpwdyHNsxZIw/ uiRxAcEmKBEgtdlsNu9X/AraFZiKdgWmol2BqWhXYCraFZiKdgWmol2BqWhXYCra FZiKdgWmol2BqWhXYCraFZiKdgWmol2BqWhXYCraFZiKdgWm4ngh2+32/fn5efH5 P8VpBL2+vn4QqvvHx8f3u7u7j2fdC+RxfXt7+0eG0sgXbm9vv9Rdws3NzZcyS/eS 5/eqV9VfFbEi5eXl5ZNkKaurLFfkeJ7ulUY5BkNllYe1Ux8oDXnK0/P9/f1HHT2T 5oOse5X3dLWJDlX9VRGL4k9PT1+IoYNLaeqYW5GenSA9C5CDHB+oh4eHz8GTDOox WEksA8UAZf3VESurTWvZRSyvDPKBE6t8pWnAkO/EYnkgZ0paLANP+ar+qohVp0UC Hd5FrO6XBiEtVmlYmZ55NzuxsjjdVwOaxEqOyHNis/7qiJWiPpWUxjOWiRWqLB3C ennnQR4yKesrDVmerpJPOdrwdv2D6Pd8FKv6qyJ2X7g1Dcd5G5R1nPA9tma0KzAV 7QpMRbsCU9GuwFScXigxAn/mg5X36elQN2MJLIu8nF+re/9IIjfLnNDT+n1i8Wa0 7vQFvjpKGjEBXVmTKp0FPQ6AOu5eVDocHuRxdxeHggFGJ9bOVfurJ5YOQSJECES9 vDN4WrLIjAV4mhO1RCxXD+p4eQawav8iiMW9xUJwVd2byo55urvGIoEI1HfEenzA p74Tu9T+6on1EB/upVsTU15XLJKwI50mzad4+v2QKOIZOGSrTaEitmr/IoiFHHWY IDIdJBbgHyl/jzo8CKO66esnkIFst9iMA2T7F0HsMVbu+OkUzdVIM9oVmIp2Baai XYGpaFdgKtoVmIrDKmoZ5b54Lll25X/n51fPvk+V9XhWGdqp0kDGIXIj8UQ7HIdV dO/F9/l35bMw941B1pIst9IlRQaeHPv/6Wllm8hjfw3ZHkdgeebr36rtFmLp2BKx ni8C3Uf3rWrfQOSsgXtdurL/n3XSvV0i1t1p6SF4naW2z04se/TqcEVs5qePLmCF fiKGMnhkuqeMW6hb/z7EopO/UnJmVW2fnVifThWxmU88YPv3/ADpHMrAaijDdOQM gg+WT1W3WI8hMKWJHfiBD2KxabHZ9tmJJYCR99/l+5kCketxAOr68SCsOl8tEIBM 2qliCNR32QJBGicw2z47sedEdlId/8nhCn8dnBH9xA1FuwJT0a7AVLQrMBXtCkzF cma1xSHkmf30z5fKUYY0X0ey/FmSlVsoVZyh+hcBuYfIqvKr5x8Tm0fKleY+u7ub 7oNLqapcns6m46wzWZinLD/tLRm4wpTHFfVyXi91dVmkQZbLxYlAP5wT39Q8mFga 9DP/vvDOcpUL66evq407X6dWsrBudczdVyfM3WLq8Y9DrmNTFuVwDJxYynle5Zof TWx6QRUZ/ImS5fyswL7EIgtLcZcUy0vZag8L9llCuZSVM9NdWnePGaxfsVh3D52A PC9QlSNeoGc/Jp/EVrLSynBpPQaBi5zTOX8KqSy2ehXkeYaTWaxGm6nr56sQnH+8 MKpL5ZY+hu6eVrII9/mZBJepcv4hRLbHBTwm4bKyn3zYOApFWoYUjyJ2X/iIr0lW M44Xso0jk2uRdfHEXnEl9krsALQrMBXtCkxFuwJT0a7AVLQrMBXtCkxFuwJT0a7A VLQrMBXtCkxFuwJT0a7AVLQrMBXtCkxFuwIj8QcptXQ7MFYOKgAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -175.98,
    x: 190.15
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -168.78,
    x: "174.8 177.8 180.8 184.394 187.38799 189.78798 192.78798 195.77599 199.38199 202.38199 205.37"
  }, "&#x0423;&#x043f;&#x0440;&#x0430;&#x0432;&#x043b;&#x0435;&#x043d;&#x0438;&#x0435; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -161.58,
    x: "176.38 179.374 181.774 184.774 188.36801 191.362 195.562 198.55 200.95601 203.95601"
  }, "&#x0432;&#x0445;&#x043e;&#x0434;&#x044f;&#x0449;&#x0435;&#x0433;&#x043e; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6.025,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -154.38,
    x: "172.63 175.63045 177.4259 180.42635 182.8243 185.81873 188.81917 191.81963 194.81406 199.60996 202.61042 204.4119 207.41234"
  }, "&#x0438; &#x0438;&#x0441;&#x0445;&#x043e;&#x0434;&#x044f;&#x0449;&#x0435;&#x0433;&#x043e; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -147.15,
    x: "168.18 171.18 174.168 177.18 180.168 183.174 185.56801 188.56801 191.562 193.962 196.962 199.956 202.94998 205.94998 208.94998"
  }, "&#x043f;&#x0435;&#x0440;&#x0435;&#x0441;&#x0442;&#x0440;&#x0430;&#x0445;&#x043e;&#x0432;&#x0430;&#x043d;&#x0438;&#x044f;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -139.95,
    x: 190.15
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_415)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,156.6,454.80003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_417",
    width: 116,
    height: 36,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAHQAAAAkCAYAAABYFB7QAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAsUlEQVR4nO3bMQoDIRBAUW/u0WwEXfVOBotkWRIIIUXi5xevshn4 yFQTQghTKGHGGGfOeZZStKFa60wpnUHHGLO1ps09gq7Kvx5G3zmO43XQP9gB+sAK aVAQg8IYFMagMAaFMSiMQWEMCmNQGIPCGBTGoDAGhTEojEFhDApjUBiDwhgUxqAw BoUxKIxBYQwKY1AYg8IYFOZt0PWgffTen4PeK2tfl6DrWNTfubfLwa84bpAdGG2j Ib2uAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#00b050",
    d: "M156.81 121.8H223.222V140.301H156.81Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_418)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.59999999,156,448.80003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_420",
    width: 121,
    height: 58,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAHkAAAA6CAYAAACUNvaLAAAACXBIWXMAAA7EAAAO xAGVKw4bAAADUUlEQVR4nO2ZUW4qMQxF2XmXwlL4gdIW9sTTRTrVlesAj7ZKYe7H FYNJYjsnmSGe1Wq1OkVPr+kBRIEcBXIUyFEgL0XTA4gCOQrkKJCjQF6KpgcQBXIU yFEgR4G8FE0PIArk6NcgbzabL99fXl5mBztN6/X6tN1uT+/v7+fP2fH8COTD4fAJ WnA/Pj4WC1l5A3e/30+P58cgH4/HM1hd73a7c5KyKUmkRSDpWr+9vb199ped9iwW 2kqvr69fbLSjn/x6m0vX6iN1/T2n6uuSf+XsYys/H/Najj4/HselHNxvF3PX5m7I ErtZA+pTK1k2OdGnvmOjHaBJUNLvstFeO0M2dojEuEoCf1pk+GUiSJjxdM14Utef fDx+3X5l6/zTj3xk0+9amNdyrON1u7/Lp/NbY9Z11+ZbkEmOHV2DA5qvRFYYAFkQ 9NdYPqbaaMJJlgnSp9po5/AsZKwK2Se2699NLqr+NXG+y/DLXQLbKMc6HpAkja0+ XT6d3xrzqM23IEuaqDqpFTLO2D3+O2P4TsbmgTpkbuWXVr6vcp+wrv8IMpBG/lnk Wij+KBjl2I3XQery6fzWmEdt7obsO2Q02Q7Zb1EkpMSxy6bJYtH4jvNkfffwP+Aa ZE0ukLv+I8jEV/2TB7f9ztbl2I3H/xmPr8tn5MPbjtrcDZmJc5tuQ/4Hg2OF/8nw 9th8oklK43t7P6Lhm9/db73m2erj1f5d/Pi85N9PE52t5tiNRz/vO8qn81FjHsVx F+Rb5bey6M9qegBRIEeBHD0XZM6Yfm6Nngzyg9ePA/maOP9K+kfPkcnPkF6VGtWP vZ0KC17QcBtFBx1hKGKMiiwPoOkB3CQKH7wsoMDg1SCKLoD1QoQXHyhKqHghiPrk nIsPyqHY1e4/Kkx/TdMDuBmyF+SpnLkcgteFqRBhAyQVKiDXCp/7Vl/KmQ+o6QHc JHalrr10yQsPfxOEuh0PaC2YCrSz0Z/r2fPw1JB5nejFfCDzfPY3Qf7CYnS79hp3 rVHXd+ns+Nnz8NSQkb8LrvXqWiPne23nteBa4+5q9jyXH/jYNj2AKJCjQI4COQrk pWh6AFEgR4EcBXIUyEvR9ACiQI4COQrkKJCXoukBRIEcBXIUyFEgL0L/APcDJi+J CuYgAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6.025,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -139.6,
    x: 190.15
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -132.38,
    x: "158.18 161.18 164.18 167.77399 170.76798 173.16797 176.16797 179.15598 182.76198 185.76198 188.74999 189.96199 192.35599 195.35599 198.35599 201.94998 204.34998 207.34998 210.34398 213.34398 216.93799 218.73799 221.73799"
  }, "&#x0423;&#x043f;&#x0440;&#x0430;&#x0432;&#x043b;&#x0435;&#x043d;&#x0438;&#x0435; &#x0433;&#x043b;&#x043e;&#x0431;&#x0430;&#x043b;&#x044c;&#x043d;&#x043e;&#x0433;&#x043e; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -125.18,
    x: "179.85 182.85 186.44402 188.84401 191.84401 194.83202 197.83802 200.238"
  }, "&#x0431;&#x0438;&#x0437;&#x043d;&#x0435;&#x0441;&#x0430; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -117.98,
    x: 190.15
  })), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M223.12 189.14H229.35V160.21H223.22"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M223.12 189.14H229.35V131.05H223.22"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_421)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.59999999,616.8,347.40003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_423",
    width: 110,
    height: 43,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAG4AAAArCAYAAACZzr0kAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAqklEQVR4nO3cMQqEQBQFwbn/pSYRRD2Ui4EsZputDRXUwGQfOn9j jHFe5pznuq683N1rXM+yLOe+7wQcx/ENd33+fRC/2bZNuCLhooSLEi5KuCjhooSL Ei5KuCjhooSLEi5KuCjhooSLEi5KuCjhooSLEi5KuCjhooSLEi5KuCjhooSLEi5K uCjhooSLEi5KuCjhooSLEi5KuCjhoh7h7Jx0PHZOLAt13L0+1uRLGGOZ3B4AAAAA SUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    d: "M616.9 224.68H679.82907V248.155H616.9Z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#7030a0",
    d: "M616.9 224.68H679.82907V248.155H616.9Z"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -250.78,
    x: 648.83
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -242.38,
    x: "628.6 633.3974 636.9954 640.5935 644.1843 647.78237 650.7735 653.77188 659.1617 662.16006 666.3505 668.7492"
  }, "&#x0414;&#x0435;&#x043f;&#x0430;&#x0440;&#x0442;&#x0430;&#x043c;&#x0435;&#x043d;&#x0442; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -233.95,
    x: "629.67 633.26998 636.8628 640.46279 643.45797 647.058 650.65798 654.25796 657.2675 660.85317 664.4531 668.04598"
  }, "&#x043f;&#x0430;&#x0440;&#x0442;&#x043d;&#x0435;&#x0440;&#x0441;&#x043a;&#x0438;&#x0445; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -225.55,
    x: "633.35 636.94998 640.5499 644.7403 647.13796 650.7379 654.33078 659.1332 664.526"
  }, "&#x043f;&#x0440;&#x043e;&#x0433;&#x0440;&#x0430;&#x043c;&#x043c; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -217.15,
    x: 648.83
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_424)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,617.4,375)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_426",
    width: 110,
    height: 45,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAG4AAAAtCAYAAABPl145AAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAqklEQVR4nO3TOQrDQAAEwf3/w4SuP61RYuHIzuSGCiofaGaMMSZJ Y67rOo/jmPu+8+fO87zDidZxnewd7ukx/O46mXBBwkUJFyVclHBRwkUJFyVclHBR wkUJFyVclHBRwkUJFyVclHBRwkUJFyVclHBRwkUJFyVclHBRwkUJFyVclHBRwkUJ FyVclHBRwkUJFyVclHBRwkUJF/URbtu2xwfx3dVpWZY7HD0vZuU36+jwcvQAAAAA SUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    d: "M617.25 196.1H680.327V220.292H617.25Z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#7030a0",
    d: "M617.25 196.1H680.327V220.292H617.25Z"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6.025,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -216.83,
    x: 649.25
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -209.6,
    x: 633.22
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -209.6,
    x: "634.57 637.57 640.57 644.164 647.158 649.55807 652.55807 655.546 659.15206 662.15206 665.14"
  }, "&#x0423;&#x043f;&#x0440;&#x0430;&#x0432;&#x043b;&#x0435;&#x043d;&#x0438;&#x0435; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -202.4,
    x: "622.67 625.67 628.664 631.664 634.05807 637.05807 640.046 643.65206 646.05209 649.0461 652.0461 654.4461 656.2401 659.2401 662.2401 665.2401 668.8341 671.8281 676.0221"
  }, "&#x043f;&#x0430;&#x0440;&#x0442;&#x043d;&#x0435;&#x0440;&#x0441;&#x043a;&#x0438;&#x0445; &#x043f;&#x0440;&#x043e;&#x0434;&#x0430;&#x0436; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -195.2,
    x: 649.25
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_427)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.59999999,617.4,404.40003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_429",
    width: 110,
    height: 43,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAG4AAAArCAYAAACZzr0kAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAqElEQVR4nO3csQ3DMBAEQfbflBIpkYqiQXVgJ8TCE8zHD2x+Y4wx CTqOYz7PM+/7JmC1Ws3GdV3bn+E753nOsc7uRxDuLwgXJVyUcFHCRQkXJVyUcFHC RQkXJVyUcFHCRQkXJVyUcFHCRQkXJVyUcFHCRQkXJVyUcFHCRQkXJVyUcFHCRQkX JVyUcFHCRQkXJVyUcFHCRb3h1mbG7kf4zrtzsn0hh598ADDGGRhsB5vXAAAAAElF TkSuQmCC"
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    d: "M617.04 167.87H680.81997V190.956H617.04Z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#7030a0",
    d: "M617.04 167.87H680.81997V190.956H617.04Z"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -184.4,
    x: 633.38
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -184.4,
    x: "634.73 637.73 640.73 644.324 647.318 649.718 652.718 655.706 659.312 662.312"
  }, "&#x0423;&#x043f;&#x0440;&#x0430;&#x0432;&#x043b;&#x0435;&#x043d;&#x0438;&#x0435;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -177.2,
    x: "628.65 631.64407 634.64407 637.64407 640.64407 644.23806 647.23806 650.23208 652.6261 655.6261 658.6201 661.6201 664.6201 667.0141 670.0141"
  }, "&#x043a;&#x043e;&#x0440;&#x043f;&#x043e;&#x0440;&#x0430;&#x0442;&#x0438;&#x0432;&#x043d;&#x043e;&#x0433;&#x043e; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6.025,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -170,
    x: "637.85 640.85049 643.8449 646.24288 649.2373 652.23776 654.62966 658.22659 660.6245"
  }, "&#x0440;&#x0430;&#x0437;&#x0432;&#x0438;&#x0442;&#x0438;&#x044f; ")), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M189.66 357.38V353.34H189.65V352.81"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M189.65 333.19 189.63 323.32"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_430)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,394.8,213.6)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_432",
    width: 107,
    height: 45,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGsAAAAtCAYAAACpvpV9AAAACXBIWXMAAA7EAAAO xAGVKw4bAAAA1UlEQVR4nO3cSwrDMAwAUd3cR8llDPneyUUmbQkl3cYDs3hgtB1b S0dENGFEq7W2dV01qOzTYx3H0bZt0+CyU8zz/Bns+/74LdJX9ni3yU6XWH3w/F7W 6aeNscZlLBBjgRgLxFggxgIxFoixQIwFYiwQY4EYC8RYIMYCMRaIsUCMBWIsEGOB GAvEWCDGAjEWiLFAjAViLBBjgRgLxFggxgIxFoixQIwFYiwQY4EYC+RvrGVZ+lBj yB63sTSuHmuapst/CxpP9iml5GqMfnj6yeveGaq9AHb3S/ZsvKvgAAAAAElFTkSu QmCC"
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#ff3300",
    d: "M394.52 357.38H456.315V381.572H394.52Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_433)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,400.8,207.60002)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_435",
    width: 90,
    height: 67,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFoAAABDCAYAAAAccRJRAAAACXBIWXMAAA7EAAAO xAGVKw4bAAADaElEQVR4nO2Z3XLqMAyEeXMehUfhhn94p54RM19nqyoBGso2R1zs JLFjab2WHVtZLBaLjzdeAjuBLrAT6AI7gS6wE+gCO4EusBPoAjuBLrAT6AI7gS6w E+gCO4EusBPoAjuBLrAT6AI7gS6wE+gCO4EusBPoAjuBLrAT6ILhyvV6/eV5tVp9 K+uE0+n0sd/vrzocj8dHtagrlsvl1VgYpyyez+fz1ZG70w4cDodPTUKH0Giy0BgO o4wcTkLoGFkFTuNdEOU66pfL5VuZ2hoqDyiv3AZfY354r7qnrZZjJ5D7RTl1k4XW qN7tdp/XcBD3is1mc20TpBlxrvF+1Mc9syKudIZn6ihX+4gR13gH+9Qx88KPtsNP 9U6+13fgBZ+xuslCE9UIURGKEa6EjvKIPNrGM1E/ZEuFZppSj9BVW7WRBxEujwgd PBmoLHRV9xShNaqZKvcITXsIxXsahdq5KtK5z0IjXhXRQ7PrUaEJrkroqm6y0BGR CI1YP4lo1npEHIpoXZ64ZqEZMP0w5YgmIBCFNf1eoelrJXRVN1loOqzRfK/QrGEQ 04hVoXWNzmt7Xh50hgwtHepHeVfflQzs0JfKV1X3lIjOX2/EpeMR8fpOnq7aNu8U 1JbuLtirqn2e+epzX+06Kt/Zj4JBybuOyldVN1nonyCv0XOALh+/iOcazNH1xi8J /cZbaDfsBLrATqAL7AS64PlGyZ6NZdDYH8eVUyQ7lpx+zPvivA8Pf3mffCtreMvn LITOJy46WCWH9Dib8yABjtGA0yricNLkmJ9t5HLSAGM+ZyN0dCAOARwEstB6HEbo EIAopzyescXgaH6DhJRGtx6TyYvkhNSYz9kITSfIQWehNTq103r81uMwbRAZoXOE DglNckpt5/zJLIXWnHIlNMJp53LaVLN/cb/dbr/4QKRsf0joWD7iWf8YDfmchdA5 L6zCqtB5umrU5vVSs3E6QNWPgCx0gNmjS47OrsrnLIRGDEAUIQRRQ2aQPxZD/wdp Rx07hWoHAoccmVU275bPPy+0rpka5WPtNNJeBYPP13VuCDkq/1OffqGbwE6gC+wE usBOoAvsBLrATqAL7AS6wE6gC+wEusBOoAvsBLrATqAL7AS6wE6gC+wEusBOoAvs BLrATqAL7AS6wE6gC+wEWuAfOFTNo+Ph0AQAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -379.75,
    x: 425.72
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -371.35,
    x: "403.7 407.30003 411.49043 415.09043 418.68324 421.6856 425.876 428.87843 434.2784 439.6784 443.8688 447.4688"
  }, "&#x0423;&#x043f;&#x0440;&#x0430;&#x0432;&#x043b;&#x044f;&#x044e;&#x0449;&#x0438;&#x0439; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -362.95,
    x: "411.22 415.42497 419.023 423.2135 426.21189 429.8027 432.79386 436.3919"
  }, "&#x0434;&#x0438;&#x0440;&#x0435;&#x043a;&#x0442;&#x043e;&#x0440;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -354.53,
    x: 425.72
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_436)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,394.8,242.40001)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_438",
    width: 107,
    height: 33,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGsAAAAhCAYAAADefFUGAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAoUlEQVR4nO3aOwpDIRQAUXfu5gS/ezJI4DXhSTodmOKIdhcGrQwh hCmIGONsrelipZRvrJzz8WG0V2v9jdV7n+usO2xjrf3xd1mPFclYEMYCMRaIsUCM BWIsEGOBGAvEWCDGAjEWiLFAjAViLBBjgRgLxFggxgIxFoixQIwFYiwQY4EYC8RY INtYutMTa4xxfBj9GWstKaXjn/D1bl2o1ekD0MNB1AzpG0QAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#ff3300",
    d: "M394.52 335.49H456.03199V353.00999H394.52Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_439)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,397.8,237.00002)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_441",
    width: 96,
    height: 53,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGAAAAA1CAYAAAC+2+58AAAACXBIWXMAAA7EAAAO xAGVKw4bAAAChklEQVR4nO2WXW7DMAyDc/MepUfpS//bO3VgARasprQesoHYuAcC TuLIn0XL9jRN0+1fVtkB0mUHSJcdIF12gHTZAdJlB0iXHSBddoB02QHSZQdIlx0g XXaAdNkB0mUHSJcdIF12gHTZAdJlB0iXHSBddoB02QF+tTabzV0/asDlcrmdz+eH 8OyeuFuHw+F2Op2ecnK9Xu9tGoI2+iwyAMEQaLvdPoKqAavV6g4Dde+o9Xr9iIdn XTX4hmf+x2/sOxKjrkT20blUVsTTPhpjbmx+Q2KZdPZFfJrCvB2Px+8xYL/ffzIA A7I6MDCEd7vd7qliIIACkn35H+LAXK0ytNlXhX5dDDJyHHJCYJlj1WTVuXVjMyf1 PxUSzjiDO8XrDgzYQeIb2picGgXY+g9XLN8xgTSAk0QsTpqlznZdpYzBsWkcTGCy ucI7VqqbWzd2fd8ZgEph3IHV/94AAOk+Vg2oK+WdAbpvagVof67OOQNqDIypVYF/ yP2KtdOIAYzFaqvfaP7iCoCbrwzgRLGq9L85A5g4LWPtz31UD6+ahC5G3XdpirJ3 rB3niAFacXyH8XgGQDyQFx3C9fZT93SA6L7KycwZoKujM0DH45lTk9DFYHLJzERr BXSsdSsZNUDNr7cgbom6e9QFOmwAYeuNhmXOKsHASEy9QXBgvbGgjYTrLUUN0ziM VffaGoOLAd+0Xf+trJUTz7qtdGPXSkB+cNDzJtfdxBYZoKe/ul+veEtUKyZM8x/r /Xd0ZXxVgyvlr8oOkC47QLrsAOmyA6TLDpAuO0C67ADpsgOkyw6QLjtAuuwA6bID pMsOkC47QLrsAOmyA6TLDpAuO0C67ADpsgOkyw4QrQ/FYeG8UE2NCQAAAABJRU5E rkJggg=="
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -350.3,
    x: 425.57
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -341.9,
    x: "400.77 405.5724 409.1724 412.77238 416.36518 419.96519 422.9604 425.96278 431.35557 434.35798 438.54838 440.94599"
  }, "&#x0414;&#x0435;&#x043f;&#x0430;&#x0440;&#x0442;&#x0430;&#x043c;&#x0435;&#x043d;&#x0442; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -341.9,
    x: "442.83 446.42979"
  }, "CX")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -333.5,
    x: 425.57
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_442)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,238.8,213.6)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_444",
    width: 105,
    height: 45,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGkAAAAtCAYAAACtS0VAAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAwElEQVR4nO3csQ0DIRQE0d9/E5RCgkDA9YSFLduBnR8jTfDylSbf iIil48XKOa855+q96yDXdX0jjTF0qFrrK9KudvcY/VdKMdLpjARgJAAjARgJwEgA RgIwEoCRAIwEYCQAIwEYCcBIAEYCMBKAkQCMBGAkACMBGAnASABGAjASgJEAjARg JAAjARgJwEgARgIwEoCRAIwEYCQAIwEYCcBIAEYC+ERqrd0+Rr/2S81+q4n3f82+ SNmxdI6U0rPNA0oRpni7MfKrAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip_445)"
  }, /*#__PURE__*/React.createElement("image", {
    x: 238,
    y: 213,
    width: 62,
    height: 25,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAD4AAAAZCAYAAABpaJ3KAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAB5UlEQVR4nO2Y907CUBxGff83cCsajdG4RzTGaNxEpkwXUJFVRssS KPTzR6SmEkpvERWpf3wPcHJu7j25I4IgoLmcspyA7MdEZLIi0q3xGREpWjKTRyKd R5wW4/OI8gU8pwrgkgWEaU+JIh7iRdzHigi+lOCPluCl3T6X4eLKcEReYQu/4jpU weVTBeePFZw+VHF8X8XRXQ2HwRoOAjXs+SXs+CRseiWse+pYpa3c1rHsbmCJtuhq YIE275Qx55AxS5uxy5imTdEmbTImbMB4a2M37xuljSjgggpcDZ9RwfNZBVz8BP5C U4OHCPyxBX4XKyFA8L4O4FYCvyLwCwI/I/ATDfAtAt/w1rGmA25pgjsMgusZ5xmM R5rgCTbjNyE249u/Zlx91DWMtx/1TsY7HfV241pH/ceNtx/zbsY5A8bt4YE3LvbF uNblpjbe7XJTjOuBW3oB79V482KLptiNOwma1fiuAeOWfhjXfM56MN7tOVOM6z1n W4xHvXfjOk+Z2rj6KWMx7iFoN8dufD8g/YxxpoDJsgVMiDFgrIwB863GvxowUTMH zNAlq+kCxsTJ+h8w5kjWQQyYgTNusmTVDxhW478eMEaTNfGfrEOcrHqXW7/+3P5s wHAGAmbwk9WMf27DnKxvO2nh2zrj7h8AAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#99ccff",
    d: "M238.8 357.38H299.178V381.572H238.8Z"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -383.98,
    x: 269.17
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -375.55,
    x: "250.02 253.61281 256.6152 262.008 265.608 268.0056 271.00083 274.60084 277.59605 281.19606 284.79606 288.38887"
  }, "&#x0417;&#x0430;&#x043c;&#x0435;&#x0441;&#x0442;&#x0438;&#x0442;&#x0435;&#x043b;&#x044c; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -367.15,
    x: "247.58 251.7776 255.968 258.9704 263.1608 266.1704 269.77043 273.96083 277.56083 279.95845 283.55845 287.15846 290.74406"
  }, "&#x041f;&#x0440;&#x0435;&#x0434;&#x0441;&#x0435;&#x0434;&#x0430;&#x0442;&#x0435;&#x043b;&#x044f; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -358.75,
    x: "252.43 256.62773 260.8182 263.8166 267.4074 271.00547 274.60353 278.794 282.39207 285.9901"
  }, "&#x041f;&#x0440;&#x0430;&#x0432;&#x043b;&#x0435;&#x043d;&#x0438;&#x044f; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -350.33,
    x: 269.17
  })), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M377.55 109.72H382.65V85.198H377.67"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M377.55 109.72H382.65V60.972H377.67"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M377.55 109.72H382.65V36.331H377.27"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_446)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,697.8,246)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_448",
    width: 125,
    height: 45,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAH0AAAAtCAYAAACDDmTSAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAzElEQVR4nO3cMQoDIRQAUW/u0WxWxPVQBtnEJmS7rOBM8RorYfja /RBC6IKJMfbzPAWQUrqi55yXX0bPaK1d0Y/jmIe11l5K0WZG7J/R5/hrK7eTbvQ9 GR3I6EBGBzI6kNGBjA5kdCCjAxkdyOhARgcyOpDRgYwOZHQgowMZHcjoQEYHMjqQ 0YGMDmR0IKMDGR3I6EBGBzI6kNGBjA5kdCCjAxkdyOhARge6je52qT19bZdyjxzH jD42Ro4JX30h/dfnFX8/+ev/HD3rBQBpGdG3Ch9nAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#7030a0",
    d: "M697.47 325.12H769.753V349.31199H697.47Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_449)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,706.8,238.80002)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_451",
    width: 97,
    height: 70,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGEAAABGCAYAAADcr/otAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAEJElEQVR4nO2aXU5rMQyE2TlLYSm88A974mqQvurDyqnKrWjd4ocR 56SxM/Ekaexyc3Nz8zk4O85OYNCAwKABgUEDAoMGBAYNCAwaEBg0IDBoQGDQgMCg AYFBAwKDBgQGDQgMGhAYNCAwaEBg0IDA4Decfnx8fL6+vu7e7+/vv70PTiBC8P7+ /hX8PEeAh4eHr/fn5+cv8FkEQ6jqI21uv7u7+2ZLn9qWfvhljNvb211/nt3H7dX+ YkXIJN7e3naCZIL5G0ESNH+W57TRD3v6vby87PrGHiAwtnl/fHzc2XgMRMpz+rs9 Y8JhZX+xInjCBKzujlVbguAVnXcCnL95DxAGPw7409PTTsD4wA4uVQQvjpX9RYvA bvAq3CdCJp5ji885xixC3tOOXz5DBFY0qDuw7oSI6f4r+4sVIQIkYN7SWyIEW4Il SBaB74nYY1dFyErO80r8KgI8LEK1v2gRMilv57Txzor3UcHkCUDaYkOg8Ql84+J4 yspldTOGx82zLwXehXw/VPuLFeFQeJX+YZyXgK+PfxhnJzBoQGBwSKeauQ5OKALX QCc4gxOKsCq65ZpX6zbVjvoO19NVrSZtvrraj6+gXC35PH6wpb6zymg9pn3WPrR5 jK1nxrbPWl/a1/+/RKB2QrLEvZn7tDNQD0Y2i03sA4tKUrbywzPZMWPiGx7sUCdf K3/UglxfghdcPcbWM35JKu0PrPofJYKToUwGskyeRIas1iK4WpoVQU2IwJLdpp0E jM/S7sAysSRyXgzm5uA624UzAak7G9GYV60trcauxcOVCO5/tAgOtCdkog4CAUzg LUJsWXUEnt2GL5ejqwjsSgprXnHxxfhkuivOjMUx5s8sFKt8a2zXolY7ofY/WgSO DSZhpV1AI6iejI+xrePIAfT5XkWou4uVa26szNrOkcaO5Acnft9gB24dR3Vsjtet nVD7HyUCgak7AsfUe1x6JnguhhHwBNh+WPX4ccXSNR2PyTMrjqCYM/4qZx9VXB4Q aTXGvrHhWWtLW7ZHifBTrLbnbxTBvFqvBGcn8GNcYfJ4dgKDBgQGDQgMGhAYnGog 11R8jSVfoJ+fXX9Z2bkGta8edYgvbGt97CpEcCnAeYSzZ5cgaqmEDN3/h+R3rqrO pGv9iOSSdu7w9o8fMumrEiGTYnUnkXLdhRVHLalm1TWo1Y6Ey7Wn1XguRRirbNg1 rKsRoQZtJQIlBlYmbV7tHBfVnwtrLht4PLdtieB60lWKwGS9SleB8U6g4EY7pYIa 5HocrcZzm79zLAL/bXeVIjDZ+iNIJlp/kHF96RA7V179XO38v0QrX7Y9UzZ+0sEG I0JbnJ3AoAGBQQMCgwYEBg0IDBoQGDQgMGhAYNCAwKABgUEDAoMGBAYNCAwaEBg0 IDBoQGDQgMCgAYE/j39RxMQ2aMYhOAAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -349.58,
    x: 734.15
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6.025,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -342.38,
    x: "718.8 721.8004 724.8009 728.3978 731.3923 733.7902 736.79067 739.7911 743.382 746.38247 749.3829"
  }, "&#x0423;&#x043f;&#x0440;&#x0430;&#x0432;&#x043b;&#x0435;&#x043d;&#x0438;&#x0435; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -335.15,
    x: "709.35 712.37399 717.19198 720.216 724.43399 727.45199 729.87 732.894 736.512 739.536 742.554 744.978 748.59609 751.62008 754.63809 755.8381 759.45608"
  }, "&#x0431;&#x044e;&#x0434;&#x0436;&#x0435;&#x0442;&#x0438;&#x0440;&#x043e;&#x0432;&#x0430;&#x043d;&#x0438;&#x044f; &#x0438; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -327.95,
    x: "720.1 723.1 725.494 728.48806 731.476 733.882 736.882 739.882 742.87606 744.6761"
  }, "&#x043e;&#x0442;&#x0447;&#x0435;&#x0442;&#x043d;&#x043e;&#x0441;&#x0442;&#x0438;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -320.75,
    x: 734.15
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_452)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,697.8,275.4)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_454",
    width: 125,
    height: 36,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAH0AAAAkCAYAAACkATUaAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAwUlEQVR4nO3bMQrDIBhAYe9/qSwxxuRQlr+lEijt1FbwveFzcBKe iosppdSEk9q+763WqolF42VZHtG3bWvHcQggwt+jr+vaJ8/zHL4j9X3R9dn3JXo/ /prK9VAbHcLoQEYHMjqQ0YGMDmR0IKMDGR3I6EBGBzI6kNGBjA5kdCCjAxkdyOhA RgcyOpDRgYwOZHQgowMZHcjoQEYH+hg959xKKZpMfGJ8G11z69HjSh+9GP1H/58e Q4QffQXpt67vtRuunkJbasyrRAAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#7030a0",
    d: "M697.47 300.93H769.753V319.746H697.47Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_455)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.59999999,702.6,269.40003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_457",
    width: 110,
    height: 58,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAG4AAAA6CAYAAABRRGwaAAAACXBIWXMAAA7EAAAO xAGVKw4bAAADW0lEQVR4nO2ZXY7bMAyEc/McJUfJSzb/d9pign7BlKDsxaYtsxAf BlYYURxqJFumN5vN5rPxI1FOoNHCTYVyAo0WbiqUE2i0cFOhnECjhZsK5QQaLdxU KCfQaOGmQjmBRgs3FcoJNFq4qVBOoNHCTYX8j/v9/nm5XJ6/1fbfjXKM/7zdbp/7 /f6PtnA6nR7gP+zn8/lpwy6b+mJTO9oY0321cATv85X2drtN/Zc4LY23xnUUnzzh kI21lsO3hWPXabDr9fqw6YpwbpOwHx8fj6tPHv2Ox+NzAeAvqC82djRjyV9tYsDL dz52cWRxZf6eU+Q0Gjv2zbhm8Xe73eN/n6Ms7lIOLwnHJCJWTNKFcxuBlQBk8Sdx rqxEJk2TM1oc0YadidKYmqBR3xGnUf/YN3LN4pO7xGHXjeKOcvgrwrGLolhrwrE6 lQCrz4WD5OFweGAkHEm4LfIhWflH4XwSRpyysbO+kWsWn3jiIV+/C8S4oxxeFo4D iT8rRsIhgifObSHbcVqJagtabXEySFALZ+1W6buA23r0X+KUjR37kmPGNcYXNBcs BBZTjLuUw0vCQSLaYptdpqAkxqpTArr6w9x3QzaeJs2fr6O4WVu+mf8ap2w87xt3 79rhRD5+WMviLuXwknBfRXyONP4Lygk0WripUE6g0cJNhXICjSrh/IhPGYtjr9fr 6BuP6e6vvn6k9teL7CXXj9fuS+lpxCMbz3kQV1cd4/U+6Lwixyy22hQbsrppuXDU BnnhpFIAYa8KCFQUSCbzx87Laubr9UCv82nSeNHNeIzG8xonrzj08a8lGcdRbESP NdO3Ec4nxCdRNq12qiqsSvWjWhAnAkFcuMzXC7cek0pHXAjwGI1H7LhD2IUuXOSY xSbeNMKx+2KNM/pya4u7C7/vCKfY1BT5TzYhfr1wjllsuP044dZulS7WqD26VfLc 8k8lfMnwXfLVWyWc4+cgfOOOy26VWez977LeWwoXH8xU1plcP4gwAbEmuPTgH/nq Gg8n9Od5M+IxGi8eTvwAkx2C/HDiPt6fw9rbCbe2CyvxLjz+AcoJNFq4qVBOoNHC TYVyAo0WbiqUE2i0cFOhnECjhZsK5QQaLdxUKCfQaOGmQjmBRgs3FcoJNFq4qVBO oPEN/AJLwYxS6ZrmRQAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -319.05,
    x: 734.15
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -311.85,
    x: "705.47 708.47 711.47 715.06399 718.058 720.458 723.458 726.446 730.052 733.052 736.04 737.252 740.24606 743.84 746.24008 749.24008 752.83407 755.2341 758.2281 759.4281 762.4281"
  }, "&#x0423;&#x043f;&#x0440;&#x0430;&#x0432;&#x043b;&#x0435;&#x043d;&#x0438;&#x0435; &#x0430;&#x043d;&#x0430;&#x043b;&#x0438;&#x0437;&#x0430; &#x0438; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -304.65,
    x: "711.6 714.62399 717.648 721.266 723.066 726.684 729.708 732.132 735.156 738.77407 741.79806 744.81607 747.83407 750.8581 753.8821"
  }, "&#x043f;&#x0440;&#x043e;&#x0433;&#x043d;&#x043e;&#x0437;&#x0438;&#x0440;&#x043e;&#x0432;&#x0430;&#x043d;&#x0438;&#x044f;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6.025,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -297.45,
    x: 734.15
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_458)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,542.4,213.6)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_460",
    width: 98,
    height: 45,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGIAAAAtCAYAAABVq763AAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAyklEQVR4nO3bOwrDMBAAUd3/UiqFPndS2MZxSHAXaUBTPDBbmR22 VEopTSGkmXOevfdZa9VCsfPY/RWitaaNrhBRJwZexdpriJ3H91eI21B/9mPnhjDE wQwBYQgIQ0AYAsIQEIaAMASEISAMAWEICENAGALCEBCGgDAEhCEgDAFhCAhDQBgC whAQhoAwBIQhIAwBYQgIQ0AYAsIQEIaAMASEISAMAWEIiMcQ8dKxlKIFHl+Var2P EFFo9w+daozxDhFisPtcT3OLMF8bDV9Jy4f/KQAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#7030a0",
    d: "M542.42 357.38H598.209V381.572H542.42Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_461)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,545.4,207.60002)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_463",
    width: 90,
    height: 67,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFoAAABDCAYAAAAccRJRAAAACXBIWXMAAA7EAAAO xAGVKw4bAAADdklEQVR4nO1ZW47CMBDj5hyFo/DDG+7EypW8skbpY7ddrK77YRHy mHGcSUiG3W63e2/4COwEUmAnkAI7gRTYCaTATiAFdgIpsBNIgZ1ACuwEUmAnkAI7 gRTYCaTATiAFdgIpsBNIgZ1ACuwEUmAnkAI7gRTYCaSgv/F4PHYYq0vB5XJ5P5/P rny73d6v12sZoWHs8Xh8C3s4HDpH9/vdPmkHICzmT5zP52WE3u/3nagQG99ZhkOI f71ev6GrizYsCvuoPfbXXaG2ptTXNvpiH/WDNh3DPlPKtINPbeP8tG2W0BrVXE1G M8qoV3AMytoOG7Uen5yQ1uETW7T60F2EMoG20+nUfVJYRhz7MAjYZ2qZ/slzqG22 0BrVFLzPqQpddwGjjjZRx61HsdAOW9wxnAgF07Hor2PJB4vKRYRPjNOFnio0bbaE brXNFlqjGqS5VcaEZhtJUTCNUhVLgb4QmwukQgOwzYhVoVu7S8dOFVrP4Sp0X9ts oXkm1e3704jGccAxfVFZjxH+wleh2c7F0IjmEQcf3I0/FZpz1SAZa5sttEagGh0T WledkVlFrOJyUepZrWJx0fUIU6F5/NQdUufSAo4ylrFIfUK32haJ6PrrrZGOMs/U ugj11sHv7K+/9Hq7qHd1tc++PMJaY3gjaN069KakYJS27NRbR6ttttC/gUb7WqDH 1x9heaM1Ijf8kdAbNqE3oQNgJ5ACO4EULG9Us2eaeWvdj/VOrfdstaf3YtphWe+z 9W7MO3QrmzfmcxVC6wuLLz3U8zXFieoLsb4MdXFYxxei2mESic9xBR8g+hplNm/I 52qE5qRRbgmNCNPnOOvx5OZTnRk3RJsuDsr6h0TNg9R0ABNZsKvZvCGfqxFak0ot oTWKVOgqDoXTaNY8dCsSq9CanKLtuiuqz1UIrTnlPqHZzslpgqZGl/7DQ7C/Jqr6 hIYdpneZzdOIbvlchdB9mTE9F5lTqEIzcusZrdm9ugP077WW0DWbh/6oG/K5GqER Gfrrj0lolk1F0AXgDaBOuJXdq7eOvptNHc9bx5jPVQhdM3eImKFsXj0vPwGDz89N rg81b/1PffqFDoGdQArsBFJgJ5ACO4EU2AmkwE4gBXYCKbATSIGdQArsBFJgJ5AC O4EU2AmkwE4gBXYCKbATSIGdQArsBFJgJ5ACO4EIfAEJ58a//jxpaAAAAABJRU5E rkJggg=="
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -379.75,
    x: 570.72
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -371.35,
    x: "548.7 552.30007 556.4904 560.0904 563.6832 566.68569 570.87606 573.8784 579.2784 584.67837 588.8687 592.4687"
  }, "&#x0423;&#x043f;&#x0440;&#x0430;&#x0432;&#x043b;&#x044f;&#x044e;&#x0449;&#x0438;&#x0439; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -362.95,
    x: "556.22 560.4249 564.023 568.2135 571.21188 574.8027 577.7938 581.39187"
  }, "&#x0434;&#x0438;&#x0440;&#x0435;&#x043a;&#x0442;&#x043e;&#x0440;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -354.53,
    x: 570.72
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_464)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,543,339.00004)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_466",
    width: 97,
    height: 44,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGEAAAAsCAYAAAB1wNYRAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAwUlEQVR4nO3bPQrEIBQAYe9/KUt/4p1c3sKGQCDdxgGn+JJW3qid KaU0QylFL/vNPsWntTZ771rACAC3CMdxLD+iO7hu+luE+F/uKf1JbHYjGEFGADAC gBEAjABgBAAjABgBwAgARgAwAoARAIwAYAQAIwAYAcAIAEYAMAKAEQCMAGAEACMA GAHACABGADACgBEAjABgBAAjABgBwAgARgAwAsBjBL3vjLB6IbuKE3FGyDnPWuvy 9707GWN85x7z/wDMOcFgSeaM3gAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#7030a0",
    d: "M542.99 232.39H598.266V256.582H542.99Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_467)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,547.8,328.2)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_469",
    width: 84,
    height: 81,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFQAAABRCAYAAABMpoFyAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAEgElEQVR4nO2aWXIbMQxEdXMfxUfxj3f7Tkq1qp6rg2AYVbTAaeuj S7OAYLMJUiSGu91ut7/hrBgnkIZxAmkYJ5CGcQJpGCeQhnECaRgnkIZxAmkYJ5CG cQJpGCeQhnECaRgnkIZxAmkYJ5CGcQJpGCeQhnECaRgnkIZxAmkYJ5CGtcHd3d3+ 7e3tNzw+Pk6T/s5YGzw8POzf39/3Hx8f+5eXl8O1fr8B8e+KtcHn5+dBRAmrexdU 0fv6+noQm+jVc0Ww7ACdIehaz2T79PT0VQfPeUe9DnHofFBegDfv4d1xpRxldC0b gqjWfRZBiUoRqoKqchG7v7//Iqtrj2Q1WNcSWffPz8+HsipHY9yezqADsNM1vqsP 6tC93rsg2HZcdS8b7wSVV1u7us8iKBFWK/V3VOxRBFEaJ6GIEu95F7SrE/+863xw T4TJ3kXb4oqgRGydzmrdJwsq8vTQlqAeTTzfEpSGK2poVDcKvCG1UZ2PGqlwqoJW rj4yuv+HswqqEIewzzs+p9Sh1kWcC+pzZBehzIO61vzWNarzwT0BILA6oY6Oazcy LiZo/Xd36BlLJyeq6EEgiDHvyR8+Zadybu+i+7JMwvp950Pv6YD6Z+dlK1fnWXl3 5c8iaLdEqo0+FTVS/nNsD3kiq75jaXFOQYPWtuME0jBOIA3jBNIwTiAN4wTSME4g Dccb+8KYRT/LJ5IJNTuj9apvEbUc6zJYLNTdp+dg2QRQ1q+rnxUfz1Z5cqazvbig 7GREmtQX1yz2tcf2VF7dJbH7qEKw+6oJFt/y4o/rLT8rPpRR58nXyvZqgnYRVPfE Tsp7X3ts/Hj2xwWtUe2JDa9ry8+KT9eGFferCFoTF57bdKG5dyH4hOJRQnkXiDQc SeKanOmiDT8rPp2gK+5XEdQjxzPcHh3s9SU+SYwq6NaQR7CucccM+RWfWmZlezVB 6x+FoPmHpC5ZchfA7ZkjyYIzD9fnqq82Tu//5mfFp5ZZ2V5N0HMmRgJxvHHXuzec IOgNN0FvggZgnEAaxgmkYZxAGv5u5OeCWPz6N/HuWzmZJZXXcsszPL4j4vt53f75 N3o/3uO7mi3fek7mCp9smf053/HVNtXRnRm4iKBUIjIC61F2TJ618a2lN5odiKfI sCFDpPe+Pyej5WeeZEPnbvl2Py5o9eNpSNJ63nkXE7SebPPnWw3wKPIo9EbXexpe T8R5BsqTLCvfdZtcO4ZIpT6O9nTZs4sI2lXQCcowr0kOXdczTXSUJ5VrXS4oowF/ iuAt390pPheUkYTYHD26iqBk6j1vuSWoz30ciSEV53lOhi1zIBHndfnBMMqSBGaa 6HwfM+QZBTXlV08PXkTQ2lCiiQZ5A7rzSd15JD+DxHyJvX8NYH4kGj1HuuWb534a hbNMei5fnPTjXJTzOfEkyz8V+gM1In4wzuOoRsQPxjiBNIwTSMM4gTSME0jDOIE0 jBNIwziBNIwTSMM4gTSME0jDOIE0jBNIwziBNIwTSMM4gTSME0jDOIE0jBNIwziB NIwTSMM4gSj8AhckIblzy0IEAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -258.85,
    x: 571.03
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -250.45,
    x: "550.8 555.5974 559.19546 562.7935 566.38436 569.98239 572.9735 575.97189 581.3617 584.36007 588.55056 590.9492"
  }, "&#x0414;&#x0435;&#x043f;&#x0430;&#x0440;&#x0442;&#x0430;&#x043c;&#x0435;&#x043d;&#x0442; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -242.03,
    x: "553.27 556.8916 561.1108 564.13479 567.75637 571.3779 574.9924 578.61398 582.8331 585.2596 588.88119"
  }, "&#x0440;&#x043e;&#x0437;&#x043d;&#x0438;&#x0447;&#x043d;&#x043e;&#x0433;&#x043e; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -233.63,
    x: "552.03 555.0396 557.43 561.62039 564.6228 568.21566 571.8156 575.40847 579.0013 582.6013 586.2013"
  }, "&#x0441;&#x0442;&#x0440;&#x0430;&#x0445;&#x043e;&#x0432;&#x0430;&#x043d;&#x0438;&#x044f;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -225.2,
    x: 571.03
  })), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M542.99 244.48H540.15V217.23H542.99"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M542.42 334.5H538.45V278.86H542.42"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_470)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,542.4,278.40003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_472",
    width: 98,
    height: 45,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGIAAAAtCAYAAABVq763AAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAzUlEQVR4nO3cTQrDIBQAYe9/KZfiz50sb5EQEAqFVgc6iy8EsnN8 7kxKKc2Qc56lFG00xpjX+qd41Fpna00HxNobAmIJ0Xs/Pq7/4rn5lxCPMdGPxaY3 BIAhIAwBYQgIQ0AYAsIQEIaAMASEISAMAWEICENAGALCEBCGgDAEhCEgDAFhCAhD QBgCwhAQhoAwBIQhIAwBYQgIQ0AYAsIQEIaAMASEISAMAWEIiLch4mO8a48lxCd3 gvVdsfnvEPH7h+to0t6JiDvXdwid9wKhn2B+asejLwAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#7030a0",
    d: "M542.42 292.87H598.263V317.06199H542.42Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_473)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,547.2,271.2)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_475",
    width: 84,
    height: 70,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFQAAABGCAYAAABSdbNRAAAACXBIWXMAAA7EAAAO xAGVKw4bAAADwElEQVR4nO2aXW7iQBCEuTlHyVHyQkL4uROrQvpWta22iQirhtp9 KNluT9s1NWPcNXiz2Wwu//FQjBNIwziBNIwTSMM4gTSME0jDOIE0jBNIwziBNIwT SMM4gTSME0jDOIE0jBNIwziBNIwTSMM4gTSME0jDOIE03J/8+fl5OR6Pv48/Pj4u h8NhukPT+NkFTqfT5f39/bovMc/n8xX7/f6K3W53PaeY2qkN7QXt65wPhAZKuYpt t9trTNfx6ymuAdSxt/HBJa594rqX4l3+UwgqgpqlEobZKiEQVIIT077E0pZO0FZb RO1iylGMe2grMb6+vv64L7x84IjrmAnQ5T+FoHSW2dl1rMYQR/tvb2/XmeIxBFVH tfXBujVoxBhk4hpAbYl3+U8jKLO0irgkKEK5uJopLqiE5qeAmeSCdiJUkVxQ7kP8 wSI+TlB1lsfnlqBqx5ZHXvsIV2cobV0cn6kMAvdee+R9AJnxNf8pBBU5f8kQq/t0 UB3Q7PPzPNa0rbHuegKz0fO8HYPmcV5KXf5TCPpd/EPl1DiBNIwTSMM4gTSME0jD OIE0LJ/E+eC3ics+ep3X+XT389WnVz/f5VePTynlpY7Xj5RDfk/KsyWP3/Wj1qUd 37sFpTMseGifgljHeHK1U8x9emftulzuU/MpuvHzCMp1JVbn0d0U4K66gn+pH16X LvH9kaAIwsXcsjl5Yli8zi11ubXD5GM93ePTSb/GkkfXMatMnce/1Y81vg8RtFo/ H+3Op3eCdrlVUPI7j99do3r0ug5QBXXrudaPNb4PeeRdlG65DT+PT18StOYu5Xce v+tk9eh1HWDtke/6UQXt+N4tKCOiDnYe2n8Dq0+/5b/992gpv3r8tevyUuLFspZT vXzn+df43i3od/FTnx7m88cJpGGcQBrGCaRhnEAaxgmk4e9cmHLHC2LsokobL490 jH+mXMLfexvt+xoBkGWtbbwE4n9+X494OUFxJRTn3in+NnaB5IgUp5D2r1JYsKDg 9+JdOb6oQRsKfu7ZWcuXE5RZx4oNcf9gwRc96DiisbjBtdxqKu6WeKmN284YQZml EsgXL3ROj77bO/JYwOA8IvNJTido14ZvBiIEpYN0nKUwF5TZ4+eYrS4oK15rgt5q 8/KCMuN4GbAAXF849b91RPYXl5/3BWH34V2bJU//koI++IuMV8E4gTSME0jDOIE0 jBNIwziBNIwTSMM4gTSME0jDOIE0jBNIwziBNIwTSMM4gTSME0jDOIE0jBNIwziB NIwTSMM4gSj8AoWBBXVoFyGIAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -317.27,
    x: 570.75
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -310.08,
    x: "555.4 558.4 561.4 564.994 567.98806 570.38809 573.38809 576.37606 579.98208 582.98208 585.97006"
  }, "&#x0423;&#x043f;&#x0440;&#x0430;&#x0432;&#x043b;&#x0435;&#x043d;&#x0438;&#x0435; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -302.88,
    x: "550 552.994 555.994 558.994 561.994 565.588 568.588 571.58206 573.9761 576.9761 579.9701 582.9701 585.9701 588.3641 591.3641"
  }, "&#x043a;&#x043e;&#x0440;&#x043f;&#x043e;&#x0440;&#x0430;&#x0442;&#x0438;&#x0432;&#x043d;&#x043e;&#x0433;&#x043e; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6.025,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -295.68,
    x: "559.2 562.2005 565.19497 567.5929 570.58737 573.58779 575.9797 579.5766"
  }, "&#x0440;&#x0430;&#x0437;&#x0432;&#x0438;&#x0442;&#x0438;&#x044f;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -288.45,
    x: 570.75
  })), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M542.42 334.5H538.45V304.96H542.42"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_476)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,316.2,379.80003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_478",
    width: 105,
    height: 48,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGkAAAAwCAYAAAASA1QFAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAxElEQVR4nO3cMQpDIRAG4b3/uRRRD2XYJiEkee3bIVN82AqDln9E xFF5cXrvZ8551loqInuMMV6RDFTT3vt7pKyne2Wcn5HyLPD//r3Ll2SkGowEYCQA IwEYCcBIAEYCMBKAkQCMBGAkACMBGAnASABGAjASgJEAjARgJAAjARgJwEgARgIw EoCRAIwEYCQAIwEYCcBIAEYCMBKAkQCMBGAkACMBGAnASABGAnBsA+BybEO1vEVq rd1+IX0GymGuZyTV9gCS8YVyE1btzgAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#ff3300",
    d: "M316.21 189.43H376.151V215.54199H316.21Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_479)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.59999999,315.6,377.40003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_481",
    width: 107,
    height: 58,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGsAAAA6CAYAAAC3badeAAAACXBIWXMAAA7EAAAO xAGVKw4bAAADaUlEQVR4nO2ZW3IqMQxE2TlLYSn88IY95VZTdaguxTNAbhKBoo8u xopk96gtg5XFYrH4aLwN0gk0WqySSCfQaLFKIp1Ao8UqiXQCjRarJNIJNFqskkgn 0GixSiKdQKPFKol0Ao0WqyTSCTReVaz1ev1pvFwus5PwLvjdBU+n000wfZ7P5+wE vBN+d0EJJMH0fDgcrpBtv9/foLGw2+2uYh6Px1v1ya6x5pCvbJfL5TqWXc+yxflk 22w2V7/tdnubyzcO87ld82GP8eXFEqguCaFPJUEgyYyVfMRBBBK5Wq1uVenxvhFY Q3MqXlAc63ucPl0UQRtkLv5PiEV1kdgpsbApSQijZEkIjT2eysKmZwTVnMTgozlj XBRLMVTWKP5PiCVQVXNiKUHYeFayOIb0HOPZ9fwNsTTWseoc5ipL/lqTo3QUX14s vbBXwJxYSrQS5juZMTtdNolHZVBxCIpYfiRSdXNiwc+/92J8ebEeBYmUSPGn/b2f +3OJ/N+rQvJVI1+YEVSBL3DsvBrSCTRarJJIJ9BosUoinUDjO8TSrzH6dxpz16AN JJt+xnofjpaM7jnce2LjlnjaOdynWDf6aU5+GeLnPTutx/rcm3wexWgt7lbE6Nlt 8uFZ/BUX71Sakzue5wBfXz/yGvnF3uWd+9v4D7R4SBYvrgW9W+7dAheHTy7Bo3if Rz5++XQ/RJUfl9XYvYcDn7S02Ez0Cv3v3ntkIzhX2VwU4uhN+lz4+EaOvEZ+4sZG 9NinxNLOYiHG7GRP2pRYHivbKB4/QT5ekXEdfKg4r8RRC4quBnHe2MXmYtHBoMNP tyKKxfsIXkW0qNh0U7yiH1z0/ECDePoI9IRzJFL2j1SW+47i3Y/jduTn/lSLd+L9 JeES+UeuXlkIR3zkN0qgcxcPOJP4Ea8pP47cqbXuikVCgI/j/4SmKoudzXkd43lh dhjfY9HPv5+oNNnYnSTbKyby5yifOgY9qV4dMYGsy1rYvIr5nhrxin6e8y8fg76D fDzq1Y1i4hn9TPwzfvE/zb7jGd9JwNMYzakj3G1TvKLfk/i+l4hi/cTcEf7dRdKi LQM/xCv3pRotVlWkE2i0WCWRTqDRYpVEOoFGi1US6QQaLVZJpBNotFglkU6g0WKV RDqBRotVEukEGi1WSaQTaDyIfxI6rHnlQIGDAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -211.1,
    x: 346.42
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -203.9,
    x: "331.07 334.07 337.07 340.664 343.658 346.05799 349.05799 352.046 355.65199 358.65199 361.63999"
  }, "&#x0423;&#x043f;&#x0440;&#x0430;&#x0432;&#x043b;&#x0435;&#x043d;&#x0438;&#x0435; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -196.68,
    x: "318.03 320.43 324.024 327.024 330.024 333.024 336.01799 339.01799 343.21199 346.80598 349.79399 352.80598 355.80598 358.79997 359.99995 362.99394 365.9879 368.9879 371.9819"
  }, "&#x0441;&#x043e;&#x043f;&#x0440;&#x043e;&#x0432;&#x043e;&#x0436;&#x0434;&#x0435;&#x043d;&#x0438;&#x044f; &#x0437;&#x0430;&#x0434;&#x0430;&#x0447;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -189.48,
    x: 346.42
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_482)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,316.2,409.2)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_484",
    width: 105,
    height: 46,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGkAAAAuCAYAAAAr3zfuAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAzElEQVR4nO3cQQqEMBAF0dz/EjlKNgY1yZ0yiIwgyGztYmrx9g0F vfwppTQVXppjjNlaUzC995lzPiNt2/b6QXpWaz0jHcW+5dZ11cv2fb8iLctyj3QI 8H//XinFSNEZCcBIAEYCMBKAkQCMBGAkACMBGAnASABGAjASgJEAjARgJAAjARgJ wEgARgIwEoCRAIwEYCQAIwEYCcBIAEYCMBKAkQCMBGAkACMBGAnASABGAjASwM9I TgTE8DgR4NhGXNfYhrM1Md1maxTbB17W+EtFQN4uAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#ff3300",
    d: "M316.3 161.33H376.58299V186.14801H316.3Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_485)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,316.8,413.40003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_487",
    width: 104,
    height: 34,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGgAAAAiCAYAAACz35yrAAAACXBIWXMAAA7EAAAO xAGVKw4bAAACq0lEQVR4nO2Za47CMAyEuTlH4Sj84Q136mqQvtWs5bT7EkmRf4wa knpie5KWuJvNZjMVhkZ3Bwol0KrR3YFCCbRqdHegMIpA+/1+ejwen793u92zb4Ak jIzXCnS/3z9/X6/X6XA49E7A6HjthBKFXXS73abtdjudz+dnv3C5XJ5juoc+33US VH2y1Q6EU8Krjx2ptvrF7YtD/fBp3P1qtdnp0f4tBVKgJJ1EZMnR9Xg8PgX0xJMc CRUTDbdsIreuGuee7wikOSQKNtH+LQUiAQQ+JxB9upedgLDex06hT7zsRHgkssYE tRkD8dGrediF4svs31YgkhlFiQK5gLSxO51OXwTSVY8iksu7jTGfb25eFw6++O58 MV6/e/yRNSeQ7lNi2A30q8/fL7S5X9BjLvKBKGzW9nt4rEX7txToJ0L29mEQdHeg BFqjQIUSaC3o7kChBFo1ujtQ+I1AOuip1OL/+ymheH2M84cfJgU/N+jA56UZtf2c wdlG92V8bqszkfozvtYcwOt77tdcnP5vMotf9vIn2lAIbnF5pWKhtpcP+GlfSSEI 6mMkFPJYo8KWRFMmIUmc9L2epnbGhy28Lb7WHB5TxtOKkz73Mcbvc8bykttELuzg +pVABEPwfpKmqksZJK6QTCCVZ3x1IYS4qE5nfK3ERr7WHEsCZXFSifDxLH4EzqoX tDMut1s487UF8lUu9bPtiABeQfbalQtEMdO5Aasr45tb+c63NEeLZy5OPm/4Ls84 53ZQxhV94dPJjwTy9wOl9mx1Uzejxha/ucSV6kkhobqyIp3PV5v7k/G15lgSKIuT uh7frHzhZbubzyJRoBYXMUnUPz/iRsN/loFGjnNWIP6dDOBg6tt/co0a56xAhWHQ 3YFCCbRqdHegUAKtGt0dKJRA68UHMTOijhWIRXwAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6.025,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -175.13,
    x: 330.67
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6.025,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -175.13,
    x: "332.02 335.02046 338.0209 341.61784 344.61228 347.01023 350.01069 353.01115 356.60206 359.6025 362.60298"
  }, "&#x0423;&#x043f;&#x0440;&#x0430;&#x0432;&#x043b;&#x0435;&#x043d;&#x0438;&#x0435; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -167.9,
    x: "318.97 321.97 324.958 327.964 330.964 334.55799 336.95799 339.95198 342.95198 345.95198 349.54597 350.74595 353.74595 356.74595 360.33995 363.32795 365.73994 368.1339 371.7279"
  }, "&#x0440;&#x0435;&#x0430;&#x043b;&#x0438;&#x0437;&#x0430;&#x0446;&#x0438;&#x0438; &#x043f;&#x0440;&#x043e;&#x0435;&#x043a;&#x0442;&#x043e;&#x0432;")), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_488)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,87.6,415.2)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_490",
    width: 104,
    height: 49,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGgAAAAxCAYAAAA2neyeAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAwklEQVR4nO3cMQ6CUBRFwb//TVESCHvCECNqNLacxCmmee35UN4x xthJG/s0Tfu6rvuyLEQcPbZtuwd6HGg5A83zfB6vfjk8P5ajy0egwD/37wkUJ1Cc QHECxQkUJ1CcQHECxQkUJ1CcQHECxQkUJ1CcQHECxQkUJ1CcQHECxQkUJ1CcQHEC xQkUJ1CcQHECxQkUJ1CcQHECxQkUJ1CcQHECxQkUJ1CcQHECxf0MdPXKBl+WRl6P dJxbPdauet4C0XUD4EDLIMSaR14AAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#cad318",
    d: "M87.783 153.59H147.483V180.05699H87.783Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_491)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,93.6,409.2)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_493",
    width: 85,
    height: 70,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFUAAABGCAYAAAC9t9hvAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAEGklEQVR4nO2aaY4qMQyEuTlH4Sj8YYc7zVMhfajGclh7nmcMP0qd pLNUKs7idM9ms9nXB5OjnEBHlBPoiHICHVFOoCPKCXREOYGOKCfQEeUEOqKcQEeU E+iIcgIdUU6gI8oJdEQ5gY4oJ9AR5QQ6opxAR5QT6Ij7Mp5Op6/9fn+JL5fLb/EP nhBVOB6PZzEVlqCr1eoc3263Z/BOA4DwsQ6lefpisfhWljwxTfmo19sg/3w+v5oe y8e2YnuUyfowqagidTgcLgKLsJ4SWKT8ncJKIx/lybfb7S55VR4wYJRVfL1eX8p4 G3Q4C6tNOGTl3VAif29T77wPk4sKCRFAgGi9WZoI+sAojmB6Ki6oXq/HBdxsNpeO y4IoB5coqp5wzcqPZp+nuzF4HyYXFWvNrCQTVR3RMsF7lg0XVXGlUy/vEBWLA9HC oqXKIklHyFj+lqgxTB8mF1WNxyk0ElUYDYDqcFFZZ5WXclFUWRocbk1/54Gosfwt UVVG1smG/ODa+piViqRPH6URZzR9atIZOkQawlEncItg3dU0xPqYht5uDPuGyfoa y1/jL7CxZRvY5NP/Hvjovymmr1Qj/OBu2Q3lBDqinEBHlBN4GSw30Vv7iPoCdOTh +BbPob9OVI5AfoQa+e7xmBXD7ofHPMSjlY188qwueEXfH/891pX1bXS3EMN3zIax oO6SQhqvSO9wF939Iw8E3OV0397dQN7p6efX6BKTlzSdd7P2uJPQ2RRviDYQdtS3 yNvT/Z7ihoc1FtUvGnyEcSsVVwcgB2GIxksSOqz6EFBl/JCPF6V3COwdRFS8sqw9 iY3HBsSZpSHr24g3A8DAwDPW/5CoVIZnxOjrSR7SXFTIQtQtjPyq0y9SsAaEjBcs XMQwlZmKsb1Y50hU71tWjw+ku7/O6anpTwWICKJvT2ch4VYGSaYVluYbjPJw3eaD 4BcmtMMyA2J7LB0uThQ161usxweApQ6eT4nqG4U34FaC5eJTszH4eqOwL+5Mdery MEcjhPf2ESFyyNrTk6s+4t5e1rdRPZ4eeT4lahWiFbhl/RGUE+iIcgIdUU6gI8oJ dEQ5gQs4SfgXA44yfoZUuns3vol5evZJurWomQ+dnf1wEhTmXDrKK+D1FJ8Y/n+j HLjd8gT3lrjKGwlDXj8vRk/obUSNvw9lQuGZ+Q8Vo7x4ZhJXFu3OxduIeq2z2aE/ /lGS5cXiNWDu/byNqNp43NcfTX//9u+fr32jYkMjD5cjuM1PfK//m6JiRfGeFOuL ogqcCpjmWd54X+B/qLyFqD+BbJ3OfvP5iPoAsmn+wq+QH1F/IcoJdEQ5gY4oJ9AR 5QQ6opxAR5QT6IhyAh1RTqAjygl0RDmBjign0BHlBDqinEBHlBPoiHICHVFOoCPK CbTDPxAbz/v5MqiPAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -179,
    x: 117.73
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -171.8,
    x: "98.55 101.55 104.55 108.144008 111.13801 113.53801 116.53801 119.52601 123.13201 126.13201 129.12001 130.33202 133.92603 136.92603"
  }, "&#x0423;&#x043f;&#x0440;&#x0430;&#x0432;&#x043b;&#x0435;&#x043d;&#x0438;&#x0435; &#x043f;&#x043e; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6.025,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -164.6,
    x: "95.875 98.86943 101.26738 104.26181 107.26226 111.45566 114.45611 118.05304 121.05349 124.05394 126.45189 128.84383 131.83824 135.43517"
  }, "&#x0432;&#x0437;&#x0430;&#x0438;&#x043c;&#x043e;&#x0434;&#x0435;&#x0439;&#x0441;&#x0442;&#x0432;&#x0438;&#x044e;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -157.38,
    x: "109.15 111.55 112.75001 115.74401 119.33801 122.33801"
  }, "&#x0441; &#x0415;&#x0421;&#x0411;&#x0414;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -150.17,
    x: 117.73
  })), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M88.735 333.19H84.31V166.82H87.783"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_494)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,616.2,213.6)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_496",
    width: 107,
    height: 45,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGsAAAAtCAYAAACpvpV9AAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAxklEQVR4nO3cMQrEIBQAUW/uUTyKjSDqoQwhyybZLVLGgSleo+XI 7/whhDCFEWaMcbbWtKhSyhlrP+i9a1FjjJlSOmLVWr8Xb78ina7Bcs7/sRaYy/rY x5+xIIwFYiwQY4EYC8RYIMYCMRaIsUCMBWIsEGOBGAvEWCDGAjEWiLFAjAViLBBj gRgLxFggxgIxFoixQIwFYiwQY4EYC8RYIMYCMRaIsUCMBWIsEGOBPMZ6+4e6Hn7r /15oLbc9GG6YWdttw4wYNgBs7vqVvnOsAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#7030a0",
    d: "M616.4 357.66H677.62808V381.583H616.4Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_497)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,622.2,207.60002)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_499",
    width: 90,
    height: 67,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFoAAABDCAYAAAAccRJRAAAACXBIWXMAAA7EAAAO xAGVKw4bAAADSUlEQVR4nO2Z287iMAyEeXMehUfhBn6O78RqkD5p1htOS8Vs11yM 2iapPZ44KTGLxWJx+eIjiBPogjiBLogT6II4gS6IE+iCOIEuiBPogjiBLogT6II4 gS6IE+iCOIEuiBPogjiBLogT6II4gS6IE+iCOIEuiBPogjiBLrjdeT6fr+B5uVxe DofDZb1ep0lHsNvtrvHr/nQ6/abNW0LLqAwi7M/Pz+V4PL7q4L+B4pYm0kB4MeFu d8qQhGYWZVz3ymw51QwDTYLGrFar67Pe1VXjNJ6MAE6y2lLbyIfz8j58YZNn/Fde ss097RrnY7Cz3+//eL/2vS10zWpE171E51lXAQJMSJ19b9d4ka+2GOvt1b7usaXr ZrO5XhEXn7zn9hCr3stGbce+xzXqm0RoD6yKQJYhnBMScT1r1unzTKiBqm273V5t Kbt0r3ZlH6KNAnahsYsAmkjaXxWamEZC175JhEZID+AZoenTlazyLKuB0s6KITPZ snyynI8L7TYYe0/cW0KzWpg4j2vUN4nQ/gFgv3tGaN9uBMRQlsnOKGhlr4vl3wbs 88vHtzDfOuiTHz7eutaVU+9ZSYjp21AVuvZNIjTZ5xv/s0JzrfuaZzTLu+6r/lV3 ockk38JcaBcEAX0buQe3w2q8tYonF/pVVEJzwQc4f4UWPnAQywfZBHECXRAn0AVx Al0QJ9AFcQJdML1Rr555xUsnND8e6/BB5Yz6Rq3U8Z7aNF4nQ7eDr+qTw5DGeBun 20c+ZyE0J0VOggThhRgvLPlp0I/vCOK2fCy++A3sfmnjGF6refd8zkZoL0CNhPZA EZo6N0dlMg/RagnUy7DUwn2S/Znsp5byyOcshCYYSFehPcs9o71u4O94vcTFrqXb W0KPKn+PfM5CaIRk7/NAvWDvwZHdXoeulTv2W6+PU8lzwUZCU82Dj4pH93z+80LX ypmDj5nvhff2aP7+8tLlaI+mn4moQo/eZ9Jv+ZyN0PWj8mhZ/sW/FW8j4HNaoUdV sEeVsa/QX3yFniHiBLogTqAL4gS6IE6gC+IEuiBOoAviBLogTqAL4gS6IE6gC+IE uiBOoAviBLogTqAL4gS6IE6gC+IEuiBOoAviBLogTqAFfgGScHlkXvGACAAAAABJ RU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -379.9,
    x: 647.47
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -371.5,
    x: "625.47 629.07 633.2604 636.86038 640.4532 643.4556 647.646 650.6484 656.04837 661.4483 665.6387 669.23867"
  }, "&#x0423;&#x043f;&#x0440;&#x0430;&#x0432;&#x043b;&#x044f;&#x044e;&#x0449;&#x0438;&#x0439; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -363.08,
    x: "633 637.1904 640.7976 644.988 647.99038 651.5832 654.57839 658.17837"
  }, "&#x0434;&#x0438;&#x0440;&#x0435;&#x043a;&#x0442;&#x043e;&#x0440;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -354.67,
    x: 647.47
  })), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#3366cc",
    d: "M367.59 492.19H358.38V484.5H326.07"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#3366cc",
    d: "M367.59 492.19H358.38V504.44H326.07"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#3366cc",
    d: "M367.59 492.19H358.38V524.39H326.07"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M456.31 369.48H464.82V344.25H456.03"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_500)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,617.4,314.40003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_502",
    width: 105,
    height: 45,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGkAAAAtCAYAAACtS0VAAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAy0lEQVR4nO3bOwoDIRgAYW/uUTzKNoLs6p0MsnktCaTUIVN8IFqO /p0hhNC1vNBjjH3fdy2mtfaKNDaO49Biaq09pXRGKqU8D2bfHl0fzLZtn5EWmL9/ L+dspNUZCcBIAEYCMBKAkQCMBGAkACMBGAnASABGAjASgJEAjARgJAAjARgJwEgA RgIwEoCRAIwEYCQAIwEYCcBIAEYCMBKAkQCMBGAkACMBGAnASABGAvgZaaw11/sP 9K+RtBYjAdxH4DkHR7HZz1xXjzY3bwxkw7PCjy8AAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#7030a0",
    d: "M617.54 256.58H677.634V280.77198H617.54Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_503)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,617.4,295.80003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_505",
    width: 105,
    height: 109,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGkAAABtCAYAAACiE08sAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAFhUlEQVR4nO1bbVIrMQzj5hyFo/QP33An3vjNiBEaO7tAW7dGPzSA mzjaKEkTbbi5ubn5MC4e7QQMizQC7QQMizQC7QQMizQC7QQMizQC7QQMizQC7QQM izQC7QQMizQC7QQMizQC7QQMizQC7QQMizQC7QQMizQC7QQMizQC7QQMizQC7QQM izQC7QQMizQC7QQMizQC7QQMizQCx096OBw+np6ePhF/X8CDXjOOn/T19fULXl5e uh/y2nH8pG9vb/9nUPweAqlImGG3t7efsWr2cRzl4yf+rspu5Xh/f/8yw1GGOSlX tHd3d/eZI7Bq+yJFCnIxe+7v71OR4neeZVEedRghdHRA/ESO+B0dhzIo//DwkM7g KgfqPj4+fuGFTs+4oo1sAJ549TiuSPHQ6Hx9kOgAfBajEp2HTsfDQ4AogzycF+Wf n58/OxydH4MjPgOfLAd4QKiYGciBPBlXCBDtBgfwR1va9sWKBPJYNjKREAvE6KxE is7TEcoioTw6MOuoLAfEirJRNzodAq24RrnVjLkKkUIYdDBiLBKWC12vK5HQKZF3 ayZVImU5sIyFgLzMIW/FVXnqUn4VIuko0+8YiIiHwwNXImXfPSwSRj6PaO2oLAdm O4sYeTGzeMAp1xEioXMZ/IWNHRLvgHTXFHHdNfHuC52F0Z/t0piX5uCdHTYuWV3l mu3uttq+SJEykvyFfAzoiP4DOF4yHpUMPk8cAzqi/wDaCRgWaQTaCRgWaQTaCRin FCl2V+oc67lFzzIrtzg793B89dmqDu8ss/JZft6psutexbntPWXOJhKf4uNvdo3x NxuXYcvgjMOIsupi87mK22GrZlVHHexVeY7BvVdnAe1Wce6XPWXOJhKLECMlex0A f03NSO4QdsSzB1O3XF10rQNTFa8p4N1V5bODMWLw+7SsxvfUbREJZOBmw/TU1wHs JGci6TsodhTwGXt2/A4qq8PlINKqfCVSPAsGHefI4nvqtogUBGBKghAeBCJVTkM2 k1AWRmXkwojnjuWZlNVBB4Ejz6SsfCWSGr0om8X31D27SFhSeFrDquEZhmWOlz4V CcsPi423qpWrvlVHRarK84qQdTQbuiySxvfUPbtIvGvRHYw62liC2GvLdmTsVqOM uupYTqs66h9WTrXGMi6I8S62iu+pe3aRzgHMRo2d6J3NJaOdgGGRRqCdgGGRRmC7 EB8keRttXIhIfNuGrw8bFyISbnaG5cNxPRfpOUPPIlu3bPi+tQ6QalDw+Ss7J+Fz zlk55ofkdtJWnZWbvjeW5f22SHodlw+WOKXjfhrOLlqHne/svpo6CSDNbkW2xFYu BLfNzkMMNHXTOZfeM+c6AAYrLCU2k7NY1SZzU+P52yKh4egkWCJ6d5uv3uro1PJ6 h7q6Gw6zFpfpMdJ5ZlUdizhceTZaIbbeTq1ysdfH19LYakKOKpa1mVlovxZJieBB 2OXVkckzI3uHFHV59AERg3i8VPH7ITzoSiSOo4PUdd8jOPNjA5lH/yqWtckG7M7v +fpDJOZ/D+GZEeB3NlwXI5mdYF3uqrvhGs/W7Z/MpOy/O/bOJAbn4gG8inGb1QD5 kUjcoVCdZ0Y2/XlW8BKXiVTdt+aL/9W2f0sk5NMy6oDrzGdoHeTi3KtY1SbPUOXy I5FWd7ez3R1cX75bsNrdZfk1T+YgVzsydFS2u9Ndp8YBfofFn7GLn+X6boz76Fci XRt2Lh9LnPC/I36KdgJHBc+wQWgnYFikEWgnYFikEWgnYFikEWgnYFikEWgnYFik EWgnYFikEWgnYFikEWgnYFikEWgnYFikEWgnYFikEWgnYFikEWgnYFikEWgnYFik EWgnYFikEWgnYFikEWgnYFikEWgnYFikEWgnYGzgHzCFDO+cF6xWAAAAAElFTkSu QmCC"
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -291.48,
    x: 648.05
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -283.08,
    x: 648.05
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -274.65,
    x: "627.82 632.6224 636.22238 639.8223 643.41519 647.01516 650.0103 653.01278 658.4056 661.40798 665.5984 667.996"
  }, "&#x0414;&#x0435;&#x043f;&#x0430;&#x0440;&#x0442;&#x0430;&#x043c;&#x0435;&#x043d;&#x0442; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -266.25,
    x: "625 629.8024 633.4024 636.3976 639.99758 644.188 647.79519 651.39517 654.9951 657.99038 661.59036 665.7807 666.9831 671.17349"
  }, "&#x043c;&#x0435;&#x0442;&#x043e;&#x0434;&#x043e;&#x043b;&#x043e;&#x0433;&#x0438;&#x0438; &#x0438; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -257.83,
    x: "620.63 624.23 628.42037 631.4227 635.02279 638.62277"
  }, "&#x0431;&#x0438;&#x0437;&#x043d;&#x0435;&#x0441;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -257.83,
    x: 641.5
  }, "-")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -257.83,
    x: "643.65 647.25 650.85 655.04037 658.6403 662.2403 665.2499 668.25949 671.8378"
  }, "&#x043f;&#x0440;&#x043e;&#x0446;&#x0435;&#x0441;&#x0441;&#x043e;&#x0432;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -249.43,
    x: 648.05
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -241.02,
    x: 648.05
  })), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#515151",
    d: "M87.955 357.38V347.42H51.874V343.17"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#515151",
    d: "M87.955 357.38V347.42H116.69V343.32"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M78.236 333.39H81.543V301.78H77.102"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#515151",
    d: "M238.8 369.48H234.55V242.33H238.09"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M238.8 369.48H234.55V334.94H237.71"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M238.8 369.48H234.55V208.16H238.19"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M223.1 310.12H227.55V280.33H223.17"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M300.55 334.94H306.22V307.34H301.32"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M300.55 334.94H306.22V278.51H301.32"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#515151",
    d: "M316.72 369.48H310.71V335.3H316.38"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#515151",
    d: "M316.72 369.48H310.71V255.59H316.4"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#515151",
    d: "M316.72 369.48H310.71V228.31H316.4"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M316.72 369.48H310.71V142.01H315.54"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M316.72 369.48H310.71V109.72H315.84"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#515151",
    d: "M375.45 369.48H386V289.99H395.63"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M457.45 289.99H466.54V264.74H458.04"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M457.45 289.99H466.54V240.41H458.32"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M456.6 167.5H463.71V140.08H456.91"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M456.6 167.5H463.71V112.7H456.35"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M375.45 369.48H386V167.5H395.65"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M598.21 369.48H602.33V244.48H598.26"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M598.21 369.48H602.33V334.5H597.98"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M692.37 368.13H688.12V337.22H697.47"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M692.37 368.13H688.12V310.34H697.47"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M696.62 281.24H688.12V256.08H697.47"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M679.83 236.42H688.83V208.19H680.33"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M679.83 236.42H688.83V179.42H680.82"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M677.63 369.62H683.3V338.62H677.63"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M698.61 231.7H692.94V201.49H698.75"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M696.48 168.54H687.98V145.66H696.48"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M696.48 168.54H687.98V122.57H696.48"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M45.435 369.48H23.42V273.67H25.998"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M45.435 369.48H23.42V252.35H25.998"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M617.54 268.67H607.75V268.93"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_506)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,396,369.6)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_508",
    width: 110,
    height: 45,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAG4AAAAtCAYAAABPl145AAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAv0lEQVR4nO3cPQoFIQwA4dz/Upb+HcrFwn08kK0zMMXXiN2QlImI WEKK1Xtfc841xlBypZRfOKNx7FZvuPO4J6/WqoTOcF3D7Q8JdrcuPifOcHkZDspw UIaDMhyU4aAMB2U4KMNBGQ7KcFCGgzIclOGgDAdlOCjDQRkOynBQhoMyHJThoAwH ZTgow0EZDspwUIaDMhyU4aAMB2U4KMNBGQ7KcFCGg/oM59WFvK5XF7xzwvEXrrVm PICzEd9w4nkAqXlHjLSjn4cAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#ff3300",
    d: "M395.88 201.54H458.951V225.728H395.88Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_509)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,397.2,366.00004)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_511",
    width: 105,
    height: 58,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGkAAAA6CAYAAACzmHdjAAAACXBIWXMAAA7EAAAO xAGVKw4bAAADuUlEQVR4nO2ZXY7CMAyEuTlH4Si8wPJ7J1ZT6UMjKy3sChSI5mGU NI0dx+OkibtarVa34OPR3YAgJA2B7gYEIWkIdDcgCElDoLsBQUgaAt0NCELSEOhu QBCShkB3A4KQNAS6GxCEpCHQ3YAgJA2B1yu9XC639Xo9+xx8AEnH43GC6ofD4U6S 6kDPm81mwna7neA69Kx+3oYsz5KtbYxDUKB/qa6+Xnf5qtftr7ZJ59eQpAlAzPl8 nhyw2+1up9NpmoxKPQvqp2eVPz8/d4LUBtS23+8nXZCuNuQEtSNHH8aFxLk6Mi15 5tSyH1sZn/IrSGI1uUPdKSohCRKYbF1JvK9OUhsBgHPUfr1e7+N6IPC+kqTAcL1V 3kmq9lMnuCQrm76GJK0iTZptb44k2jRBSGKyTiJ1vVOprYX+kMA2y5ZUVzAr0fWp TU6ek39EEv2/jiRNThP3A8McSR7lEELdVxf9RU5dUejASXxvVC5td4wBKS35RyQh 41v0V5DEluGR6AcBj3IikRUncCBQm+/9/uHWGDhRdcbStwtZDgSM+0y9yi/Zzztk fHv8eJKehUdn8KEktY7ewYeRFISkkdDdgCAkvR/cv/xeyJ3O+9V7lL7Heua+tpBW Wjag3heW8mx+NKVfq2/raF4N9H61rlLHY3dC6wLaGs9lqHsbfWvb3AGHFBg2UJfT /Z7I5d5J8tSTXyP+RJKzTHSQL/M7hkcSA6tNUYWOlnyVxchWP9ehUrprSskvuDXC dbl2PejytnoxrT6oK6OujkqSnnWH0rNnONxvT67W9gtNypXUC6cPVp1V83AYXOXd uTzPjaNSE/ZkJlEqR+FAbPE0kAcP8h4YlOrvdsmxjE+yuEWSj+kk1eByHXWe/yKJ W/Tc8yOSakS35N1pZMHnxsEZ7nhI8sSprwonhO0E+UoS9nhJht23p+onOZoEayUJ ezQnX5mV3H+TxDL27LAMUMlvg0crSX2JRm9D3mXdkUv9fLsT6upA1vX497G13dGv rgB9J9nm3NEAMj1B66uS4PZvT/0mkULz7f5pktjyPCfFdiTF/lON96q7g8jLcSho yeNc6aCt9vMPt4/lGW5fHUQzejzXV38/1DbZ7G040W2u27iD7D1bGQcG109d7/DR g7zfU8vtT6gR+060oru1Lb0DrXHI1r94rNcb77+jR0brtOe/5T+apODl6G5AEJKG QHcDgpA0BLobEISkIdDdgCAkDYHuBgQhaQh0NyAISUOguwFBSBoC3Q0IQtIQ6G5A 8AC/aP4hQAv4RagAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -222.25,
    x: 427.73
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -215.05,
    x: "408.55 411.55 414.55 418.14399 421.13798 423.53797 426.53797 429.52598 433.13197 436.13197 439.11997 440.33195 443.92594 446.92594"
  }, "&#x0423;&#x043f;&#x0440;&#x0430;&#x0432;&#x043b;&#x0435;&#x043d;&#x0438;&#x0435; &#x043f;&#x043e; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -207.85,
    x: "399.7 402.1 405.694 408.694 411.694 414.694 417.688 420.688 424.882 428.47599 431.464 434.47599 437.47599 442.29399 443.49397 447.09397 452.51197"
  }, "&#x0441;&#x043e;&#x043f;&#x0440;&#x043e;&#x0432;&#x043e;&#x0436;&#x0434;&#x0435;&#x043d;&#x0438;&#x044e; &#x0414;&#x041c;&#x0421;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6.025,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -200.65,
    x: 427.73
  })), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M458.04 264.74H466.54V213.63H458.95"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_512)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,156.6,363.6)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_514",
    width: 116,
    height: 46,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAHQAAAAuCAYAAAD5jz22AAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAz0lEQVR4nO3cywnDMBQFUXWuUlSOkFSUwoP8TIghEDBvmMXxwnhh GGTvbiml7Nba7r0rsVrrjpYlLmutPedUYmOMV9CrX0b/8RE0TurVnw79Jk7m16Dx wP2mknj/XRoUwKAwBoUxKIxBYQwKY1AYg8IYFMagMAaFMSiMQWEMCmNQGIPCGBTG oDAGhTEojEFhDApjUBiDwhgUxqAwBoUxKIxBYQwKY1AYg8IYFMagMAaFMSiMQWFO gzprk8/prI1yewZ1Gi6/wzSc4435PcYbb0vSPHJLr5RiAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#00b050",
    d: "M156.46 206.69H223.31V231.957H156.46Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_515)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,155.4,366.00004)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_517",
    width: 120,
    height: 39,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAHgAAAAnCAYAAADEvIzwAAAACXBIWXMAAA7EAAAO xAGVKw4bAAADjElEQVR4nO2aW47qQAxE2TlLYSn88IY9zVVFOqMaXzsZwYhA8Ecp oenYbpftJm1Wq9Xqq7FozG5AowluNMGNJvhDMbsBjSa40QQ3XoPg4/H4dblcvnG9 Xud2wNLxXIXn83kgVUTrKpJfwAlLxvMJPp1Owz3ZzHf7/f6bdF232+0wzpgDWV4J 1uv1MK7P/p3k+me+r2Qwdrvdhjm6+jOVrbrf7Xb/ra3SvTiCN5vNsMCMYH0nR8lB zMMR3Gu+roxrrghBjq7Mp0owXyRJL/oJnkwGVSbq53Nla0VwpXtxBB8Ohx9EuBO4 x7G6sj+749zxyiKeiQQzH8fLqTEQKhlkL5mJzilbY5Xx6pTpXhzBsTw5wZS4LLoz gpmve0hygrMqEZ2cyZAeJxpiIXLMVq808ffF4gl2RwGygL2PqJcTRJAyfopgSl9W ov06RnCUAXledqk+Gq9srUr0xxDMvujw0kcZBWSI36t04kRd9Z2yz/c2Sqy+01X7 pMv3zIsy0C0SkaF7no2y3NZoM1Wk0r1IguN4jPS/gGdS40mKlCG8dkSC//q1YaZM eVXMbkCjCW40wY0m+FH4L+c32uNnN+AtEDtgTfCCoFeuNyP1dwRzDkvUcowXOyO8 4/KZrk7suHDaw/uwnzK5rqyzwxiHB5lsjXMqhUy6SXGcQxfmjHV6/ETMmw6VTJ6J Z9KVbdHPGsv8r9fMat13EezHghLOHsS4H7qL/NhRkXLefb0F50eUZIUWjy7OhWNX R3MIjkx2FjTYw7iCJjYWPOAygrEDG/WM9Fcy0e22OVnRNtZFQEd73P/Vuu8mOBMQ jfA5cZE4xSOfZ/woz7tHLodxFuPRPSbb4QR790fyCcwYTHG9cY10mzKZ2OeBMWVb rIQxILyqZut+KIOnCKYs0xtlkRjgfVk33Mu56yIjvFq4XiI96xF7dfEOEQRQ6rBT 9/wJoXKYZzmNBic1ymQev7idsMq2LJEy/1frvotg9owYnVkGe080licnyn+Fkgmu yyPZgyE2JjLZvynR3sT3/4eNBTTk8byuNP0zmVE+ATBVor3VWPm/WvddBONIOiNk m4yCGIxWRGqeb/p0YxhHlgeAl2lkxK4MYB/KZPu+j0yyiL3LdcXnGauaFD6fjlIl Ex+57WO2xbWzDWX+r9Z9N8FTqMpL42XwmIAYxY2Xw+wGNJrgRhPcaII/FLMb0GiC G01wI8U/TpkZmiqVuqkAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -221.05,
    x: "169.8 174.6024 178.2024 181.8024 185.39519 188.99518 191.99037 194.99277 200.38558 203.38797 207.57837"
  }, "&#x0414;&#x0435;&#x043f;&#x0430;&#x0440;&#x0442;&#x0430;&#x043c;&#x0435;&#x043d;&#x0442;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -212.65,
    x: "158.05 161.0596 163.45 167.6404 170.64279 174.23558 177.83557 181.42836 185.02115 188.62114 192.22115 195.80675 197.61394 201.21395 205.40435 208.40674 212.00673 215.60672 218.61632"
  }, "&#x0441;&#x0442;&#x0440;&#x0430;&#x0445;&#x043e;&#x0432;&#x0430;&#x043d;&#x0438;&#x044f; &#x0431;&#x0438;&#x0437;&#x043d;&#x0435;&#x0441;&#x0430;")), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M394.52 344.25H390.01V322.64H394.7"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_518)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,480,360.00004)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_520",
    width: 87,
    height: 43,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFcAAAArCAYAAAANKBTWAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAvElEQVR4nO3bOQ7DMAwFUd7/Umq0QMudFFCI0wROETsQfjDFNCyf BHY0M5v0s2yOMWatlW6o9748F27OebbW6MYceeHGGF9DV9/98sq53yluCGH3jpLO UcEFVy9wwdUMXHA1AxdczcAFVzNwwdUMXHA1AxdczcAFVzNwwdUMXHA1AxdczcAF VzNwwdUMXHA1AxdczcAFV7OPuD4spdCXvR2cpJQuX6/QyTWPr4LjCoWu55b+YZ+r Yv+u+tcewBuJ11Ny0VMAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#99ccff",
    d: "M479.63 212.31H529.236V235.15799H479.63Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_521)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,487.2,359.4)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_523",
    width: 65,
    height: 46,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAEEAAAAuCAYAAAB3VXTKAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAC4ElEQVR4nO2ZXW7CQAyEuTlH4Si88A93oppIH5q6BgVCsVP1YZRk E29mx96svVksFovrP+oJdEA5gQ4oJ9AB5QQ6oJxAB5QT6ICfjZfL5Xo8Hm/X6/X6 2/UfRH7jfD4Pg9f54XAY0IDsZ0VQNJxOp5sgq9VqEELnigpE0tHblsvlYLPf74fn 1cd2u72JqefUpvtq0zW2HnV6BuHdITrH1ttlo/bM/mUReInEgGB8KSJASkcGDHjG 7WObjgiufhHS3/FIBMRWe2Y/SQQEcAKZCLRtNpsBeN0jBHtdExGKLgbvRw0G6Bns dB1FkOjqj+cz+5dFiB4bEwmuvMjIIxB3e7Xrvn+AXQT6yMSPIjBVXYRo/7IIzFXv SIq7CHiJwfgKIg/hdd33PgW1+ZzlXP1rIN6fv9f7IwJ4H46L9pOmwxi4l2aMaR3s drux864zygl0QDmBDignMBp8EFuLwPqvL7a+FbSz/GXg3pgB/mL98r7OIEnqSuI0 Bo+EmqUICEGSRCpLPq928gKvHchLtNoQUZ6rzE4EwUVwUTyrixljBJngLEWIkYB3 8bgXOVEEooYomaUIpK5UlAyE4sYzTGw88/R6I5bd7UXAy+49yHuxlQ2M+kNHRYKX x7P6JjyCVgoKHgqrT727jQiCpkecDk1QTqADygl0QDmBDign0AHlBDrg/k3/96C1 24si3y+kYvSMkDWdHIGlkTyBnEC2bsc1G7L3NnJJrrD1LfvIa5II7OaKBNvvngQJ nt15kuQ5AWRJiEiZPVX2RMhtYmKViZAtuc5rkgi8gMovDpj2WChBwnecGTxCeWGU iaCIw8vxbxU8MhEyXpMjwcOcQbgXRdaf81oAzyMkYrCBktUQ8X1jpoP3k/GaHAl0 GHN9POU/a+N/BSdOPcB3xp/JRPB/C94XO9tqozL13e6M1yQRnsUT//664X2d6RvA R29mKCfQAeUEOqCcQAeUE+iAcgIdUE6gHF82MSKGw9+iQQAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -228.77,
    x: "489.45 492.45 495.45 499.044 502.038 504.438 507.438 510.426 514.032 517.032 520.01998"
  }, "&#x0423;&#x043f;&#x0440;&#x0430;&#x0432;&#x043b;&#x0435;&#x043d;&#x0438;&#x0435; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -221.55,
    x: "497.02 500.62 501.82 504.814 506.014 508.40803 511.402"
  }, "Digital")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -214.35,
    x: "490 494.194 497.188 500.188 502.58799 505.576 507.982 511.576 514.576 516.97"
  }, "&#x043c;&#x0430;&#x0440;&#x043a;&#x0435;&#x0442;&#x0438;&#x043d;&#x0433;&#x0430;")), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_524)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,479.4,213.6)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_526",
    width: 89,
    height: 39,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFkAAAAnCAYAAABkI+QeAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAq0lEQVR4nO3bOw7DIBBF0dn/pmj4iM+eSAYrkd1jOXm6xZUQ5WFE N2Zmk27PZkpp1lppc2OMA9kPrTW6qZzztFLK96L3/vjrK+SOH9MY4xXZzz/wf/19 IQSQQRYIZJA1AhlkjUAGWSOQQdYIZJA1AhlkjUAGWSOQQdYIZJA1AhlkjUAGWSOQ QdYIZJA1AhlkjUB+Gpn2t5DP6rS/tc7g4+17Iz7RtLc1xW/fF842uTPJuEAJAAAA AElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#7030a0",
    d: "M479.15 360.74H530.174V381.572H479.15Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_527)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,480,205.8)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_529",
    width: 87,
    height: 67,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFcAAABDCAYAAADpj5nhAAAACXBIWXMAAA7EAAAO xAGVKw4bAAADX0lEQVR4nO2ZW67iQBBD2TlLYSn88IY9MTLSQZ5SwgCXi0MNH1Y6 /ahyuyuddGU2m83OX/wa4gQ6I06gM+IEOiNOoDPiBDojTqAz4gQ6I06gM+IEOiNO oDPiBDojTqAz4gQ6I06gM+IEOiNOoDPiBDojTqAz4gQ6I06gM+IEPga73e68XC4v 5e12ey0/Je7xeDwfDofr/Xq9vtzfYbQlpIfjR+Lu9/u/xMRoepJJKGLvjNrb4soA gp5Op4vQEpwIdqhOY1ar1aUPUc9Y2WKxBBFU/yFb2PE6+sOJepXpSzt+1Kay2xsr a5zXLxaLq406prY9JS7RKyPab3Sdz+dXR6yiyqpzEuxPTBCB3WYlLaGpRyDER1xd 1SYe7hsb+FM7fiTGo+J6cNQxte1pcT1ShhwJQ+LSxmQ1QV09er0/QuCDOvmvkat6 LR62xqIc8XV9RFxdx+Y81Pa0uL5SRN494tKXCSOER3u1tdlsrmPlk73NBfNHEl7+ JPlW4C/gR8TF99ATNtT2lLiQrV8N94jr+662BO4Rtk6OesThbVzFpW1sW/BtjAWt vOqCA+8ztn0NtT0lrqJEE5A4KvtWwWRZhBrVRKjGql5iaML09cecvt7GODhgXzZ4 edK38tHEda++8qs62XM/DsSVHfVjjOYCj1ttP9oWHkGN6k/AL3J+rcEaRZ8Atp/J i/vFV9yvuA0QJ9AZcQKdESfQGa83Wk8+fhTWh73K9WTmJzr6CPpQp95zDZyOaPPD gJ8Aa5aMz8RbPictbs0huLikIIdE8XpOPyR7vOxCqaycBN/Xvgi+0F5mgcZ8TlZc EiscN4eSODWR45HomSxsDeUBvL4uLHkOROTebY/5nLS4JEw8sVIjVyADVhM5nsmS jTEBieL6u8XF9IXWPQl/j9zqc7LiSjCyWvVvhIvrj7CLy9iacfNEDALVpPqQuO6T RXcuYz4nKW7NiJGyhDhZMZU9o8VEPWvmdhGXbJn6aSGJOn8Z1fH8kahZsn/5nKS4 9RH2xPgYPBLfhTf5fJ2xoewS+dhb4zwS34U3+XzfhP5DxAl0RpxAZ8QJdEacQGfE CXRGnEBnxAl0RpxAZ8QJdEacQGfECXRGnEBnxAl0RpxAZ8QJdEacQGfECXRGnEBn xAl0RpxAW/wBfM54M+xVKV8AAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -381.45,
    x: 505.02
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -373.03,
    x: "483 486.6 490.7904 494.3904 497.98323 500.9856 505.176 508.1784 513.57839 518.97836 523.1687"
  }, "&#x0423;&#x043f;&#x0440;&#x0430;&#x0432;&#x043b;&#x044f;&#x044e;&#x0449;&#x0438;&#x0439;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.2,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -364.63,
    x: "490.52 494.7104 498.3176 502.508 505.5104 509.1032 512.09848 515.6984"
  }, "&#x0434;&#x0438;&#x0440;&#x0435;&#x043a;&#x0442;&#x043e;&#x0440;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 7.225,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -356.23,
    x: 505.02
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_530)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,480,334.8)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_532",
    width: 87,
    height: 42,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFcAAAAqCAYAAADGdMdzAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAsUlEQVR4nO3bOw7DIBBF0dk5S6Phz6KIcCQrUTrLFnrkFreiQQc0 3ZiZDXosG7XWkXOmm/Lev3FTSqO1Rjd34IYQll9kt+Yk+ME9vzNdaqKCC65e4IKr GbjgagYuuJqBC65m4IKrGbjgagYuuJqBC65m4IKrGbjgagYuuJqBC65m4IKrGbjg agYuuJqBuwq3934c0LWm3xdujPHR/YB/7MR1zo1SyvJX36mP8bp+Vu3aCzGXIaPH BF0tAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#99ccff",
    d: "M479.63 238.23H529.236V260.318H479.63Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_533)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,481.8,334.2)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_535",
    width: 80,
    height: 46,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFAAAAAuCAYAAAC/OZ4cAAAACXBIWXMAAA7EAAAO xAGVKw4bAAADrUlEQVR4nO2aXW4CMQyEuTlH4Si88A93oppKH5q6SWCBreuqDxZZ x06cibObSVgsFovrv7wk6QFUl/QAqkt6ANUlPYDqkh5AdXnOcbVaXS+Xyxfder3O HkwdAJfL5fV8Pn/+6nm3210Ph0P2YOoAKBFggHY6nT4zUFm53+9vQqYKYD1vNpub v+yxI3uZCOnIcPlgx+Rhg59s1Rflll5tS9/yTwGQLFQQ+pWOZ5WPx+OtDr10AAHA +mUisMMWHZNEu4DBKvB+VaYP9AISfcs/BUCyUEH4YFsAuo4sJAOl8wlAegDqV3X4 +SShdwAFnutb/mkAKoMUCLN4D0ANZrvdfsu2mMGeVQAJgK2sGWUgwCFvyLr3AMiy YIAjAJlxB9t1AKiMdh0Z5AAqg1Umex8BUGUAbPmnAKjseyT9PdNiXU8nGbWvSXhl 6b3q/xYAp2TqH94jpgdQXdIDqC7pAVSX9AC+iT4e7C8j3/6Fkh7AF2H/p61GkQ/P NAfYgzJDogFDx5yvOs9lOxL9ZBd92ZspA503S+DTqpO/+wA4/bMH9Xhap0ej+lkA VKDs6xis79vY7MImOAho+WHnvs5ZoWCyU5kDC/xhFQJUevqCvfCsOHyz7mMZ1c8G oM8azIKsIQgPygfnfm6Hr5/YUKdyzO6WHoYB0PQZ2U4cS69+NgA9e/yEg6UTl50G 1PIDAPcVT24B5RzaMzMCqLLs6NO5cAvAUf2sS5iMYZCccDin5eSD91n0AzT35SPi r4c4Wc51WwCqzBecNkcA9upnXcL+IWCA8YTDX8w9v55v74X+C7/M0xy0JOPXcU6/ ApIeQHVJD6C6pAdQXdIDqC7pAVSXfmW8y3U+y11ri8tK5/e72EZ/v9L0DXi0c87q sfge0TlxbIe2/d8UlKMOf7+IegpAv01To+z+eXbO66wCLup0Co4b/d3XL+ZbdpHp 0KbKHFC4HWVuDf2CK47PY5AdG3DvbzKACt7/qqFnn90YSATQd/XQqujPIJ2F9PqB KcQ7Y+oigIBP2xw4xBs/YvXbQBIAJvU0gM4GxC95hm7dy0CWBRw3+rsvXLdlF++I OblxOsgtmwMYs2eUgZ7pHGJ4e5MBjJw0PkPsRwCSKXoftvzjYQSULtr5f3AYkJ5Z 7n7HSxkQ/OirB6AfyXEyFPubDKDP2uj53vuTD0jPv3f3+yjnbWWZv/hbMbxZ3t+o HyLMLS0Af5hz/1hHf1XSA6gu6QFUl/QAqkt6ANUlPYDqkh5AafkAKScbnaoMnEMA AAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -254.33,
    x: "489.45 492.45 495.45 499.044 502.038 504.438 507.438 510.426 514.032 517.032 520.01998"
  }, "&#x0423;&#x043f;&#x0440;&#x0430;&#x0432;&#x043b;&#x0435;&#x043d;&#x0438;&#x0435; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -247.13,
    x: "487.83 490.83 493.82398 496.22398 499.81797 502.21797 505.81196 508.81196 511.20594 513.60598 517.19998 518.39999 521.39999"
  }, "&#x0440;&#x0430;&#x0437;&#x0440;&#x0430;&#x0431;&#x043e;&#x0442;&#x043a;&#x0438; &#x0438; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6.025,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -239.93,
    x: "484.3 486.69795 490.29487 493.29533 496.29576 499.2962 502.29066 505.2911 509.4845 513.0814 516.08187 519.08236 522.08279"
  }, "&#x0441;&#x043e;&#x043f;&#x0440;&#x043e;&#x0432;&#x043e;&#x0436;&#x0434;&#x0435;&#x043d;&#x0438;&#x044f;")), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M529.43 276.42H533.02V249.27H529.24"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M529.43 276.42H533.02V223.74H529.24"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M530.16 341.72H534.88V323.73H530.16"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M530.16 341.72H534.88V305.98H530.16"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M504.66 360.74V353.93H504.65V351.8"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M504.57 388.54 504.65 381.53"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M770.95 231.7H782.03V111.42H771.66"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#3366cc",
    d: "M435.62 448.1H532.99V439.36"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M156.46 219.33H153.49V218.95"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M223.31 252.66H227.55V279.54"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M479.16 280.55H472.54V388.6"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#8976ac",
    d: "M498.43 405.76H436.99"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 9.025,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -560.75,
    x: "649.88 655.8816 660.6829 664.27487 667.87588 671.46786 676.26919 680.46578 684.66238 688.25436 692.4509 697.25228 702.04458 703.8406 708.0372 712.8294 717.026 722.41397 727.2062 732.0075 736.20419 738.5958 742.19686"
  }, "&#x041e;&#x0440;&#x0433;&#x0441;&#x0442;&#x0440;&#x0443;&#x043a;&#x0442;&#x0443;&#x0440;&#x0430; &#x0432;&#x0432;&#x0435;&#x0434;&#x0435;&#x043d;&#x0430; &#x0441; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 9.025,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -560.75,
    x: "744.35 749.14968"
  }, "12")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 9.025,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -560.75,
    x: 753.47
  }, ".")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 9.025,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -560.75,
    x: "755.88 760.6797"
  }, "02")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 9.025,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -560.75,
    x: 765
  }, ".")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 9.025,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -560.75,
    x: "767.4 772.1923 776.389 781.1813 785.3779"
  }, "2024 ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 9.025,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -560.75,
    x: 787.7
  }, "&#x0433;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 9.025,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -560.75,
    x: 790.9
  }, ".")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 9,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -549.92,
    x: "649.88 655.28 660.068 661.868 666.65597 670.256 675.071 679.85 684.053 688.256 693.071 698.44406 703.241 705.041 709.829 714.032 720.61996 725.40798 730.22299 735.011 739.214 741.014 745.811 750.608 755.39596 759.59896 763.1899 767.3929 769.1929 774.58389 779.38088 784.1688 788.3718 792.54788 796.16586 800.9538 805.74179 810.5297"
  }, "&#x041d;&#x0430; &#x043e;&#x0441;&#x043d;&#x043e;&#x0432;&#x0430;&#x043d;&#x0438;&#x0438; &#x0440;&#x0435;&#x0448;&#x0435;&#x043d;&#x0438;&#x044f; &#x0421;&#x043e;&#x0432;&#x0435;&#x0442;&#x0430; &#x0434;&#x0438;&#x0440;&#x0435;&#x043a;&#x0442;&#x043e;&#x0440;&#x043e;&#x0432;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 9,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -539.13,
    x: "649.88 655.28 660.068 664.85598 668.4469 673.23489 677.4109 682.2259 686.4289"
  }, "&#x041f;&#x0440;&#x043e;&#x0442;&#x043e;&#x043a;&#x043e;&#x043b; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 9,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -539.13,
    x: 688.75
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 9,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -539.13,
    x: 697.98
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 9,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -539.13,
    x: "700.03 704.818 709.021"
  }, "15 ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 9,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -539.13,
    x: "711.2 715.988 719.5789"
  }, "&#x043e;&#x0442; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 9,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -539.13,
    x: "721.45 726.265 730.486"
  }, "09 ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 9,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -539.13,
    x: "732.63 738.03 742.81808 747.02108 751.809 756.012 760.80007 765.00308"
  }, "&#x0444;&#x0435;&#x0432;&#x0440;&#x0430;&#x043b;&#x044f; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 9,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -539.13,
    x: "767 771.78799 775.99099"
  }, "202")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 9,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -539.13,
    x: 780.68
  }, "4")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 9,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -539.13,
    x: 785.25
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 9,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -539.13,
    x: 787.27
  }, "&#x0433;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 9,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -539.13,
    x: 790.4
  }, ".")), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M616.9 236.42 607.75 236.33"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M348.64 381.95 348.66 388.59"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M401.61 391.91V388.98H87.955V381.57"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M401.61 391.91V388.98H730.73V381.64"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M375.45 369.48H394.52"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M269.83 381.76 269.86 388.4"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M189.66 381.97 189.69 388.6"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M730.73 381.57V388.98H782.02V231.7H770.55"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M769.76 281.24H782.02V281.12"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M569.74 381.95 569.76 388.59"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M647.03 381.97 647.06 388.6"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M618.86 143.68H607.75V388.98"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M617.54 338.62H611.87V294.94H617.54"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#000000",
    d: "M617.54 315.83 611.87 315.85"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_536)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,726,207.00002)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_538",
    width: 8,
    height: 3,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAYAAACuyE5IAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAHklEQVR4nGNgYGD4TwAz/D9y5Mj/U6dOYWC4AnwYAD48JgtKGfJo AAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 0.6006,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#515151",
    d: "M725.67 388.84H728.5 725.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_539)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,316.2,275.40003)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_541",
    width: 104,
    height: 28,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGgAAAAcCAYAAACNr/p2AAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAnklEQVR4nO3UMQrEIBBAUW/uUTyKjWDUQ7lMkYTAsm0+7C8egtMI nzGllLbQ0s4579ba7r0LYIyxSyl3oLiccwrkOI470Frr9QfpKbboayDAn/vXIoyB wAwEZyA4A8EZCM5AcAaCMxCcgeAMBGcgOAPBGQjOQHAGgjMQnIHgDARnILifgeKM gd5ztngEOquJ5QpUa3V7QCJONLkCiesD1d4SwYXqh00AAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#ff3300",
    d: "M316.27 306.07H375.595V319.654H316.27Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_542)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.59999999,328.2,259.8)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_544",
    width: 66,
    height: 82,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAEIAAABSCAYAAADgggJzAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAC/0lEQVR4nO2YW47bMBRDs/MsZZYyP3nMJNlTCho4A0Kw0zzckg36 cRD7SrIo5tq+8maz2Vz/MxEX0EJcQAtxAS3EBbQQF9BCXEALcQEtxAW0EBfQQlxA C3EBLcQFtBAX0EJcQAtxAS3EBbQQF9BCXEALcQEtxAW0EBfQQlxAC3EBLcQFtBAX 0EJcQAtxAS3EBbQQF9DCfMPn5+cE5x8fH9fL5ZIWmzHidDr9nH99fU0UCP67RggZ QVacz+cpK3a73fV4PE5gjDLlcDj8xBlPTO3b7XaKMV4xrq1jxdSmc7JPMfrQdut4 v99PY+fGv2QEWaELygjFvr+/fxbsMUF/JpcwGcDC6cviMVLXUR/auJbwOdA1d4we jZkb/5IRZAUTLInwGIvCSAQSw0jFlDFuCNdRG+aOZnvMTXOdc+NfNsL/+VtGKB0x jlsBYX7LMAbxSm3S240YddzKCObElAcWf58R/s/9zghnzA5uL88IZQH/GM+PMc3n DJw7diPHLPRn1tNGjK/QJSRAixn7KkvGGM8M2sikubkfWMQa45+baClt/2HiAlqI C2ghLqCF5cbxYTf38Hsjlhsphzn3V9Ubcp8ROta7Wb/+WuU1pWzhve0ltcpsnVOL eIHFfsP3Ld7uc3C8FPe9xRhbzQjqdzLCq0H6UB+ojxYvEV7t6Vfn6k9RRUGldna3 zKe+VIg+nxdJxKli2biNsdWMYCPlJihGeeuT+b5EC6PuVz8ZNJroC2SHiyH3GkGV 6kZ4bBUj3FU3YsyIOSPG8nxcFIJJY8SPe49bRrgB/I6x1YzwbwmPGMEGyLfI41gy i3YZohjZ5P38duLbiJvlRsxpe9qItVj6QIIpasNsDPTzETd7Rf68EUvothlvnXvw r1tvYUQZcQEtxAW0EBfQQlxAC3EBLcQFtBAX0EJcQAtxAS3EBbQQF9BCXEALcQEt xAW0EBfQQlxAC3EBLcQFtBAX0EJcQAtxAS3EBbQQF9BCXEALcQEtxAW0EBfQQlxA C3EBLcQFVPALWG3XVoSj964AAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6.025,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -328.8,
    x: 346.18
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -321.58,
    x: 346.18
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -314.38,
    x: "330.83 333.83 336.83 340.42399 343.41798 345.81797 348.81797 351.80598 355.41197 358.41197 361.39997"
  }, "&#x0423;&#x043f;&#x0440;&#x0430;&#x0432;&#x043b;&#x0435;&#x043d;&#x0438;&#x0435; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -307.18,
    x: "331.07 334.66999 338.26399 340.65797 343.64598 345.45796 348.45796 351.45195 355.04597 358.04597"
  }, "&#x0418;&#x043d;&#x0442;&#x0435;&#x0433;&#x0440;&#x0430;&#x0446;&#x0438;&#x0438;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -292.75,
    x: 346.18
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_545)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,316.2,292.8)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_547",
    width: 104,
    height: 27,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGgAAAAbCAYAAACQqsrOAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAnElEQVR4nO3aMQrEIBQAUe9/KRtR1EO5/CIkgRC2cyBTPAUrYdBG U0pphZzzaq0JIFocXVIMtdY1xhBI7/0MNOfcviH9ESgWdx/vr7u2eDxBl7tPG0QY A4EZCM5AcAaCMxCcgeAMBGcgOAPBGQjOQHAGgjMQnIHgDARnIDgDwRkI7jVQzLvf 5L/u9dOIOG6B4l+ckTiiRSnlDCSuH+RbhpKtqvfkAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#ff3300",
    d: "M316.27 289.06H375.595V302.64399H316.27Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_548)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,321,280.2)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_550",
    width: 88,
    height: 70,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFgAAABGCAYAAABISVPfAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAClUlEQVR4nO2WW27qQBBE2TlLYSn88IY9cVWWTlSxxkkINyqp5I8j 2+OZ9umeB2w2m81z5U+JC7QTF2gnLtBOXKCduEA7cYF24gLtxAXaiQu0ExdoJy7Q TlygnbhAO3GBduIC7cQF2okLtBMXaCcu0E5coJ24QDtxgXbiAu3EBdqJC7QTF2gn LtBOXKCduEA7cYF2xi+u1+tzu91+PN/v97To2zwej+flcpnu9/v9lOO8nefj8fgp d7V5LL3XeHE+n18vsD7IR0+n0xRIUgoGu91uauMqPAb9mShdGUubx5y3KS7PxF66 x2E0Hg6Hw0cxVDTlNW+n8GrTs9pVBybD+7jvywXWYEnoervdpiD6qO71UWZObcyk +vMxzTjtGkMietY7doSPVTyN5xt8X+NIeOmeMaPxXmBWoxeMAqsvfsRVcelPbrr3 Ff4Nyy+ZOWQ8IVadnn2l+1ZjJVFMLzBF17NWGgXWVTF0rz4ky4T66sLH34/GeyHJ Z1Rg8gEWGZ7EYgLfLrDP6FcF9jaEOGKWCuyFZcvOC8Q2952jqxfYi740fnRE+Iok vu80oVWqNt9l5Dk/k18usAL4Vv6qwBTHV4yS1Dut6vkRoaR1pRBeYO/jBV46Ivz4 Who/KrDvNnLwgntsxjMpHEPKlQn+VYHnM+U/Kpx3EqGvn0skyHs/MhirBDkj1YfY isOPi97/5EeO2KPx85zYnRRY7fzgeVw/7jxn+rBAvlnN7/318RW18gcFHv09W/mP BV5ZC5wmLtBOXKCduEA7cYF24gLtxAXaiQu0ExdoJy7QTlygnbhAO3GBduIC7cQF 2okLtBMXaCcu0E5coJ24QDtxgXbiAu3EBdqJC7QTF2gnLtBOXKCduEA7cYFq/gG3 JzwTXJzTjwAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6.025,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -308.18,
    x: 346.18
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -300.95,
    x: 346.18
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -293.75,
    x: "323.25 326.25 329.25 332.844 335.83799 338.23799 341.23799 344.22599 347.83198 350.83198 353.81999 355.03196 358.62596 362.22593 365.81993"
  }, "&#x0423;&#x043f;&#x0440;&#x0430;&#x0432;&#x043b;&#x0435;&#x043d;&#x0438;&#x0435; &#x041a;&#x0418;&#x0410;&#x0421;")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -279.33,
    x: 346.18
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_551)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6,0,0,.6,316.8,309.6)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_553",
    width: 103,
    height: 27,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAGcAAAAbCAYAAABhoZFDAAAACXBIWXMAAA7EAAAO xAGVKw4bAAAAqElEQVR4nO3aOwrDMBBF0dn/ptToL+1JQXZCHELSzgPf4jRGheFa 42bMzBZk2aq1rtYaRMQYzzg559V7h5AxxhlnV7o+9P5q7uwa6CtOCMF7xt5aKYU4 qogjjDjCiCOMOMKII4w4wogjjDjCiCOMOMKII4w4wogjjDjCiCOMOMKII+xvnJTS cQA+9g7HzzjQccTZo8z7RfBpb+I8R52tOaf7lcbb69//ALzblU13osA2AAAAAElF TkSuQmCC"
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#ff3300",
    d: "M316.47 272.05H375.795V285.63398H316.47Z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_554)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59999999,0,0,.6,325.8,297.6)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image_556",
    width: 73,
    height: 69,
    xlinkHref: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAEkAAABFCAYAAAAGscunAAAACXBIWXMAAA7EAAAO xAGVKw4bAAACF0lEQVR4nO2US27DMAwFffMcJUfJxvk5uZOLZ+AFhKomKbSYvqCL gWVZtEYk7WmapvWfl+ACCeACCeACCeACCeACCeACCeACCeACCeACCeACCeACCeAC CeACCeACCeACCeACCeACCeACCeACCeACCeACCeACCeACCeACCeACCeACCeACCeAC CeACCXyfPBwO6/F4fNzvdrv1crnQosPoHOfzeeN6vW73+/1+nef590kSt9ttS5bG SpheSh9yFJ1H53KShObeOFv/wf1+fwTrqnt1k8baZFmWbQPNe60EVB3HaI1jNad4 rbGg1/l9Poj3cfcq3gVT1T2u83rH6XTqxtckeV+t1fOhJNVu8gFchfpMV8toM3+m auNWzPFKpMaOqVcn33O1+k5GddDYRVICe/E1SS6cYp3UoSR5c3fCT0nynCTrYZQ8 SznGPEtWRcl2jLuzOmhPd6PHbXyvkzQ//LnVzNfOetVJqo7HEul1ksftJ912Um/f tpO83knqxfeSpAINJ8mV8KHbf4DHFnW1vdb/hfr/aefaT8MHcdf4fc/+Se5yzfvz aeONu8f4vUOd9A61yh/M2AtqlT8YXCABXCABXCABXCABXCABXCABXCABXCABXCAB XCABXCABXCABXCABXCABXCABXCABXCABXCABXCABXCABXCABXCABXCABXCABXCAB XCABXCABXCABXCABXODP8wVqZNbPAzXlMQAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6.025,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -291.15,
    x: 346.38
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -283.92,
    x: 346.38
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -276.73,
    x: "327.97 330.97 333.97 337.564 340.55799 342.95799 345.95799 348.94599 352.55198 355.55198 358.53999"
  }, "&#x0423;&#x043f;&#x0440;&#x0430;&#x0432;&#x043b;&#x0435;&#x043d;&#x0438;&#x0435; ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -276.73,
    x: "360.02 363.02"
  }, "BI")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1 0 -0 1 0 595.2)",
    fontSize: 6,
    fontFamily: "Calibri,Bold",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: -262.3,
    x: 346.38
  })), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#515151",
    d: "M375.74 335.3H381.46V278.84H375.79"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#515151",
    d: "M375.59 312.86H377.72V312.87H381.46"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#515151",
    d: "M375.59 295.85H377.72V295.86H381.46"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#515151",
    d: "M376.59 173.74H382.26V202.49H376.15"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.2)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#515151",
    d: "M375.6 228.31H382.26V202.49"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrgStruct);
export default __webpack_public_path__ + "static/media/org_struct.3b167cfac0976beb9fc664a046334ab4.svg";
export { ForwardRef as ReactComponent };